export const citiesData = [
          {
            id: "110000",
            text: "未知地",
            children: [
              {
                id: "110100",
                text: "北京时间",
                children: [
                  {
                    id: "110101",
                    text: "--",
                    gisGcj02Lat: 39.9288,
                    gisGcj02Lng: 116.416,
                  },
                ],
              },
            ],
          },
          {
            id: "110000",
            text: "北京市",
            children: [
              {
                id: "110100",
                text: "北京市",
                children: [
                  {
                    id: "110101",
                    text: "东城区",
                    gisGcj02Lat: 39.9316,
                    gisGcj02Lng: 116.41,
                  },
                  {
                    id: "110102",
                    text: "西城区",
                    gisGcj02Lat: 39.9305,
                    gisGcj02Lng: 116.36,
                  },
                  {
                    id: "110105",
                    text: "朝阳区",
                    gisGcj02Lat: 39.9484,
                    gisGcj02Lng: 116.485,
                  },
                  {
                    id: "110106",
                    text: "丰台区",
                    gisGcj02Lat: 39.8585,
                    gisGcj02Lng: 116.286,
                  },
                  {
                    id: "110107",
                    text: "石景山区",
                    gisGcj02Lat: 39.9056,
                    gisGcj02Lng: 116.223,
                  },
                  {
                    id: "110108",
                    text: "海淀区",
                    gisGcj02Lat: 39.9593,
                    gisGcj02Lng: 116.298,
                  },
                  {
                    id: "110109",
                    text: "门头沟区",
                    gisGcj02Lat: 39.9404,
                    gisGcj02Lng: 116.101,
                  },
                  {
                    id: "110111",
                    text: "房山区",
                    gisGcj02Lat: 39.7479,
                    gisGcj02Lng: 116.143,
                  },
                  {
                    id: "110112",
                    text: "通州区",
                    gisGcj02Lat: 39.9097,
                    gisGcj02Lng: 116.657,
                  },
                  {
                    id: "110113",
                    text: "顺义区",
                    gisGcj02Lat: 40.1302,
                    gisGcj02Lng: 116.654,
                  },
                  {
                    id: "110114",
                    text: "昌平区",
                    gisGcj02Lat: 40.2207,
                    gisGcj02Lng: 116.231,
                  },
                  {
                    id: "110115",
                    text: "大兴区",
                    gisGcj02Lat: 39.7267,
                    gisGcj02Lng: 116.341,
                  },
                  {
                    id: "110116",
                    text: "怀柔区",
                    gisGcj02Lat: 40.316,
                    gisGcj02Lng: 116.632,
                  },
                  {
                    id: "110117",
                    text: "平谷区",
                    gisGcj02Lat: 40.1406,
                    gisGcj02Lng: 117.121,
                  },
                  {
                    id: "110228",
                    text: "密云区",
                    gisGcj02Lat: 40.3762,
                    gisGcj02Lng: 116.843,
                  },
                  {
                    id: "110229",
                    text: "延庆区",
                    gisGcj02Lat: 40.4567,
                    gisGcj02Lng: 115.975,
                  },
                ],
              },
            ],
          },
          {
            id: "120000",
            text: "天津市",
            children: [
              {
                id: "120100",
                text: "天津市",
                children: [
                  {
                    id: "120101",
                    text: "和平区",
                    gisGcj02Lat: 39.1172,
                    gisGcj02Lng: 117.215,
                  },
                  {
                    id: "120102",
                    text: "河东区",
                    gisGcj02Lat: 39.1232,
                    gisGcj02Lng: 117.226,
                  },
                  {
                    id: "120103",
                    text: "河西区",
                    gisGcj02Lat: 39.1096,
                    gisGcj02Lng: 117.223,
                  },
                  {
                    id: "120104",
                    text: "南开区",
                    gisGcj02Lat: 39.1382,
                    gisGcj02Lng: 117.151,
                  },
                  {
                    id: "120105",
                    text: "河北区",
                    gisGcj02Lat: 39.1482,
                    gisGcj02Lng: 117.197,
                  },
                  {
                    id: "120106",
                    text: "红桥区",
                    gisGcj02Lat: 39.1671,
                    gisGcj02Lng: 117.151,
                  },
                  {
                    id: "120110",
                    text: "东丽区",
                    gisGcj02Lat: 39.0863,
                    gisGcj02Lng: 117.314,
                  },
                  {
                    id: "120111",
                    text: "西青区",
                    gisGcj02Lat: 39.1412,
                    gisGcj02Lng: 117.009,
                  },
                  {
                    id: "120112",
                    text: "津南区",
                    gisGcj02Lat: 38.9914,
                    gisGcj02Lng: 117.385,
                  },
                  {
                    id: "120113",
                    text: "北辰区",
                    gisGcj02Lat: 39.2213,
                    gisGcj02Lng: 117.132,
                  },
                  {
                    id: "120114",
                    text: "武清区",
                    gisGcj02Lat: 39.3842,
                    gisGcj02Lng: 117.044,
                  },
                  {
                    id: "120115",
                    text: "宝坻区",
                    gisGcj02Lat: 39.7176,
                    gisGcj02Lng: 117.31,
                  },
                  {
                    id: "120116",
                    text: "滨海新区",
                    gisGcj02Lat: 39.0267,
                    gisGcj02Lng: 117.702,
                  },
                  {
                    id: "120221",
                    text: "宁河区",
                    gisGcj02Lat: 39.3305,
                    gisGcj02Lng: 117.826,
                  },
                  {
                    id: "120223",
                    text: "静海区",
                    gisGcj02Lat: 38.9458,
                    gisGcj02Lng: 116.974,
                  },
                  {
                    id: "120225",
                    text: "蓟州区",
                    gisGcj02Lat: 40.0457,
                    gisGcj02Lng: 117.408,
                  },
                ],
              },
            ],
          },
          {
            id: "130000",
            text: "河北省",
            children: [
              {
                id: "130100",
                text: "石家庄市",
                children: [
                  {
                    id: "130102",
                    text: "长安区",
                    gisGcj02Lat: 38.0367,
                    gisGcj02Lng: 114.539,
                  },
                  {
                    id: "130104",
                    text: "桥西区",
                    gisGcj02Lat: 38.0322,
                    gisGcj02Lng: 114.47,
                  },
                  {
                    id: "130105",
                    text: "新华区",
                    gisGcj02Lat: 38.0509,
                    gisGcj02Lng: 114.463,
                  },
                  {
                    id: "130107",
                    text: "井陉矿区",
                    gisGcj02Lat: 38.0671,
                    gisGcj02Lng: 114.065,
                  },
                  {
                    id: "130108",
                    text: "裕华区",
                    gisGcj02Lat: 38.006,
                    gisGcj02Lng: 114.531,
                  },
                  {
                    id: "130109",
                    text: "藁城区",
                    gisGcj02Lat: 38.0216,
                    gisGcj02Lng: 114.847,
                  },
                  {
                    id: "130110",
                    text: "鹿泉区",
                    gisGcj02Lat: 38.0878,
                    gisGcj02Lng: 114.313,
                  },
                  {
                    id: "130111",
                    text: "栾城区",
                    gisGcj02Lat: 37.9002,
                    gisGcj02Lng: 114.648,
                  },
                  {
                    id: "130121",
                    text: "井陉县",
                    gisGcj02Lat: 38.0369,
                    gisGcj02Lng: 114.143,
                  },
                  {
                    id: "130123",
                    text: "正定县",
                    gisGcj02Lat: 38.1445,
                    gisGcj02Lng: 114.573,
                  },
                  {
                    id: "130125",
                    text: "行唐县",
                    gisGcj02Lat: 38.4365,
                    gisGcj02Lng: 114.553,
                  },
                  {
                    id: "130126",
                    text: "灵寿县",
                    gisGcj02Lat: 38.3084,
                    gisGcj02Lng: 114.383,
                  },
                  {
                    id: "130127",
                    text: "高邑县",
                    gisGcj02Lat: 37.6156,
                    gisGcj02Lng: 114.611,
                  },
                  {
                    id: "130128",
                    text: "深泽县",
                    gisGcj02Lat: 38.1835,
                    gisGcj02Lng: 115.204,
                  },
                  {
                    id: "130129",
                    text: "赞皇县",
                    gisGcj02Lat: 37.6614,
                    gisGcj02Lng: 114.388,
                  },
                  {
                    id: "130130",
                    text: "无极县",
                    gisGcj02Lat: 38.1765,
                    gisGcj02Lng: 114.975,
                  },
                  {
                    id: "130131",
                    text: "平山县",
                    gisGcj02Lat: 38.2599,
                    gisGcj02Lng: 114.186,
                  },
                  {
                    id: "130132",
                    text: "元氏县",
                    gisGcj02Lat: 37.7667,
                    gisGcj02Lng: 114.525,
                  },
                  {
                    id: "130133",
                    text: "赵县",
                    gisGcj02Lat: 37.7563,
                    gisGcj02Lng: 114.776,
                  },
                  {
                    id: "130181",
                    text: "辛集市",
                    gisGcj02Lat: 37.9408,
                    gisGcj02Lng: 115.206,
                  },
                  {
                    id: "130183",
                    text: "晋州市",
                    gisGcj02Lat: 38.0313,
                    gisGcj02Lng: 115.043,
                  },
                  {
                    id: "130184",
                    text: "新乐市",
                    gisGcj02Lat: 38.3442,
                    gisGcj02Lng: 114.69,
                  },
                ],
              },
              {
                id: "130200",
                text: "唐山市",
                children: [
                  {
                    id: "130202",
                    text: "路南区",
                    gisGcj02Lat: 39.625,
                    gisGcj02Lng: 118.154,
                  },
                  {
                    id: "130203",
                    text: "路北区",
                    gisGcj02Lat: 39.6244,
                    gisGcj02Lng: 118.201,
                  },
                  {
                    id: "130204",
                    text: "古冶区",
                    gisGcj02Lat: 39.7199,
                    gisGcj02Lng: 118.458,
                  },
                  {
                    id: "130205",
                    text: "开平区",
                    gisGcj02Lat: 39.6713,
                    gisGcj02Lng: 118.262,
                  },
                  {
                    id: "130207",
                    text: "丰南区",
                    gisGcj02Lat: 39.5648,
                    gisGcj02Lng: 118.113,
                  },
                  {
                    id: "130208",
                    text: "丰润区",
                    gisGcj02Lat: 39.8244,
                    gisGcj02Lng: 118.13,
                  },
                  {
                    id: "130209",
                    text: "曹妃甸区",
                    gisGcj02Lat: 39.2731,
                    gisGcj02Lng: 118.46,
                  },
                  {
                    id: "130223",
                    text: "滦县",
                    gisGcj02Lat: 39.7406,
                    gisGcj02Lng: 118.703,
                  },
                  {
                    id: "130224",
                    text: "滦南县",
                    gisGcj02Lat: 39.5039,
                    gisGcj02Lng: 118.674,
                  },
                  {
                    id: "130225",
                    text: "乐亭县",
                    gisGcj02Lat: 39.4256,
                    gisGcj02Lng: 118.912,
                  },
                  {
                    id: "130227",
                    text: "迁西县",
                    gisGcj02Lat: 40.1459,
                    gisGcj02Lng: 118.316,
                  },
                  {
                    id: "130229",
                    text: "玉田县",
                    gisGcj02Lat: 39.9005,
                    gisGcj02Lng: 117.739,
                  },
                  {
                    id: "130281",
                    text: "遵化市",
                    gisGcj02Lat: 40.1874,
                    gisGcj02Lng: 117.964,
                  },
                  {
                    id: "130283",
                    text: "迁安市",
                    gisGcj02Lat: 39.9983,
                    gisGcj02Lng: 118.701,
                  },
                ],
              },
              {
                id: "130300",
                text: "秦皇岛市",
                children: [
                  {
                    id: "130302",
                    text: "海港区",
                    gisGcj02Lat: 39.9345,
                    gisGcj02Lng: 119.61,
                  },
                  {
                    id: "130303",
                    text: "山海关区",
                    gisGcj02Lat: 39.9787,
                    gisGcj02Lng: 119.776,
                  },
                  {
                    id: "130304",
                    text: "北戴河区",
                    gisGcj02Lat: 39.8341,
                    gisGcj02Lng: 119.484,
                  },
                  {
                    id: "130321",
                    text: "青龙满族自治县",
                    gisGcj02Lat: 40.4074,
                    gisGcj02Lng: 118.952,
                  },
                  {
                    id: "130322",
                    text: "昌黎县",
                    gisGcj02Lat: 39.7088,
                    gisGcj02Lng: 119.166,
                  },
                  {
                    id: "130323",
                    text: "抚宁区",
                    gisGcj02Lat: 39.8754,
                    gisGcj02Lng: 119.245,
                  },
                  {
                    id: "130324",
                    text: "卢龙县",
                    gisGcj02Lat: 39.8918,
                    gisGcj02Lng: 118.893,
                  },
                ],
              },
              {
                id: "130400",
                text: "邯郸市",
                children: [
                  {
                    id: "130402",
                    text: "邯山区",
                    gisGcj02Lat: 36.6001,
                    gisGcj02Lng: 114.484,
                  },
                  {
                    id: "130403",
                    text: "丛台区",
                    gisGcj02Lat: 36.6185,
                    gisGcj02Lng: 114.493,
                  },
                  {
                    id: "130404",
                    text: "复兴区",
                    gisGcj02Lat: 36.6113,
                    gisGcj02Lng: 114.459,
                  },
                  {
                    id: "130406",
                    text: "峰峰矿区",
                    gisGcj02Lat: 36.4194,
                    gisGcj02Lng: 114.211,
                  },
                  {
                    id: "130421",
                    text: "邯郸县",
                    gisGcj02Lat: 36.5938,
                    gisGcj02Lng: 114.531,
                  },
                  {
                    id: "130423",
                    text: "临漳县",
                    gisGcj02Lat: 36.3346,
                    gisGcj02Lng: 114.619,
                  },
                  {
                    id: "130424",
                    text: "成安县",
                    gisGcj02Lat: 36.4441,
                    gisGcj02Lng: 114.67,
                  },
                  {
                    id: "130425",
                    text: "大名县",
                    gisGcj02Lat: 36.2799,
                    gisGcj02Lng: 115.154,
                  },
                  {
                    id: "130426",
                    text: "涉县",
                    gisGcj02Lat: 36.5807,
                    gisGcj02Lng: 113.692,
                  },
                  {
                    id: "130427",
                    text: "磁县",
                    gisGcj02Lat: 36.3739,
                    gisGcj02Lng: 114.374,
                  },
                  {
                    id: "130428",
                    text: "肥乡区",
                    gisGcj02Lat: 36.5481,
                    gisGcj02Lng: 114.8,
                  },
                  {
                    id: "130429",
                    text: "永年区",
                    gisGcj02Lat: 36.7836,
                    gisGcj02Lng: 114.489,
                  },
                  {
                    id: "130430",
                    text: "邱县",
                    gisGcj02Lat: 36.8208,
                    gisGcj02Lng: 115.174,
                  },
                  {
                    id: "130431",
                    text: "鸡泽县",
                    gisGcj02Lat: 36.9237,
                    gisGcj02Lng: 114.874,
                  },
                  {
                    id: "130432",
                    text: "广平县",
                    gisGcj02Lat: 36.4805,
                    gisGcj02Lng: 114.947,
                  },
                  {
                    id: "130433",
                    text: "馆陶县",
                    gisGcj02Lat: 36.5372,
                    gisGcj02Lng: 115.299,
                  },
                  {
                    id: "130434",
                    text: "魏县",
                    gisGcj02Lat: 36.3617,
                    gisGcj02Lng: 114.935,
                  },
                  {
                    id: "130435",
                    text: "曲周县",
                    gisGcj02Lat: 36.7767,
                    gisGcj02Lng: 114.952,
                  },
                  {
                    id: "130481",
                    text: "武安市",
                    gisGcj02Lat: 36.6928,
                    gisGcj02Lng: 114.202,
                  },
                ],
              },
              {
                id: "130500",
                text: "邢台市",
                children: [
                  {
                    id: "130502",
                    text: "襄都区",
                    gisGcj02Lat: 37.068,
                    gisGcj02Lng: 114.507,
                  },
                  {
                    id: "130503",
                    text: "信都区",
                    gisGcj02Lat: 37.0598,
                    gisGcj02Lng: 114.468,
                  },
                  {
                    id: "130521",
                    text: "邢台县",
                    gisGcj02Lat: 37.0456,
                    gisGcj02Lng: 114.566,
                  },
                  {
                    id: "130522",
                    text: "临城县",
                    gisGcj02Lat: 37.4398,
                    gisGcj02Lng: 114.504,
                  },
                  {
                    id: "130523",
                    text: "内丘县",
                    gisGcj02Lat: 37.2867,
                    gisGcj02Lng: 114.512,
                  },
                  {
                    id: "130524",
                    text: "柏乡县",
                    gisGcj02Lat: 37.4824,
                    gisGcj02Lng: 114.693,
                  },
                  {
                    id: "130525",
                    text: "隆尧县",
                    gisGcj02Lat: 37.3535,
                    gisGcj02Lng: 114.776,
                  },
                  {
                    id: "130526",
                    text: "任泽区",
                    gisGcj02Lat: 37.1258,
                    gisGcj02Lng: 114.684,
                  },
                  {
                    id: "130527",
                    text: "南和区",
                    gisGcj02Lat: 37.0049,
                    gisGcj02Lng: 114.684,
                  },
                  {
                    id: "130528",
                    text: "宁晋县",
                    gisGcj02Lat: 37.617,
                    gisGcj02Lng: 114.921,
                  },
                  {
                    id: "130529",
                    text: "巨鹿县",
                    gisGcj02Lat: 37.218,
                    gisGcj02Lng: 115.035,
                  },
                  {
                    id: "130530",
                    text: "新河县",
                    gisGcj02Lat: 37.5272,
                    gisGcj02Lng: 115.25,
                  },
                  {
                    id: "130531",
                    text: "广宗县",
                    gisGcj02Lat: 37.0746,
                    gisGcj02Lng: 115.143,
                  },
                  {
                    id: "130532",
                    text: "平乡县",
                    gisGcj02Lat: 37.0632,
                    gisGcj02Lng: 115.03,
                  },
                  {
                    id: "130533",
                    text: "威县",
                    gisGcj02Lat: 36.9768,
                    gisGcj02Lng: 115.264,
                  },
                  {
                    id: "130534",
                    text: "清河县",
                    gisGcj02Lat: 37.0712,
                    gisGcj02Lng: 115.665,
                  },
                  {
                    id: "130535",
                    text: "临西县",
                    gisGcj02Lat: 36.8708,
                    gisGcj02Lng: 115.501,
                  },
                  {
                    id: "130581",
                    text: "南宫市",
                    gisGcj02Lat: 37.358,
                    gisGcj02Lng: 115.391,
                  },
                  {
                    id: "130582",
                    text: "沙河市",
                    gisGcj02Lat: 36.8577,
                    gisGcj02Lng: 114.498,
                  },
                ],
              },
              {
                id: "130600",
                text: "保定市",
                children: [
                  {
                    id: "130602",
                    text: "新市区",
                    gisGcj02Lat: 38.8775,
                    gisGcj02Lng: 115.459,
                  },
                  {
                    id: "130603",
                    text: "北市区",
                    gisGcj02Lat: 38.8832,
                    gisGcj02Lng: 115.497,
                  },
                  {
                    id: "130604",
                    text: "南市区",
                    gisGcj02Lat: 38.8545,
                    gisGcj02Lng: 115.529,
                  },
                  {
                    id: "130621",
                    text: "满城县",
                    gisGcj02Lat: 38.9497,
                    gisGcj02Lng: 115.323,
                  },
                  {
                    id: "130622",
                    text: "清苑县",
                    gisGcj02Lat: 38.7671,
                    gisGcj02Lng: 115.493,
                  },
                  {
                    id: "130623",
                    text: "涞水县",
                    gisGcj02Lat: 39.394,
                    gisGcj02Lng: 115.715,
                  },
                  {
                    id: "130624",
                    text: "阜平县",
                    gisGcj02Lat: 38.8476,
                    gisGcj02Lng: 114.197,
                  },
                  {
                    id: "130625",
                    text: "徐水县",
                    gisGcj02Lat: 39.021,
                    gisGcj02Lng: 115.658,
                  },
                  {
                    id: "130626",
                    text: "定兴县",
                    gisGcj02Lat: 39.2631,
                    gisGcj02Lng: 115.808,
                  },
                  {
                    id: "130627",
                    text: "唐县",
                    gisGcj02Lat: 38.7451,
                    gisGcj02Lng: 114.985,
                  },
                  {
                    id: "130628",
                    text: "高阳县",
                    gisGcj02Lat: 38.7,
                    gisGcj02Lng: 115.779,
                  },
                  {
                    id: "130629",
                    text: "容城县",
                    gisGcj02Lat: 39.0535,
                    gisGcj02Lng: 115.872,
                  },
                  {
                    id: "130630",
                    text: "涞源县",
                    gisGcj02Lat: 39.3539,
                    gisGcj02Lng: 114.691,
                  },
                  {
                    id: "130631",
                    text: "望都县",
                    gisGcj02Lat: 38.71,
                    gisGcj02Lng: 115.157,
                  },
                  {
                    id: "130632",
                    text: "安新县",
                    gisGcj02Lat: 38.9353,
                    gisGcj02Lng: 115.936,
                  },
                  {
                    id: "130633",
                    text: "易县",
                    gisGcj02Lat: 39.3489,
                    gisGcj02Lng: 115.498,
                  },
                  {
                    id: "130634",
                    text: "曲阳县",
                    gisGcj02Lat: 38.6215,
                    gisGcj02Lng: 114.701,
                  },
                  {
                    id: "130635",
                    text: "蠡县",
                    gisGcj02Lat: 38.4897,
                    gisGcj02Lng: 115.577,
                  },
                  {
                    id: "130636",
                    text: "顺平县",
                    gisGcj02Lat: 38.8385,
                    gisGcj02Lng: 115.135,
                  },
                  {
                    id: "130637",
                    text: "博野县",
                    gisGcj02Lat: 38.4564,
                    gisGcj02Lng: 115.47,
                  },
                  {
                    id: "130638",
                    text: "雄县",
                    gisGcj02Lat: 38.9944,
                    gisGcj02Lng: 116.109,
                  },
                  {
                    id: "130681",
                    text: "涿州市",
                    gisGcj02Lat: 39.4862,
                    gisGcj02Lng: 115.981,
                  },
                  {
                    id: "130682",
                    text: "定州市",
                    gisGcj02Lat: 38.5162,
                    gisGcj02Lng: 114.99,
                  },
                  {
                    id: "130683",
                    text: "安国市",
                    gisGcj02Lat: 38.4139,
                    gisGcj02Lng: 115.323,
                  },
                  {
                    id: "130684",
                    text: "高碑店市",
                    gisGcj02Lat: 39.3265,
                    gisGcj02Lng: 115.874,
                  },
                ],
              },
              {
                id: "130700",
                text: "张家口市",
                children: [
                  {
                    id: "130702",
                    text: "桥东区",
                    gisGcj02Lat: 40.7884,
                    gisGcj02Lng: 114.894,
                  },
                  {
                    id: "130703",
                    text: "桥西区",
                    gisGcj02Lat: 40.8195,
                    gisGcj02Lng: 114.87,
                  },
                  {
                    id: "130705",
                    text: "宣化区",
                    gisGcj02Lat: 40.6096,
                    gisGcj02Lng: 115.065,
                  },
                  {
                    id: "130706",
                    text: "下花园区",
                    gisGcj02Lat: 40.5024,
                    gisGcj02Lng: 115.287,
                  },
                  {
                    id: "130721",
                    text: "宣化县",
                    gisGcj02Lat: 40.5662,
                    gisGcj02Lng: 115.155,
                  },
                  {
                    id: "130722",
                    text: "张北县",
                    gisGcj02Lat: 41.1598,
                    gisGcj02Lng: 114.714,
                  },
                  {
                    id: "130723",
                    text: "康保县",
                    gisGcj02Lat: 41.8522,
                    gisGcj02Lng: 114.6,
                  },
                  {
                    id: "130724",
                    text: "沽源县",
                    gisGcj02Lat: 41.6696,
                    gisGcj02Lng: 115.689,
                  },
                  {
                    id: "130725",
                    text: "尚义县",
                    gisGcj02Lat: 41.0778,
                    gisGcj02Lng: 113.971,
                  },
                  {
                    id: "130726",
                    text: "蔚县",
                    gisGcj02Lat: 39.8407,
                    gisGcj02Lng: 114.589,
                  },
                  {
                    id: "130727",
                    text: "阳原县",
                    gisGcj02Lat: 40.1036,
                    gisGcj02Lng: 114.151,
                  },
                  {
                    id: "130728",
                    text: "怀安县",
                    gisGcj02Lat: 40.6743,
                    gisGcj02Lng: 114.386,
                  },
                  {
                    id: "130729",
                    text: "万全区",
                    gisGcj02Lat: 40.7669,
                    gisGcj02Lng: 114.741,
                  },
                  {
                    id: "130730",
                    text: "怀来县",
                    gisGcj02Lat: 40.4154,
                    gisGcj02Lng: 115.518,
                  },
                  {
                    id: "130731",
                    text: "涿鹿县",
                    gisGcj02Lat: 40.3764,
                    gisGcj02Lng: 115.224,
                  },
                  {
                    id: "130732",
                    text: "赤城县",
                    gisGcj02Lat: 40.9144,
                    gisGcj02Lng: 115.832,
                  },
                  {
                    id: "130733",
                    text: "崇礼区",
                    gisGcj02Lat: 40.9752,
                    gisGcj02Lng: 115.28,
                  },
                ],
              },
              {
                id: "130800",
                text: "承德市",
                children: [
                  {
                    id: "130802",
                    text: "双桥区",
                    gisGcj02Lat: 40.9747,
                    gisGcj02Lng: 117.943,
                  },
                  {
                    id: "130803",
                    text: "双滦区",
                    gisGcj02Lat: 40.9538,
                    gisGcj02Lng: 117.745,
                  },
                  {
                    id: "130804",
                    text: "鹰手营子矿区",
                    gisGcj02Lat: 40.5474,
                    gisGcj02Lng: 117.66,
                  },
                  {
                    id: "130821",
                    text: "承德县",
                    gisGcj02Lat: 40.7699,
                    gisGcj02Lng: 118.176,
                  },
                  {
                    id: "130822",
                    text: "兴隆县",
                    gisGcj02Lat: 40.4171,
                    gisGcj02Lng: 117.501,
                  },
                  {
                    id: "130823",
                    text: "平泉县",
                    gisGcj02Lat: 41.0184,
                    gisGcj02Lng: 118.702,
                  },
                  {
                    id: "130824",
                    text: "滦平县",
                    gisGcj02Lat: 40.9415,
                    gisGcj02Lng: 117.333,
                  },
                  {
                    id: "130825",
                    text: "隆化县",
                    gisGcj02Lat: 41.3141,
                    gisGcj02Lng: 117.73,
                  },
                  {
                    id: "130826",
                    text: "丰宁满族自治县",
                    gisGcj02Lat: 41.2048,
                    gisGcj02Lng: 116.649,
                  },
                  {
                    id: "130827",
                    text: "宽城满族自治县",
                    gisGcj02Lat: 40.6083,
                    gisGcj02Lng: 118.492,
                  },
                  {
                    id: "130828",
                    text: "围场满族蒙古族自治县",
                    gisGcj02Lat: 41.9437,
                    gisGcj02Lng: 117.76,
                  },
                ],
              },
              {
                id: "130900",
                text: "沧州市",
                children: [
                  {
                    id: "130902",
                    text: "新华区",
                    gisGcj02Lat: 38.3144,
                    gisGcj02Lng: 116.866,
                  },
                  {
                    id: "130903",
                    text: "运河区",
                    gisGcj02Lat: 38.3135,
                    gisGcj02Lng: 116.857,
                  },
                  {
                    id: "130921",
                    text: "沧县",
                    gisGcj02Lat: 38.2936,
                    gisGcj02Lng: 116.878,
                  },
                  {
                    id: "130922",
                    text: "青县",
                    gisGcj02Lat: 38.5835,
                    gisGcj02Lng: 116.803,
                  },
                  {
                    id: "130923",
                    text: "东光县",
                    gisGcj02Lat: 37.8857,
                    gisGcj02Lng: 116.537,
                  },
                  {
                    id: "130924",
                    text: "海兴县",
                    gisGcj02Lat: 38.1396,
                    gisGcj02Lng: 117.498,
                  },
                  {
                    id: "130925",
                    text: "盐山县",
                    gisGcj02Lat: 38.0565,
                    gisGcj02Lng: 117.231,
                  },
                  {
                    id: "130926",
                    text: "肃宁县",
                    gisGcj02Lat: 38.4227,
                    gisGcj02Lng: 115.83,
                  },
                  {
                    id: "130927",
                    text: "南皮县",
                    gisGcj02Lat: 38.0411,
                    gisGcj02Lng: 116.702,
                  },
                  {
                    id: "130928",
                    text: "吴桥县",
                    gisGcj02Lat: 37.6255,
                    gisGcj02Lng: 116.385,
                  },
                  {
                    id: "130929",
                    text: "献县",
                    gisGcj02Lat: 38.1923,
                    gisGcj02Lng: 116.127,
                  },
                  {
                    id: "130930",
                    text: "孟村回族自治县",
                    gisGcj02Lat: 38.0534,
                    gisGcj02Lng: 117.104,
                  },
                  {
                    id: "130981",
                    text: "泊头市",
                    gisGcj02Lat: 38.0836,
                    gisGcj02Lng: 116.578,
                  },
                  {
                    id: "130982",
                    text: "任丘市",
                    gisGcj02Lat: 38.7112,
                    gisGcj02Lng: 116.103,
                  },
                  {
                    id: "130983",
                    text: "黄骅市",
                    gisGcj02Lat: 38.3706,
                    gisGcj02Lng: 117.339,
                  },
                  {
                    id: "130984",
                    text: "河间市",
                    gisGcj02Lat: 38.4455,
                    gisGcj02Lng: 116.099,
                  },
                ],
              },
              {
                id: "131000",
                text: "廊坊市",
                children: [
                  {
                    id: "131002",
                    text: "安次区",
                    gisGcj02Lat: 39.5206,
                    gisGcj02Lng: 116.703,
                  },
                  {
                    id: "131003",
                    text: "广阳区",
                    gisGcj02Lat: 39.5228,
                    gisGcj02Lng: 116.711,
                  },
                  {
                    id: "131022",
                    text: "固安县",
                    gisGcj02Lat: 39.4383,
                    gisGcj02Lng: 116.299,
                  },
                  {
                    id: "131023",
                    text: "永清县",
                    gisGcj02Lat: 39.3207,
                    gisGcj02Lng: 116.501,
                  },
                  {
                    id: "131024",
                    text: "香河县",
                    gisGcj02Lat: 39.7613,
                    gisGcj02Lng: 117.006,
                  },
                  {
                    id: "131025",
                    text: "大城县",
                    gisGcj02Lat: 38.7053,
                    gisGcj02Lng: 116.654,
                  },
                  {
                    id: "131026",
                    text: "文安县",
                    gisGcj02Lat: 38.8732,
                    gisGcj02Lng: 116.458,
                  },
                  {
                    id: "131028",
                    text: "大厂回族自治县",
                    gisGcj02Lat: 39.8865,
                    gisGcj02Lng: 116.989,
                  },
                  {
                    id: "131081",
                    text: "霸州市",
                    gisGcj02Lat: 39.1257,
                    gisGcj02Lng: 116.392,
                  },
                  {
                    id: "131082",
                    text: "三河市",
                    gisGcj02Lat: 39.9836,
                    gisGcj02Lng: 117.072,
                  },
                ],
              },
              {
                id: "131100",
                text: "衡水市",
                children: [
                  {
                    id: "131102",
                    text: "桃城区",
                    gisGcj02Lat: 37.735,
                    gisGcj02Lng: 115.675,
                  },
                  {
                    id: "131121",
                    text: "枣强县",
                    gisGcj02Lat: 37.5103,
                    gisGcj02Lng: 115.726,
                  },
                  {
                    id: "131122",
                    text: "武邑县",
                    gisGcj02Lat: 37.8018,
                    gisGcj02Lng: 115.887,
                  },
                  {
                    id: "131123",
                    text: "武强县",
                    gisGcj02Lat: 38.0414,
                    gisGcj02Lng: 115.982,
                  },
                  {
                    id: "131124",
                    text: "饶阳县",
                    gisGcj02Lat: 38.2353,
                    gisGcj02Lng: 115.726,
                  },
                  {
                    id: "131125",
                    text: "安平县",
                    gisGcj02Lat: 38.2339,
                    gisGcj02Lng: 115.519,
                  },
                  {
                    id: "131126",
                    text: "故城县",
                    gisGcj02Lat: 37.3477,
                    gisGcj02Lng: 115.971,
                  },
                  {
                    id: "131127",
                    text: "景县",
                    gisGcj02Lat: 37.6926,
                    gisGcj02Lng: 116.269,
                  },
                  {
                    id: "131128",
                    text: "阜城县",
                    gisGcj02Lat: 37.8688,
                    gisGcj02Lng: 116.144,
                  },
                  {
                    id: "131181",
                    text: "冀州市",
                    gisGcj02Lat: 37.5508,
                    gisGcj02Lng: 115.579,
                  },
                  {
                    id: "131182",
                    text: "深州市",
                    gisGcj02Lat: 38.0011,
                    gisGcj02Lng: 115.56,
                  },
                  {
                    id: "131183",
                    text: "冀州区",
                    gisGcj02Lat: 37.5508,
                    gisGcj02Lng: 115.579,
                  },
                ],
              },
            ],
          },
          {
            id: "140000",
            text: "山西省",
            children: [
              {
                id: "140100",
                text: "太原市",
                children: [
                  {
                    id: "140105",
                    text: "小店区",
                    gisGcj02Lat: 37.7356,
                    gisGcj02Lng: 112.569,
                  },
                  {
                    id: "140106",
                    text: "迎泽区",
                    gisGcj02Lat: 37.8633,
                    gisGcj02Lng: 112.563,
                  },
                  {
                    id: "140107",
                    text: "杏花岭区",
                    gisGcj02Lat: 37.8843,
                    gisGcj02Lng: 112.562,
                  },
                  {
                    id: "140108",
                    text: "尖草坪区",
                    gisGcj02Lat: 37.9419,
                    gisGcj02Lng: 112.487,
                  },
                  {
                    id: "140109",
                    text: "万柏林区",
                    gisGcj02Lat: 37.8592,
                    gisGcj02Lng: 112.516,
                  },
                  {
                    id: "140110",
                    text: "晋源区",
                    gisGcj02Lat: 37.7248,
                    gisGcj02Lng: 112.48,
                  },
                  {
                    id: "140121",
                    text: "清徐县",
                    gisGcj02Lat: 37.6076,
                    gisGcj02Lng: 112.359,
                  },
                  {
                    id: "140122",
                    text: "阳曲县",
                    gisGcj02Lat: 38.0599,
                    gisGcj02Lng: 112.679,
                  },
                  {
                    id: "140123",
                    text: "娄烦县",
                    gisGcj02Lat: 38.0669,
                    gisGcj02Lng: 111.795,
                  },
                  {
                    id: "140181",
                    text: "古交市",
                    gisGcj02Lat: 37.9098,
                    gisGcj02Lng: 112.169,
                  },
                ],
              },
              {
                id: "140200",
                text: "大同市",
                children: [
                  {
                    id: "140202",
                    text: "城区",
                    gisGcj02Lat: 40.0757,
                    gisGcj02Lng: 113.298,
                  },
                  {
                    id: "140203",
                    text: "矿区",
                    gisGcj02Lat: 40.0368,
                    gisGcj02Lng: 113.177,
                  },
                  {
                    id: "140211",
                    text: "南郊区",
                    gisGcj02Lat: 40.0054,
                    gisGcj02Lng: 113.149,
                  },
                  {
                    id: "140212",
                    text: "新荣区",
                    gisGcj02Lat: 40.2562,
                    gisGcj02Lng: 113.135,
                  },
                  {
                    id: "140221",
                    text: "阳高县",
                    gisGcj02Lat: 40.3626,
                    gisGcj02Lng: 113.75,
                  },
                  {
                    id: "140222",
                    text: "天镇县",
                    gisGcj02Lat: 40.423,
                    gisGcj02Lng: 114.093,
                  },
                  {
                    id: "140223",
                    text: "广灵县",
                    gisGcj02Lat: 39.7608,
                    gisGcj02Lng: 114.282,
                  },
                  {
                    id: "140224",
                    text: "灵丘县",
                    gisGcj02Lat: 39.4404,
                    gisGcj02Lng: 114.237,
                  },
                  {
                    id: "140225",
                    text: "浑源县",
                    gisGcj02Lat: 39.6996,
                    gisGcj02Lng: 113.696,
                  },
                  {
                    id: "140226",
                    text: "左云县",
                    gisGcj02Lat: 40.0134,
                    gisGcj02Lng: 112.703,
                  },
                  {
                    id: "140227",
                    text: "大同县",
                    gisGcj02Lat: 40.0401,
                    gisGcj02Lng: 113.612,
                  },
                ],
              },
              {
                id: "140300",
                text: "阳泉市",
                children: [
                  {
                    id: "140302",
                    text: "城区",
                    gisGcj02Lat: 37.8474,
                    gisGcj02Lng: 113.601,
                  },
                  {
                    id: "140303",
                    text: "矿区",
                    gisGcj02Lat: 37.8689,
                    gisGcj02Lng: 113.557,
                  },
                  {
                    id: "140311",
                    text: "郊区",
                    gisGcj02Lat: 37.9414,
                    gisGcj02Lng: 113.585,
                  },
                  {
                    id: "140321",
                    text: "平定县",
                    gisGcj02Lat: 37.786,
                    gisGcj02Lng: 113.658,
                  },
                  {
                    id: "140322",
                    text: "盂县",
                    gisGcj02Lat: 38.0858,
                    gisGcj02Lng: 113.412,
                  },
                ],
              },
              {
                id: "140400",
                text: "长治市",
                children: [
                  {
                    id: "140402",
                    text: "城区",
                    gisGcj02Lat: 36.2035,
                    gisGcj02Lng: 113.123,
                  },
                  {
                    id: "140411",
                    text: "郊区",
                    gisGcj02Lat: 36.1992,
                    gisGcj02Lng: 113.127,
                  },
                  {
                    id: "140421",
                    text: "长治县",
                    gisGcj02Lat: 36.0472,
                    gisGcj02Lng: 113.048,
                  },
                  {
                    id: "140423",
                    text: "襄垣县",
                    gisGcj02Lat: 36.5353,
                    gisGcj02Lng: 113.052,
                  },
                  {
                    id: "140424",
                    text: "屯留县",
                    gisGcj02Lat: 36.3158,
                    gisGcj02Lng: 112.892,
                  },
                  {
                    id: "140425",
                    text: "平顺县",
                    gisGcj02Lat: 36.2001,
                    gisGcj02Lng: 113.436,
                  },
                  {
                    id: "140426",
                    text: "黎城县",
                    gisGcj02Lat: 36.503,
                    gisGcj02Lng: 113.388,
                  },
                  {
                    id: "140427",
                    text: "壶关县",
                    gisGcj02Lat: 36.113,
                    gisGcj02Lng: 113.207,
                  },
                  {
                    id: "140428",
                    text: "长子县",
                    gisGcj02Lat: 36.1213,
                    gisGcj02Lng: 112.877,
                  },
                  {
                    id: "140429",
                    text: "武乡县",
                    gisGcj02Lat: 36.8369,
                    gisGcj02Lng: 112.863,
                  },
                  {
                    id: "140430",
                    text: "沁县",
                    gisGcj02Lat: 36.7563,
                    gisGcj02Lng: 112.699,
                  },
                  {
                    id: "140431",
                    text: "沁源县",
                    gisGcj02Lat: 36.5001,
                    gisGcj02Lng: 112.338,
                  },
                  {
                    id: "140481",
                    text: "潞城市",
                    gisGcj02Lat: 36.3341,
                    gisGcj02Lng: 113.229,
                  },
                ],
              },
              {
                id: "140500",
                text: "晋城市",
                children: [
                  {
                    id: "140502",
                    text: "城区",
                    gisGcj02Lat: 35.5018,
                    gisGcj02Lng: 112.853,
                  },
                  {
                    id: "140521",
                    text: "沁水县",
                    gisGcj02Lat: 35.691,
                    gisGcj02Lng: 112.187,
                  },
                  {
                    id: "140522",
                    text: "阳城县",
                    gisGcj02Lat: 35.4861,
                    gisGcj02Lng: 112.415,
                  },
                  {
                    id: "140524",
                    text: "陵川县",
                    gisGcj02Lat: 35.7753,
                    gisGcj02Lng: 113.281,
                  },
                  {
                    id: "140525",
                    text: "泽州县",
                    gisGcj02Lat: 35.5079,
                    gisGcj02Lng: 112.839,
                  },
                  {
                    id: "140581",
                    text: "高平市",
                    gisGcj02Lat: 35.7971,
                    gisGcj02Lng: 112.923,
                  },
                ],
              },
              {
                id: "140600",
                text: "朔州市",
                children: [
                  {
                    id: "140602",
                    text: "朔城区",
                    gisGcj02Lat: 39.3198,
                    gisGcj02Lng: 112.432,
                  },
                  {
                    id: "140603",
                    text: "平鲁区",
                    gisGcj02Lat: 39.5116,
                    gisGcj02Lng: 112.288,
                  },
                  {
                    id: "140621",
                    text: "山阴县",
                    gisGcj02Lat: 39.527,
                    gisGcj02Lng: 112.817,
                  },
                  {
                    id: "140622",
                    text: "应县",
                    gisGcj02Lat: 39.5528,
                    gisGcj02Lng: 113.191,
                  },
                  {
                    id: "140623",
                    text: "右玉县",
                    gisGcj02Lat: 39.9901,
                    gisGcj02Lng: 112.469,
                  },
                  {
                    id: "140624",
                    text: "怀仁县",
                    gisGcj02Lat: 39.8281,
                    gisGcj02Lng: 113.1,
                  },
                ],
              },
              {
                id: "140700",
                text: "晋中市",
                children: [
                  {
                    id: "140702",
                    text: "榆次区",
                    gisGcj02Lat: 37.6978,
                    gisGcj02Lng: 112.708,
                  },
                  {
                    id: "140721",
                    text: "榆社县",
                    gisGcj02Lat: 37.0721,
                    gisGcj02Lng: 112.976,
                  },
                  {
                    id: "140722",
                    text: "左权县",
                    gisGcj02Lat: 37.0824,
                    gisGcj02Lng: 113.379,
                  },
                  {
                    id: "140723",
                    text: "和顺县",
                    gisGcj02Lat: 37.3296,
                    gisGcj02Lng: 113.57,
                  },
                  {
                    id: "140724",
                    text: "昔阳县",
                    gisGcj02Lat: 37.6186,
                    gisGcj02Lng: 113.705,
                  },
                  {
                    id: "140725",
                    text: "寿阳县",
                    gisGcj02Lat: 37.889,
                    gisGcj02Lng: 113.175,
                  },
                  {
                    id: "140726",
                    text: "太谷区",
                    gisGcj02Lat: 37.4216,
                    gisGcj02Lng: 112.552,
                  },
                  {
                    id: "140727",
                    text: "祁县",
                    gisGcj02Lat: 37.3579,
                    gisGcj02Lng: 112.334,
                  },
                  {
                    id: "140728",
                    text: "平遥县",
                    gisGcj02Lat: 37.1892,
                    gisGcj02Lng: 112.176,
                  },
                  {
                    id: "140729",
                    text: "灵石县",
                    gisGcj02Lat: 36.8481,
                    gisGcj02Lng: 111.777,
                  },
                  {
                    id: "140781",
                    text: "介休市",
                    gisGcj02Lat: 37.0277,
                    gisGcj02Lng: 111.918,
                  },
                ],
              },
              {
                id: "140800",
                text: "运城市",
                children: [
                  {
                    id: "140802",
                    text: "盐湖区",
                    gisGcj02Lat: 35.0151,
                    gisGcj02Lng: 110.998,
                  },
                  {
                    id: "140821",
                    text: "临猗县",
                    gisGcj02Lat: 35.1446,
                    gisGcj02Lng: 110.774,
                  },
                  {
                    id: "140822",
                    text: "万荣县",
                    gisGcj02Lat: 35.4156,
                    gisGcj02Lng: 110.837,
                  },
                  {
                    id: "140823",
                    text: "闻喜县",
                    gisGcj02Lat: 35.3555,
                    gisGcj02Lng: 111.223,
                  },
                  {
                    id: "140824",
                    text: "稷山县",
                    gisGcj02Lat: 35.5999,
                    gisGcj02Lng: 110.979,
                  },
                  {
                    id: "140825",
                    text: "新绛县",
                    gisGcj02Lat: 35.6157,
                    gisGcj02Lng: 111.225,
                  },
                  {
                    id: "140826",
                    text: "绛县",
                    gisGcj02Lat: 35.491,
                    gisGcj02Lng: 111.567,
                  },
                  {
                    id: "140827",
                    text: "垣曲县",
                    gisGcj02Lat: 35.2992,
                    gisGcj02Lng: 111.672,
                  },
                  {
                    id: "140828",
                    text: "夏县",
                    gisGcj02Lat: 35.1412,
                    gisGcj02Lng: 111.22,
                  },
                  {
                    id: "140829",
                    text: "平陆县",
                    gisGcj02Lat: 34.8377,
                    gisGcj02Lng: 111.217,
                  },
                  {
                    id: "140830",
                    text: "芮城县",
                    gisGcj02Lat: 34.6938,
                    gisGcj02Lng: 110.695,
                  },
                  {
                    id: "140881",
                    text: "永济市",
                    gisGcj02Lat: 34.8656,
                    gisGcj02Lng: 110.445,
                  },
                  {
                    id: "140882",
                    text: "河津市",
                    gisGcj02Lat: 35.5948,
                    gisGcj02Lng: 110.712,
                  },
                ],
              },
              {
                id: "140900",
                text: "忻州市",
                children: [
                  {
                    id: "140902",
                    text: "忻府区",
                    gisGcj02Lat: 38.4041,
                    gisGcj02Lng: 112.746,
                  },
                  {
                    id: "140921",
                    text: "定襄县",
                    gisGcj02Lat: 38.4739,
                    gisGcj02Lng: 112.957,
                  },
                  {
                    id: "140922",
                    text: "五台县",
                    gisGcj02Lat: 38.7277,
                    gisGcj02Lng: 113.253,
                  },
                  {
                    id: "140923",
                    text: "代县",
                    gisGcj02Lat: 39.0672,
                    gisGcj02Lng: 112.959,
                  },
                  {
                    id: "140924",
                    text: "繁峙县",
                    gisGcj02Lat: 39.1889,
                    gisGcj02Lng: 113.263,
                  },
                  {
                    id: "140925",
                    text: "宁武县",
                    gisGcj02Lat: 39.0021,
                    gisGcj02Lng: 112.304,
                  },
                  {
                    id: "140926",
                    text: "静乐县",
                    gisGcj02Lat: 38.3602,
                    gisGcj02Lng: 111.942,
                  },
                  {
                    id: "140927",
                    text: "神池县",
                    gisGcj02Lat: 39.09,
                    gisGcj02Lng: 112.205,
                  },
                  {
                    id: "140928",
                    text: "五寨县",
                    gisGcj02Lat: 38.9076,
                    gisGcj02Lng: 111.849,
                  },
                  {
                    id: "140929",
                    text: "岢岚县",
                    gisGcj02Lat: 38.7045,
                    gisGcj02Lng: 111.574,
                  },
                  {
                    id: "140930",
                    text: "河曲县",
                    gisGcj02Lat: 39.3844,
                    gisGcj02Lng: 111.138,
                  },
                  {
                    id: "140931",
                    text: "保德县",
                    gisGcj02Lat: 39.0225,
                    gisGcj02Lng: 111.087,
                  },
                  {
                    id: "140932",
                    text: "偏关县",
                    gisGcj02Lat: 39.4361,
                    gisGcj02Lng: 111.509,
                  },
                  {
                    id: "140981",
                    text: "原平市",
                    gisGcj02Lat: 38.7318,
                    gisGcj02Lng: 112.706,
                  },
                ],
              },
              {
                id: "141000",
                text: "临汾市",
                children: [
                  {
                    id: "141002",
                    text: "尧都区",
                    gisGcj02Lat: 36.083,
                    gisGcj02Lng: 111.579,
                  },
                  {
                    id: "141021",
                    text: "曲沃县",
                    gisGcj02Lat: 35.6412,
                    gisGcj02Lng: 111.475,
                  },
                  {
                    id: "141022",
                    text: "翼城县",
                    gisGcj02Lat: 35.7388,
                    gisGcj02Lng: 111.718,
                  },
                  {
                    id: "141023",
                    text: "襄汾县",
                    gisGcj02Lat: 35.8771,
                    gisGcj02Lng: 111.442,
                  },
                  {
                    id: "141024",
                    text: "洪洞县",
                    gisGcj02Lat: 36.2542,
                    gisGcj02Lng: 111.675,
                  },
                  {
                    id: "141025",
                    text: "古县",
                    gisGcj02Lat: 36.2669,
                    gisGcj02Lng: 111.92,
                  },
                  {
                    id: "141026",
                    text: "安泽县",
                    gisGcj02Lat: 36.148,
                    gisGcj02Lng: 112.25,
                  },
                  {
                    id: "141027",
                    text: "浮山县",
                    gisGcj02Lat: 35.9685,
                    gisGcj02Lng: 111.847,
                  },
                  {
                    id: "141028",
                    text: "吉县",
                    gisGcj02Lat: 36.0987,
                    gisGcj02Lng: 110.681,
                  },
                  {
                    id: "141029",
                    text: "乡宁县",
                    gisGcj02Lat: 35.9707,
                    gisGcj02Lng: 110.847,
                  },
                  {
                    id: "141030",
                    text: "大宁县",
                    gisGcj02Lat: 36.4662,
                    gisGcj02Lng: 110.752,
                  },
                  {
                    id: "141031",
                    text: "隰县",
                    gisGcj02Lat: 36.6926,
                    gisGcj02Lng: 110.939,
                  },
                  {
                    id: "141032",
                    text: "永和县",
                    gisGcj02Lat: 36.7584,
                    gisGcj02Lng: 110.632,
                  },
                  {
                    id: "141033",
                    text: "蒲县",
                    gisGcj02Lat: 36.4124,
                    gisGcj02Lng: 111.097,
                  },
                  {
                    id: "141034",
                    text: "汾西县",
                    gisGcj02Lat: 36.6506,
                    gisGcj02Lng: 111.568,
                  },
                  {
                    id: "141081",
                    text: "侯马市",
                    gisGcj02Lat: 35.619,
                    gisGcj02Lng: 111.372,
                  },
                  {
                    id: "141082",
                    text: "霍州市",
                    gisGcj02Lat: 36.5638,
                    gisGcj02Lng: 111.755,
                  },
                ],
              },
              {
                id: "141100",
                text: "吕梁市",
                children: [
                  {
                    id: "141102",
                    text: "离石区",
                    gisGcj02Lat: 37.5177,
                    gisGcj02Lng: 111.151,
                  },
                  {
                    id: "141121",
                    text: "文水县",
                    gisGcj02Lat: 37.4384,
                    gisGcj02Lng: 112.028,
                  },
                  {
                    id: "141122",
                    text: "交城县",
                    gisGcj02Lat: 37.5512,
                    gisGcj02Lng: 112.159,
                  },
                  {
                    id: "141123",
                    text: "兴县",
                    gisGcj02Lat: 38.4632,
                    gisGcj02Lng: 111.127,
                  },
                  {
                    id: "141124",
                    text: "临县",
                    gisGcj02Lat: 37.9527,
                    gisGcj02Lng: 110.993,
                  },
                  {
                    id: "141125",
                    text: "柳林县",
                    gisGcj02Lat: 37.4293,
                    gisGcj02Lng: 110.889,
                  },
                  {
                    id: "141126",
                    text: "石楼县",
                    gisGcj02Lat: 36.9973,
                    gisGcj02Lng: 110.835,
                  },
                  {
                    id: "141127",
                    text: "岚县",
                    gisGcj02Lat: 38.2787,
                    gisGcj02Lng: 111.676,
                  },
                  {
                    id: "141128",
                    text: "方山县",
                    gisGcj02Lat: 37.8898,
                    gisGcj02Lng: 111.24,
                  },
                  {
                    id: "141129",
                    text: "中阳县",
                    gisGcj02Lat: 37.3572,
                    gisGcj02Lng: 111.179,
                  },
                  {
                    id: "141130",
                    text: "交口县",
                    gisGcj02Lat: 36.9821,
                    gisGcj02Lng: 111.181,
                  },
                  {
                    id: "141181",
                    text: "孝义市",
                    gisGcj02Lat: 37.1441,
                    gisGcj02Lng: 111.774,
                  },
                  {
                    id: "141182",
                    text: "汾阳市",
                    gisGcj02Lat: 37.266,
                    gisGcj02Lng: 111.788,
                  },
                ],
              },
            ],
          },
          {
            id: "150000",
            text: "内蒙古",
            children: [
              {
                id: "150100",
                text: "呼和浩特市",
                children: [
                  {
                    id: "150102",
                    text: "新城区",
                    gisGcj02Lat: 40.8583,
                    gisGcj02Lng: 111.666,
                  },
                  {
                    id: "150103",
                    text: "回民区",
                    gisGcj02Lat: 40.8083,
                    gisGcj02Lng: 111.624,
                  },
                  {
                    id: "150104",
                    text: "玉泉区",
                    gisGcj02Lat: 40.7523,
                    gisGcj02Lng: 111.675,
                  },
                  {
                    id: "150105",
                    text: "赛罕区",
                    gisGcj02Lat: 40.7921,
                    gisGcj02Lng: 111.702,
                  },
                  {
                    id: "150121",
                    text: "土默特左旗",
                    gisGcj02Lat: 40.7223,
                    gisGcj02Lng: 111.149,
                  },
                  {
                    id: "150122",
                    text: "托克托县",
                    gisGcj02Lat: 40.2749,
                    gisGcj02Lng: 111.191,
                  },
                  {
                    id: "150123",
                    text: "和林格尔县",
                    gisGcj02Lat: 40.3789,
                    gisGcj02Lng: 111.822,
                  },
                  {
                    id: "150124",
                    text: "清水河县",
                    gisGcj02Lat: 39.9097,
                    gisGcj02Lng: 111.683,
                  },
                  {
                    id: "150125",
                    text: "武川县",
                    gisGcj02Lat: 41.0929,
                    gisGcj02Lng: 111.458,
                  },
                ],
              },
              {
                id: "150200",
                text: "包头市",
                children: [
                  {
                    id: "150202",
                    text: "东河区",
                    gisGcj02Lat: 40.5824,
                    gisGcj02Lng: 110.046,
                  },
                  {
                    id: "150203",
                    text: "昆都仑区",
                    gisGcj02Lat: 40.6418,
                    gisGcj02Lng: 109.839,
                  },
                  {
                    id: "150204",
                    text: "青山区",
                    gisGcj02Lat: 40.6433,
                    gisGcj02Lng: 109.901,
                  },
                  {
                    id: "150205",
                    text: "石拐区",
                    gisGcj02Lat: 40.673,
                    gisGcj02Lng: 110.273,
                  },
                  {
                    id: "150206",
                    text: "白云鄂博矿区",
                    gisGcj02Lat: 41.7697,
                    gisGcj02Lng: 109.974,
                  },
                  {
                    id: "150207",
                    text: "九原区",
                    gisGcj02Lat: 40.6055,
                    gisGcj02Lng: 109.965,
                  },
                  {
                    id: "150221",
                    text: "土默特右旗",
                    gisGcj02Lat: 40.5688,
                    gisGcj02Lng: 110.524,
                  },
                  {
                    id: "150222",
                    text: "固阳县",
                    gisGcj02Lat: 41.0185,
                    gisGcj02Lng: 110.064,
                  },
                  {
                    id: "150223",
                    text: "达尔罕茂明安联合旗",
                    gisGcj02Lat: 41.6987,
                    gisGcj02Lng: 110.433,
                  },
                ],
              },
              {
                id: "150300",
                text: "乌海市",
                children: [
                  {
                    id: "150302",
                    text: "海勃湾区",
                    gisGcj02Lat: 39.6696,
                    gisGcj02Lng: 106.822,
                  },
                  {
                    id: "150303",
                    text: "海南区",
                    gisGcj02Lat: 39.4413,
                    gisGcj02Lng: 106.887,
                  },
                  {
                    id: "150304",
                    text: "乌达区",
                    gisGcj02Lat: 39.505,
                    gisGcj02Lng: 106.727,
                  },
                ],
              },
              {
                id: "150400",
                text: "赤峰市",
                children: [
                  {
                    id: "150402",
                    text: "红山区",
                    gisGcj02Lat: 42.2431,
                    gisGcj02Lng: 118.958,
                  },
                  {
                    id: "150403",
                    text: "元宝山区",
                    gisGcj02Lat: 42.0401,
                    gisGcj02Lng: 119.289,
                  },
                  {
                    id: "150404",
                    text: "松山区",
                    gisGcj02Lat: 42.2861,
                    gisGcj02Lng: 118.933,
                  },
                  {
                    id: "150421",
                    text: "阿鲁科尔沁旗",
                    gisGcj02Lat: 43.8799,
                    gisGcj02Lng: 120.065,
                  },
                  {
                    id: "150422",
                    text: "巴林左旗",
                    gisGcj02Lat: 43.9703,
                    gisGcj02Lng: 119.38,
                  },
                  {
                    id: "150423",
                    text: "巴林右旗",
                    gisGcj02Lat: 43.5339,
                    gisGcj02Lng: 118.665,
                  },
                  {
                    id: "150424",
                    text: "林西县",
                    gisGcj02Lat: 43.6116,
                    gisGcj02Lng: 118.047,
                  },
                  {
                    id: "150425",
                    text: "克什克腾旗",
                    gisGcj02Lat: 43.265,
                    gisGcj02Lng: 117.546,
                  },
                  {
                    id: "150426",
                    text: "翁牛特旗",
                    gisGcj02Lat: 42.9315,
                    gisGcj02Lng: 119.03,
                  },
                  {
                    id: "150428",
                    text: "喀喇沁旗",
                    gisGcj02Lat: 41.9292,
                    gisGcj02Lng: 118.701,
                  },
                  {
                    id: "150429",
                    text: "宁城县",
                    gisGcj02Lat: 41.5966,
                    gisGcj02Lng: 119.344,
                  },
                  {
                    id: "150430",
                    text: "敖汉旗",
                    gisGcj02Lat: 42.2907,
                    gisGcj02Lng: 119.922,
                  },
                ],
              },
              {
                id: "150500",
                text: "通辽市",
                children: [
                  {
                    id: "150502",
                    text: "科尔沁区",
                    gisGcj02Lat: 43.6226,
                    gisGcj02Lng: 122.256,
                  },
                  {
                    id: "150521",
                    text: "科尔沁左翼中旗",
                    gisGcj02Lat: 44.1301,
                    gisGcj02Lng: 123.319,
                  },
                  {
                    id: "150522",
                    text: "科尔沁左翼后旗",
                    gisGcj02Lat: 42.949,
                    gisGcj02Lng: 122.357,
                  },
                  {
                    id: "150523",
                    text: "开鲁县",
                    gisGcj02Lat: 43.6,
                    gisGcj02Lng: 121.319,
                  },
                  {
                    id: "150524",
                    text: "库伦旗",
                    gisGcj02Lat: 42.73,
                    gisGcj02Lng: 121.776,
                  },
                  {
                    id: "150525",
                    text: "奈曼旗",
                    gisGcj02Lat: 42.8453,
                    gisGcj02Lng: 120.663,
                  },
                  {
                    id: "150526",
                    text: "扎鲁特旗",
                    gisGcj02Lat: 44.5559,
                    gisGcj02Lng: 120.915,
                  },
                  {
                    id: "150581",
                    text: "霍林郭勒市",
                    gisGcj02Lat: 45.5345,
                    gisGcj02Lng: 119.654,
                  },
                ],
              },
              {
                id: "150600",
                text: "鄂尔多斯市",
                children: [
                  {
                    id: "150602",
                    text: "东胜区",
                    gisGcj02Lat: 39.8224,
                    gisGcj02Lng: 109.963,
                  },
                  {
                    id: "150603",
                    text: "康巴什区",
                    gisGcj02Lat: 39.8224,
                    gisGcj02Lng: 109.963,
                  },
                  {
                    id: "150621",
                    text: "达拉特旗",
                    gisGcj02Lat: 40.4001,
                    gisGcj02Lng: 110.033,
                  },
                  {
                    id: "150622",
                    text: "准格尔旗",
                    gisGcj02Lat: 39.8678,
                    gisGcj02Lng: 111.236,
                  },
                  {
                    id: "150623",
                    text: "鄂托克前旗",
                    gisGcj02Lat: 38.184,
                    gisGcj02Lng: 107.484,
                  },
                  {
                    id: "150624",
                    text: "鄂托克旗",
                    gisGcj02Lat: 39.0946,
                    gisGcj02Lng: 107.982,
                  },
                  {
                    id: "150625",
                    text: "杭锦旗",
                    gisGcj02Lat: 39.8402,
                    gisGcj02Lng: 108.729,
                  },
                  {
                    id: "150626",
                    text: "乌审旗",
                    gisGcj02Lat: 38.5909,
                    gisGcj02Lng: 108.846,
                  },
                  {
                    id: "150627",
                    text: "伊金霍洛旗",
                    gisGcj02Lat: 39.5739,
                    gisGcj02Lng: 109.749,
                  },
                ],
              },
              {
                id: "150700",
                text: "呼伦贝尔市",
                children: [
                  {
                    id: "150702",
                    text: "海拉尔区",
                    gisGcj02Lat: 49.2122,
                    gisGcj02Lng: 119.736,
                  },
                  {
                    id: "150703",
                    text: "扎赉诺尔区",
                    gisGcj02Lat: 49.4869,
                    gisGcj02Lng: 117.793,
                  },
                  {
                    id: "150721",
                    text: "阿荣旗",
                    gisGcj02Lat: 48.1258,
                    gisGcj02Lng: 123.459,
                  },
                  {
                    id: "150722",
                    text: "莫力达瓦达斡尔族自治旗",
                    gisGcj02Lat: 48.4805,
                    gisGcj02Lng: 124.515,
                  },
                  {
                    id: "150723",
                    text: "鄂伦春自治旗",
                    gisGcj02Lat: 50.5978,
                    gisGcj02Lng: 123.726,
                  },
                  {
                    id: "150724",
                    text: "鄂温克族自治旗",
                    gisGcj02Lat: 49.1428,
                    gisGcj02Lng: 119.757,
                  },
                  {
                    id: "150725",
                    text: "陈巴尔虎旗",
                    gisGcj02Lat: 49.3268,
                    gisGcj02Lng: 119.424,
                  },
                  {
                    id: "150726",
                    text: "新巴尔虎左旗",
                    gisGcj02Lat: 48.2184,
                    gisGcj02Lng: 118.27,
                  },
                  {
                    id: "150727",
                    text: "新巴尔虎右旗",
                    gisGcj02Lat: 48.6647,
                    gisGcj02Lng: 116.824,
                  },
                  {
                    id: "150781",
                    text: "满洲里市",
                    gisGcj02Lat: 49.5827,
                    gisGcj02Lng: 117.479,
                  },
                  {
                    id: "150782",
                    text: "牙克石市",
                    gisGcj02Lat: 49.2856,
                    gisGcj02Lng: 120.712,
                  },
                  {
                    id: "150783",
                    text: "扎兰屯市",
                    gisGcj02Lat: 48.0136,
                    gisGcj02Lng: 122.738,
                  },
                  {
                    id: "150784",
                    text: "额尔古纳市",
                    gisGcj02Lat: 50.2425,
                    gisGcj02Lng: 120.191,
                  },
                  {
                    id: "150785",
                    text: "根河市",
                    gisGcj02Lat: 50.78,
                    gisGcj02Lng: 121.522,
                  },
                ],
              },
              {
                id: "150800",
                text: "巴彦淖尔市",
                children: [
                  {
                    id: "150802",
                    text: "临河区",
                    gisGcj02Lat: 40.7583,
                    gisGcj02Lng: 107.427,
                  },
                  {
                    id: "150821",
                    text: "五原县",
                    gisGcj02Lat: 41.0963,
                    gisGcj02Lng: 108.269,
                  },
                  {
                    id: "150822",
                    text: "磴口县",
                    gisGcj02Lat: 40.3306,
                    gisGcj02Lng: 107.009,
                  },
                  {
                    id: "150823",
                    text: "乌拉特前旗",
                    gisGcj02Lat: 40.7365,
                    gisGcj02Lng: 108.652,
                  },
                  {
                    id: "150824",
                    text: "乌拉特中旗",
                    gisGcj02Lat: 41.5679,
                    gisGcj02Lng: 108.526,
                  },
                  {
                    id: "150825",
                    text: "乌拉特后旗",
                    gisGcj02Lat: 41.4315,
                    gisGcj02Lng: 106.99,
                  },
                  {
                    id: "150826",
                    text: "杭锦后旗",
                    gisGcj02Lat: 40.8863,
                    gisGcj02Lng: 107.151,
                  },
                ],
              },
              {
                id: "150900",
                text: "乌兰察布市",
                children: [
                  {
                    id: "150902",
                    text: "集宁区",
                    gisGcj02Lat: 41.0353,
                    gisGcj02Lng: 113.115,
                  },
                  {
                    id: "150921",
                    text: "卓资县",
                    gisGcj02Lat: 40.8941,
                    gisGcj02Lng: 112.578,
                  },
                  {
                    id: "150922",
                    text: "化德县",
                    gisGcj02Lat: 41.9043,
                    gisGcj02Lng: 114.011,
                  },
                  {
                    id: "150923",
                    text: "商都县",
                    gisGcj02Lat: 41.5621,
                    gisGcj02Lng: 113.578,
                  },
                  {
                    id: "150924",
                    text: "兴和县",
                    gisGcj02Lat: 40.8719,
                    gisGcj02Lng: 113.834,
                  },
                  {
                    id: "150925",
                    text: "凉城县",
                    gisGcj02Lat: 40.5335,
                    gisGcj02Lng: 112.496,
                  },
                  {
                    id: "150926",
                    text: "察哈尔右翼前旗",
                    gisGcj02Lat: 40.7788,
                    gisGcj02Lng: 113.221,
                  },
                  {
                    id: "150927",
                    text: "察哈尔右翼中旗",
                    gisGcj02Lat: 41.2774,
                    gisGcj02Lng: 112.635,
                  },
                  {
                    id: "150928",
                    text: "察哈尔右翼后旗",
                    gisGcj02Lat: 41.4355,
                    gisGcj02Lng: 113.192,
                  },
                  {
                    id: "150929",
                    text: "四子王旗",
                    gisGcj02Lat: 41.5331,
                    gisGcj02Lng: 111.707,
                  },
                  {
                    id: "150981",
                    text: "丰镇市",
                    gisGcj02Lat: 40.4369,
                    gisGcj02Lng: 113.11,
                  },
                ],
              },
              {
                id: "152200",
                text: "兴安盟",
                children: [
                  {
                    id: "152201",
                    text: "乌兰浩特市",
                    gisGcj02Lat: 46.0624,
                    gisGcj02Lng: 122.064,
                  },
                  {
                    id: "152202",
                    text: "阿尔山市",
                    gisGcj02Lat: 47.1772,
                    gisGcj02Lng: 119.943,
                  },
                  {
                    id: "152221",
                    text: "科尔沁右翼前旗",
                    gisGcj02Lat: 46.0795,
                    gisGcj02Lng: 121.953,
                  },
                  {
                    id: "152222",
                    text: "科尔沁右翼中旗",
                    gisGcj02Lat: 45.056,
                    gisGcj02Lng: 121.468,
                  },
                  {
                    id: "152223",
                    text: "扎赉特旗",
                    gisGcj02Lat: 46.7267,
                    gisGcj02Lng: 122.912,
                  },
                  {
                    id: "152224",
                    text: "突泉县",
                    gisGcj02Lat: 45.3819,
                    gisGcj02Lng: 121.594,
                  },
                ],
              },
              {
                id: "152500",
                text: "锡林郭勒盟",
                children: [
                  {
                    id: "152501",
                    text: "二连浩特市",
                    gisGcj02Lat: 43.653,
                    gisGcj02Lng: 111.983,
                  },
                  {
                    id: "152502",
                    text: "锡林浩特市",
                    gisGcj02Lat: 43.9334,
                    gisGcj02Lng: 116.086,
                  },
                  {
                    id: "152522",
                    text: "阿巴嘎旗",
                    gisGcj02Lat: 44.0217,
                    gisGcj02Lng: 114.968,
                  },
                  {
                    id: "152523",
                    text: "苏尼特左旗",
                    gisGcj02Lat: 43.8569,
                    gisGcj02Lng: 113.651,
                  },
                  {
                    id: "152524",
                    text: "苏尼特右旗",
                    gisGcj02Lat: 42.7469,
                    gisGcj02Lng: 112.657,
                  },
                  {
                    id: "152525",
                    text: "东乌珠穆沁旗",
                    gisGcj02Lat: 45.5111,
                    gisGcj02Lng: 116.973,
                  },
                  {
                    id: "152526",
                    text: "西乌珠穆沁旗",
                    gisGcj02Lat: 44.5962,
                    gisGcj02Lng: 117.61,
                  },
                  {
                    id: "152527",
                    text: "太仆寺旗",
                    gisGcj02Lat: 41.8773,
                    gisGcj02Lng: 115.283,
                  },
                  {
                    id: "152528",
                    text: "镶黄旗",
                    gisGcj02Lat: 42.2393,
                    gisGcj02Lng: 113.845,
                  },
                  {
                    id: "152529",
                    text: "正镶白旗",
                    gisGcj02Lat: 42.3071,
                    gisGcj02Lng: 115.001,
                  },
                  {
                    id: "152530",
                    text: "正蓝旗",
                    gisGcj02Lat: 42.2523,
                    gisGcj02Lng: 116.004,
                  },
                  {
                    id: "152531",
                    text: "多伦县",
                    gisGcj02Lat: 42.203,
                    gisGcj02Lng: 116.486,
                  },
                ],
              },
              {
                id: "152900",
                text: "阿拉善盟",
                children: [
                  {
                    id: "152921",
                    text: "阿拉善左旗",
                    gisGcj02Lat: 38.8293,
                    gisGcj02Lng: 105.675,
                  },
                  {
                    id: "152922",
                    text: "阿拉善右旗",
                    gisGcj02Lat: 39.2153,
                    gisGcj02Lng: 101.667,
                  },
                  {
                    id: "152923",
                    text: "额济纳旗",
                    gisGcj02Lat: 41.9675,
                    gisGcj02Lng: 101.069,
                  },
                ],
              },
            ],
          },
          {
            id: "210000",
            text: "辽宁省",
            children: [
              {
                id: "210100",
                text: "沈阳市",
                children: [
                  {
                    id: "210102",
                    text: "和平区",
                    gisGcj02Lat: 41.79,
                    gisGcj02Lng: 123.42,
                  },
                  {
                    id: "210103",
                    text: "沈河区",
                    gisGcj02Lat: 41.7962,
                    gisGcj02Lng: 123.459,
                  },
                  {
                    id: "210104",
                    text: "大东区",
                    gisGcj02Lat: 41.8054,
                    gisGcj02Lng: 123.47,
                  },
                  {
                    id: "210105",
                    text: "皇姑区",
                    gisGcj02Lat: 41.8204,
                    gisGcj02Lng: 123.425,
                  },
                  {
                    id: "210106",
                    text: "铁西区",
                    gisGcj02Lat: 41.8027,
                    gisGcj02Lng: 123.377,
                  },
                  {
                    id: "210111",
                    text: "苏家屯区",
                    gisGcj02Lat: 41.6647,
                    gisGcj02Lng: 123.344,
                  },
                  {
                    id: "210112",
                    text: "浑南区",
                    gisGcj02Lat: 41.7195,
                    gisGcj02Lng: 123.458,
                  },
                  {
                    id: "210113",
                    text: "沈北新区",
                    gisGcj02Lat: 42.053,
                    gisGcj02Lng: 123.527,
                  },
                  {
                    id: "210114",
                    text: "于洪区",
                    gisGcj02Lat: 41.794,
                    gisGcj02Lng: 123.308,
                  },
                  {
                    id: "210122",
                    text: "辽中区",
                    gisGcj02Lat: 41.513,
                    gisGcj02Lng: 122.727,
                  },
                  {
                    id: "210123",
                    text: "康平县",
                    gisGcj02Lat: 42.7508,
                    gisGcj02Lng: 123.354,
                  },
                  {
                    id: "210124",
                    text: "法库县",
                    gisGcj02Lat: 42.5061,
                    gisGcj02Lng: 123.412,
                  },
                  {
                    id: "210181",
                    text: "新民市",
                    gisGcj02Lat: 41.9985,
                    gisGcj02Lng: 122.829,
                  },
                ],
              },
              {
                id: "210200",
                text: "大连市",
                children: [
                  {
                    id: "210202",
                    text: "中山区",
                    gisGcj02Lat: 38.9186,
                    gisGcj02Lng: 121.645,
                  },
                  {
                    id: "210203",
                    text: "西岗区",
                    gisGcj02Lat: 38.9147,
                    gisGcj02Lng: 121.612,
                  },
                  {
                    id: "210204",
                    text: "沙河口区",
                    gisGcj02Lat: 38.9054,
                    gisGcj02Lng: 121.58,
                  },
                  {
                    id: "210211",
                    text: "甘井子区",
                    gisGcj02Lat: 38.9502,
                    gisGcj02Lng: 121.566,
                  },
                  {
                    id: "210212",
                    text: "旅顺口区",
                    gisGcj02Lat: 38.8512,
                    gisGcj02Lng: 121.262,
                  },
                  {
                    id: "210213",
                    text: "金州区",
                    gisGcj02Lat: 39.1004,
                    gisGcj02Lng: 121.719,
                  },
                  {
                    id: "210224",
                    text: "长海县",
                    gisGcj02Lat: 39.2727,
                    gisGcj02Lng: 122.589,
                  },
                  {
                    id: "210281",
                    text: "瓦房店市",
                    gisGcj02Lat: 39.6284,
                    gisGcj02Lng: 121.981,
                  },
                  {
                    id: "210282",
                    text: "普兰店市",
                    gisGcj02Lat: 39.3946,
                    gisGcj02Lng: 121.963,
                  },
                  {
                    id: "210283",
                    text: "庄河市",
                    gisGcj02Lat: 39.6881,
                    gisGcj02Lng: 122.967,
                  },
                ],
              },
              {
                id: "210300",
                text: "鞍山市",
                children: [
                  {
                    id: "210302",
                    text: "铁东区",
                    gisGcj02Lat: 41.0897,
                    gisGcj02Lng: 122.991,
                  },
                  {
                    id: "210303",
                    text: "铁西区",
                    gisGcj02Lat: 41.1198,
                    gisGcj02Lng: 122.97,
                  },
                  {
                    id: "210304",
                    text: "立山区",
                    gisGcj02Lat: 41.1501,
                    gisGcj02Lng: 123.029,
                  },
                  {
                    id: "210311",
                    text: "千山区",
                    gisGcj02Lat: 41.0751,
                    gisGcj02Lng: 122.96,
                  },
                  {
                    id: "210321",
                    text: "台安县",
                    gisGcj02Lat: 41.4127,
                    gisGcj02Lng: 122.436,
                  },
                  {
                    id: "210323",
                    text: "岫岩满族自治县",
                    gisGcj02Lat: 40.28,
                    gisGcj02Lng: 123.289,
                  },
                  {
                    id: "210381",
                    text: "海城市",
                    gisGcj02Lat: 40.8814,
                    gisGcj02Lng: 122.685,
                  },
                ],
              },
              {
                id: "210400",
                text: "抚顺市",
                children: [
                  {
                    id: "210402",
                    text: "新抚区",
                    gisGcj02Lat: 41.862,
                    gisGcj02Lng: 123.913,
                  },
                  {
                    id: "210403",
                    text: "东洲区",
                    gisGcj02Lat: 41.8519,
                    gisGcj02Lng: 124.038,
                  },
                  {
                    id: "210404",
                    text: "望花区",
                    gisGcj02Lat: 41.8553,
                    gisGcj02Lng: 123.783,
                  },
                  {
                    id: "210411",
                    text: "顺城区",
                    gisGcj02Lat: 41.8832,
                    gisGcj02Lng: 123.945,
                  },
                  {
                    id: "210421",
                    text: "抚顺县",
                    gisGcj02Lat: 41.7122,
                    gisGcj02Lng: 124.178,
                  },
                  {
                    id: "210422",
                    text: "新宾满族自治县",
                    gisGcj02Lat: 41.7341,
                    gisGcj02Lng: 125.04,
                  },
                  {
                    id: "210423",
                    text: "清原满族自治县",
                    gisGcj02Lat: 42.1022,
                    gisGcj02Lng: 124.928,
                  },
                ],
              },
              {
                id: "210500",
                text: "本溪市",
                children: [
                  {
                    id: "210502",
                    text: "平山区",
                    gisGcj02Lat: 41.2997,
                    gisGcj02Lng: 123.769,
                  },
                  {
                    id: "210503",
                    text: "溪湖区",
                    gisGcj02Lat: 41.3292,
                    gisGcj02Lng: 123.768,
                  },
                  {
                    id: "210504",
                    text: "明山区",
                    gisGcj02Lat: 41.3083,
                    gisGcj02Lng: 123.817,
                  },
                  {
                    id: "210505",
                    text: "南芬区",
                    gisGcj02Lat: 41.1006,
                    gisGcj02Lng: 123.745,
                  },
                  {
                    id: "210521",
                    text: "本溪满族自治县",
                    gisGcj02Lat: 41.3006,
                    gisGcj02Lng: 124.127,
                  },
                  {
                    id: "210522",
                    text: "桓仁满族自治县",
                    gisGcj02Lat: 41.268,
                    gisGcj02Lng: 125.361,
                  },
                ],
              },
              {
                id: "210600",
                text: "丹东市",
                children: [
                  {
                    id: "210602",
                    text: "元宝区",
                    gisGcj02Lat: 40.1365,
                    gisGcj02Lng: 124.396,
                  },
                  {
                    id: "210603",
                    text: "振兴区",
                    gisGcj02Lat: 40.1049,
                    gisGcj02Lng: 124.36,
                  },
                  {
                    id: "210604",
                    text: "振安区",
                    gisGcj02Lat: 40.1583,
                    gisGcj02Lng: 124.428,
                  },
                  {
                    id: "210624",
                    text: "宽甸满族自治县",
                    gisGcj02Lat: 40.7319,
                    gisGcj02Lng: 124.782,
                  },
                  {
                    id: "210681",
                    text: "东港市",
                    gisGcj02Lat: 39.8626,
                    gisGcj02Lng: 124.163,
                  },
                  {
                    id: "210682",
                    text: "凤城市",
                    gisGcj02Lat: 40.453,
                    gisGcj02Lng: 124.067,
                  },
                ],
              },
              {
                id: "210700",
                text: "锦州市",
                children: [
                  {
                    id: "210702",
                    text: "古塔区",
                    gisGcj02Lat: 41.1172,
                    gisGcj02Lng: 121.128,
                  },
                  {
                    id: "210703",
                    text: "凌河区",
                    gisGcj02Lat: 41.115,
                    gisGcj02Lng: 121.151,
                  },
                  {
                    id: "210711",
                    text: "太和区",
                    gisGcj02Lat: 41.1093,
                    gisGcj02Lng: 121.104,
                  },
                  {
                    id: "210726",
                    text: "黑山县",
                    gisGcj02Lat: 41.6942,
                    gisGcj02Lng: 122.121,
                  },
                  {
                    id: "210727",
                    text: "义县",
                    gisGcj02Lat: 41.5346,
                    gisGcj02Lng: 121.24,
                  },
                  {
                    id: "210781",
                    text: "凌海市",
                    gisGcj02Lat: 41.1737,
                    gisGcj02Lng: 121.357,
                  },
                  {
                    id: "210782",
                    text: "北镇市",
                    gisGcj02Lat: 41.5954,
                    gisGcj02Lng: 121.799,
                  },
                ],
              },
              {
                id: "210800",
                text: "营口市",
                children: [
                  {
                    id: "210802",
                    text: "站前区",
                    gisGcj02Lat: 40.6727,
                    gisGcj02Lng: 122.259,
                  },
                  {
                    id: "210803",
                    text: "西市区",
                    gisGcj02Lat: 40.6664,
                    gisGcj02Lng: 122.206,
                  },
                  {
                    id: "210804",
                    text: "鲅鱼圈区",
                    gisGcj02Lat: 40.2687,
                    gisGcj02Lng: 122.133,
                  },
                  {
                    id: "210811",
                    text: "老边区",
                    gisGcj02Lat: 40.6803,
                    gisGcj02Lng: 122.38,
                  },
                  {
                    id: "210881",
                    text: "盖州市",
                    gisGcj02Lat: 40.4045,
                    gisGcj02Lng: 122.355,
                  },
                  {
                    id: "210882",
                    text: "大石桥市",
                    gisGcj02Lat: 40.6457,
                    gisGcj02Lng: 122.509,
                  },
                ],
              },
              {
                id: "210900",
                text: "阜新市",
                children: [
                  {
                    id: "210902",
                    text: "海州区",
                    gisGcj02Lat: 42.0134,
                    gisGcj02Lng: 121.656,
                  },
                  {
                    id: "210903",
                    text: "新邱区",
                    gisGcj02Lat: 42.0918,
                    gisGcj02Lng: 121.793,
                  },
                  {
                    id: "210904",
                    text: "太平区",
                    gisGcj02Lat: 42.0107,
                    gisGcj02Lng: 121.679,
                  },
                  {
                    id: "210905",
                    text: "清河门区",
                    gisGcj02Lat: 41.7831,
                    gisGcj02Lng: 121.416,
                  },
                  {
                    id: "210911",
                    text: "细河区",
                    gisGcj02Lat: 42.0253,
                    gisGcj02Lng: 121.68,
                  },
                  {
                    id: "210921",
                    text: "阜新蒙古族自治县",
                    gisGcj02Lat: 42.0651,
                    gisGcj02Lng: 121.758,
                  },
                  {
                    id: "210922",
                    text: "彰武县",
                    gisGcj02Lat: 42.3862,
                    gisGcj02Lng: 122.54,
                  },
                ],
              },
              {
                id: "211000",
                text: "辽阳市",
                children: [
                  {
                    id: "211002",
                    text: "白塔区",
                    gisGcj02Lat: 41.2702,
                    gisGcj02Lng: 123.175,
                  },
                  {
                    id: "211003",
                    text: "文圣区",
                    gisGcj02Lat: 41.2627,
                    gisGcj02Lng: 123.185,
                  },
                  {
                    id: "211004",
                    text: "宏伟区",
                    gisGcj02Lat: 41.2185,
                    gisGcj02Lng: 123.193,
                  },
                  {
                    id: "211005",
                    text: "弓长岭区",
                    gisGcj02Lat: 41.1518,
                    gisGcj02Lng: 123.42,
                  },
                  {
                    id: "211011",
                    text: "太子河区",
                    gisGcj02Lat: 41.2534,
                    gisGcj02Lng: 123.182,
                  },
                  {
                    id: "211021",
                    text: "辽阳县",
                    gisGcj02Lat: 41.2054,
                    gisGcj02Lng: 123.106,
                  },
                  {
                    id: "211081",
                    text: "灯塔市",
                    gisGcj02Lat: 41.4261,
                    gisGcj02Lng: 123.339,
                  },
                ],
              },
              {
                id: "211100",
                text: "盘锦市",
                children: [
                  {
                    id: "211102",
                    text: "双台子区",
                    gisGcj02Lat: 41.1906,
                    gisGcj02Lng: 122.06,
                  },
                  {
                    id: "211103",
                    text: "兴隆台区",
                    gisGcj02Lat: 41.124,
                    gisGcj02Lng: 122.075,
                  },
                  {
                    id: "211121",
                    text: "大洼县",
                    gisGcj02Lat: 41.0024,
                    gisGcj02Lng: 122.082,
                  },
                  {
                    id: "211122",
                    text: "盘山县",
                    gisGcj02Lat: 41.238,
                    gisGcj02Lng: 121.998,
                  },
                ],
              },
              {
                id: "211200",
                text: "铁岭市",
                children: [
                  {
                    id: "211202",
                    text: "银州区",
                    gisGcj02Lat: 42.2951,
                    gisGcj02Lng: 123.857,
                  },
                  {
                    id: "211204",
                    text: "清河区",
                    gisGcj02Lat: 42.5468,
                    gisGcj02Lng: 124.159,
                  },
                  {
                    id: "211221",
                    text: "铁岭县",
                    gisGcj02Lat: 42.225,
                    gisGcj02Lng: 123.773,
                  },
                  {
                    id: "211223",
                    text: "西丰县",
                    gisGcj02Lat: 42.7376,
                    gisGcj02Lng: 124.73,
                  },
                  {
                    id: "211224",
                    text: "昌图县",
                    gisGcj02Lat: 42.7843,
                    gisGcj02Lng: 124.112,
                  },
                  {
                    id: "211281",
                    text: "调兵山市",
                    gisGcj02Lat: 42.4675,
                    gisGcj02Lng: 123.567,
                  },
                  {
                    id: "211282",
                    text: "开原市",
                    gisGcj02Lat: 42.5458,
                    gisGcj02Lng: 124.039,
                  },
                ],
              },
              {
                id: "211300",
                text: "朝阳市",
                children: [
                  {
                    id: "211302",
                    text: "双塔区",
                    gisGcj02Lat: 41.566,
                    gisGcj02Lng: 120.454,
                  },
                  {
                    id: "211303",
                    text: "龙城区",
                    gisGcj02Lat: 41.5926,
                    gisGcj02Lng: 120.437,
                  },
                  {
                    id: "211321",
                    text: "朝阳县",
                    gisGcj02Lat: 41.4324,
                    gisGcj02Lng: 120.174,
                  },
                  {
                    id: "211322",
                    text: "建平县",
                    gisGcj02Lat: 41.4031,
                    gisGcj02Lng: 119.644,
                  },
                  {
                    id: "211324",
                    text: "喀喇沁左翼蒙古族自治县",
                    gisGcj02Lat: 41.128,
                    gisGcj02Lng: 119.742,
                  },
                  {
                    id: "211381",
                    text: "北票市",
                    gisGcj02Lat: 41.802,
                    gisGcj02Lng: 120.77,
                  },
                  {
                    id: "211382",
                    text: "凌源市",
                    gisGcj02Lat: 41.2456,
                    gisGcj02Lng: 119.401,
                  },
                ],
              },
              {
                id: "211400",
                text: "葫芦岛市",
                children: [
                  {
                    id: "211402",
                    text: "连山区",
                    gisGcj02Lat: 40.7555,
                    gisGcj02Lng: 120.864,
                  },
                  {
                    id: "211403",
                    text: "龙港区",
                    gisGcj02Lat: 40.7192,
                    gisGcj02Lng: 120.949,
                  },
                  {
                    id: "211404",
                    text: "南票区",
                    gisGcj02Lat: 41.1071,
                    gisGcj02Lng: 120.75,
                  },
                  {
                    id: "211421",
                    text: "绥中县",
                    gisGcj02Lat: 40.3255,
                    gisGcj02Lng: 120.345,
                  },
                  {
                    id: "211422",
                    text: "建昌县",
                    gisGcj02Lat: 40.8245,
                    gisGcj02Lng: 119.838,
                  },
                  {
                    id: "211481",
                    text: "兴城市",
                    gisGcj02Lat: 40.6149,
                    gisGcj02Lng: 120.725,
                  },
                ],
              },
              {
                id: "211500",
                text: "金普新区",
                children: [
                  {
                    id: "211501",
                    text: "金州新区",
                    gisGcj02Lat: 39.0523,
                    gisGcj02Lng: 121.785,
                  },
                  {
                    id: "211502",
                    text: "普湾新区",
                    gisGcj02Lat: 39.3301,
                    gisGcj02Lng: 121.813,
                  },
                  {
                    id: "211503",
                    text: "保税区",
                    gisGcj02Lat: 39.2246,
                    gisGcj02Lng: 121.943,
                  },
                ],
              },
            ],
          },
          {
            id: "220000",
            text: "吉林省",
            children: [
              {
                id: "220100",
                text: "长春市",
                children: [
                  {
                    id: "220184",
                    text: "公主岭市",
                    gisGcj02Lat: 43.5045,
                    gisGcj02Lng: 124.823,
                  },
                  {
                    id: "220102",
                    text: "南关区",
                    gisGcj02Lat: 43.864,
                    gisGcj02Lng: 125.35,
                  },
                  {
                    id: "220103",
                    text: "宽城区",
                    gisGcj02Lat: 43.9018,
                    gisGcj02Lng: 125.326,
                  },
                  {
                    id: "220104",
                    text: "朝阳区",
                    gisGcj02Lat: 43.8334,
                    gisGcj02Lng: 125.288,
                  },
                  {
                    id: "220105",
                    text: "二道区",
                    gisGcj02Lat: 43.865,
                    gisGcj02Lng: 125.374,
                  },
                  {
                    id: "220106",
                    text: "绿园区",
                    gisGcj02Lat: 43.8805,
                    gisGcj02Lng: 125.256,
                  },
                  {
                    id: "220112",
                    text: "双阳区",
                    gisGcj02Lat: 43.528,
                    gisGcj02Lng: 125.656,
                  },
                  {
                    id: "220113",
                    text: "九台区",
                    gisGcj02Lat: 44.1516,
                    gisGcj02Lng: 125.84,
                  },
                  {
                    id: "220122",
                    text: "农安县",
                    gisGcj02Lat: 44.4327,
                    gisGcj02Lng: 125.185,
                  },
                  {
                    id: "220182",
                    text: "榆树市",
                    gisGcj02Lat: 44.8252,
                    gisGcj02Lng: 126.557,
                  },
                  {
                    id: "220183",
                    text: "德惠市",
                    gisGcj02Lat: 44.5372,
                    gisGcj02Lng: 125.705,
                  },
                ],
              },
              {
                id: "220200",
                text: "吉林市",
                children: [
                  {
                    id: "220202",
                    text: "昌邑区",
                    gisGcj02Lat: 43.8818,
                    gisGcj02Lng: 126.574,
                  },
                  {
                    id: "220203",
                    text: "龙潭区",
                    gisGcj02Lat: 43.9105,
                    gisGcj02Lng: 126.562,
                  },
                  {
                    id: "220204",
                    text: "船营区",
                    gisGcj02Lat: 43.8334,
                    gisGcj02Lng: 126.541,
                  },
                  {
                    id: "220211",
                    text: "丰满区",
                    gisGcj02Lat: 43.8224,
                    gisGcj02Lng: 126.562,
                  },
                  {
                    id: "220221",
                    text: "永吉县",
                    gisGcj02Lat: 43.672,
                    gisGcj02Lng: 126.496,
                  },
                  {
                    id: "220281",
                    text: "蛟河市",
                    gisGcj02Lat: 43.727,
                    gisGcj02Lng: 127.344,
                  },
                  {
                    id: "220282",
                    text: "桦甸市",
                    gisGcj02Lat: 42.9721,
                    gisGcj02Lng: 126.746,
                  },
                  {
                    id: "220283",
                    text: "舒兰市",
                    gisGcj02Lat: 44.4058,
                    gisGcj02Lng: 126.965,
                  },
                  {
                    id: "220284",
                    text: "磐石市",
                    gisGcj02Lat: 42.9463,
                    gisGcj02Lng: 126.062,
                  },
                ],
              },
              {
                id: "220300",
                text: "四平市",
                children: [
                  {
                    id: "220302",
                    text: "铁西区",
                    gisGcj02Lat: 43.1746,
                    gisGcj02Lng: 124.374,
                  },
                  {
                    id: "220303",
                    text: "铁东区",
                    gisGcj02Lat: 43.1624,
                    gisGcj02Lng: 124.41,
                  },
                  {
                    id: "220322",
                    text: "梨树县",
                    gisGcj02Lat: 43.3072,
                    gisGcj02Lng: 124.336,
                  },
                  {
                    id: "220323",
                    text: "伊通满族自治县",
                    gisGcj02Lat: 43.3443,
                    gisGcj02Lng: 125.306,
                  },
                  {
                    id: "220382",
                    text: "双辽市",
                    gisGcj02Lat: 43.521,
                    gisGcj02Lng: 123.501,
                  },
                ],
              },
              {
                id: "220400",
                text: "辽源市",
                children: [
                  {
                    id: "220402",
                    text: "龙山区",
                    gisGcj02Lat: 42.8971,
                    gisGcj02Lng: 125.136,
                  },
                  {
                    id: "220403",
                    text: "西安区",
                    gisGcj02Lat: 42.927,
                    gisGcj02Lng: 125.149,
                  },
                  {
                    id: "220421",
                    text: "东丰县",
                    gisGcj02Lat: 42.6783,
                    gisGcj02Lng: 125.532,
                  },
                  {
                    id: "220422",
                    text: "东辽县",
                    gisGcj02Lat: 42.9249,
                    gisGcj02Lng: 124.986,
                  },
                ],
              },
              {
                id: "220500",
                text: "通化市",
                children: [
                  {
                    id: "220502",
                    text: "东昌区",
                    gisGcj02Lat: 41.7285,
                    gisGcj02Lng: 125.955,
                  },
                  {
                    id: "220503",
                    text: "二道江区",
                    gisGcj02Lat: 41.7741,
                    gisGcj02Lng: 126.043,
                  },
                  {
                    id: "220521",
                    text: "通化县",
                    gisGcj02Lat: 41.6793,
                    gisGcj02Lng: 125.759,
                  },
                  {
                    id: "220523",
                    text: "辉南县",
                    gisGcj02Lat: 42.685,
                    gisGcj02Lng: 126.047,
                  },
                  {
                    id: "220524",
                    text: "柳河县",
                    gisGcj02Lat: 42.2847,
                    gisGcj02Lng: 125.745,
                  },
                  {
                    id: "220581",
                    text: "梅河口市",
                    gisGcj02Lat: 42.5383,
                    gisGcj02Lng: 125.71,
                  },
                  {
                    id: "220582",
                    text: "集安市",
                    gisGcj02Lat: 41.1227,
                    gisGcj02Lng: 126.188,
                  },
                ],
              },
              {
                id: "220600",
                text: "白山市",
                children: [
                  {
                    id: "220602",
                    text: "浑江区",
                    gisGcj02Lat: 41.9457,
                    gisGcj02Lng: 126.422,
                  },
                  {
                    id: "220605",
                    text: "江源区",
                    gisGcj02Lat: 42.0566,
                    gisGcj02Lng: 126.591,
                  },
                  {
                    id: "220621",
                    text: "抚松县",
                    gisGcj02Lat: 42.342,
                    gisGcj02Lng: 127.28,
                  },
                  {
                    id: "220622",
                    text: "靖宇县",
                    gisGcj02Lat: 42.3886,
                    gisGcj02Lng: 126.813,
                  },
                  {
                    id: "220623",
                    text: "长白朝鲜族自治县",
                    gisGcj02Lat: 41.42,
                    gisGcj02Lng: 128.2,
                  },
                  {
                    id: "220681",
                    text: "临江市",
                    gisGcj02Lat: 41.8114,
                    gisGcj02Lng: 126.918,
                  },
                ],
              },
              {
                id: "220700",
                text: "松原市",
                children: [
                  {
                    id: "220702",
                    text: "宁江区",
                    gisGcj02Lat: 45.1717,
                    gisGcj02Lng: 124.817,
                  },
                  {
                    id: "220721",
                    text: "前郭尔罗斯蒙古族自治县",
                    gisGcj02Lat: 45.1173,
                    gisGcj02Lng: 124.824,
                  },
                  {
                    id: "220722",
                    text: "长岭县",
                    gisGcj02Lat: 44.2758,
                    gisGcj02Lng: 123.967,
                  },
                  {
                    id: "220723",
                    text: "乾安县",
                    gisGcj02Lat: 45.0107,
                    gisGcj02Lng: 124.027,
                  },
                  {
                    id: "220781",
                    text: "扶余市",
                    gisGcj02Lat: 44.9862,
                    gisGcj02Lng: 126.043,
                  },
                ],
              },
              {
                id: "220800",
                text: "白城市",
                children: [
                  {
                    id: "220802",
                    text: "洮北区",
                    gisGcj02Lat: 45.6217,
                    gisGcj02Lng: 122.851,
                  },
                  {
                    id: "220821",
                    text: "镇赉县",
                    gisGcj02Lat: 45.8478,
                    gisGcj02Lng: 123.199,
                  },
                  {
                    id: "220822",
                    text: "通榆县",
                    gisGcj02Lat: 44.8139,
                    gisGcj02Lng: 123.088,
                  },
                  {
                    id: "220881",
                    text: "洮南市",
                    gisGcj02Lat: 45.335,
                    gisGcj02Lng: 122.788,
                  },
                  {
                    id: "220882",
                    text: "大安市",
                    gisGcj02Lat: 45.5085,
                    gisGcj02Lng: 124.295,
                  },
                ],
              },
              {
                id: "222400",
                text: "延边朝鲜族自治州",
                children: [
                  {
                    id: "222401",
                    text: "延吉市",
                    gisGcj02Lat: 42.9068,
                    gisGcj02Lng: 129.514,
                  },
                  {
                    id: "222402",
                    text: "图们市",
                    gisGcj02Lat: 42.968,
                    gisGcj02Lng: 129.844,
                  },
                  {
                    id: "222403",
                    text: "敦化市",
                    gisGcj02Lat: 43.373,
                    gisGcj02Lng: 128.232,
                  },
                  {
                    id: "222404",
                    text: "珲春市",
                    gisGcj02Lat: 42.8624,
                    gisGcj02Lng: 130.366,
                  },
                  {
                    id: "222405",
                    text: "龙井市",
                    gisGcj02Lat: 42.768,
                    gisGcj02Lng: 129.426,
                  },
                  {
                    id: "222406",
                    text: "和龙市",
                    gisGcj02Lat: 42.5464,
                    gisGcj02Lng: 129.011,
                  },
                  {
                    id: "222424",
                    text: "汪清县",
                    gisGcj02Lat: 43.3128,
                    gisGcj02Lng: 129.771,
                  },
                  {
                    id: "222426",
                    text: "安图县",
                    gisGcj02Lat: 43.1153,
                    gisGcj02Lng: 128.906,
                  },
                ],
              },
            ],
          },
          {
            id: "230000",
            text: "黑龙江省",
            children: [
              {
                id: "230100",
                text: "哈尔滨市",
                children: [
                  {
                    id: "230102",
                    text: "道里区",
                    gisGcj02Lat: 45.7559,
                    gisGcj02Lng: 126.617,
                  },
                  {
                    id: "230103",
                    text: "南岗区",
                    gisGcj02Lat: 45.76,
                    gisGcj02Lng: 126.669,
                  },
                  {
                    id: "230104",
                    text: "道外区",
                    gisGcj02Lat: 45.7919,
                    gisGcj02Lng: 126.649,
                  },
                  {
                    id: "230108",
                    text: "平房区",
                    gisGcj02Lat: 45.5978,
                    gisGcj02Lng: 126.637,
                  },
                  {
                    id: "230109",
                    text: "松北区",
                    gisGcj02Lat: 45.8083,
                    gisGcj02Lng: 126.563,
                  },
                  {
                    id: "230110",
                    text: "香坊区",
                    gisGcj02Lat: 45.7238,
                    gisGcj02Lng: 126.68,
                  },
                  {
                    id: "230111",
                    text: "呼兰区",
                    gisGcj02Lat: 45.889,
                    gisGcj02Lng: 126.588,
                  },
                  {
                    id: "230112",
                    text: "阿城区",
                    gisGcj02Lat: 45.5414,
                    gisGcj02Lng: 126.975,
                  },
                  {
                    id: "230113",
                    text: "双城区",
                    gisGcj02Lat: 45.3779,
                    gisGcj02Lng: 126.309,
                  },
                  {
                    id: "230123",
                    text: "依兰县",
                    gisGcj02Lat: 46.3247,
                    gisGcj02Lng: 129.568,
                  },
                  {
                    id: "230124",
                    text: "方正县",
                    gisGcj02Lat: 45.8516,
                    gisGcj02Lng: 128.83,
                  },
                  {
                    id: "230125",
                    text: "宾县",
                    gisGcj02Lat: 45.755,
                    gisGcj02Lng: 127.487,
                  },
                  {
                    id: "230126",
                    text: "巴彦县",
                    gisGcj02Lat: 46.0815,
                    gisGcj02Lng: 127.408,
                  },
                  {
                    id: "230127",
                    text: "木兰县",
                    gisGcj02Lat: 45.9494,
                    gisGcj02Lng: 128.045,
                  },
                  {
                    id: "230128",
                    text: "通河县",
                    gisGcj02Lat: 45.9901,
                    gisGcj02Lng: 128.746,
                  },
                  {
                    id: "230129",
                    text: "延寿县",
                    gisGcj02Lat: 45.4554,
                    gisGcj02Lng: 128.334,
                  },
                  {
                    id: "230183",
                    text: "尚志市",
                    gisGcj02Lat: 45.2174,
                    gisGcj02Lng: 127.962,
                  },
                  {
                    id: "230184",
                    text: "五常市",
                    gisGcj02Lat: 44.9318,
                    gisGcj02Lng: 127.168,
                  },
                ],
              },
              {
                id: "230200",
                text: "齐齐哈尔市",
                children: [
                  {
                    id: "230202",
                    text: "龙沙区",
                    gisGcj02Lat: 47.3178,
                    gisGcj02Lng: 123.958,
                  },
                  {
                    id: "230203",
                    text: "建华区",
                    gisGcj02Lat: 47.3672,
                    gisGcj02Lng: 124.013,
                  },
                  {
                    id: "230204",
                    text: "铁锋区",
                    gisGcj02Lat: 47.3408,
                    gisGcj02Lng: 123.978,
                  },
                  {
                    id: "230205",
                    text: "昂昂溪区",
                    gisGcj02Lat: 47.1551,
                    gisGcj02Lng: 123.822,
                  },
                  {
                    id: "230206",
                    text: "富拉尔基区",
                    gisGcj02Lat: 47.2088,
                    gisGcj02Lng: 123.629,
                  },
                  {
                    id: "230207",
                    text: "碾子山区",
                    gisGcj02Lat: 47.5166,
                    gisGcj02Lng: 122.882,
                  },
                  {
                    id: "230208",
                    text: "梅里斯达斡尔族区",
                    gisGcj02Lat: 47.3095,
                    gisGcj02Lng: 123.753,
                  },
                  {
                    id: "230221",
                    text: "龙江县",
                    gisGcj02Lat: 47.3387,
                    gisGcj02Lng: 123.205,
                  },
                  {
                    id: "230223",
                    text: "依安县",
                    gisGcj02Lat: 47.8931,
                    gisGcj02Lng: 125.309,
                  },
                  {
                    id: "230224",
                    text: "泰来县",
                    gisGcj02Lat: 46.3939,
                    gisGcj02Lng: 123.423,
                  },
                  {
                    id: "230225",
                    text: "甘南县",
                    gisGcj02Lat: 47.9244,
                    gisGcj02Lng: 123.503,
                  },
                  {
                    id: "230227",
                    text: "富裕县",
                    gisGcj02Lat: 47.7743,
                    gisGcj02Lng: 124.475,
                  },
                  {
                    id: "230229",
                    text: "克山县",
                    gisGcj02Lat: 48.0326,
                    gisGcj02Lng: 125.874,
                  },
                  {
                    id: "230230",
                    text: "克东县",
                    gisGcj02Lat: 48.0383,
                    gisGcj02Lng: 126.249,
                  },
                  {
                    id: "230231",
                    text: "拜泉县",
                    gisGcj02Lat: 47.6082,
                    gisGcj02Lng: 126.092,
                  },
                  {
                    id: "230281",
                    text: "讷河市",
                    gisGcj02Lat: 48.4839,
                    gisGcj02Lng: 124.877,
                  },
                ],
              },
              {
                id: "230300",
                text: "鸡西市",
                children: [
                  {
                    id: "230302",
                    text: "鸡冠区",
                    gisGcj02Lat: 45.304,
                    gisGcj02Lng: 130.981,
                  },
                  {
                    id: "230303",
                    text: "恒山区",
                    gisGcj02Lat: 45.2107,
                    gisGcj02Lng: 130.905,
                  },
                  {
                    id: "230304",
                    text: "滴道区",
                    gisGcj02Lat: 45.3511,
                    gisGcj02Lng: 130.848,
                  },
                  {
                    id: "230305",
                    text: "梨树区",
                    gisGcj02Lat: 45.0904,
                    gisGcj02Lng: 130.698,
                  },
                  {
                    id: "230306",
                    text: "城子河区",
                    gisGcj02Lat: 45.3369,
                    gisGcj02Lng: 131.011,
                  },
                  {
                    id: "230307",
                    text: "麻山区",
                    gisGcj02Lat: 45.2121,
                    gisGcj02Lng: 130.478,
                  },
                  {
                    id: "230321",
                    text: "鸡东县",
                    gisGcj02Lat: 45.2603,
                    gisGcj02Lng: 131.124,
                  },
                  {
                    id: "230381",
                    text: "虎林市",
                    gisGcj02Lat: 45.7629,
                    gisGcj02Lng: 132.937,
                  },
                  {
                    id: "230382",
                    text: "密山市",
                    gisGcj02Lat: 45.5297,
                    gisGcj02Lng: 131.846,
                  },
                ],
              },
              {
                id: "230400",
                text: "鹤岗市",
                children: [
                  {
                    id: "230402",
                    text: "向阳区",
                    gisGcj02Lat: 47.3425,
                    gisGcj02Lng: 130.294,
                  },
                  {
                    id: "230403",
                    text: "工农区",
                    gisGcj02Lat: 47.3187,
                    gisGcj02Lng: 130.275,
                  },
                  {
                    id: "230404",
                    text: "南山区",
                    gisGcj02Lat: 47.314,
                    gisGcj02Lng: 130.277,
                  },
                  {
                    id: "230405",
                    text: "兴安区",
                    gisGcj02Lat: 47.2526,
                    gisGcj02Lng: 130.24,
                  },
                  {
                    id: "230406",
                    text: "东山区",
                    gisGcj02Lat: 47.3385,
                    gisGcj02Lng: 130.317,
                  },
                  {
                    id: "230407",
                    text: "兴山区",
                    gisGcj02Lat: 47.3578,
                    gisGcj02Lng: 130.293,
                  },
                  {
                    id: "230421",
                    text: "萝北县",
                    gisGcj02Lat: 47.5796,
                    gisGcj02Lng: 130.833,
                  },
                  {
                    id: "230422",
                    text: "绥滨县",
                    gisGcj02Lat: 47.2903,
                    gisGcj02Lng: 131.86,
                  },
                ],
              },
              {
                id: "230500",
                text: "双鸭山市",
                children: [
                  {
                    id: "230502",
                    text: "尖山区",
                    gisGcj02Lat: 46.6464,
                    gisGcj02Lng: 131.158,
                  },
                  {
                    id: "230503",
                    text: "岭东区",
                    gisGcj02Lat: 46.5904,
                    gisGcj02Lng: 131.165,
                  },
                  {
                    id: "230505",
                    text: "四方台区",
                    gisGcj02Lat: 46.595,
                    gisGcj02Lng: 131.336,
                  },
                  {
                    id: "230506",
                    text: "宝山区",
                    gisGcj02Lat: 46.5772,
                    gisGcj02Lng: 131.402,
                  },
                  {
                    id: "230521",
                    text: "集贤县",
                    gisGcj02Lat: 46.7268,
                    gisGcj02Lng: 131.141,
                  },
                  {
                    id: "230522",
                    text: "友谊县",
                    gisGcj02Lat: 46.7674,
                    gisGcj02Lng: 131.808,
                  },
                  {
                    id: "230523",
                    text: "宝清县",
                    gisGcj02Lat: 46.3272,
                    gisGcj02Lng: 132.197,
                  },
                  {
                    id: "230524",
                    text: "饶河县",
                    gisGcj02Lat: 46.799,
                    gisGcj02Lng: 134.02,
                  },
                ],
              },
              {
                id: "230600",
                text: "大庆市",
                children: [
                  {
                    id: "230602",
                    text: "萨尔图区",
                    gisGcj02Lat: 46.5936,
                    gisGcj02Lng: 125.088,
                  },
                  {
                    id: "230603",
                    text: "龙凤区",
                    gisGcj02Lat: 46.5327,
                    gisGcj02Lng: 125.117,
                  },
                  {
                    id: "230604",
                    text: "让胡路区",
                    gisGcj02Lat: 46.6522,
                    gisGcj02Lng: 124.871,
                  },
                  {
                    id: "230605",
                    text: "红岗区",
                    gisGcj02Lat: 46.4013,
                    gisGcj02Lng: 124.892,
                  },
                  {
                    id: "230606",
                    text: "大同区",
                    gisGcj02Lat: 46.033,
                    gisGcj02Lng: 124.816,
                  },
                  {
                    id: "230621",
                    text: "肇州县",
                    gisGcj02Lat: 45.7041,
                    gisGcj02Lng: 125.271,
                  },
                  {
                    id: "230622",
                    text: "肇源县",
                    gisGcj02Lat: 45.5203,
                    gisGcj02Lng: 125.085,
                  },
                  {
                    id: "230623",
                    text: "林甸县",
                    gisGcj02Lat: 47.186,
                    gisGcj02Lng: 124.876,
                  },
                  {
                    id: "230624",
                    text: "杜尔伯特蒙古族自治县",
                    gisGcj02Lat: 46.8651,
                    gisGcj02Lng: 124.449,
                  },
                ],
              },
              {
                id: "230700",
                text: "伊春市",
                children: [
                  {
                    id: "230723",
                    text: "汤旺县",
                    gisGcj02Lat: 48.458,
                    gisGcj02Lng: 129.577,
                  },
                  {
                    id: "230707",
                    text: "丰林县",
                    gisGcj02Lat: 48.296,
                    gisGcj02Lng: 129.54,
                  },
                  {
                    id: "230725",
                    text: "大箐山县",
                    gisGcj02Lat: 47.034,
                    gisGcj02Lng: 129.027,
                  },
                  {
                    id: "230726",
                    text: "南岔县",
                    gisGcj02Lat: 47.143,
                    gisGcj02Lng: 129.289,
                  },
                  {
                    id: "230717",
                    text: "伊美区",
                    gisGcj02Lat: 47.734,
                    gisGcj02Lng: 128.913,
                  },
                  {
                    id: "230718",
                    text: "乌翠区",
                    gisGcj02Lat: 47.728,
                    gisGcj02Lng: 128.908,
                  },
                  {
                    id: "230751",
                    text: "金林区",
                    gisGcj02Lat: 47.732,
                    gisGcj02Lng: 128.676,
                  },
                  {
                    id: "230702",
                    text: "伊春区",
                    gisGcj02Lat: 47.728,
                    gisGcj02Lng: 128.908,
                  },
                  {
                    id: "230703",
                    text: "南岔区",
                    gisGcj02Lat: 47.139,
                    gisGcj02Lng: 129.284,
                  },
                  {
                    id: "230704",
                    text: "友好区",
                    gisGcj02Lat: 47.8537,
                    gisGcj02Lng: 128.84,
                  },
                  {
                    id: "230705",
                    text: "西林区",
                    gisGcj02Lat: 47.481,
                    gisGcj02Lng: 129.312,
                  },
                  {
                    id: "230706",
                    text: "翠峦区",
                    gisGcj02Lat: 47.725,
                    gisGcj02Lng: 128.667,
                  },
                  {
                    id: "230707",
                    text: "新青区",
                    gisGcj02Lat: 48.2907,
                    gisGcj02Lng: 129.537,
                  },
                  {
                    id: "230708",
                    text: "美溪区",
                    gisGcj02Lat: 47.6351,
                    gisGcj02Lng: 129.137,
                  },
                  {
                    id: "230709",
                    text: "金山屯区",
                    gisGcj02Lat: 47.4135,
                    gisGcj02Lng: 129.438,
                  },
                  {
                    id: "230710",
                    text: "五营区",
                    gisGcj02Lat: 48.1079,
                    gisGcj02Lng: 129.245,
                  },
                  {
                    id: "230711",
                    text: "乌马河区",
                    gisGcj02Lat: 47.728,
                    gisGcj02Lng: 128.797,
                  },
                  {
                    id: "230712",
                    text: "汤旺河区",
                    gisGcj02Lat: 48.4518,
                    gisGcj02Lng: 129.572,
                  },
                  {
                    id: "230713",
                    text: "带岭区",
                    gisGcj02Lat: 47.0255,
                    gisGcj02Lng: 129.024,
                  },
                  {
                    id: "230714",
                    text: "乌伊岭区",
                    gisGcj02Lat: 48.596,
                    gisGcj02Lng: 129.44,
                  },
                  {
                    id: "230715",
                    text: "红星区",
                    gisGcj02Lat: 48.2394,
                    gisGcj02Lng: 129.389,
                  },
                  {
                    id: "230716",
                    text: "上甘岭区",
                    gisGcj02Lat: 47.9752,
                    gisGcj02Lng: 129.024,
                  },
                  {
                    id: "230722",
                    text: "嘉荫县",
                    gisGcj02Lat: 48.8917,
                    gisGcj02Lng: 130.398,
                  },
                  {
                    id: "230781",
                    text: "铁力市",
                    gisGcj02Lat: 46.9857,
                    gisGcj02Lng: 128.032,
                  },
                ],
              },
              {
                id: "230800",
                text: "佳木斯市",
                children: [
                  {
                    id: "230803",
                    text: "向阳区",
                    gisGcj02Lat: 46.8078,
                    gisGcj02Lng: 130.365,
                  },
                  {
                    id: "230804",
                    text: "前进区",
                    gisGcj02Lat: 46.814,
                    gisGcj02Lng: 130.375,
                  },
                  {
                    id: "230805",
                    text: "东风区",
                    gisGcj02Lat: 46.8226,
                    gisGcj02Lng: 130.404,
                  },
                  {
                    id: "230811",
                    text: "郊区",
                    gisGcj02Lat: 46.8096,
                    gisGcj02Lng: 130.327,
                  },
                  {
                    id: "230822",
                    text: "桦南县",
                    gisGcj02Lat: 46.2392,
                    gisGcj02Lng: 130.554,
                  },
                  {
                    id: "230826",
                    text: "桦川县",
                    gisGcj02Lat: 47.023,
                    gisGcj02Lng: 130.719,
                  },
                  {
                    id: "230828",
                    text: "汤原县",
                    gisGcj02Lat: 46.7276,
                    gisGcj02Lng: 129.91,
                  },
                  {
                    id: "230833",
                    text: "抚远县",
                    gisGcj02Lat: 48.3679,
                    gisGcj02Lng: 134.296,
                  },
                  {
                    id: "230881",
                    text: "同江市",
                    gisGcj02Lat: 47.6421,
                    gisGcj02Lng: 132.511,
                  },
                  {
                    id: "230882",
                    text: "富锦市",
                    gisGcj02Lat: 47.2513,
                    gisGcj02Lng: 132.037,
                  },
                ],
              },
              {
                id: "230900",
                text: "七台河市",
                children: [
                  {
                    id: "230902",
                    text: "新兴区",
                    gisGcj02Lat: 45.8162,
                    gisGcj02Lng: 130.932,
                  },
                  {
                    id: "230903",
                    text: "桃山区",
                    gisGcj02Lat: 45.7678,
                    gisGcj02Lng: 131.018,
                  },
                  {
                    id: "230904",
                    text: "茄子河区",
                    gisGcj02Lat: 45.7852,
                    gisGcj02Lng: 131.068,
                  },
                  {
                    id: "230921",
                    text: "勃利县",
                    gisGcj02Lat: 45.755,
                    gisGcj02Lng: 130.592,
                  },
                ],
              },
              {
                id: "231000",
                text: "牡丹江市",
                children: [
                  {
                    id: "231002",
                    text: "东安区",
                    gisGcj02Lat: 44.5813,
                    gisGcj02Lng: 129.627,
                  },
                  {
                    id: "231003",
                    text: "阳明区",
                    gisGcj02Lat: 44.596,
                    gisGcj02Lng: 129.635,
                  },
                  {
                    id: "231004",
                    text: "爱民区",
                    gisGcj02Lat: 44.5965,
                    gisGcj02Lng: 129.591,
                  },
                  {
                    id: "231005",
                    text: "西安区",
                    gisGcj02Lat: 44.5777,
                    gisGcj02Lng: 129.616,
                  },
                  {
                    id: "231024",
                    text: "东宁市",
                    gisGcj02Lat: 44.0661,
                    gisGcj02Lng: 131.128,
                  },
                  {
                    id: "231025",
                    text: "林口县",
                    gisGcj02Lat: 45.2781,
                    gisGcj02Lng: 130.284,
                  },
                  {
                    id: "231081",
                    text: "绥芬河市",
                    gisGcj02Lat: 44.4125,
                    gisGcj02Lng: 131.151,
                  },
                  {
                    id: "231083",
                    text: "海林市",
                    gisGcj02Lat: 44.59,
                    gisGcj02Lng: 129.382,
                  },
                  {
                    id: "231084",
                    text: "宁安市",
                    gisGcj02Lat: 44.3402,
                    gisGcj02Lng: 129.483,
                  },
                  {
                    id: "231085",
                    text: "穆棱市",
                    gisGcj02Lat: 44.919,
                    gisGcj02Lng: 130.525,
                  },
                ],
              },
              {
                id: "231100",
                text: "黑河市",
                children: [
                  {
                    id: "231102",
                    text: "爱辉区",
                    gisGcj02Lat: 50.252,
                    gisGcj02Lng: 127.501,
                  },
                  {
                    id: "231121",
                    text: "嫩江市",
                    gisGcj02Lat: 49.1784,
                    gisGcj02Lng: 125.226,
                  },
                  {
                    id: "231123",
                    text: "逊克县",
                    gisGcj02Lat: 49.5798,
                    gisGcj02Lng: 128.479,
                  },
                  {
                    id: "231124",
                    text: "孙吴县",
                    gisGcj02Lat: 49.4254,
                    gisGcj02Lng: 127.336,
                  },
                  {
                    id: "231181",
                    text: "北安市",
                    gisGcj02Lat: 48.2387,
                    gisGcj02Lng: 126.482,
                  },
                  {
                    id: "231182",
                    text: "五大连池市",
                    gisGcj02Lat: 48.5151,
                    gisGcj02Lng: 126.203,
                  },
                ],
              },
              {
                id: "231200",
                text: "绥化市",
                children: [
                  {
                    id: "231202",
                    text: "北林区",
                    gisGcj02Lat: 46.6373,
                    gisGcj02Lng: 126.986,
                  },
                  {
                    id: "231221",
                    text: "望奎县",
                    gisGcj02Lat: 46.8308,
                    gisGcj02Lng: 126.482,
                  },
                  {
                    id: "231222",
                    text: "兰西县",
                    gisGcj02Lat: 46.2525,
                    gisGcj02Lng: 126.29,
                  },
                  {
                    id: "231223",
                    text: "青冈县",
                    gisGcj02Lat: 46.6853,
                    gisGcj02Lng: 126.113,
                  },
                  {
                    id: "231224",
                    text: "庆安县",
                    gisGcj02Lat: 46.8802,
                    gisGcj02Lng: 127.508,
                  },
                  {
                    id: "231225",
                    text: "明水县",
                    gisGcj02Lat: 47.1733,
                    gisGcj02Lng: 125.906,
                  },
                  {
                    id: "231226",
                    text: "绥棱县",
                    gisGcj02Lat: 47.2427,
                    gisGcj02Lng: 127.116,
                  },
                  {
                    id: "231281",
                    text: "安达市",
                    gisGcj02Lat: 46.4177,
                    gisGcj02Lng: 125.344,
                  },
                  {
                    id: "231282",
                    text: "肇东市",
                    gisGcj02Lat: 46.0513,
                    gisGcj02Lng: 125.962,
                  },
                  {
                    id: "231283",
                    text: "海伦市",
                    gisGcj02Lat: 47.4609,
                    gisGcj02Lng: 126.968,
                  },
                ],
              },
              {
                id: "232700",
                text: "大兴安岭地区",
                children: [
                  {
                    id: "232701",
                    text: "加格达奇区",
                    gisGcj02Lat: 51.9814,
                    gisGcj02Lng: 124.31,
                  },
                  {
                    id: "232702",
                    text: "新林区",
                    gisGcj02Lat: 51.6734,
                    gisGcj02Lng: 124.398,
                  },
                  {
                    id: "232703",
                    text: "松岭区",
                    gisGcj02Lat: 51.9855,
                    gisGcj02Lng: 124.19,
                  },
                  {
                    id: "232704",
                    text: "呼中区",
                    gisGcj02Lat: 52.0335,
                    gisGcj02Lng: 123.6,
                  },
                  {
                    id: "232721",
                    text: "呼玛县",
                    gisGcj02Lat: 51.7311,
                    gisGcj02Lng: 126.662,
                  },
                  {
                    id: "232722",
                    text: "塔河县",
                    gisGcj02Lat: 52.3343,
                    gisGcj02Lng: 124.71,
                  },
                  {
                    id: "232723",
                    text: "漠河县",
                    gisGcj02Lat: 52.97,
                    gisGcj02Lng: 122.538,
                  },
                ],
              },
            ],
          },
          {
            id: "310000",
            text: "上海市",
            children: [
              {
                id: "310100",
                text: "上海市",
                children: [
                  {
                    id: "310101",
                    text: "黄浦区",
                    gisGcj02Lat: 31.2234,
                    gisGcj02Lng: 121.493,
                  },
                  {
                    id: "310104",
                    text: "徐汇区",
                    gisGcj02Lat: 31.1883,
                    gisGcj02Lng: 121.437,
                  },
                  {
                    id: "310105",
                    text: "长宁区",
                    gisGcj02Lat: 31.2204,
                    gisGcj02Lng: 121.425,
                  },
                  {
                    id: "310106",
                    text: "静安区",
                    gisGcj02Lat: 31.2288,
                    gisGcj02Lng: 121.444,
                  },
                  {
                    id: "310107",
                    text: "普陀区",
                    gisGcj02Lat: 31.2495,
                    gisGcj02Lng: 121.397,
                  },
                  {
                    id: "310108",
                    text: "闸北区",
                    gisGcj02Lat: 31.2808,
                    gisGcj02Lng: 121.446,
                  },
                  {
                    id: "310109",
                    text: "虹口区",
                    gisGcj02Lat: 31.2779,
                    gisGcj02Lng: 121.482,
                  },
                  {
                    id: "310110",
                    text: "杨浦区",
                    gisGcj02Lat: 31.2595,
                    gisGcj02Lng: 121.526,
                  },
                  {
                    id: "310112",
                    text: "闵行区",
                    gisGcj02Lat: 31.1125,
                    gisGcj02Lng: 121.382,
                  },
                  {
                    id: "310113",
                    text: "宝山区",
                    gisGcj02Lat: 31.4045,
                    gisGcj02Lng: 121.489,
                  },
                  {
                    id: "310114",
                    text: "嘉定区",
                    gisGcj02Lat: 31.3747,
                    gisGcj02Lng: 121.266,
                  },
                  {
                    id: "310115",
                    text: "浦东新区",
                    gisGcj02Lat: 31.2225,
                    gisGcj02Lng: 121.545,
                  },
                  {
                    id: "310116",
                    text: "金山区",
                    gisGcj02Lat: 30.7416,
                    gisGcj02Lng: 121.342,
                  },
                  {
                    id: "310117",
                    text: "松江区",
                    gisGcj02Lat: 31.0322,
                    gisGcj02Lng: 121.229,
                  },
                  {
                    id: "310118",
                    text: "青浦区",
                    gisGcj02Lat: 31.1497,
                    gisGcj02Lng: 121.124,
                  },
                  {
                    id: "310120",
                    text: "奉贤区",
                    gisGcj02Lat: 30.9179,
                    gisGcj02Lng: 121.474,
                  },
                  {
                    id: "310230",
                    text: "崇明区",
                    gisGcj02Lat: 31.6228,
                    gisGcj02Lng: 121.398,
                  },
                ],
              },
            ],
          },
          {
            id: "320000",
            text: "江苏省",
            children: [
              {
                id: "320100",
                text: "南京市",
                children: [
                  {
                    id: "320102",
                    text: "玄武区",
                    gisGcj02Lat: 32.0486,
                    gisGcj02Lng: 118.798,
                  },
                  {
                    id: "320104",
                    text: "秦淮区",
                    gisGcj02Lat: 32.0111,
                    gisGcj02Lng: 118.798,
                  },
                  {
                    id: "320105",
                    text: "建邺区",
                    gisGcj02Lat: 32.031,
                    gisGcj02Lng: 118.766,
                  },
                  {
                    id: "320106",
                    text: "鼓楼区",
                    gisGcj02Lat: 32.0663,
                    gisGcj02Lng: 118.77,
                  },
                  {
                    id: "320111",
                    text: "浦口区",
                    gisGcj02Lat: 32.0588,
                    gisGcj02Lng: 118.628,
                  },
                  {
                    id: "320113",
                    text: "栖霞区",
                    gisGcj02Lat: 32.1135,
                    gisGcj02Lng: 118.881,
                  },
                  {
                    id: "320114",
                    text: "雨花台区",
                    gisGcj02Lat: 31.992,
                    gisGcj02Lng: 118.78,
                  },
                  {
                    id: "320115",
                    text: "江宁区",
                    gisGcj02Lat: 31.9526,
                    gisGcj02Lng: 118.84,
                  },
                  {
                    id: "320116",
                    text: "六合区",
                    gisGcj02Lat: 32.3422,
                    gisGcj02Lng: 118.841,
                  },
                  {
                    id: "320117",
                    text: "溧水区",
                    gisGcj02Lat: 31.6531,
                    gisGcj02Lng: 119.029,
                  },
                  {
                    id: "320118",
                    text: "高淳区",
                    gisGcj02Lat: 31.3271,
                    gisGcj02Lng: 118.876,
                  },
                ],
              },
              {
                id: "320200",
                text: "无锡市",
                children: [
                  {
                    id: "320202",
                    text: "崇安区",
                    gisGcj02Lat: 31.58,
                    gisGcj02Lng: 120.3,
                  },
                  {
                    id: "320203",
                    text: "南长区",
                    gisGcj02Lat: 31.5636,
                    gisGcj02Lng: 120.309,
                  },
                  {
                    id: "320204",
                    text: "北塘区",
                    gisGcj02Lat: 31.6059,
                    gisGcj02Lng: 120.294,
                  },
                  {
                    id: "320205",
                    text: "锡山区",
                    gisGcj02Lat: 31.5886,
                    gisGcj02Lng: 120.357,
                  },
                  {
                    id: "320206",
                    text: "惠山区",
                    gisGcj02Lat: 31.6809,
                    gisGcj02Lng: 120.298,
                  },
                  {
                    id: "320207",
                    text: "梁溪区",
                    gisGcj02Lat: 31.6809,
                    gisGcj02Lng: 120.298,
                  },
                  {
                    id: "320208",
                    text: "新吴区",
                    gisGcj02Lat: 31.6809,
                    gisGcj02Lng: 120.298,
                  },
                  {
                    id: "320211",
                    text: "滨湖区",
                    gisGcj02Lat: 31.5216,
                    gisGcj02Lng: 120.295,
                  },
                  {
                    id: "320281",
                    text: "江阴市",
                    gisGcj02Lat: 31.92,
                    gisGcj02Lng: 120.285,
                  },
                  {
                    id: "320282",
                    text: "宜兴市",
                    gisGcj02Lat: 31.3398,
                    gisGcj02Lng: 119.824,
                  },
                ],
              },
              {
                id: "320300",
                text: "徐州市",
                children: [
                  {
                    id: "320302",
                    text: "鼓楼区",
                    gisGcj02Lat: 34.2885,
                    gisGcj02Lng: 117.186,
                  },
                  {
                    id: "320303",
                    text: "云龙区",
                    gisGcj02Lat: 34.249,
                    gisGcj02Lng: 117.231,
                  },
                  {
                    id: "320305",
                    text: "贾汪区",
                    gisGcj02Lat: 34.4426,
                    gisGcj02Lng: 117.453,
                  },
                  {
                    id: "320311",
                    text: "泉山区",
                    gisGcj02Lat: 34.2442,
                    gisGcj02Lng: 117.194,
                  },
                  {
                    id: "320312",
                    text: "铜山区",
                    gisGcj02Lat: 34.1929,
                    gisGcj02Lng: 117.184,
                  },
                  {
                    id: "320321",
                    text: "丰县",
                    gisGcj02Lat: 34.6997,
                    gisGcj02Lng: 116.6,
                  },
                  {
                    id: "320322",
                    text: "沛县",
                    gisGcj02Lat: 34.7216,
                    gisGcj02Lng: 116.937,
                  },
                  {
                    id: "320324",
                    text: "睢宁县",
                    gisGcj02Lat: 33.9127,
                    gisGcj02Lng: 117.941,
                  },
                  {
                    id: "320381",
                    text: "新沂市",
                    gisGcj02Lat: 34.3694,
                    gisGcj02Lng: 118.355,
                  },
                  {
                    id: "320382",
                    text: "邳州市",
                    gisGcj02Lat: 34.3333,
                    gisGcj02Lng: 117.959,
                  },
                ],
              },
              {
                id: "320400",
                text: "常州市",
                children: [
                  {
                    id: "320402",
                    text: "天宁区",
                    gisGcj02Lat: 31.7521,
                    gisGcj02Lng: 119.951,
                  },
                  {
                    id: "320404",
                    text: "钟楼区",
                    gisGcj02Lat: 31.8022,
                    gisGcj02Lng: 119.902,
                  },
                  {
                    id: "320405",
                    text: "戚墅堰区",
                    gisGcj02Lat: 31.7196,
                    gisGcj02Lng: 120.061,
                  },
                  {
                    id: "320411",
                    text: "新北区",
                    gisGcj02Lat: 31.8305,
                    gisGcj02Lng: 119.971,
                  },
                  {
                    id: "320412",
                    text: "武进区",
                    gisGcj02Lat: 31.7009,
                    gisGcj02Lng: 119.942,
                  },
                  {
                    id: "320481",
                    text: "溧阳市",
                    gisGcj02Lat: 31.4154,
                    gisGcj02Lng: 119.484,
                  },
                  {
                    id: "320482",
                    text: "金坛区",
                    gisGcj02Lat: 31.7404,
                    gisGcj02Lng: 119.578,
                  },
                ],
              },
              {
                id: "320500",
                text: "苏州市",
                children: [
                  {
                    id: "320571",
                    text: "工业园区",
                    gisGcj02Lat: 31.3304,
                    gisGcj02Lng: 120.729,
                  },
                  {
                    id: "320505",
                    text: "虎丘区",
                    gisGcj02Lat: 31.2953,
                    gisGcj02Lng: 120.573,
                  },
                  {
                    id: "320506",
                    text: "吴中区",
                    gisGcj02Lat: 31.2623,
                    gisGcj02Lng: 120.632,
                  },
                  {
                    id: "320507",
                    text: "相城区",
                    gisGcj02Lat: 31.3689,
                    gisGcj02Lng: 120.642,
                  },
                  {
                    id: "320508",
                    text: "姑苏区",
                    gisGcj02Lat: 31.2994,
                    gisGcj02Lng: 120.62,
                  },
                  {
                    id: "320509",
                    text: "吴江区",
                    gisGcj02Lat: 31.1598,
                    gisGcj02Lng: 120.638,
                  },
                  {
                    id: "320581",
                    text: "常熟市",
                    gisGcj02Lat: 31.6537,
                    gisGcj02Lng: 120.752,
                  },
                  {
                    id: "320582",
                    text: "张家港市",
                    gisGcj02Lat: 31.8753,
                    gisGcj02Lng: 120.555,
                  },
                  {
                    id: "320583",
                    text: "昆山市",
                    gisGcj02Lat: 31.3846,
                    gisGcj02Lng: 120.981,
                  },
                  {
                    id: "320585",
                    text: "太仓市",
                    gisGcj02Lat: 31.4497,
                    gisGcj02Lng: 121.109,
                  },
                ],
              },
              {
                id: "320600",
                text: "南通市",
                children: [
                  {
                    id: "320602",
                    text: "崇川区",
                    gisGcj02Lat: 32.0098,
                    gisGcj02Lng: 120.857,
                  },
                  {
                    id: "320611",
                    text: "港闸区",
                    gisGcj02Lat: 32.0316,
                    gisGcj02Lng: 120.818,
                  },
                  {
                    id: "320612",
                    text: "通州区",
                    gisGcj02Lat: 32.0676,
                    gisGcj02Lng: 121.073,
                  },
                  {
                    id: "320621",
                    text: "海安县",
                    gisGcj02Lat: 32.5451,
                    gisGcj02Lng: 120.459,
                  },
                  {
                    id: "320623",
                    text: "如东县",
                    gisGcj02Lat: 32.3144,
                    gisGcj02Lng: 121.189,
                  },
                  {
                    id: "320681",
                    text: "启东市",
                    gisGcj02Lat: 31.8108,
                    gisGcj02Lng: 121.66,
                  },
                  {
                    id: "320682",
                    text: "如皋市",
                    gisGcj02Lat: 32.376,
                    gisGcj02Lng: 120.56,
                  },
                  {
                    id: "320684",
                    text: "海门区",
                    gisGcj02Lat: 31.8942,
                    gisGcj02Lng: 121.17,
                  },
                ],
              },
              {
                id: "320700",
                text: "连云港市",
                children: [
                  {
                    id: "320703",
                    text: "连云区",
                    gisGcj02Lat: 34.7529,
                    gisGcj02Lng: 119.373,
                  },
                  {
                    id: "320706",
                    text: "海州区",
                    gisGcj02Lat: 34.5699,
                    gisGcj02Lng: 119.131,
                  },
                  {
                    id: "320707",
                    text: "赣榆区",
                    gisGcj02Lat: 34.8392,
                    gisGcj02Lng: 119.129,
                  },
                  {
                    id: "320708",
                    text: "新浦区",
                    gisGcj02Lat: 34.8392,
                    gisGcj02Lng: 119.129,
                  },
                  {
                    id: "320722",
                    text: "东海县",
                    gisGcj02Lat: 34.5421,
                    gisGcj02Lng: 118.771,
                  },
                  {
                    id: "320723",
                    text: "灌云县",
                    gisGcj02Lat: 34.2839,
                    gisGcj02Lng: 119.239,
                  },
                  {
                    id: "320724",
                    text: "灌南县",
                    gisGcj02Lat: 34.09,
                    gisGcj02Lng: 119.356,
                  },
                ],
              },
              {
                id: "320800",
                text: "淮安市",
                children: [
                  {
                    id: "320802",
                    text: "清河区",
                    gisGcj02Lat: 33.5995,
                    gisGcj02Lng: 119.008,
                  },
                  {
                    id: "320803",
                    text: "淮安区",
                    gisGcj02Lat: 33.5975,
                    gisGcj02Lng: 119.021,
                  },
                  {
                    id: "320804",
                    text: "淮阴区",
                    gisGcj02Lat: 33.6317,
                    gisGcj02Lng: 119.035,
                  },
                  {
                    id: "320805",
                    text: "清江浦区",
                    gisGcj02Lat: 33.6317,
                    gisGcj02Lng: 119.035,
                  },
                  {
                    id: "320811",
                    text: "清浦区",
                    gisGcj02Lat: 33.5523,
                    gisGcj02Lng: 119.026,
                  },
                  {
                    id: "320826",
                    text: "涟水县",
                    gisGcj02Lat: 33.7809,
                    gisGcj02Lng: 119.261,
                  },
                  {
                    id: "320829",
                    text: "洪泽区",
                    gisGcj02Lat: 33.2943,
                    gisGcj02Lng: 118.873,
                  },
                  {
                    id: "320830",
                    text: "盱眙县",
                    gisGcj02Lat: 33.0109,
                    gisGcj02Lng: 118.545,
                  },
                  {
                    id: "320831",
                    text: "金湖县",
                    gisGcj02Lat: 33.0222,
                    gisGcj02Lng: 119.023,
                  },
                ],
              },
              {
                id: "320900",
                text: "盐城市",
                children: [
                  {
                    id: "320902",
                    text: "亭湖区",
                    gisGcj02Lat: 33.3783,
                    gisGcj02Lng: 120.166,
                  },
                  {
                    id: "320903",
                    text: "盐都区",
                    gisGcj02Lat: 33.3373,
                    gisGcj02Lng: 120.154,
                  },
                  {
                    id: "320921",
                    text: "响水县",
                    gisGcj02Lat: 34.2051,
                    gisGcj02Lng: 119.57,
                  },
                  {
                    id: "320922",
                    text: "滨海县",
                    gisGcj02Lat: 33.9897,
                    gisGcj02Lng: 119.821,
                  },
                  {
                    id: "320923",
                    text: "阜宁县",
                    gisGcj02Lat: 33.7823,
                    gisGcj02Lng: 119.802,
                  },
                  {
                    id: "320924",
                    text: "射阳县",
                    gisGcj02Lat: 33.7764,
                    gisGcj02Lng: 120.26,
                  },
                  {
                    id: "320925",
                    text: "建湖县",
                    gisGcj02Lat: 33.4724,
                    gisGcj02Lng: 119.799,
                  },
                  {
                    id: "320981",
                    text: "东台市",
                    gisGcj02Lat: 32.8508,
                    gisGcj02Lng: 120.324,
                  },
                  {
                    id: "320982",
                    text: "大丰区",
                    gisGcj02Lat: 33.1989,
                    gisGcj02Lng: 120.466,
                  },
                ],
              },
              {
                id: "321000",
                text: "扬州市",
                children: [
                  {
                    id: "321002",
                    text: "广陵区",
                    gisGcj02Lat: 32.3947,
                    gisGcj02Lng: 119.432,
                  },
                  {
                    id: "321003",
                    text: "邗江区",
                    gisGcj02Lat: 32.3765,
                    gisGcj02Lng: 119.398,
                  },
                  {
                    id: "321012",
                    text: "江都区",
                    gisGcj02Lat: 32.4266,
                    gisGcj02Lng: 119.567,
                  },
                  {
                    id: "321023",
                    text: "宝应县",
                    gisGcj02Lat: 33.2355,
                    gisGcj02Lng: 119.312,
                  },
                  {
                    id: "321081",
                    text: "仪征市",
                    gisGcj02Lat: 32.272,
                    gisGcj02Lng: 119.184,
                  },
                  {
                    id: "321084",
                    text: "高邮市",
                    gisGcj02Lat: 32.7813,
                    gisGcj02Lng: 119.46,
                  },
                ],
              },
              {
                id: "321100",
                text: "镇江市",
                children: [
                  {
                    id: "321102",
                    text: "京口区",
                    gisGcj02Lat: 32.1981,
                    gisGcj02Lng: 119.469,
                  },
                  {
                    id: "321111",
                    text: "润州区",
                    gisGcj02Lat: 32.1952,
                    gisGcj02Lng: 119.411,
                  },
                  {
                    id: "321112",
                    text: "丹徒区",
                    gisGcj02Lat: 32.1318,
                    gisGcj02Lng: 119.434,
                  },
                  {
                    id: "321181",
                    text: "丹阳市",
                    gisGcj02Lat: 31.9912,
                    gisGcj02Lng: 119.575,
                  },
                  {
                    id: "321182",
                    text: "扬中市",
                    gisGcj02Lat: 32.2363,
                    gisGcj02Lng: 119.797,
                  },
                  {
                    id: "321183",
                    text: "句容市",
                    gisGcj02Lat: 31.9559,
                    gisGcj02Lng: 119.165,
                  },
                ],
              },
              {
                id: "321200",
                text: "泰州市",
                children: [
                  {
                    id: "321202",
                    text: "海陵区",
                    gisGcj02Lat: 32.491,
                    gisGcj02Lng: 119.919,
                  },
                  {
                    id: "321203",
                    text: "高港区",
                    gisGcj02Lat: 32.3183,
                    gisGcj02Lng: 119.881,
                  },
                  {
                    id: "321204",
                    text: "姜堰区",
                    gisGcj02Lat: 32.5085,
                    gisGcj02Lng: 120.148,
                  },
                  {
                    id: "321281",
                    text: "兴化市",
                    gisGcj02Lat: 32.9094,
                    gisGcj02Lng: 119.852,
                  },
                  {
                    id: "321282",
                    text: "靖江市",
                    gisGcj02Lat: 32.0159,
                    gisGcj02Lng: 120.273,
                  },
                  {
                    id: "321283",
                    text: "泰兴市",
                    gisGcj02Lat: 32.1719,
                    gisGcj02Lng: 120.052,
                  },
                ],
              },
              {
                id: "321300",
                text: "宿迁市",
                children: [
                  {
                    id: "321302",
                    text: "宿城区",
                    gisGcj02Lat: 33.9422,
                    gisGcj02Lng: 118.291,
                  },
                  {
                    id: "321311",
                    text: "宿豫区",
                    gisGcj02Lat: 33.9467,
                    gisGcj02Lng: 118.329,
                  },
                  {
                    id: "321322",
                    text: "沭阳县",
                    gisGcj02Lat: 34.1145,
                    gisGcj02Lng: 118.769,
                  },
                  {
                    id: "321323",
                    text: "泗阳县",
                    gisGcj02Lat: 33.721,
                    gisGcj02Lng: 118.703,
                  },
                  {
                    id: "321324",
                    text: "泗洪县",
                    gisGcj02Lat: 33.46,
                    gisGcj02Lng: 118.217,
                  },
                ],
              },
            ],
          },
          {
            id: "330000",
            text: "浙江省",
            children: [
              {
                id: "330100",
                text: "杭州市",
                children: [
                  {
                    id: "330113",
                    text: "临平区",
                    gisGcj02Lat: 30.424,
                    gisGcj02Lng: 120.306,
                  },
                  {
                    id: "330114",
                    text: "钱塘区",
                    gisGcj02Lat: 30.329,
                    gisGcj02Lng: 120.5,
                  },
                  {
                    id: "330102",
                    text: "上城区",
                    gisGcj02Lat: 30.2425,
                    gisGcj02Lng: 120.169,
                  },
                  {
                    id: "330103",
                    text: "下城区",
                    gisGcj02Lat: 30.2815,
                    gisGcj02Lng: 120.181,
                  },
                  {
                    id: "330104",
                    text: "江干区",
                    gisGcj02Lat: 30.2572,
                    gisGcj02Lng: 120.205,
                  },
                  {
                    id: "330105",
                    text: "拱墅区",
                    gisGcj02Lat: 30.3197,
                    gisGcj02Lng: 120.142,
                  },
                  {
                    id: "330106",
                    text: "西湖区",
                    gisGcj02Lat: 30.2595,
                    gisGcj02Lng: 120.13,
                  },
                  {
                    id: "330108",
                    text: "滨江区",
                    gisGcj02Lat: 30.2083,
                    gisGcj02Lng: 120.212,
                  },
                  {
                    id: "330109",
                    text: "萧山市",
                    gisGcj02Lat: 30.185,
                    gisGcj02Lng: 120.265,
                  },
                  {
                    id: "330110",
                    text: "余杭区",
                    gisGcj02Lat: 30.4183,
                    gisGcj02Lng: 120.3,
                  },
                  {
                    id: "330122",
                    text: "桐庐县",
                    gisGcj02Lat: 29.7978,
                    gisGcj02Lng: 119.689,
                  },
                  {
                    id: "330127",
                    text: "淳安县",
                    gisGcj02Lat: 29.6099,
                    gisGcj02Lng: 119.043,
                  },
                  {
                    id: "330182",
                    text: "建德市",
                    gisGcj02Lat: 29.476,
                    gisGcj02Lng: 119.282,
                  },
                  {
                    id: "330183",
                    text: "富阳区",
                    gisGcj02Lat: 30.0488,
                    gisGcj02Lng: 119.96,
                  },
                  {
                    id: "330185",
                    text: "临安市",
                    gisGcj02Lat: 30.2345,
                    gisGcj02Lng: 119.725,
                  },
                ],
              },
              {
                id: "330200",
                text: "宁波市",
                children: [
                  {
                    id: "330203",
                    text: "海曙区",
                    gisGcj02Lat: 29.8598,
                    gisGcj02Lng: 121.551,
                  },
                  {
                    id: "330204",
                    text: "江东区",
                    gisGcj02Lat: 29.867,
                    gisGcj02Lng: 121.57,
                  },
                  {
                    id: "330205",
                    text: "江北区",
                    gisGcj02Lat: 29.8878,
                    gisGcj02Lng: 121.557,
                  },
                  {
                    id: "330206",
                    text: "北仑区",
                    gisGcj02Lat: 29.9007,
                    gisGcj02Lng: 121.844,
                  },
                  {
                    id: "330211",
                    text: "镇海区",
                    gisGcj02Lat: 29.9489,
                    gisGcj02Lng: 121.716,
                  },
                  {
                    id: "330212",
                    text: "鄞州区",
                    gisGcj02Lat: 29.8161,
                    gisGcj02Lng: 121.548,
                  },
                  {
                    id: "330225",
                    text: "象山县",
                    gisGcj02Lat: 29.4776,
                    gisGcj02Lng: 121.869,
                  },
                  {
                    id: "330226",
                    text: "宁海县",
                    gisGcj02Lat: 29.2889,
                    gisGcj02Lng: 121.431,
                  },
                  {
                    id: "330281",
                    text: "余姚市",
                    gisGcj02Lat: 30.0387,
                    gisGcj02Lng: 121.153,
                  },
                  {
                    id: "330282",
                    text: "慈溪市",
                    gisGcj02Lat: 30.1696,
                    gisGcj02Lng: 121.266,
                  },
                  {
                    id: "330283",
                    text: "奉化区",
                    gisGcj02Lat: 29.6554,
                    gisGcj02Lng: 121.41,
                  },
                ],
              },
              {
                id: "330300",
                text: "温州市",
                children: [
                  {
                    id: "330302",
                    text: "鹿城区",
                    gisGcj02Lat: 28.0149,
                    gisGcj02Lng: 120.655,
                  },
                  {
                    id: "330303",
                    text: "龙湾区",
                    gisGcj02Lat: 27.9128,
                    gisGcj02Lng: 120.831,
                  },
                  {
                    id: "330304",
                    text: "瓯海区",
                    gisGcj02Lat: 28.0071,
                    gisGcj02Lng: 120.638,
                  },
                  {
                    id: "330322",
                    text: "洞头区",
                    gisGcj02Lat: 27.8363,
                    gisGcj02Lng: 121.156,
                  },
                  {
                    id: "330324",
                    text: "永嘉县",
                    gisGcj02Lat: 28.1546,
                    gisGcj02Lng: 120.693,
                  },
                  {
                    id: "330326",
                    text: "平阳县",
                    gisGcj02Lat: 27.6625,
                    gisGcj02Lng: 120.565,
                  },
                  {
                    id: "330327",
                    text: "苍南县",
                    gisGcj02Lat: 27.5174,
                    gisGcj02Lng: 120.426,
                  },
                  {
                    id: "330328",
                    text: "文成县",
                    gisGcj02Lat: 27.7868,
                    gisGcj02Lng: 120.091,
                  },
                  {
                    id: "330329",
                    text: "泰顺县",
                    gisGcj02Lat: 27.5569,
                    gisGcj02Lng: 119.718,
                  },
                  {
                    id: "330381",
                    text: "瑞安市",
                    gisGcj02Lat: 27.7804,
                    gisGcj02Lng: 120.655,
                  },
                  {
                    id: "330382",
                    text: "乐清市",
                    gisGcj02Lat: 28.124,
                    gisGcj02Lng: 120.962,
                  },
                  {
                    id: "330383",
                    text: "龙港市",
                    gisGcj02Lat: 27.584,
                    gisGcj02Lng: 120.559,
                  },
                ],
              },
              {
                id: "330400",
                text: "嘉兴市",
                children: [
                  {
                    id: "330402",
                    text: "南湖区",
                    gisGcj02Lat: 30.7486,
                    gisGcj02Lng: 120.785,
                  },
                  {
                    id: "330411",
                    text: "秀洲区",
                    gisGcj02Lat: 30.7645,
                    gisGcj02Lng: 120.709,
                  },
                  {
                    id: "330421",
                    text: "嘉善县",
                    gisGcj02Lat: 30.8299,
                    gisGcj02Lng: 120.926,
                  },
                  {
                    id: "330424",
                    text: "海盐县",
                    gisGcj02Lat: 30.5255,
                    gisGcj02Lng: 120.946,
                  },
                  {
                    id: "330481",
                    text: "海宁市",
                    gisGcj02Lat: 30.5097,
                    gisGcj02Lng: 120.681,
                  },
                  {
                    id: "330482",
                    text: "平湖市",
                    gisGcj02Lat: 30.6962,
                    gisGcj02Lng: 121.022,
                  },
                  {
                    id: "330483",
                    text: "桐乡市",
                    gisGcj02Lat: 30.6302,
                    gisGcj02Lng: 120.565,
                  },
                ],
              },
              {
                id: "330500",
                text: "湖州市",
                children: [
                  {
                    id: "330502",
                    text: "吴兴区",
                    gisGcj02Lat: 30.8575,
                    gisGcj02Lng: 120.125,
                  },
                  {
                    id: "330503",
                    text: "南浔区",
                    gisGcj02Lat: 30.8669,
                    gisGcj02Lng: 120.42,
                  },
                  {
                    id: "330521",
                    text: "德清县",
                    gisGcj02Lat: 30.5337,
                    gisGcj02Lng: 119.978,
                  },
                  {
                    id: "330522",
                    text: "长兴县",
                    gisGcj02Lat: 31.0061,
                    gisGcj02Lng: 119.908,
                  },
                  {
                    id: "330523",
                    text: "安吉县",
                    gisGcj02Lat: 30.638,
                    gisGcj02Lng: 119.682,
                  },
                ],
              },
              {
                id: "330600",
                text: "绍兴市",
                children: [
                  {
                    id: "330602",
                    text: "越城区",
                    gisGcj02Lat: 29.989,
                    gisGcj02Lng: 120.582,
                  },
                  {
                    id: "330603",
                    text: "柯桥区",
                    gisGcj02Lat: 30.0876,
                    gisGcj02Lng: 120.493,
                  },
                  {
                    id: "330604",
                    text: "上虞区",
                    gisGcj02Lat: 30.078,
                    gisGcj02Lng: 120.476,
                  },
                  {
                    id: "330624",
                    text: "新昌县",
                    gisGcj02Lat: 29.4999,
                    gisGcj02Lng: 120.904,
                  },
                  {
                    id: "330681",
                    text: "诸暨市",
                    gisGcj02Lat: 29.7136,
                    gisGcj02Lng: 120.236,
                  },
                  {
                    id: "330683",
                    text: "嵊州市",
                    gisGcj02Lat: 29.5885,
                    gisGcj02Lng: 120.822,
                  },
                ],
              },
              {
                id: "330700",
                text: "金华市",
                children: [
                  {
                    id: "330702",
                    text: "婺城区",
                    gisGcj02Lat: 29.0952,
                    gisGcj02Lng: 119.571,
                  },
                  {
                    id: "330703",
                    text: "金东区",
                    gisGcj02Lat: 29.0991,
                    gisGcj02Lng: 119.693,
                  },
                  {
                    id: "330723",
                    text: "武义县",
                    gisGcj02Lat: 28.8933,
                    gisGcj02Lng: 119.816,
                  },
                  {
                    id: "330726",
                    text: "浦江县",
                    gisGcj02Lat: 29.4535,
                    gisGcj02Lng: 119.892,
                  },
                  {
                    id: "330727",
                    text: "磐安县",
                    gisGcj02Lat: 29.0573,
                    gisGcj02Lng: 120.45,
                  },
                  {
                    id: "330781",
                    text: "兰溪市",
                    gisGcj02Lat: 29.2084,
                    gisGcj02Lng: 119.46,
                  },
                  {
                    id: "330782",
                    text: "义乌市",
                    gisGcj02Lat: 29.3056,
                    gisGcj02Lng: 120.074,
                  },
                  {
                    id: "330783",
                    text: "东阳市",
                    gisGcj02Lat: 29.2894,
                    gisGcj02Lng: 120.242,
                  },
                  {
                    id: "330784",
                    text: "永康市",
                    gisGcj02Lat: 28.8884,
                    gisGcj02Lng: 120.047,
                  },
                ],
              },
              {
                id: "330800",
                text: "衢州市",
                children: [
                  {
                    id: "330802",
                    text: "柯城区",
                    gisGcj02Lat: 28.9686,
                    gisGcj02Lng: 118.871,
                  },
                  {
                    id: "330803",
                    text: "衢江区",
                    gisGcj02Lat: 28.9798,
                    gisGcj02Lng: 118.96,
                  },
                  {
                    id: "330822",
                    text: "常山县",
                    gisGcj02Lat: 28.9019,
                    gisGcj02Lng: 118.51,
                  },
                  {
                    id: "330824",
                    text: "开化县",
                    gisGcj02Lat: 29.1378,
                    gisGcj02Lng: 118.416,
                  },
                  {
                    id: "330825",
                    text: "龙游县",
                    gisGcj02Lat: 29.0282,
                    gisGcj02Lng: 119.172,
                  },
                  {
                    id: "330881",
                    text: "江山市",
                    gisGcj02Lat: 28.7386,
                    gisGcj02Lng: 118.627,
                  },
                ],
              },
              {
                id: "330900",
                text: "舟山市",
                children: [
                  {
                    id: "330902",
                    text: "定海区",
                    gisGcj02Lat: 30.0198,
                    gisGcj02Lng: 122.107,
                  },
                  {
                    id: "330903",
                    text: "普陀区",
                    gisGcj02Lat: 29.9491,
                    gisGcj02Lng: 122.303,
                  },
                  {
                    id: "330921",
                    text: "岱山县",
                    gisGcj02Lat: 30.2439,
                    gisGcj02Lng: 122.205,
                  },
                  {
                    id: "330922",
                    text: "嵊泗县",
                    gisGcj02Lat: 30.7268,
                    gisGcj02Lng: 122.451,
                  },
                ],
              },
              {
                id: "331000",
                text: "台州市",
                children: [
                  {
                    id: "331002",
                    text: "椒江区",
                    gisGcj02Lat: 28.673,
                    gisGcj02Lng: 121.443,
                  },
                  {
                    id: "331003",
                    text: "黄岩区",
                    gisGcj02Lat: 28.6508,
                    gisGcj02Lng: 121.259,
                  },
                  {
                    id: "331004",
                    text: "路桥区",
                    gisGcj02Lat: 28.5802,
                    gisGcj02Lng: 121.374,
                  },
                  {
                    id: "331021",
                    text: "玉环县",
                    gisGcj02Lat: 28.1364,
                    gisGcj02Lng: 121.232,
                  },
                  {
                    id: "331022",
                    text: "三门县",
                    gisGcj02Lat: 29.1051,
                    gisGcj02Lng: 121.394,
                  },
                  {
                    id: "331023",
                    text: "天台县",
                    gisGcj02Lat: 29.1429,
                    gisGcj02Lng: 121.008,
                  },
                  {
                    id: "331024",
                    text: "仙居县",
                    gisGcj02Lat: 28.8467,
                    gisGcj02Lng: 120.729,
                  },
                  {
                    id: "331081",
                    text: "温岭市",
                    gisGcj02Lat: 28.3718,
                    gisGcj02Lng: 121.386,
                  },
                  {
                    id: "331082",
                    text: "临海市",
                    gisGcj02Lat: 28.856,
                    gisGcj02Lng: 121.139,
                  },
                ],
              },
              {
                id: "331100",
                text: "丽水市",
                children: [
                  {
                    id: "331102",
                    text: "莲都区",
                    gisGcj02Lat: 28.4458,
                    gisGcj02Lng: 119.913,
                  },
                  {
                    id: "331121",
                    text: "青田县",
                    gisGcj02Lat: 28.139,
                    gisGcj02Lng: 120.29,
                  },
                  {
                    id: "331122",
                    text: "缙云县",
                    gisGcj02Lat: 28.6594,
                    gisGcj02Lng: 120.09,
                  },
                  {
                    id: "331123",
                    text: "遂昌县",
                    gisGcj02Lat: 28.5929,
                    gisGcj02Lng: 119.276,
                  },
                  {
                    id: "331124",
                    text: "松阳县",
                    gisGcj02Lat: 28.4494,
                    gisGcj02Lng: 119.482,
                  },
                  {
                    id: "331125",
                    text: "云和县",
                    gisGcj02Lat: 28.1164,
                    gisGcj02Lng: 119.573,
                  },
                  {
                    id: "331126",
                    text: "庆元县",
                    gisGcj02Lat: 27.6184,
                    gisGcj02Lng: 119.063,
                  },
                  {
                    id: "331127",
                    text: "景宁畲族自治县",
                    gisGcj02Lat: 27.9739,
                    gisGcj02Lng: 119.638,
                  },
                  {
                    id: "331181",
                    text: "龙泉市",
                    gisGcj02Lat: 28.0743,
                    gisGcj02Lng: 119.142,
                  },
                ],
              },
              {
                id: "331200",
                text: "舟山群岛新区",
                children: [
                  {
                    id: "331201",
                    text: "金塘岛",
                    gisGcj02Lat: 30.0406,
                    gisGcj02Lng: 121.893,
                  },
                  {
                    id: "331202",
                    text: "六横岛",
                    gisGcj02Lat: 29.6629,
                    gisGcj02Lng: 122.143,
                  },
                  {
                    id: "331203",
                    text: "衢山岛",
                    gisGcj02Lat: 30.4426,
                    gisGcj02Lng: 122.358,
                  },
                  {
                    id: "331204",
                    text: "舟山本岛西北部",
                    gisGcj02Lat: 30.1404,
                    gisGcj02Lng: 122.031,
                  },
                  {
                    id: "331205",
                    text: "岱山岛西南部",
                    gisGcj02Lat: 30.2773,
                    gisGcj02Lng: 122.18,
                  },
                  {
                    id: "331206",
                    text: "泗礁岛",
                    gisGcj02Lat: 30.7251,
                    gisGcj02Lng: 122.458,
                  },
                  {
                    id: "331207",
                    text: "朱家尖岛",
                    gisGcj02Lat: 29.9163,
                    gisGcj02Lng: 122.391,
                  },
                  {
                    id: "331208",
                    text: "洋山岛",
                    gisGcj02Lat: 30.0946,
                    gisGcj02Lng: 121.996,
                  },
                  {
                    id: "331209",
                    text: "长涂岛",
                    gisGcj02Lat: 30.2489,
                    gisGcj02Lng: 122.285,
                  },
                  {
                    id: "331210",
                    text: "虾峙岛",
                    gisGcj02Lat: 29.7529,
                    gisGcj02Lng: 122.245,
                  },
                ],
              },
            ],
          },
          {
            id: "340000",
            text: "安徽省",
            children: [
              {
                id: "340100",
                text: "合肥市",
                children: [
                  {
                    id: "340102",
                    text: "瑶海区",
                    gisGcj02Lat: 31.8581,
                    gisGcj02Lng: 117.309,
                  },
                  {
                    id: "340103",
                    text: "庐阳区",
                    gisGcj02Lat: 31.8787,
                    gisGcj02Lng: 117.265,
                  },
                  {
                    id: "340104",
                    text: "蜀山区",
                    gisGcj02Lat: 31.8512,
                    gisGcj02Lng: 117.261,
                  },
                  {
                    id: "340111",
                    text: "包河区",
                    gisGcj02Lat: 31.795,
                    gisGcj02Lng: 117.31,
                  },
                  {
                    id: "340121",
                    text: "长丰县",
                    gisGcj02Lat: 32.4796,
                    gisGcj02Lng: 117.165,
                  },
                  {
                    id: "340122",
                    text: "肥东县",
                    gisGcj02Lat: 31.8853,
                    gisGcj02Lng: 117.471,
                  },
                  {
                    id: "340123",
                    text: "肥西县",
                    gisGcj02Lat: 31.7214,
                    gisGcj02Lng: 117.168,
                  },
                  {
                    id: "340124",
                    text: "庐江县",
                    gisGcj02Lat: 31.2515,
                    gisGcj02Lng: 117.29,
                  },
                  {
                    id: "340181",
                    text: "巢湖市",
                    gisGcj02Lat: 31.6005,
                    gisGcj02Lng: 117.874,
                  },
                ],
              },
              {
                id: "340200",
                text: "芜湖市",
                children: [
                  {
                    id: "340202",
                    text: "镜湖区",
                    gisGcj02Lat: 31.3404,
                    gisGcj02Lng: 118.385,
                  },
                  {
                    id: "340203",
                    text: "弋江区",
                    gisGcj02Lat: 31.3118,
                    gisGcj02Lng: 118.373,
                  },
                  {
                    id: "340207",
                    text: "鸠江区",
                    gisGcj02Lat: 31.3693,
                    gisGcj02Lng: 118.392,
                  },
                  {
                    id: "340208",
                    text: "三山区",
                    gisGcj02Lat: 31.207,
                    gisGcj02Lng: 118.225,
                  },
                  {
                    id: "340221",
                    text: "湾沚区",
                    gisGcj02Lat: 31.1348,
                    gisGcj02Lng: 118.575,
                  },
                  {
                    id: "340222",
                    text: "繁昌区",
                    gisGcj02Lat: 31.0832,
                    gisGcj02Lng: 118.2,
                  },
                  {
                    id: "340223",
                    text: "南陵县",
                    gisGcj02Lat: 30.9197,
                    gisGcj02Lng: 118.337,
                  },
                  {
                    id: "340225",
                    text: "无为市",
                    gisGcj02Lat: 31.3031,
                    gisGcj02Lng: 117.911,
                  },
                ],
              },
              {
                id: "340300",
                text: "蚌埠市",
                children: [
                  {
                    id: "340302",
                    text: "龙子湖区",
                    gisGcj02Lat: 32.943,
                    gisGcj02Lng: 117.394,
                  },
                  {
                    id: "340303",
                    text: "蚌山区",
                    gisGcj02Lat: 32.9441,
                    gisGcj02Lng: 117.368,
                  },
                  {
                    id: "340304",
                    text: "禹会区",
                    gisGcj02Lat: 32.9334,
                    gisGcj02Lng: 117.353,
                  },
                  {
                    id: "340311",
                    text: "淮上区",
                    gisGcj02Lat: 32.9642,
                    gisGcj02Lng: 117.36,
                  },
                  {
                    id: "340321",
                    text: "怀远县",
                    gisGcj02Lat: 32.9701,
                    gisGcj02Lng: 117.205,
                  },
                  {
                    id: "340322",
                    text: "五河县",
                    gisGcj02Lat: 33.1446,
                    gisGcj02Lng: 117.891,
                  },
                  {
                    id: "340323",
                    text: "固镇县",
                    gisGcj02Lat: 33.318,
                    gisGcj02Lng: 117.316,
                  },
                ],
              },
              {
                id: "340400",
                text: "淮南市",
                children: [
                  {
                    id: "340402",
                    text: "大通区",
                    gisGcj02Lat: 32.6326,
                    gisGcj02Lng: 117.053,
                  },
                  {
                    id: "340403",
                    text: "田家庵区",
                    gisGcj02Lat: 32.647,
                    gisGcj02Lng: 117.017,
                  },
                  {
                    id: "340404",
                    text: "谢家集区",
                    gisGcj02Lat: 32.5982,
                    gisGcj02Lng: 116.864,
                  },
                  {
                    id: "340405",
                    text: "八公山区",
                    gisGcj02Lat: 32.6294,
                    gisGcj02Lng: 116.837,
                  },
                  {
                    id: "340406",
                    text: "潘集区",
                    gisGcj02Lat: 32.7829,
                    gisGcj02Lng: 116.816,
                  },
                  {
                    id: "340421",
                    text: "凤台县",
                    gisGcj02Lat: 32.7075,
                    gisGcj02Lng: 116.716,
                  },
                  {
                    id: "340422",
                    text: "寿县",
                    gisGcj02Lat: 32.7075,
                    gisGcj02Lng: 116.716,
                  },
                ],
              },
              {
                id: "340500",
                text: "马鞍山市",
                children: [
                  {
                    id: "340503",
                    text: "花山区",
                    gisGcj02Lat: 31.7001,
                    gisGcj02Lng: 118.512,
                  },
                  {
                    id: "340504",
                    text: "雨山区",
                    gisGcj02Lat: 31.6822,
                    gisGcj02Lng: 118.499,
                  },
                  {
                    id: "340506",
                    text: "博望区",
                    gisGcj02Lat: 31.5619,
                    gisGcj02Lng: 118.844,
                  },
                  {
                    id: "340521",
                    text: "当涂县",
                    gisGcj02Lat: 31.571,
                    gisGcj02Lng: 118.498,
                  },
                  {
                    id: "340522",
                    text: "含山县",
                    gisGcj02Lat: 31.7278,
                    gisGcj02Lng: 118.106,
                  },
                  {
                    id: "340523",
                    text: "和县",
                    gisGcj02Lat: 31.7418,
                    gisGcj02Lng: 118.351,
                  },
                ],
              },
              {
                id: "340600",
                text: "淮北市",
                children: [
                  {
                    id: "340602",
                    text: "杜集区",
                    gisGcj02Lat: 33.9936,
                    gisGcj02Lng: 116.83,
                  },
                  {
                    id: "340603",
                    text: "相山区",
                    gisGcj02Lat: 33.9598,
                    gisGcj02Lng: 116.795,
                  },
                  {
                    id: "340604",
                    text: "烈山区",
                    gisGcj02Lat: 33.8936,
                    gisGcj02Lng: 116.814,
                  },
                  {
                    id: "340621",
                    text: "濉溪县",
                    gisGcj02Lat: 33.9146,
                    gisGcj02Lng: 116.768,
                  },
                ],
              },
              {
                id: "340700",
                text: "铜陵市",
                children: [
                  {
                    id: "340702",
                    text: "铜官山区",
                    gisGcj02Lat: 30.9342,
                    gisGcj02Lng: 117.815,
                  },
                  {
                    id: "340703",
                    text: "狮子山区",
                    gisGcj02Lat: 30.9263,
                    gisGcj02Lng: 117.892,
                  },
                  {
                    id: "340711",
                    text: "郊区",
                    gisGcj02Lat: 30.9198,
                    gisGcj02Lng: 117.809,
                  },
                  {
                    id: "340721",
                    text: "铜陵县",
                    gisGcj02Lat: 30.9536,
                    gisGcj02Lng: 117.791,
                  },
                  {
                    id: "340722",
                    text: "铜官区",
                    gisGcj02Lat: 30.9536,
                    gisGcj02Lng: 117.791,
                  },
                  {
                    id: "340723",
                    text: "义安区",
                    gisGcj02Lat: 30.9536,
                    gisGcj02Lng: 117.791,
                  },
                  {
                    id: "340724",
                    text: "郊区",
                    gisGcj02Lat: 30.9536,
                    gisGcj02Lng: 117.791,
                  },
                  {
                    id: "340725",
                    text: "枞阳县",
                    gisGcj02Lat: 30.9536,
                    gisGcj02Lng: 117.791,
                  },
                ],
              },
              {
                id: "340800",
                text: "安庆市",
                children: [
                  {
                    id: "340802",
                    text: "迎江区",
                    gisGcj02Lat: 30.5042,
                    gisGcj02Lng: 117.049,
                  },
                  {
                    id: "340803",
                    text: "大观区",
                    gisGcj02Lat: 30.5122,
                    gisGcj02Lng: 117.034,
                  },
                  {
                    id: "340811",
                    text: "宜秀区",
                    gisGcj02Lat: 30.5078,
                    gisGcj02Lng: 117.061,
                  },
                  {
                    id: "340822",
                    text: "怀宁县",
                    gisGcj02Lat: 30.7338,
                    gisGcj02Lng: 116.83,
                  },
                  {
                    id: "340823",
                    text: "枞阳县",
                    gisGcj02Lat: 30.6996,
                    gisGcj02Lng: 117.22,
                  },
                  {
                    id: "340824",
                    text: "潜山县",
                    gisGcj02Lat: 30.6304,
                    gisGcj02Lng: 116.576,
                  },
                  {
                    id: "340825",
                    text: "太湖县",
                    gisGcj02Lat: 30.4541,
                    gisGcj02Lng: 116.309,
                  },
                  {
                    id: "340826",
                    text: "宿松县",
                    gisGcj02Lat: 30.1536,
                    gisGcj02Lng: 116.129,
                  },
                  {
                    id: "340827",
                    text: "望江县",
                    gisGcj02Lat: 30.1259,
                    gisGcj02Lng: 116.688,
                  },
                  {
                    id: "340828",
                    text: "岳西县",
                    gisGcj02Lat: 30.8498,
                    gisGcj02Lng: 116.36,
                  },
                  {
                    id: "340881",
                    text: "桐城市",
                    gisGcj02Lat: 31.0522,
                    gisGcj02Lng: 116.951,
                  },
                ],
              },
              {
                id: "341000",
                text: "黄山市",
                children: [
                  {
                    id: "341002",
                    text: "屯溪区",
                    gisGcj02Lat: 29.7114,
                    gisGcj02Lng: 118.334,
                  },
                  {
                    id: "341003",
                    text: "黄山区",
                    gisGcj02Lat: 30.2729,
                    gisGcj02Lng: 118.142,
                  },
                  {
                    id: "341004",
                    text: "徽州区",
                    gisGcj02Lat: 29.8278,
                    gisGcj02Lng: 118.337,
                  },
                  {
                    id: "341021",
                    text: "歙县",
                    gisGcj02Lat: 29.8675,
                    gisGcj02Lng: 118.437,
                  },
                  {
                    id: "341022",
                    text: "休宁县",
                    gisGcj02Lat: 29.7861,
                    gisGcj02Lng: 118.181,
                  },
                  {
                    id: "341023",
                    text: "黟县",
                    gisGcj02Lat: 29.9259,
                    gisGcj02Lng: 117.941,
                  },
                  {
                    id: "341024",
                    text: "祁门县",
                    gisGcj02Lat: 29.8572,
                    gisGcj02Lng: 117.718,
                  },
                ],
              },
              {
                id: "341100",
                text: "滁州市",
                children: [
                  {
                    id: "341102",
                    text: "琅琊区",
                    gisGcj02Lat: 32.2952,
                    gisGcj02Lng: 118.305,
                  },
                  {
                    id: "341103",
                    text: "南谯区",
                    gisGcj02Lat: 32.3186,
                    gisGcj02Lng: 118.312,
                  },
                  {
                    id: "341122",
                    text: "来安县",
                    gisGcj02Lat: 32.4518,
                    gisGcj02Lng: 118.434,
                  },
                  {
                    id: "341124",
                    text: "全椒县",
                    gisGcj02Lat: 32.0852,
                    gisGcj02Lng: 118.273,
                  },
                  {
                    id: "341125",
                    text: "定远县",
                    gisGcj02Lat: 32.5249,
                    gisGcj02Lng: 117.68,
                  },
                  {
                    id: "341126",
                    text: "凤阳县",
                    gisGcj02Lat: 32.8651,
                    gisGcj02Lng: 117.565,
                  },
                  {
                    id: "341181",
                    text: "天长市",
                    gisGcj02Lat: 32.6912,
                    gisGcj02Lng: 118.999,
                  },
                  {
                    id: "341182",
                    text: "明光市",
                    gisGcj02Lat: 32.7782,
                    gisGcj02Lng: 117.991,
                  },
                ],
              },
              {
                id: "341200",
                text: "阜阳市",
                children: [
                  {
                    id: "341202",
                    text: "颍州区",
                    gisGcj02Lat: 32.8835,
                    gisGcj02Lng: 115.807,
                  },
                  {
                    id: "341203",
                    text: "颍东区",
                    gisGcj02Lat: 32.913,
                    gisGcj02Lng: 115.857,
                  },
                  {
                    id: "341204",
                    text: "颍泉区",
                    gisGcj02Lat: 32.9249,
                    gisGcj02Lng: 115.807,
                  },
                  {
                    id: "341221",
                    text: "临泉县",
                    gisGcj02Lat: 33.0676,
                    gisGcj02Lng: 115.262,
                  },
                  {
                    id: "341222",
                    text: "太和县",
                    gisGcj02Lat: 33.1603,
                    gisGcj02Lng: 115.622,
                  },
                  {
                    id: "341225",
                    text: "阜南县",
                    gisGcj02Lat: 32.6355,
                    gisGcj02Lng: 115.586,
                  },
                  {
                    id: "341226",
                    text: "颍上县",
                    gisGcj02Lat: 32.63,
                    gisGcj02Lng: 116.265,
                  },
                  {
                    id: "341282",
                    text: "界首市",
                    gisGcj02Lat: 33.2571,
                    gisGcj02Lng: 115.374,
                  },
                ],
              },
              {
                id: "341300",
                text: "宿州市",
                children: [
                  {
                    id: "341302",
                    text: "埇桥区",
                    gisGcj02Lat: 33.6406,
                    gisGcj02Lng: 116.977,
                  },
                  {
                    id: "341321",
                    text: "砀山县",
                    gisGcj02Lat: 34.4236,
                    gisGcj02Lng: 116.354,
                  },
                  {
                    id: "341322",
                    text: "萧县",
                    gisGcj02Lat: 34.1879,
                    gisGcj02Lng: 116.945,
                  },
                  {
                    id: "341323",
                    text: "灵璧县",
                    gisGcj02Lat: 33.5434,
                    gisGcj02Lng: 117.558,
                  },
                  {
                    id: "341324",
                    text: "泗县",
                    gisGcj02Lat: 33.4829,
                    gisGcj02Lng: 117.91,
                  },
                ],
              },
              {
                id: "341500",
                text: "六安市",
                children: [
                  {
                    id: "341502",
                    text: "金安区",
                    gisGcj02Lat: 31.7557,
                    gisGcj02Lng: 116.509,
                  },
                  {
                    id: "341503",
                    text: "裕安区",
                    gisGcj02Lat: 31.7379,
                    gisGcj02Lng: 116.48,
                  },
                  {
                    id: "341504",
                    text: "叶集区",
                    gisGcj02Lat: 31.7379,
                    gisGcj02Lng: 116.48,
                  },
                  {
                    id: "341521",
                    text: "寿县",
                    gisGcj02Lat: 32.5765,
                    gisGcj02Lng: 116.785,
                  },
                  {
                    id: "341522",
                    text: "霍邱县",
                    gisGcj02Lat: 32.353,
                    gisGcj02Lng: 116.278,
                  },
                  {
                    id: "341523",
                    text: "舒城县",
                    gisGcj02Lat: 31.4641,
                    gisGcj02Lng: 116.945,
                  },
                  {
                    id: "341524",
                    text: "金寨县",
                    gisGcj02Lat: 31.7351,
                    gisGcj02Lng: 115.935,
                  },
                  {
                    id: "341525",
                    text: "霍山县",
                    gisGcj02Lat: 31.3929,
                    gisGcj02Lng: 116.333,
                  },
                ],
              },
              {
                id: "341600",
                text: "亳州市",
                children: [
                  {
                    id: "341602",
                    text: "谯城区",
                    gisGcj02Lat: 33.8753,
                    gisGcj02Lng: 115.779,
                  },
                  {
                    id: "341621",
                    text: "涡阳县",
                    gisGcj02Lat: 33.5091,
                    gisGcj02Lng: 116.217,
                  },
                  {
                    id: "341622",
                    text: "蒙城县",
                    gisGcj02Lat: 33.2648,
                    gisGcj02Lng: 116.565,
                  },
                  {
                    id: "341623",
                    text: "利辛县",
                    gisGcj02Lat: 33.142,
                    gisGcj02Lng: 116.208,
                  },
                ],
              },
              {
                id: "341700",
                text: "池州市",
                children: [
                  {
                    id: "341702",
                    text: "贵池区",
                    gisGcj02Lat: 30.6528,
                    gisGcj02Lng: 117.487,
                  },
                  {
                    id: "341721",
                    text: "东至县",
                    gisGcj02Lat: 30.0969,
                    gisGcj02Lng: 117.027,
                  },
                  {
                    id: "341722",
                    text: "石台县",
                    gisGcj02Lat: 30.2104,
                    gisGcj02Lng: 117.487,
                  },
                  {
                    id: "341723",
                    text: "青阳县",
                    gisGcj02Lat: 30.6393,
                    gisGcj02Lng: 117.847,
                  },
                ],
              },
              {
                id: "341800",
                text: "宣城市",
                children: [
                  {
                    id: "341802",
                    text: "宣州区",
                    gisGcj02Lat: 30.9444,
                    gisGcj02Lng: 118.755,
                  },
                  {
                    id: "341821",
                    text: "郎溪县",
                    gisGcj02Lat: 31.126,
                    gisGcj02Lng: 119.179,
                  },
                  {
                    id: "341822",
                    text: "广德市",
                    gisGcj02Lat: 30.8937,
                    gisGcj02Lng: 119.418,
                  },
                  {
                    id: "341823",
                    text: "泾县",
                    gisGcj02Lat: 30.695,
                    gisGcj02Lng: 118.42,
                  },
                  {
                    id: "341824",
                    text: "绩溪县",
                    gisGcj02Lat: 30.0707,
                    gisGcj02Lng: 118.598,
                  },
                  {
                    id: "341825",
                    text: "旌德县",
                    gisGcj02Lat: 30.289,
                    gisGcj02Lng: 118.543,
                  },
                  {
                    id: "341881",
                    text: "宁国市",
                    gisGcj02Lat: 30.6238,
                    gisGcj02Lng: 118.983,
                  },
                ],
              },
            ],
          },
          {
            id: "350000",
            text: "福建省",
            children: [
              {
                id: "350100",
                text: "福州市",
                children: [
                  {
                    id: "350102",
                    text: "鼓楼区",
                    gisGcj02Lat: 26.0823,
                    gisGcj02Lng: 119.304,
                  },
                  {
                    id: "350103",
                    text: "台江区",
                    gisGcj02Lat: 26.062,
                    gisGcj02Lng: 119.309,
                  },
                  {
                    id: "350104",
                    text: "仓山区",
                    gisGcj02Lat: 26.0434,
                    gisGcj02Lng: 119.315,
                  },
                  {
                    id: "350105",
                    text: "马尾区",
                    gisGcj02Lat: 25.9894,
                    gisGcj02Lng: 119.455,
                  },
                  {
                    id: "350111",
                    text: "晋安区",
                    gisGcj02Lat: 26.0818,
                    gisGcj02Lng: 119.328,
                  },
                  {
                    id: "350121",
                    text: "闽侯县",
                    gisGcj02Lat: 26.1501,
                    gisGcj02Lng: 119.134,
                  },
                  {
                    id: "350122",
                    text: "连江县",
                    gisGcj02Lat: 26.1947,
                    gisGcj02Lng: 119.534,
                  },
                  {
                    id: "350123",
                    text: "罗源县",
                    gisGcj02Lat: 26.4875,
                    gisGcj02Lng: 119.551,
                  },
                  {
                    id: "350124",
                    text: "闽清县",
                    gisGcj02Lat: 26.219,
                    gisGcj02Lng: 118.862,
                  },
                  {
                    id: "350125",
                    text: "永泰县",
                    gisGcj02Lat: 25.8682,
                    gisGcj02Lng: 118.936,
                  },
                  {
                    id: "350128",
                    text: "平潭县",
                    gisGcj02Lat: 25.5037,
                    gisGcj02Lng: 119.791,
                  },
                  {
                    id: "350181",
                    text: "福清市",
                    gisGcj02Lat: 25.7209,
                    gisGcj02Lng: 119.385,
                  },
                  {
                    id: "350182",
                    text: "长乐区",
                    gisGcj02Lat: 25.9628,
                    gisGcj02Lng: 119.523,
                  },
                ],
              },
              {
                id: "350200",
                text: "厦门市",
                children: [
                  {
                    id: "350203",
                    text: "思明区",
                    gisGcj02Lat: 24.4454,
                    gisGcj02Lng: 118.082,
                  },
                  {
                    id: "350205",
                    text: "海沧区",
                    gisGcj02Lat: 24.4846,
                    gisGcj02Lng: 118.033,
                  },
                  {
                    id: "350206",
                    text: "湖里区",
                    gisGcj02Lat: 24.5125,
                    gisGcj02Lng: 118.146,
                  },
                  {
                    id: "350211",
                    text: "集美区",
                    gisGcj02Lat: 24.5758,
                    gisGcj02Lng: 118.097,
                  },
                  {
                    id: "350212",
                    text: "同安区",
                    gisGcj02Lat: 24.7231,
                    gisGcj02Lng: 118.152,
                  },
                  {
                    id: "350213",
                    text: "翔安区",
                    gisGcj02Lat: 24.6186,
                    gisGcj02Lng: 118.248,
                  },
                ],
              },
              {
                id: "350300",
                text: "莆田市",
                children: [
                  {
                    id: "350302",
                    text: "城厢区",
                    gisGcj02Lat: 25.4187,
                    gisGcj02Lng: 118.995,
                  },
                  {
                    id: "350303",
                    text: "涵江区",
                    gisGcj02Lat: 25.4588,
                    gisGcj02Lng: 119.116,
                  },
                  {
                    id: "350304",
                    text: "荔城区",
                    gisGcj02Lat: 25.4337,
                    gisGcj02Lng: 119.013,
                  },
                  {
                    id: "350305",
                    text: "秀屿区",
                    gisGcj02Lat: 25.3183,
                    gisGcj02Lng: 119.106,
                  },
                  {
                    id: "350322",
                    text: "仙游县",
                    gisGcj02Lat: 25.3621,
                    gisGcj02Lng: 118.692,
                  },
                ],
              },
              {
                id: "350400",
                text: "三明市",
                children: [
                  {
                    id: "350402",
                    text: "梅列区",
                    gisGcj02Lat: 26.2717,
                    gisGcj02Lng: 117.646,
                  },
                  {
                    id: "350403",
                    text: "三元区",
                    gisGcj02Lat: 26.2337,
                    gisGcj02Lng: 117.608,
                  },
                  {
                    id: "350421",
                    text: "明溪县",
                    gisGcj02Lat: 26.3529,
                    gisGcj02Lng: 117.205,
                  },
                  {
                    id: "350423",
                    text: "清流县",
                    gisGcj02Lat: 26.1714,
                    gisGcj02Lng: 116.815,
                  },
                  {
                    id: "350424",
                    text: "宁化县",
                    gisGcj02Lat: 26.2587,
                    gisGcj02Lng: 116.661,
                  },
                  {
                    id: "350425",
                    text: "大田县",
                    gisGcj02Lat: 25.6926,
                    gisGcj02Lng: 117.847,
                  },
                  {
                    id: "350426",
                    text: "尤溪县",
                    gisGcj02Lat: 26.17,
                    gisGcj02Lng: 118.19,
                  },
                  {
                    id: "350427",
                    text: "沙县区",
                    gisGcj02Lat: 26.3962,
                    gisGcj02Lng: 117.793,
                  },
                  {
                    id: "350428",
                    text: "将乐县",
                    gisGcj02Lat: 26.7284,
                    gisGcj02Lng: 117.473,
                  },
                  {
                    id: "350429",
                    text: "泰宁县",
                    gisGcj02Lat: 26.9001,
                    gisGcj02Lng: 117.176,
                  },
                  {
                    id: "350430",
                    text: "建宁县",
                    gisGcj02Lat: 26.8309,
                    gisGcj02Lng: 116.846,
                  },
                  {
                    id: "350481",
                    text: "永安市",
                    gisGcj02Lat: 25.9414,
                    gisGcj02Lng: 117.365,
                  },
                ],
              },
              {
                id: "350500",
                text: "泉州市",
                children: [
                  {
                    id: "350502",
                    text: "鲤城区",
                    gisGcj02Lat: 24.8874,
                    gisGcj02Lng: 118.566,
                  },
                  {
                    id: "350503",
                    text: "丰泽区",
                    gisGcj02Lat: 24.8912,
                    gisGcj02Lng: 118.613,
                  },
                  {
                    id: "350504",
                    text: "洛江区",
                    gisGcj02Lat: 24.9398,
                    gisGcj02Lng: 118.671,
                  },
                  {
                    id: "350505",
                    text: "泉港区",
                    gisGcj02Lat: 25.1201,
                    gisGcj02Lng: 118.916,
                  },
                  {
                    id: "350521",
                    text: "惠安县",
                    gisGcj02Lat: 25.0306,
                    gisGcj02Lng: 118.797,
                  },
                  {
                    id: "350524",
                    text: "安溪县",
                    gisGcj02Lat: 25.0563,
                    gisGcj02Lng: 118.187,
                  },
                  {
                    id: "350525",
                    text: "永春县",
                    gisGcj02Lat: 25.3218,
                    gisGcj02Lng: 118.294,
                  },
                  {
                    id: "350526",
                    text: "德化县",
                    gisGcj02Lat: 25.4922,
                    gisGcj02Lng: 118.242,
                  },
                  {
                    id: "350527",
                    text: "金门县",
                    gisGcj02Lat: 24.4292,
                    gisGcj02Lng: 118.323,
                  },
                  {
                    id: "350581",
                    text: "石狮市",
                    gisGcj02Lat: 24.7324,
                    gisGcj02Lng: 118.648,
                  },
                  {
                    id: "350582",
                    text: "晋江市",
                    gisGcj02Lat: 24.7814,
                    gisGcj02Lng: 118.552,
                  },
                  {
                    id: "350583",
                    text: "南安市",
                    gisGcj02Lat: 24.9606,
                    gisGcj02Lng: 118.386,
                  },
                ],
              },
              {
                id: "350600",
                text: "漳州市",
                children: [
                  {
                    id: "350602",
                    text: "芗城区",
                    gisGcj02Lat: 24.5108,
                    gisGcj02Lng: 117.654,
                  },
                  {
                    id: "350603",
                    text: "龙文区",
                    gisGcj02Lat: 24.5032,
                    gisGcj02Lng: 117.71,
                  },
                  {
                    id: "350622",
                    text: "云霄县",
                    gisGcj02Lat: 23.9553,
                    gisGcj02Lng: 117.341,
                  },
                  {
                    id: "350623",
                    text: "漳浦县",
                    gisGcj02Lat: 24.1171,
                    gisGcj02Lng: 117.614,
                  },
                  {
                    id: "350624",
                    text: "诏安县",
                    gisGcj02Lat: 23.7115,
                    gisGcj02Lng: 117.175,
                  },
                  {
                    id: "350625",
                    text: "长泰区",
                    gisGcj02Lat: 24.6253,
                    gisGcj02Lng: 117.759,
                  },
                  {
                    id: "350626",
                    text: "东山县",
                    gisGcj02Lat: 23.7011,
                    gisGcj02Lng: 117.428,
                  },
                  {
                    id: "350627",
                    text: "南靖县",
                    gisGcj02Lat: 24.5145,
                    gisGcj02Lng: 117.357,
                  },
                  {
                    id: "350628",
                    text: "平和县",
                    gisGcj02Lat: 24.364,
                    gisGcj02Lng: 117.312,
                  },
                  {
                    id: "350629",
                    text: "华安县",
                    gisGcj02Lat: 25.0056,
                    gisGcj02Lng: 117.541,
                  },
                  {
                    id: "350681",
                    text: "龙海区",
                    gisGcj02Lat: 24.4466,
                    gisGcj02Lng: 117.818,
                  },
                ],
              },
              {
                id: "350700",
                text: "南平市",
                children: [
                  {
                    id: "350702",
                    text: "延平区",
                    gisGcj02Lat: 26.6374,
                    gisGcj02Lng: 118.182,
                  },
                  {
                    id: "350703",
                    text: "建阳区",
                    gisGcj02Lat: 27.3321,
                    gisGcj02Lng: 118.123,
                  },
                  {
                    id: "350721",
                    text: "顺昌县",
                    gisGcj02Lat: 26.793,
                    gisGcj02Lng: 117.81,
                  },
                  {
                    id: "350722",
                    text: "浦城县",
                    gisGcj02Lat: 27.9189,
                    gisGcj02Lng: 118.54,
                  },
                  {
                    id: "350723",
                    text: "光泽县",
                    gisGcj02Lat: 27.5423,
                    gisGcj02Lng: 117.333,
                  },
                  {
                    id: "350724",
                    text: "松溪县",
                    gisGcj02Lat: 27.5262,
                    gisGcj02Lng: 118.785,
                  },
                  {
                    id: "350725",
                    text: "政和县",
                    gisGcj02Lat: 27.3677,
                    gisGcj02Lng: 118.856,
                  },
                  {
                    id: "350781",
                    text: "邵武市",
                    gisGcj02Lat: 27.3403,
                    gisGcj02Lng: 117.492,
                  },
                  {
                    id: "350782",
                    text: "武夷山市",
                    gisGcj02Lat: 27.7554,
                    gisGcj02Lng: 118.037,
                  },
                  {
                    id: "350783",
                    text: "建瓯市",
                    gisGcj02Lat: 27.023,
                    gisGcj02Lng: 118.298,
                  },
                ],
              },
              {
                id: "350800",
                text: "龙岩市",
                children: [
                  {
                    id: "350802",
                    text: "新罗区",
                    gisGcj02Lat: 25.0983,
                    gisGcj02Lng: 117.037,
                  },
                  {
                    id: "350821",
                    text: "长汀县",
                    gisGcj02Lat: 25.8277,
                    gisGcj02Lng: 116.359,
                  },
                  {
                    id: "350822",
                    text: "永定区",
                    gisGcj02Lat: 24.723,
                    gisGcj02Lng: 116.732,
                  },
                  {
                    id: "350823",
                    text: "上杭县",
                    gisGcj02Lat: 25.0494,
                    gisGcj02Lng: 116.42,
                  },
                  {
                    id: "350824",
                    text: "武平县",
                    gisGcj02Lat: 25.0924,
                    gisGcj02Lng: 116.102,
                  },
                  {
                    id: "350825",
                    text: "连城县",
                    gisGcj02Lat: 25.7103,
                    gisGcj02Lng: 116.755,
                  },
                  {
                    id: "350881",
                    text: "漳平市",
                    gisGcj02Lat: 25.2911,
                    gisGcj02Lng: 117.42,
                  },
                ],
              },
              {
                id: "350900",
                text: "宁德市",
                children: [
                  {
                    id: "350902",
                    text: "蕉城区",
                    gisGcj02Lat: 26.6605,
                    gisGcj02Lng: 119.526,
                  },
                  {
                    id: "350921",
                    text: "霞浦县",
                    gisGcj02Lat: 26.8858,
                    gisGcj02Lng: 119.999,
                  },
                  {
                    id: "350922",
                    text: "古田县",
                    gisGcj02Lat: 26.5768,
                    gisGcj02Lng: 118.747,
                  },
                  {
                    id: "350923",
                    text: "屏南县",
                    gisGcj02Lat: 26.911,
                    gisGcj02Lng: 118.989,
                  },
                  {
                    id: "350924",
                    text: "寿宁县",
                    gisGcj02Lat: 27.46,
                    gisGcj02Lng: 119.504,
                  },
                  {
                    id: "350925",
                    text: "周宁县",
                    gisGcj02Lat: 27.1066,
                    gisGcj02Lng: 119.338,
                  },
                  {
                    id: "350926",
                    text: "柘荣县",
                    gisGcj02Lat: 27.2354,
                    gisGcj02Lng: 119.9,
                  },
                  {
                    id: "350981",
                    text: "福安市",
                    gisGcj02Lat: 27.0867,
                    gisGcj02Lng: 119.649,
                  },
                  {
                    id: "350982",
                    text: "福鼎市",
                    gisGcj02Lat: 27.3243,
                    gisGcj02Lng: 120.217,
                  },
                ],
              },
            ],
          },
          {
            id: "360000",
            text: "江西省",
            children: [
              {
                id: "360100",
                text: "南昌市",
                children: [
                  {
                    id: "360113",
                    text: "红谷滩区",
                    gisGcj02Lat: 28.704,
                    gisGcj02Lng: 115.864,
                  },
                  {
                    id: "360102",
                    text: "东湖区",
                    gisGcj02Lat: 28.685,
                    gisGcj02Lng: 115.899,
                  },
                  {
                    id: "360103",
                    text: "西湖区",
                    gisGcj02Lat: 28.6569,
                    gisGcj02Lng: 115.877,
                  },
                  {
                    id: "360104",
                    text: "青云谱区",
                    gisGcj02Lat: 28.632,
                    gisGcj02Lng: 115.915,
                  },
                  {
                    id: "360105",
                    text: "湾里区",
                    gisGcj02Lat: 28.7153,
                    gisGcj02Lng: 115.731,
                  },
                  {
                    id: "360111",
                    text: "青山湖区",
                    gisGcj02Lat: 28.6821,
                    gisGcj02Lng: 115.962,
                  },
                  {
                    id: "360121",
                    text: "南昌县",
                    gisGcj02Lat: 28.5456,
                    gisGcj02Lng: 115.944,
                  },
                  {
                    id: "360122",
                    text: "新建县",
                    gisGcj02Lat: 28.6925,
                    gisGcj02Lng: 115.815,
                  },
                  {
                    id: "360123",
                    text: "安义县",
                    gisGcj02Lat: 28.846,
                    gisGcj02Lng: 115.549,
                  },
                  {
                    id: "360124",
                    text: "进贤县",
                    gisGcj02Lat: 28.3768,
                    gisGcj02Lng: 116.241,
                  },
                ],
              },
              {
                id: "360200",
                text: "景德镇市",
                children: [
                  {
                    id: "360202",
                    text: "昌江区",
                    gisGcj02Lat: 29.2732,
                    gisGcj02Lng: 117.184,
                  },
                  {
                    id: "360203",
                    text: "珠山区",
                    gisGcj02Lat: 29.3013,
                    gisGcj02Lng: 117.202,
                  },
                  {
                    id: "360222",
                    text: "浮梁县",
                    gisGcj02Lat: 29.3516,
                    gisGcj02Lng: 117.215,
                  },
                  {
                    id: "360281",
                    text: "乐平市",
                    gisGcj02Lat: 28.9629,
                    gisGcj02Lng: 117.129,
                  },
                ],
              },
              {
                id: "360300",
                text: "萍乡市",
                children: [
                  {
                    id: "360302",
                    text: "安源区",
                    gisGcj02Lat: 27.6165,
                    gisGcj02Lng: 113.891,
                  },
                  {
                    id: "360313",
                    text: "湘东区",
                    gisGcj02Lat: 27.6401,
                    gisGcj02Lng: 113.733,
                  },
                  {
                    id: "360321",
                    text: "莲花县",
                    gisGcj02Lat: 27.1287,
                    gisGcj02Lng: 113.961,
                  },
                  {
                    id: "360322",
                    text: "上栗县",
                    gisGcj02Lat: 27.8747,
                    gisGcj02Lng: 113.794,
                  },
                  {
                    id: "360323",
                    text: "芦溪县",
                    gisGcj02Lat: 27.6306,
                    gisGcj02Lng: 114.03,
                  },
                ],
              },
              {
                id: "360400",
                text: "九江市",
                children: [
                  {
                    id: "360402",
                    text: "庐山市",
                    gisGcj02Lat: 29.6718,
                    gisGcj02Lng: 115.989,
                  },
                  {
                    id: "360403",
                    text: "浔阳区",
                    gisGcj02Lat: 29.7279,
                    gisGcj02Lng: 115.99,
                  },
                  {
                    id: "360404",
                    text: "濂溪区",
                    gisGcj02Lat: 29.7279,
                    gisGcj02Lng: 115.99,
                  },
                  {
                    id: "360421",
                    text: "九江县",
                    gisGcj02Lat: 29.6085,
                    gisGcj02Lng: 115.911,
                  },
                  {
                    id: "360423",
                    text: "武宁县",
                    gisGcj02Lat: 29.2584,
                    gisGcj02Lng: 115.101,
                  },
                  {
                    id: "360424",
                    text: "修水县",
                    gisGcj02Lat: 29.0254,
                    gisGcj02Lng: 114.547,
                  },
                  {
                    id: "360425",
                    text: "永修县",
                    gisGcj02Lat: 29.0209,
                    gisGcj02Lng: 115.809,
                  },
                  {
                    id: "360426",
                    text: "德安县",
                    gisGcj02Lat: 29.3134,
                    gisGcj02Lng: 115.756,
                  },
                  {
                    id: "360427",
                    text: "星子县",
                    gisGcj02Lat: 29.4461,
                    gisGcj02Lng: 116.045,
                  },
                  {
                    id: "360428",
                    text: "都昌县",
                    gisGcj02Lat: 29.2733,
                    gisGcj02Lng: 116.204,
                  },
                  {
                    id: "360429",
                    text: "湖口县",
                    gisGcj02Lat: 29.7382,
                    gisGcj02Lng: 116.219,
                  },
                  {
                    id: "360430",
                    text: "彭泽县",
                    gisGcj02Lat: 29.8959,
                    gisGcj02Lng: 116.55,
                  },
                  {
                    id: "360481",
                    text: "瑞昌市",
                    gisGcj02Lat: 29.6718,
                    gisGcj02Lng: 115.667,
                  },
                  {
                    id: "360482",
                    text: "共青城市",
                    gisGcj02Lat: 29.2388,
                    gisGcj02Lng: 115.802,
                  },
                ],
              },
              {
                id: "360500",
                text: "新余市",
                children: [
                  {
                    id: "360502",
                    text: "渝水区",
                    gisGcj02Lat: 27.801,
                    gisGcj02Lng: 114.944,
                  },
                  {
                    id: "360521",
                    text: "分宜县",
                    gisGcj02Lat: 27.8148,
                    gisGcj02Lng: 114.692,
                  },
                ],
              },
              {
                id: "360600",
                text: "鹰潭市",
                children: [
                  {
                    id: "360602",
                    text: "月湖区",
                    gisGcj02Lat: 28.2391,
                    gisGcj02Lng: 117.037,
                  },
                  {
                    id: "360622",
                    text: "余江县",
                    gisGcj02Lat: 28.2103,
                    gisGcj02Lng: 116.819,
                  },
                  {
                    id: "360681",
                    text: "贵溪市",
                    gisGcj02Lat: 28.2926,
                    gisGcj02Lng: 117.242,
                  },
                ],
              },
              {
                id: "360700",
                text: "赣州市",
                children: [
                  {
                    id: "360702",
                    text: "章贡区",
                    gisGcj02Lat: 25.8624,
                    gisGcj02Lng: 114.943,
                  },
                  {
                    id: "360703",
                    text: "南康区",
                    gisGcj02Lat: 25.6617,
                    gisGcj02Lng: 114.757,
                  },
                  {
                    id: "360721",
                    text: "赣县区",
                    gisGcj02Lat: 25.8615,
                    gisGcj02Lng: 115.012,
                  },
                  {
                    id: "360722",
                    text: "信丰县",
                    gisGcj02Lat: 25.3861,
                    gisGcj02Lng: 114.923,
                  },
                  {
                    id: "360723",
                    text: "大余县",
                    gisGcj02Lat: 25.3956,
                    gisGcj02Lng: 114.358,
                  },
                  {
                    id: "360724",
                    text: "上犹县",
                    gisGcj02Lat: 25.7957,
                    gisGcj02Lng: 114.541,
                  },
                  {
                    id: "360725",
                    text: "崇义县",
                    gisGcj02Lat: 25.6819,
                    gisGcj02Lng: 114.308,
                  },
                  {
                    id: "360726",
                    text: "安远县",
                    gisGcj02Lat: 25.1371,
                    gisGcj02Lng: 115.395,
                  },
                  {
                    id: "360727",
                    text: "龙南市",
                    gisGcj02Lat: 24.9109,
                    gisGcj02Lng: 114.79,
                  },
                  {
                    id: "360728",
                    text: "定南县",
                    gisGcj02Lat: 24.784,
                    gisGcj02Lng: 115.027,
                  },
                  {
                    id: "360729",
                    text: "全南县",
                    gisGcj02Lat: 24.7432,
                    gisGcj02Lng: 114.529,
                  },
                  {
                    id: "360730",
                    text: "宁都县",
                    gisGcj02Lat: 26.4723,
                    gisGcj02Lng: 116.016,
                  },
                  {
                    id: "360731",
                    text: "于都县",
                    gisGcj02Lat: 25.9526,
                    gisGcj02Lng: 115.414,
                  },
                  {
                    id: "360732",
                    text: "兴国县",
                    gisGcj02Lat: 26.3378,
                    gisGcj02Lng: 115.363,
                  },
                  {
                    id: "360733",
                    text: "会昌县",
                    gisGcj02Lat: 25.6007,
                    gisGcj02Lng: 115.786,
                  },
                  {
                    id: "360734",
                    text: "寻乌县",
                    gisGcj02Lat: 24.9551,
                    gisGcj02Lng: 115.649,
                  },
                  {
                    id: "360735",
                    text: "石城县",
                    gisGcj02Lat: 26.3262,
                    gisGcj02Lng: 116.344,
                  },
                  {
                    id: "360781",
                    text: "瑞金市",
                    gisGcj02Lat: 25.8856,
                    gisGcj02Lng: 116.027,
                  },
                ],
              },
              {
                id: "360800",
                text: "吉安市",
                children: [
                  {
                    id: "360802",
                    text: "吉州区",
                    gisGcj02Lat: 27.1067,
                    gisGcj02Lng: 114.976,
                  },
                  {
                    id: "360803",
                    text: "青原区",
                    gisGcj02Lat: 27.1058,
                    gisGcj02Lng: 115.017,
                  },
                  {
                    id: "360821",
                    text: "吉安县",
                    gisGcj02Lat: 27.0405,
                    gisGcj02Lng: 114.907,
                  },
                  {
                    id: "360822",
                    text: "吉水县",
                    gisGcj02Lat: 27.2107,
                    gisGcj02Lng: 115.134,
                  },
                  {
                    id: "360823",
                    text: "峡江县",
                    gisGcj02Lat: 27.576,
                    gisGcj02Lng: 115.317,
                  },
                  {
                    id: "360824",
                    text: "新干县",
                    gisGcj02Lat: 27.7409,
                    gisGcj02Lng: 115.393,
                  },
                  {
                    id: "360825",
                    text: "永丰县",
                    gisGcj02Lat: 27.3179,
                    gisGcj02Lng: 115.442,
                  },
                  {
                    id: "360826",
                    text: "泰和县",
                    gisGcj02Lat: 26.7911,
                    gisGcj02Lng: 114.908,
                  },
                  {
                    id: "360827",
                    text: "遂川县",
                    gisGcj02Lat: 26.326,
                    gisGcj02Lng: 114.516,
                  },
                  {
                    id: "360828",
                    text: "万安县",
                    gisGcj02Lat: 26.4593,
                    gisGcj02Lng: 114.787,
                  },
                  {
                    id: "360829",
                    text: "安福县",
                    gisGcj02Lat: 27.3928,
                    gisGcj02Lng: 114.62,
                  },
                  {
                    id: "360830",
                    text: "永新县",
                    gisGcj02Lat: 26.9449,
                    gisGcj02Lng: 114.242,
                  },
                  {
                    id: "360881",
                    text: "井冈山市",
                    gisGcj02Lat: 26.748,
                    gisGcj02Lng: 114.289,
                  },
                ],
              },
              {
                id: "360900",
                text: "宜春市",
                children: [
                  {
                    id: "360902",
                    text: "袁州区",
                    gisGcj02Lat: 27.7965,
                    gisGcj02Lng: 114.382,
                  },
                  {
                    id: "360921",
                    text: "奉新县",
                    gisGcj02Lat: 28.6879,
                    gisGcj02Lng: 115.4,
                  },
                  {
                    id: "360922",
                    text: "万载县",
                    gisGcj02Lat: 28.1066,
                    gisGcj02Lng: 114.446,
                  },
                  {
                    id: "360923",
                    text: "上高县",
                    gisGcj02Lat: 28.2342,
                    gisGcj02Lng: 114.925,
                  },
                  {
                    id: "360924",
                    text: "宜丰县",
                    gisGcj02Lat: 28.3855,
                    gisGcj02Lng: 114.78,
                  },
                  {
                    id: "360925",
                    text: "靖安县",
                    gisGcj02Lat: 28.8617,
                    gisGcj02Lng: 115.363,
                  },
                  {
                    id: "360926",
                    text: "铜鼓县",
                    gisGcj02Lat: 28.5231,
                    gisGcj02Lng: 114.37,
                  },
                  {
                    id: "360981",
                    text: "丰城市",
                    gisGcj02Lat: 28.1592,
                    gisGcj02Lng: 115.771,
                  },
                  {
                    id: "360982",
                    text: "樟树市",
                    gisGcj02Lat: 28.0533,
                    gisGcj02Lng: 115.547,
                  },
                  {
                    id: "360983",
                    text: "高安市",
                    gisGcj02Lat: 28.4178,
                    gisGcj02Lng: 115.375,
                  },
                ],
              },
              {
                id: "361000",
                text: "抚州市",
                children: [
                  {
                    id: "361002",
                    text: "临川区",
                    gisGcj02Lat: 27.9772,
                    gisGcj02Lng: 116.359,
                  },
                  {
                    id: "361021",
                    text: "南城县",
                    gisGcj02Lat: 27.5538,
                    gisGcj02Lng: 116.644,
                  },
                  {
                    id: "361022",
                    text: "黎川县",
                    gisGcj02Lat: 27.2823,
                    gisGcj02Lng: 116.908,
                  },
                  {
                    id: "361023",
                    text: "南丰县",
                    gisGcj02Lat: 27.2184,
                    gisGcj02Lng: 116.526,
                  },
                  {
                    id: "361024",
                    text: "崇仁县",
                    gisGcj02Lat: 27.7596,
                    gisGcj02Lng: 116.06,
                  },
                  {
                    id: "361025",
                    text: "乐安县",
                    gisGcj02Lat: 27.4281,
                    gisGcj02Lng: 115.831,
                  },
                  {
                    id: "361026",
                    text: "宜黄县",
                    gisGcj02Lat: 27.5549,
                    gisGcj02Lng: 116.236,
                  },
                  {
                    id: "361027",
                    text: "金溪县",
                    gisGcj02Lat: 27.9075,
                    gisGcj02Lng: 116.774,
                  },
                  {
                    id: "361028",
                    text: "资溪县",
                    gisGcj02Lat: 27.7049,
                    gisGcj02Lng: 117.069,
                  },
                  {
                    id: "361029",
                    text: "东乡县",
                    gisGcj02Lat: 28.2361,
                    gisGcj02Lng: 116.59,
                  },
                  {
                    id: "361030",
                    text: "广昌县",
                    gisGcj02Lat: 26.8341,
                    gisGcj02Lng: 116.325,
                  },
                ],
              },
              {
                id: "361100",
                text: "上饶市",
                children: [
                  {
                    id: "361104",
                    text: "广信区",
                    gisGcj02Lat: 28.454,
                    gisGcj02Lng: 117.915,
                  },
                  {
                    id: "361102",
                    text: "信州区",
                    gisGcj02Lat: 28.4312,
                    gisGcj02Lng: 117.967,
                  },
                  {
                    id: "361121",
                    text: "上饶县",
                    gisGcj02Lat: 28.4486,
                    gisGcj02Lng: 117.909,
                  },
                  {
                    id: "361122",
                    text: "广丰县",
                    gisGcj02Lat: 28.4377,
                    gisGcj02Lng: 118.192,
                  },
                  {
                    id: "361123",
                    text: "玉山县",
                    gisGcj02Lat: 28.6818,
                    gisGcj02Lng: 118.245,
                  },
                  {
                    id: "361124",
                    text: "铅山县",
                    gisGcj02Lat: 28.3155,
                    gisGcj02Lng: 117.71,
                  },
                  {
                    id: "361125",
                    text: "横峰县",
                    gisGcj02Lat: 28.4072,
                    gisGcj02Lng: 117.596,
                  },
                  {
                    id: "361126",
                    text: "弋阳县",
                    gisGcj02Lat: 28.3745,
                    gisGcj02Lng: 117.459,
                  },
                  {
                    id: "361127",
                    text: "余干县",
                    gisGcj02Lat: 28.7021,
                    gisGcj02Lng: 116.696,
                  },
                  {
                    id: "361128",
                    text: "鄱阳县",
                    gisGcj02Lat: 29.0118,
                    gisGcj02Lng: 116.7,
                  },
                  {
                    id: "361129",
                    text: "万年县",
                    gisGcj02Lat: 28.6954,
                    gisGcj02Lng: 117.069,
                  },
                  {
                    id: "361130",
                    text: "婺源县",
                    gisGcj02Lat: 29.2484,
                    gisGcj02Lng: 117.861,
                  },
                  {
                    id: "361131",
                    text: "波阳县",
                    gisGcj02Lat: 29.2484,
                    gisGcj02Lng: 117.861,
                  },
                  {
                    id: "361181",
                    text: "德兴市",
                    gisGcj02Lat: 28.9474,
                    gisGcj02Lng: 117.579,
                  },
                ],
              },
            ],
          },
          {
            id: "370000",
            text: "山东省",
            children: [
              {
                id: "370100",
                text: "济南市",
                children: [
                  {
                    id: "370102",
                    text: "历下区",
                    gisGcj02Lat: 36.6666,
                    gisGcj02Lng: 117.077,
                  },
                  {
                    id: "370103",
                    text: "市中区",
                    gisGcj02Lat: 36.651,
                    gisGcj02Lng: 116.997,
                  },
                  {
                    id: "370104",
                    text: "槐荫区",
                    gisGcj02Lat: 36.6514,
                    gisGcj02Lng: 116.901,
                  },
                  {
                    id: "370105",
                    text: "天桥区",
                    gisGcj02Lat: 36.678,
                    gisGcj02Lng: 116.987,
                  },
                  {
                    id: "370112",
                    text: "历城区",
                    gisGcj02Lat: 36.68,
                    gisGcj02Lng: 117.065,
                  },
                  {
                    id: "370113",
                    text: "长清区",
                    gisGcj02Lat: 36.5535,
                    gisGcj02Lng: 116.752,
                  },
                  {
                    id: "370124",
                    text: "平阴县",
                    gisGcj02Lat: 36.2896,
                    gisGcj02Lng: 116.456,
                  },
                  {
                    id: "370125",
                    text: "济阳县",
                    gisGcj02Lat: 36.9785,
                    gisGcj02Lng: 117.173,
                  },
                  {
                    id: "370126",
                    text: "商河县",
                    gisGcj02Lat: 37.3112,
                    gisGcj02Lng: 117.157,
                  },
                  {
                    id: "370181",
                    text: "章丘区",
                    gisGcj02Lat: 36.7139,
                    gisGcj02Lng: 117.537,
                  },
                ],
              },
              {
                id: "370200",
                text: "青岛市",
                children: [
                  {
                    id: "370202",
                    text: "市南区",
                    gisGcj02Lat: 36.0667,
                    gisGcj02Lng: 120.388,
                  },
                  {
                    id: "370203",
                    text: "市北区",
                    gisGcj02Lat: 36.0873,
                    gisGcj02Lng: 120.375,
                  },
                  {
                    id: "370211",
                    text: "黄岛区",
                    gisGcj02Lat: 35.9607,
                    gisGcj02Lng: 120.198,
                  },
                  {
                    id: "370212",
                    text: "崂山区",
                    gisGcj02Lat: 36.1072,
                    gisGcj02Lng: 120.469,
                  },
                  {
                    id: "370213",
                    text: "李沧区",
                    gisGcj02Lat: 36.145,
                    gisGcj02Lng: 120.433,
                  },
                  {
                    id: "370214",
                    text: "城阳区",
                    gisGcj02Lat: 36.3074,
                    gisGcj02Lng: 120.396,
                  },
                  {
                    id: "370281",
                    text: "胶州市",
                    gisGcj02Lat: 36.2644,
                    gisGcj02Lng: 120.034,
                  },
                  {
                    id: "370282",
                    text: "即墨市",
                    gisGcj02Lat: 36.3891,
                    gisGcj02Lng: 120.447,
                  },
                  {
                    id: "370283",
                    text: "平度市",
                    gisGcj02Lat: 36.7869,
                    gisGcj02Lng: 119.96,
                  },
                  {
                    id: "370285",
                    text: "莱西市",
                    gisGcj02Lat: 36.888,
                    gisGcj02Lng: 120.518,
                  },
                  {
                    id: "370286",
                    text: "西海岸新区",
                    gisGcj02Lat: 35.9607,
                    gisGcj02Lng: 120.198,
                  },
                ],
              },
              {
                id: "370300",
                text: "淄博市",
                children: [
                  {
                    id: "370302",
                    text: "淄川区",
                    gisGcj02Lat: 36.6434,
                    gisGcj02Lng: 117.967,
                  },
                  {
                    id: "370303",
                    text: "张店区",
                    gisGcj02Lat: 36.8068,
                    gisGcj02Lng: 118.018,
                  },
                  {
                    id: "370304",
                    text: "博山区",
                    gisGcj02Lat: 36.4947,
                    gisGcj02Lng: 117.862,
                  },
                  {
                    id: "370305",
                    text: "临淄区",
                    gisGcj02Lat: 36.8259,
                    gisGcj02Lng: 118.31,
                  },
                  {
                    id: "370306",
                    text: "周村区",
                    gisGcj02Lat: 36.8032,
                    gisGcj02Lng: 117.87,
                  },
                  {
                    id: "370321",
                    text: "桓台县",
                    gisGcj02Lat: 36.9604,
                    gisGcj02Lng: 118.097,
                  },
                  {
                    id: "370322",
                    text: "高青县",
                    gisGcj02Lat: 37.172,
                    gisGcj02Lng: 117.827,
                  },
                  {
                    id: "370323",
                    text: "沂源县",
                    gisGcj02Lat: 36.1854,
                    gisGcj02Lng: 118.171,
                  },
                ],
              },
              {
                id: "370400",
                text: "枣庄市",
                children: [
                  {
                    id: "370402",
                    text: "市中区",
                    gisGcj02Lat: 34.8639,
                    gisGcj02Lng: 117.556,
                  },
                  {
                    id: "370403",
                    text: "薛城区",
                    gisGcj02Lat: 34.795,
                    gisGcj02Lng: 117.263,
                  },
                  {
                    id: "370404",
                    text: "峄城区",
                    gisGcj02Lat: 34.7723,
                    gisGcj02Lng: 117.591,
                  },
                  {
                    id: "370405",
                    text: "台儿庄区",
                    gisGcj02Lat: 34.5636,
                    gisGcj02Lng: 117.735,
                  },
                  {
                    id: "370406",
                    text: "山亭区",
                    gisGcj02Lat: 35.0954,
                    gisGcj02Lng: 117.466,
                  },
                  {
                    id: "370481",
                    text: "滕州市",
                    gisGcj02Lat: 35.1053,
                    gisGcj02Lng: 117.165,
                  },
                ],
              },
              {
                id: "370500",
                text: "东营市",
                children: [
                  {
                    id: "370502",
                    text: "东营区",
                    gisGcj02Lat: 37.4487,
                    gisGcj02Lng: 118.582,
                  },
                  {
                    id: "370503",
                    text: "河口区",
                    gisGcj02Lat: 37.8854,
                    gisGcj02Lng: 118.525,
                  },
                  {
                    id: "370521",
                    text: "垦利县",
                    gisGcj02Lat: 37.5882,
                    gisGcj02Lng: 118.548,
                  },
                  {
                    id: "370522",
                    text: "利津县",
                    gisGcj02Lat: 37.4916,
                    gisGcj02Lng: 118.256,
                  },
                  {
                    id: "370523",
                    text: "广饶县",
                    gisGcj02Lat: 37.0538,
                    gisGcj02Lng: 118.407,
                  },
                ],
              },
              {
                id: "370600",
                text: "烟台市",
                children: [
                  {
                    id: "370602",
                    text: "芝罘区",
                    gisGcj02Lat: 37.5406,
                    gisGcj02Lng: 121.4,
                  },
                  {
                    id: "370611",
                    text: "福山区",
                    gisGcj02Lat: 37.4984,
                    gisGcj02Lng: 121.268,
                  },
                  {
                    id: "370612",
                    text: "牟平区",
                    gisGcj02Lat: 37.3885,
                    gisGcj02Lng: 121.601,
                  },
                  {
                    id: "370613",
                    text: "莱山区",
                    gisGcj02Lat: 37.5117,
                    gisGcj02Lng: 121.445,
                  },
                  {
                    id: "370634",
                    text: "长岛县",
                    gisGcj02Lat: 37.9175,
                    gisGcj02Lng: 120.738,
                  },
                  {
                    id: "370681",
                    text: "龙口市",
                    gisGcj02Lat: 37.6406,
                    gisGcj02Lng: 120.506,
                  },
                  {
                    id: "370682",
                    text: "莱阳市",
                    gisGcj02Lat: 36.9801,
                    gisGcj02Lng: 120.711,
                  },
                  {
                    id: "370683",
                    text: "莱州市",
                    gisGcj02Lat: 37.1781,
                    gisGcj02Lng: 119.941,
                  },
                  {
                    id: "370684",
                    text: "蓬莱区",
                    gisGcj02Lat: 37.8112,
                    gisGcj02Lng: 120.76,
                  },
                  {
                    id: "370685",
                    text: "招远市",
                    gisGcj02Lat: 37.3627,
                    gisGcj02Lng: 120.405,
                  },
                  {
                    id: "370686",
                    text: "栖霞市",
                    gisGcj02Lat: 37.3357,
                    gisGcj02Lng: 120.85,
                  },
                  {
                    id: "370687",
                    text: "海阳市",
                    gisGcj02Lat: 36.7762,
                    gisGcj02Lng: 121.16,
                  },
                ],
              },
              {
                id: "370700",
                text: "潍坊市",
                children: [
                  {
                    id: "370702",
                    text: "潍城区",
                    gisGcj02Lat: 36.7139,
                    gisGcj02Lng: 119.106,
                  },
                  {
                    id: "370703",
                    text: "寒亭区",
                    gisGcj02Lat: 36.775,
                    gisGcj02Lng: 119.218,
                  },
                  {
                    id: "370704",
                    text: "坊子区",
                    gisGcj02Lat: 36.6522,
                    gisGcj02Lng: 119.165,
                  },
                  {
                    id: "370705",
                    text: "奎文区",
                    gisGcj02Lat: 36.7072,
                    gisGcj02Lng: 119.125,
                  },
                  {
                    id: "370724",
                    text: "临朐县",
                    gisGcj02Lat: 36.5122,
                    gisGcj02Lng: 118.544,
                  },
                  {
                    id: "370725",
                    text: "昌乐县",
                    gisGcj02Lat: 36.7078,
                    gisGcj02Lng: 118.83,
                  },
                  {
                    id: "370781",
                    text: "青州市",
                    gisGcj02Lat: 36.6851,
                    gisGcj02Lng: 118.479,
                  },
                  {
                    id: "370782",
                    text: "诸城市",
                    gisGcj02Lat: 35.9966,
                    gisGcj02Lng: 119.41,
                  },
                  {
                    id: "370783",
                    text: "寿光市",
                    gisGcj02Lat: 36.8813,
                    gisGcj02Lng: 118.74,
                  },
                  {
                    id: "370784",
                    text: "安丘市",
                    gisGcj02Lat: 36.4785,
                    gisGcj02Lng: 119.219,
                  },
                  {
                    id: "370785",
                    text: "高密市",
                    gisGcj02Lat: 36.384,
                    gisGcj02Lng: 119.757,
                  },
                  {
                    id: "370786",
                    text: "昌邑市",
                    gisGcj02Lat: 36.8601,
                    gisGcj02Lng: 119.398,
                  },
                ],
              },
              {
                id: "370800",
                text: "济宁市",
                children: [
                  {
                    id: "370811",
                    text: "任城区",
                    gisGcj02Lat: 35.4066,
                    gisGcj02Lng: 116.595,
                  },
                  {
                    id: "370812",
                    text: "兖州区",
                    gisGcj02Lat: 35.5523,
                    gisGcj02Lng: 116.827,
                  },
                  {
                    id: "370826",
                    text: "微山县",
                    gisGcj02Lat: 34.8071,
                    gisGcj02Lng: 117.129,
                  },
                  {
                    id: "370827",
                    text: "鱼台县",
                    gisGcj02Lat: 34.9967,
                    gisGcj02Lng: 116.648,
                  },
                  {
                    id: "370828",
                    text: "金乡县",
                    gisGcj02Lat: 35.065,
                    gisGcj02Lng: 116.311,
                  },
                  {
                    id: "370829",
                    text: "嘉祥县",
                    gisGcj02Lat: 35.4084,
                    gisGcj02Lng: 116.342,
                  },
                  {
                    id: "370830",
                    text: "汶上县",
                    gisGcj02Lat: 35.7329,
                    gisGcj02Lng: 116.487,
                  },
                  {
                    id: "370831",
                    text: "泗水县",
                    gisGcj02Lat: 35.6611,
                    gisGcj02Lng: 117.279,
                  },
                  {
                    id: "370832",
                    text: "梁山县",
                    gisGcj02Lat: 35.8032,
                    gisGcj02Lng: 116.097,
                  },
                  {
                    id: "370881",
                    text: "曲阜市",
                    gisGcj02Lat: 35.5809,
                    gisGcj02Lng: 116.986,
                  },
                  {
                    id: "370883",
                    text: "邹城市",
                    gisGcj02Lat: 35.4053,
                    gisGcj02Lng: 116.973,
                  },
                ],
              },
              {
                id: "370900",
                text: "泰安市",
                children: [
                  {
                    id: "370902",
                    text: "泰山区",
                    gisGcj02Lat: 36.1941,
                    gisGcj02Lng: 117.134,
                  },
                  {
                    id: "370911",
                    text: "岱岳区",
                    gisGcj02Lat: 36.1875,
                    gisGcj02Lng: 117.042,
                  },
                  {
                    id: "370921",
                    text: "宁阳县",
                    gisGcj02Lat: 35.7599,
                    gisGcj02Lng: 116.805,
                  },
                  {
                    id: "370923",
                    text: "东平县",
                    gisGcj02Lat: 35.9379,
                    gisGcj02Lng: 116.471,
                  },
                  {
                    id: "370982",
                    text: "新泰市",
                    gisGcj02Lat: 35.9089,
                    gisGcj02Lng: 117.77,
                  },
                  {
                    id: "370983",
                    text: "肥城市",
                    gisGcj02Lat: 36.1825,
                    gisGcj02Lng: 116.768,
                  },
                ],
              },
              {
                id: "371000",
                text: "威海市",
                children: [
                  {
                    id: "371002",
                    text: "环翠区",
                    gisGcj02Lat: 37.502,
                    gisGcj02Lng: 122.123,
                  },
                  {
                    id: "371003",
                    text: "文登区",
                    gisGcj02Lat: 37.1962,
                    gisGcj02Lng: 122.057,
                  },
                  {
                    id: "371082",
                    text: "荣成市",
                    gisGcj02Lat: 37.1652,
                    gisGcj02Lng: 122.488,
                  },
                  {
                    id: "371083",
                    text: "乳山市",
                    gisGcj02Lat: 36.9192,
                    gisGcj02Lng: 121.538,
                  },
                ],
              },
              {
                id: "371100",
                text: "日照市",
                children: [
                  {
                    id: "371102",
                    text: "东港区",
                    gisGcj02Lat: 35.4254,
                    gisGcj02Lng: 119.462,
                  },
                  {
                    id: "371103",
                    text: "岚山区",
                    gisGcj02Lat: 35.122,
                    gisGcj02Lng: 119.319,
                  },
                  {
                    id: "371121",
                    text: "五莲县",
                    gisGcj02Lat: 35.75,
                    gisGcj02Lng: 119.207,
                  },
                  {
                    id: "371122",
                    text: "莒县",
                    gisGcj02Lat: 35.5805,
                    gisGcj02Lng: 118.838,
                  },
                ],
              },
              {
                id: "371200",
                text: "莱芜市",
                children: [
                  {
                    id: "371202",
                    text: "莱城区",
                    gisGcj02Lat: 36.2032,
                    gisGcj02Lng: 117.66,
                  },
                  {
                    id: "371203",
                    text: "钢城区",
                    gisGcj02Lat: 36.0632,
                    gisGcj02Lng: 117.805,
                  },
                ],
              },
              {
                id: "371300",
                text: "临沂市",
                children: [
                  {
                    id: "371302",
                    text: "兰山区",
                    gisGcj02Lat: 35.0687,
                    gisGcj02Lng: 118.348,
                  },
                  {
                    id: "371311",
                    text: "罗庄区",
                    gisGcj02Lat: 34.9963,
                    gisGcj02Lng: 118.285,
                  },
                  {
                    id: "371312",
                    text: "河东区",
                    gisGcj02Lat: 35.088,
                    gisGcj02Lng: 118.411,
                  },
                  {
                    id: "371321",
                    text: "沂南县",
                    gisGcj02Lat: 35.5513,
                    gisGcj02Lng: 118.471,
                  },
                  {
                    id: "371322",
                    text: "郯城县",
                    gisGcj02Lat: 34.6135,
                    gisGcj02Lng: 118.367,
                  },
                  {
                    id: "371323",
                    text: "沂水县",
                    gisGcj02Lat: 35.7873,
                    gisGcj02Lng: 118.63,
                  },
                  {
                    id: "371324",
                    text: "兰陵县",
                    gisGcj02Lat: 34.7383,
                    gisGcj02Lng: 117.857,
                  },
                  {
                    id: "371325",
                    text: "费县",
                    gisGcj02Lat: 35.2656,
                    gisGcj02Lng: 117.978,
                  },
                  {
                    id: "371326",
                    text: "平邑县",
                    gisGcj02Lat: 35.5057,
                    gisGcj02Lng: 117.639,
                  },
                  {
                    id: "371327",
                    text: "莒南县",
                    gisGcj02Lat: 35.1754,
                    gisGcj02Lng: 118.832,
                  },
                  {
                    id: "371328",
                    text: "蒙阴县",
                    gisGcj02Lat: 35.71,
                    gisGcj02Lng: 117.946,
                  },
                  {
                    id: "371329",
                    text: "临沭县",
                    gisGcj02Lat: 34.9209,
                    gisGcj02Lng: 118.653,
                  },
                  {
                    id: "371330",
                    text: "苍山县",
                    gisGcj02Lat: 34.9209,
                    gisGcj02Lng: 118.653,
                  },
                ],
              },
              {
                id: "371400",
                text: "德州市",
                children: [
                  {
                    id: "371402",
                    text: "德城区",
                    gisGcj02Lat: 37.4513,
                    gisGcj02Lng: 116.299,
                  },
                  {
                    id: "371403",
                    text: "陵城区",
                    gisGcj02Lat: 37.3357,
                    gisGcj02Lng: 116.576,
                  },
                  {
                    id: "371422",
                    text: "宁津县",
                    gisGcj02Lat: 37.653,
                    gisGcj02Lng: 116.797,
                  },
                  {
                    id: "371423",
                    text: "庆云县",
                    gisGcj02Lat: 37.7762,
                    gisGcj02Lng: 117.386,
                  },
                  {
                    id: "371424",
                    text: "临邑县",
                    gisGcj02Lat: 37.1905,
                    gisGcj02Lng: 116.865,
                  },
                  {
                    id: "371425",
                    text: "齐河县",
                    gisGcj02Lat: 36.7953,
                    gisGcj02Lng: 116.755,
                  },
                  {
                    id: "371426",
                    text: "平原县",
                    gisGcj02Lat: 37.1663,
                    gisGcj02Lng: 116.434,
                  },
                  {
                    id: "371427",
                    text: "夏津县",
                    gisGcj02Lat: 36.9485,
                    gisGcj02Lng: 116.002,
                  },
                  {
                    id: "371428",
                    text: "武城县",
                    gisGcj02Lat: 37.214,
                    gisGcj02Lng: 116.07,
                  },
                  {
                    id: "371481",
                    text: "乐陵市",
                    gisGcj02Lat: 37.7316,
                    gisGcj02Lng: 117.231,
                  },
                  {
                    id: "371482",
                    text: "禹城市",
                    gisGcj02Lat: 36.9344,
                    gisGcj02Lng: 116.643,
                  },
                ],
              },
              {
                id: "371500",
                text: "聊城市",
                children: [
                  {
                    id: "371502",
                    text: "东昌府区",
                    gisGcj02Lat: 36.4446,
                    gisGcj02Lng: 115.974,
                  },
                  {
                    id: "371521",
                    text: "阳谷县",
                    gisGcj02Lat: 36.1144,
                    gisGcj02Lng: 115.791,
                  },
                  {
                    id: "371522",
                    text: "莘县",
                    gisGcj02Lat: 36.2342,
                    gisGcj02Lng: 115.67,
                  },
                  {
                    id: "371523",
                    text: "茌平区",
                    gisGcj02Lat: 36.5797,
                    gisGcj02Lng: 116.255,
                  },
                  {
                    id: "371524",
                    text: "东阿县",
                    gisGcj02Lat: 36.3321,
                    gisGcj02Lng: 116.25,
                  },
                  {
                    id: "371525",
                    text: "冠县",
                    gisGcj02Lat: 36.4843,
                    gisGcj02Lng: 115.442,
                  },
                  {
                    id: "371526",
                    text: "高唐县",
                    gisGcj02Lat: 36.8653,
                    gisGcj02Lng: 116.232,
                  },
                  {
                    id: "371581",
                    text: "临清市",
                    gisGcj02Lat: 36.8395,
                    gisGcj02Lng: 115.706,
                  },
                ],
              },
              {
                id: "371600",
                text: "滨州市",
                children: [
                  {
                    id: "371602",
                    text: "滨城区",
                    gisGcj02Lat: 37.3852,
                    gisGcj02Lng: 118.02,
                  },
                  {
                    id: "371603",
                    text: "沾化区",
                    gisGcj02Lat: 37.6983,
                    gisGcj02Lng: 118.132,
                  },
                  {
                    id: "371621",
                    text: "惠民县",
                    gisGcj02Lat: 37.4901,
                    gisGcj02Lng: 117.511,
                  },
                  {
                    id: "371622",
                    text: "阳信县",
                    gisGcj02Lat: 37.642,
                    gisGcj02Lng: 117.581,
                  },
                  {
                    id: "371623",
                    text: "无棣县",
                    gisGcj02Lat: 37.7401,
                    gisGcj02Lng: 117.614,
                  },
                  {
                    id: "371625",
                    text: "博兴县",
                    gisGcj02Lat: 37.1432,
                    gisGcj02Lng: 118.134,
                  },
                  {
                    id: "371626",
                    text: "邹平县",
                    gisGcj02Lat: 36.8629,
                    gisGcj02Lng: 117.743,
                  },
                  {
                    id: "371627",
                    text: "北海新区",
                    gisGcj02Lat: 37.3835,
                    gisGcj02Lng: 118.017,
                  },
                ],
              },
              {
                id: "371700",
                text: "菏泽市",
                children: [
                  {
                    id: "371702",
                    text: "牡丹区",
                    gisGcj02Lat: 35.2509,
                    gisGcj02Lng: 115.417,
                  },
                  {
                    id: "371721",
                    text: "曹县",
                    gisGcj02Lat: 34.8266,
                    gisGcj02Lng: 115.542,
                  },
                  {
                    id: "371722",
                    text: "单县",
                    gisGcj02Lat: 34.7951,
                    gisGcj02Lng: 116.087,
                  },
                  {
                    id: "371723",
                    text: "成武县",
                    gisGcj02Lat: 34.9533,
                    gisGcj02Lng: 115.89,
                  },
                  {
                    id: "371724",
                    text: "巨野县",
                    gisGcj02Lat: 35.3979,
                    gisGcj02Lng: 116.095,
                  },
                  {
                    id: "371725",
                    text: "郓城县",
                    gisGcj02Lat: 35.6004,
                    gisGcj02Lng: 115.944,
                  },
                  {
                    id: "371726",
                    text: "鄄城县",
                    gisGcj02Lat: 35.5641,
                    gisGcj02Lng: 115.51,
                  },
                  {
                    id: "371727",
                    text: "定陶县",
                    gisGcj02Lat: 35.0712,
                    gisGcj02Lng: 115.573,
                  },
                  {
                    id: "371728",
                    text: "东明县",
                    gisGcj02Lat: 35.2891,
                    gisGcj02Lng: 115.091,
                  },
                ],
              },
            ],
          },
          {
            id: "410000",
            text: "河南省",
            children: [
              {
                id: "410100",
                text: "郑州市",
                children: [
                  {
                    id: "410102",
                    text: "中原区",
                    gisGcj02Lat: 34.7483,
                    gisGcj02Lng: 113.613,
                  },
                  {
                    id: "410103",
                    text: "二七区",
                    gisGcj02Lat: 34.7234,
                    gisGcj02Lng: 113.639,
                  },
                  {
                    id: "410104",
                    text: "管城回族区",
                    gisGcj02Lat: 34.7538,
                    gisGcj02Lng: 113.677,
                  },
                  {
                    id: "410105",
                    text: "金水区",
                    gisGcj02Lat: 34.8003,
                    gisGcj02Lng: 113.661,
                  },
                  {
                    id: "410106",
                    text: "上街区",
                    gisGcj02Lat: 34.8028,
                    gisGcj02Lng: 113.309,
                  },
                  {
                    id: "410108",
                    text: "惠济区",
                    gisGcj02Lat: 34.8674,
                    gisGcj02Lng: 113.617,
                  },
                  {
                    id: "410122",
                    text: "中牟县",
                    gisGcj02Lat: 34.719,
                    gisGcj02Lng: 113.976,
                  },
                  {
                    id: "410181",
                    text: "巩义市",
                    gisGcj02Lat: 34.7479,
                    gisGcj02Lng: 113.022,
                  },
                  {
                    id: "410182",
                    text: "荥阳市",
                    gisGcj02Lat: 34.7876,
                    gisGcj02Lng: 113.383,
                  },
                  {
                    id: "410183",
                    text: "新密市",
                    gisGcj02Lat: 34.537,
                    gisGcj02Lng: 113.387,
                  },
                  {
                    id: "410184",
                    text: "新郑市",
                    gisGcj02Lat: 34.3955,
                    gisGcj02Lng: 113.736,
                  },
                  {
                    id: "410185",
                    text: "登封市",
                    gisGcj02Lat: 34.4534,
                    gisGcj02Lng: 113.05,
                  },
                  {
                    id: "410186",
                    text: "郑东新区",
                    gisGcj02Lat: 34.78131,
                    gisGcj02Lng: 113.74082,
                  },
                ],
              },
              {
                id: "410200",
                text: "开封市",
                children: [
                  {
                    id: "410202",
                    text: "龙亭区",
                    gisGcj02Lat: 34.7999,
                    gisGcj02Lng: 114.355,
                  },
                  {
                    id: "410203",
                    text: "顺河回族区",
                    gisGcj02Lat: 34.7959,
                    gisGcj02Lng: 114.361,
                  },
                  {
                    id: "410204",
                    text: "鼓楼区",
                    gisGcj02Lat: 34.7952,
                    gisGcj02Lng: 114.356,
                  },
                  {
                    id: "410205",
                    text: "禹王台区",
                    gisGcj02Lat: 34.7769,
                    gisGcj02Lng: 114.348,
                  },
                  {
                    id: "410212",
                    text: "祥符区",
                    gisGcj02Lat: 34.7587,
                    gisGcj02Lng: 114.439,
                  },
                  {
                    id: "410221",
                    text: "杞县",
                    gisGcj02Lat: 34.5503,
                    gisGcj02Lng: 114.783,
                  },
                  {
                    id: "410222",
                    text: "通许县",
                    gisGcj02Lat: 34.4752,
                    gisGcj02Lng: 114.467,
                  },
                  {
                    id: "410223",
                    text: "尉氏县",
                    gisGcj02Lat: 34.4122,
                    gisGcj02Lng: 114.193,
                  },
                  {
                    id: "410225",
                    text: "兰考县",
                    gisGcj02Lat: 34.8235,
                    gisGcj02Lng: 114.82,
                  },
                ],
              },
              {
                id: "410300",
                text: "洛阳市",
                children: [
                  {
                    id: "410302",
                    text: "老城区",
                    gisGcj02Lat: 34.6836,
                    gisGcj02Lng: 112.469,
                  },
                  {
                    id: "410303",
                    text: "西工区",
                    gisGcj02Lat: 34.67,
                    gisGcj02Lng: 112.437,
                  },
                  {
                    id: "410304",
                    text: "瀍河回族区",
                    gisGcj02Lat: 34.6799,
                    gisGcj02Lng: 112.5,
                  },
                  {
                    id: "410305",
                    text: "涧西区",
                    gisGcj02Lat: 34.6582,
                    gisGcj02Lng: 112.396,
                  },
                  {
                    id: "410306",
                    text: "吉利区",
                    gisGcj02Lat: 34.9009,
                    gisGcj02Lng: 112.589,
                  },
                  {
                    id: "410311",
                    text: "洛龙区",
                    gisGcj02Lat: 34.6187,
                    gisGcj02Lng: 112.464,
                  },
                  {
                    id: "410322",
                    text: "孟津区",
                    gisGcj02Lat: 34.826,
                    gisGcj02Lng: 112.444,
                  },
                  {
                    id: "410323",
                    text: "新安县",
                    gisGcj02Lat: 34.7281,
                    gisGcj02Lng: 112.132,
                  },
                  {
                    id: "410324",
                    text: "栾川县",
                    gisGcj02Lat: 33.7858,
                    gisGcj02Lng: 111.618,
                  },
                  {
                    id: "410325",
                    text: "嵩县",
                    gisGcj02Lat: 34.1347,
                    gisGcj02Lng: 112.085,
                  },
                  {
                    id: "410326",
                    text: "汝阳县",
                    gisGcj02Lat: 34.1539,
                    gisGcj02Lng: 112.473,
                  },
                  {
                    id: "410327",
                    text: "宜阳县",
                    gisGcj02Lat: 34.5152,
                    gisGcj02Lng: 112.179,
                  },
                  {
                    id: "410328",
                    text: "洛宁县",
                    gisGcj02Lat: 34.3891,
                    gisGcj02Lng: 111.651,
                  },
                  {
                    id: "410329",
                    text: "伊川县",
                    gisGcj02Lat: 34.4221,
                    gisGcj02Lng: 112.429,
                  },
                  {
                    id: "410381",
                    text: "偃师区",
                    gisGcj02Lat: 34.7281,
                    gisGcj02Lng: 112.792,
                  },
                ],
              },
              {
                id: "410400",
                text: "平顶山市",
                children: [
                  {
                    id: "410402",
                    text: "新华区",
                    gisGcj02Lat: 33.7373,
                    gisGcj02Lng: 113.294,
                  },
                  {
                    id: "410403",
                    text: "卫东区",
                    gisGcj02Lat: 33.7347,
                    gisGcj02Lng: 113.335,
                  },
                  {
                    id: "410404",
                    text: "石龙区",
                    gisGcj02Lat: 33.8988,
                    gisGcj02Lng: 112.899,
                  },
                  {
                    id: "410411",
                    text: "湛河区",
                    gisGcj02Lat: 33.7362,
                    gisGcj02Lng: 113.293,
                  },
                  {
                    id: "410421",
                    text: "宝丰县",
                    gisGcj02Lat: 33.8692,
                    gisGcj02Lng: 113.055,
                  },
                  {
                    id: "410422",
                    text: "叶县",
                    gisGcj02Lat: 33.6222,
                    gisGcj02Lng: 113.351,
                  },
                  {
                    id: "410423",
                    text: "鲁山县",
                    gisGcj02Lat: 33.7388,
                    gisGcj02Lng: 112.906,
                  },
                  {
                    id: "410425",
                    text: "郏县",
                    gisGcj02Lat: 33.9707,
                    gisGcj02Lng: 113.216,
                  },
                  {
                    id: "410481",
                    text: "舞钢市",
                    gisGcj02Lat: 33.2938,
                    gisGcj02Lng: 113.524,
                  },
                  {
                    id: "410482",
                    text: "汝州市",
                    gisGcj02Lat: 34.1614,
                    gisGcj02Lng: 112.843,
                  },
                ],
              },
              {
                id: "410500",
                text: "安阳市",
                children: [
                  {
                    id: "410502",
                    text: "文峰区",
                    gisGcj02Lat: 36.0905,
                    gisGcj02Lng: 114.357,
                  },
                  {
                    id: "410503",
                    text: "北关区",
                    gisGcj02Lat: 36.1187,
                    gisGcj02Lng: 114.357,
                  },
                  {
                    id: "410505",
                    text: "殷都区",
                    gisGcj02Lat: 36.1099,
                    gisGcj02Lng: 114.303,
                  },
                  {
                    id: "410506",
                    text: "龙安区",
                    gisGcj02Lat: 36.119,
                    gisGcj02Lng: 114.348,
                  },
                  {
                    id: "410522",
                    text: "安阳县",
                    gisGcj02Lat: 36.067,
                    gisGcj02Lng: 114.366,
                  },
                  {
                    id: "410523",
                    text: "汤阴县",
                    gisGcj02Lat: 35.9215,
                    gisGcj02Lng: 114.358,
                  },
                  {
                    id: "410526",
                    text: "滑县",
                    gisGcj02Lat: 35.5807,
                    gisGcj02Lng: 114.521,
                  },
                  {
                    id: "410527",
                    text: "内黄县",
                    gisGcj02Lat: 35.9527,
                    gisGcj02Lng: 114.907,
                  },
                  {
                    id: "410581",
                    text: "林州市",
                    gisGcj02Lat: 36.078,
                    gisGcj02Lng: 113.816,
                  },
                ],
              },
              {
                id: "410600",
                text: "鹤壁市",
                children: [
                  {
                    id: "410602",
                    text: "鹤山区",
                    gisGcj02Lat: 35.9546,
                    gisGcj02Lng: 114.163,
                  },
                  {
                    id: "410603",
                    text: "山城区",
                    gisGcj02Lat: 35.8977,
                    gisGcj02Lng: 114.184,
                  },
                  {
                    id: "410611",
                    text: "淇滨区",
                    gisGcj02Lat: 35.7413,
                    gisGcj02Lng: 114.299,
                  },
                  {
                    id: "410621",
                    text: "浚县",
                    gisGcj02Lat: 35.6708,
                    gisGcj02Lng: 114.549,
                  },
                  {
                    id: "410622",
                    text: "淇县",
                    gisGcj02Lat: 35.6078,
                    gisGcj02Lng: 114.198,
                  },
                ],
              },
              {
                id: "410700",
                text: "新乡市",
                children: [
                  {
                    id: "410702",
                    text: "红旗区",
                    gisGcj02Lat: 35.3037,
                    gisGcj02Lng: 113.875,
                  },
                  {
                    id: "410703",
                    text: "卫滨区",
                    gisGcj02Lat: 35.3021,
                    gisGcj02Lng: 113.866,
                  },
                  {
                    id: "410704",
                    text: "凤泉区",
                    gisGcj02Lat: 35.384,
                    gisGcj02Lng: 113.915,
                  },
                  {
                    id: "410711",
                    text: "牧野区",
                    gisGcj02Lat: 35.3149,
                    gisGcj02Lng: 113.909,
                  },
                  {
                    id: "410721",
                    text: "新乡县",
                    gisGcj02Lat: 35.1908,
                    gisGcj02Lng: 113.805,
                  },
                  {
                    id: "410724",
                    text: "获嘉县",
                    gisGcj02Lat: 35.2652,
                    gisGcj02Lng: 113.662,
                  },
                  {
                    id: "410725",
                    text: "原阳县",
                    gisGcj02Lat: 35.0657,
                    gisGcj02Lng: 113.94,
                  },
                  {
                    id: "410726",
                    text: "延津县",
                    gisGcj02Lat: 35.1433,
                    gisGcj02Lng: 114.203,
                  },
                  {
                    id: "410727",
                    text: "封丘县",
                    gisGcj02Lat: 35.0417,
                    gisGcj02Lng: 114.419,
                  },
                  {
                    id: "410728",
                    text: "长垣市",
                    gisGcj02Lat: 35.2005,
                    gisGcj02Lng: 114.669,
                  },
                  {
                    id: "410781",
                    text: "卫辉市",
                    gisGcj02Lat: 35.3984,
                    gisGcj02Lng: 114.065,
                  },
                  {
                    id: "410782",
                    text: "辉县市",
                    gisGcj02Lat: 35.4631,
                    gisGcj02Lng: 113.807,
                  },
                ],
              },
              {
                id: "410800",
                text: "焦作市",
                children: [
                  {
                    id: "410802",
                    text: "解放区",
                    gisGcj02Lat: 35.2402,
                    gisGcj02Lng: 113.229,
                  },
                  {
                    id: "410803",
                    text: "中站区",
                    gisGcj02Lat: 35.2366,
                    gisGcj02Lng: 113.183,
                  },
                  {
                    id: "410804",
                    text: "马村区",
                    gisGcj02Lat: 35.2691,
                    gisGcj02Lng: 113.319,
                  },
                  {
                    id: "410811",
                    text: "山阳区",
                    gisGcj02Lat: 35.2144,
                    gisGcj02Lng: 113.255,
                  },
                  {
                    id: "410821",
                    text: "修武县",
                    gisGcj02Lat: 35.2236,
                    gisGcj02Lng: 113.448,
                  },
                  {
                    id: "410822",
                    text: "博爱县",
                    gisGcj02Lat: 35.1694,
                    gisGcj02Lng: 113.067,
                  },
                  {
                    id: "410823",
                    text: "武陟县",
                    gisGcj02Lat: 35.0951,
                    gisGcj02Lng: 113.397,
                  },
                  {
                    id: "410825",
                    text: "温县",
                    gisGcj02Lat: 34.9402,
                    gisGcj02Lng: 113.081,
                  },
                  {
                    id: "410882",
                    text: "沁阳市",
                    gisGcj02Lat: 35.0894,
                    gisGcj02Lng: 112.945,
                  },
                  {
                    id: "410883",
                    text: "孟州市",
                    gisGcj02Lat: 34.9071,
                    gisGcj02Lng: 112.791,
                  },
                ],
              },
              {
                id: "410900",
                text: "濮阳市",
                children: [
                  {
                    id: "410902",
                    text: "华龙区",
                    gisGcj02Lat: 35.7774,
                    gisGcj02Lng: 115.074,
                  },
                  {
                    id: "410922",
                    text: "清丰县",
                    gisGcj02Lat: 35.8851,
                    gisGcj02Lng: 115.104,
                  },
                  {
                    id: "410923",
                    text: "南乐县",
                    gisGcj02Lat: 36.0769,
                    gisGcj02Lng: 115.206,
                  },
                  {
                    id: "410926",
                    text: "范县",
                    gisGcj02Lat: 35.8518,
                    gisGcj02Lng: 115.504,
                  },
                  {
                    id: "410927",
                    text: "台前县",
                    gisGcj02Lat: 35.9692,
                    gisGcj02Lng: 115.872,
                  },
                  {
                    id: "410928",
                    text: "濮阳县",
                    gisGcj02Lat: 35.7075,
                    gisGcj02Lng: 115.031,
                  },
                ],
              },
              {
                id: "411000",
                text: "许昌市",
                children: [
                  {
                    id: "411002",
                    text: "魏都区",
                    gisGcj02Lat: 34.0254,
                    gisGcj02Lng: 113.823,
                  },
                  {
                    id: "411003",
                    text: "建安区",
                    gisGcj02Lat: 34.0254,
                    gisGcj02Lng: 113.823,
                  },
                  {
                    id: "411023",
                    text: "许昌县",
                    gisGcj02Lat: 34.0041,
                    gisGcj02Lng: 113.847,
                  },
                  {
                    id: "411024",
                    text: "鄢陵县",
                    gisGcj02Lat: 34.1032,
                    gisGcj02Lng: 114.188,
                  },
                  {
                    id: "411025",
                    text: "襄城县",
                    gisGcj02Lat: 33.8493,
                    gisGcj02Lng: 113.482,
                  },
                  {
                    id: "411081",
                    text: "禹州市",
                    gisGcj02Lat: 34.1405,
                    gisGcj02Lng: 113.488,
                  },
                  {
                    id: "411082",
                    text: "长葛市",
                    gisGcj02Lat: 34.2185,
                    gisGcj02Lng: 113.773,
                  },
                ],
              },
              {
                id: "411100",
                text: "漯河市",
                children: [
                  {
                    id: "411102",
                    text: "源汇区",
                    gisGcj02Lat: 33.5563,
                    gisGcj02Lng: 114.006,
                  },
                  {
                    id: "411103",
                    text: "郾城区",
                    gisGcj02Lat: 33.5872,
                    gisGcj02Lng: 114.007,
                  },
                  {
                    id: "411104",
                    text: "召陵区",
                    gisGcj02Lat: 33.586,
                    gisGcj02Lng: 114.094,
                  },
                  {
                    id: "411121",
                    text: "舞阳县",
                    gisGcj02Lat: 33.4324,
                    gisGcj02Lng: 113.598,
                  },
                  {
                    id: "411122",
                    text: "临颍县",
                    gisGcj02Lat: 33.8112,
                    gisGcj02Lng: 113.937,
                  },
                ],
              },
              {
                id: "411200",
                text: "三门峡市",
                children: [
                  {
                    id: "411202",
                    text: "湖滨区",
                    gisGcj02Lat: 34.7787,
                    gisGcj02Lng: 111.2,
                  },
                  {
                    id: "411221",
                    text: "渑池县",
                    gisGcj02Lat: 34.7673,
                    gisGcj02Lng: 111.762,
                  },
                  {
                    id: "411222",
                    text: "陕洲区",
                    gisGcj02Lat: 34.7205,
                    gisGcj02Lng: 111.103,
                  },
                  {
                    id: "411224",
                    text: "卢氏县",
                    gisGcj02Lat: 34.0544,
                    gisGcj02Lng: 111.048,
                  },
                  {
                    id: "411281",
                    text: "义马市",
                    gisGcj02Lat: 34.7472,
                    gisGcj02Lng: 111.874,
                  },
                  {
                    id: "411282",
                    text: "灵宝市",
                    gisGcj02Lat: 34.5168,
                    gisGcj02Lng: 110.895,
                  },
                ],
              },
              {
                id: "411300",
                text: "南阳市",
                children: [
                  {
                    id: "411302",
                    text: "宛城区",
                    gisGcj02Lat: 33.0038,
                    gisGcj02Lng: 112.54,
                  },
                  {
                    id: "411303",
                    text: "卧龙区",
                    gisGcj02Lat: 32.9861,
                    gisGcj02Lng: 112.535,
                  },
                  {
                    id: "411321",
                    text: "南召县",
                    gisGcj02Lat: 33.491,
                    gisGcj02Lng: 112.432,
                  },
                  {
                    id: "411322",
                    text: "方城县",
                    gisGcj02Lat: 33.2545,
                    gisGcj02Lng: 113.013,
                  },
                  {
                    id: "411323",
                    text: "西峡县",
                    gisGcj02Lat: 33.2977,
                    gisGcj02Lng: 111.482,
                  },
                  {
                    id: "411324",
                    text: "镇平县",
                    gisGcj02Lat: 33.0363,
                    gisGcj02Lng: 112.24,
                  },
                  {
                    id: "411325",
                    text: "内乡县",
                    gisGcj02Lat: 33.0467,
                    gisGcj02Lng: 111.85,
                  },
                  {
                    id: "411326",
                    text: "淅川县",
                    gisGcj02Lat: 33.1371,
                    gisGcj02Lng: 111.487,
                  },
                  {
                    id: "411327",
                    text: "社旗县",
                    gisGcj02Lat: 33.055,
                    gisGcj02Lng: 112.947,
                  },
                  {
                    id: "411328",
                    text: "唐河县",
                    gisGcj02Lat: 32.6945,
                    gisGcj02Lng: 112.836,
                  },
                  {
                    id: "411329",
                    text: "新野县",
                    gisGcj02Lat: 32.517,
                    gisGcj02Lng: 112.362,
                  },
                  {
                    id: "411330",
                    text: "桐柏县",
                    gisGcj02Lat: 32.3792,
                    gisGcj02Lng: 113.429,
                  },
                  {
                    id: "411381",
                    text: "邓州市",
                    gisGcj02Lat: 32.6858,
                    gisGcj02Lng: 112.09,
                  },
                ],
              },
              {
                id: "411400",
                text: "商丘市",
                children: [
                  {
                    id: "411402",
                    text: "梁园区",
                    gisGcj02Lat: 34.4434,
                    gisGcj02Lng: 115.645,
                  },
                  {
                    id: "411403",
                    text: "睢阳区",
                    gisGcj02Lat: 34.388,
                    gisGcj02Lng: 115.653,
                  },
                  {
                    id: "411421",
                    text: "民权县",
                    gisGcj02Lat: 34.6493,
                    gisGcj02Lng: 115.146,
                  },
                  {
                    id: "411422",
                    text: "睢县",
                    gisGcj02Lat: 34.4454,
                    gisGcj02Lng: 115.072,
                  },
                  {
                    id: "411423",
                    text: "宁陵县",
                    gisGcj02Lat: 34.4546,
                    gisGcj02Lng: 115.305,
                  },
                  {
                    id: "411424",
                    text: "柘城县",
                    gisGcj02Lat: 34.0911,
                    gisGcj02Lng: 115.305,
                  },
                  {
                    id: "411425",
                    text: "虞城县",
                    gisGcj02Lat: 34.4019,
                    gisGcj02Lng: 115.863,
                  },
                  {
                    id: "411426",
                    text: "夏邑县",
                    gisGcj02Lat: 34.2324,
                    gisGcj02Lng: 116.133,
                  },
                  {
                    id: "411481",
                    text: "永城市",
                    gisGcj02Lat: 33.9291,
                    gisGcj02Lng: 116.449,
                  },
                ],
              },
              {
                id: "411500",
                text: "信阳市",
                children: [
                  {
                    id: "411502",
                    text: "浉河区",
                    gisGcj02Lat: 32.1168,
                    gisGcj02Lng: 114.059,
                  },
                  {
                    id: "411503",
                    text: "平桥区",
                    gisGcj02Lat: 32.1009,
                    gisGcj02Lng: 114.124,
                  },
                  {
                    id: "411521",
                    text: "罗山县",
                    gisGcj02Lat: 32.2028,
                    gisGcj02Lng: 114.531,
                  },
                  {
                    id: "411522",
                    text: "光山县",
                    gisGcj02Lat: 32.0099,
                    gisGcj02Lng: 114.919,
                  },
                  {
                    id: "411523",
                    text: "新县",
                    gisGcj02Lat: 31.6439,
                    gisGcj02Lng: 114.879,
                  },
                  {
                    id: "411524",
                    text: "商城县",
                    gisGcj02Lat: 31.7999,
                    gisGcj02Lng: 115.409,
                  },
                  {
                    id: "411525",
                    text: "固始县",
                    gisGcj02Lat: 32.1801,
                    gisGcj02Lng: 115.683,
                  },
                  {
                    id: "411526",
                    text: "潢川县",
                    gisGcj02Lat: 32.1376,
                    gisGcj02Lng: 115.047,
                  },
                  {
                    id: "411527",
                    text: "淮滨县",
                    gisGcj02Lat: 32.4661,
                    gisGcj02Lng: 115.421,
                  },
                  {
                    id: "411528",
                    text: "息县",
                    gisGcj02Lat: 32.3428,
                    gisGcj02Lng: 114.74,
                  },
                ],
              },
              {
                id: "411600",
                text: "周口市",
                children: [
                  {
                    id: "411602",
                    text: "川汇区",
                    gisGcj02Lat: 33.6256,
                    gisGcj02Lng: 114.642,
                  },
                  {
                    id: "411621",
                    text: "扶沟县",
                    gisGcj02Lat: 34.06,
                    gisGcj02Lng: 114.395,
                  },
                  {
                    id: "411622",
                    text: "西华县",
                    gisGcj02Lat: 33.7855,
                    gisGcj02Lng: 114.523,
                  },
                  {
                    id: "411623",
                    text: "商水县",
                    gisGcj02Lat: 33.5391,
                    gisGcj02Lng: 114.606,
                  },
                  {
                    id: "411624",
                    text: "沈丘县",
                    gisGcj02Lat: 33.4094,
                    gisGcj02Lng: 115.099,
                  },
                  {
                    id: "411625",
                    text: "郸城县",
                    gisGcj02Lat: 33.6449,
                    gisGcj02Lng: 115.177,
                  },
                  {
                    id: "411626",
                    text: "淮阳区",
                    gisGcj02Lat: 33.7321,
                    gisGcj02Lng: 114.888,
                  },
                  {
                    id: "411627",
                    text: "太康县",
                    gisGcj02Lat: 34.0638,
                    gisGcj02Lng: 114.838,
                  },
                  {
                    id: "411628",
                    text: "鹿邑县",
                    gisGcj02Lat: 33.8593,
                    gisGcj02Lng: 115.486,
                  },
                  {
                    id: "411681",
                    text: "项城市",
                    gisGcj02Lat: 33.4672,
                    gisGcj02Lng: 114.876,
                  },
                ],
              },
              {
                id: "411700",
                text: "驻马店市",
                children: [
                  {
                    id: "411702",
                    text: "驿城区",
                    gisGcj02Lat: 32.9732,
                    gisGcj02Lng: 113.994,
                  },
                  {
                    id: "411721",
                    text: "西平县",
                    gisGcj02Lat: 33.3845,
                    gisGcj02Lng: 114.023,
                  },
                  {
                    id: "411722",
                    text: "上蔡县",
                    gisGcj02Lat: 33.2682,
                    gisGcj02Lng: 114.268,
                  },
                  {
                    id: "411723",
                    text: "平舆县",
                    gisGcj02Lat: 32.9573,
                    gisGcj02Lng: 114.636,
                  },
                  {
                    id: "411724",
                    text: "正阳县",
                    gisGcj02Lat: 32.6039,
                    gisGcj02Lng: 114.39,
                  },
                  {
                    id: "411725",
                    text: "确山县",
                    gisGcj02Lat: 32.8028,
                    gisGcj02Lng: 114.029,
                  },
                  {
                    id: "411726",
                    text: "泌阳县",
                    gisGcj02Lat: 32.7178,
                    gisGcj02Lng: 113.327,
                  },
                  {
                    id: "411727",
                    text: "汝南县",
                    gisGcj02Lat: 33.0046,
                    gisGcj02Lng: 114.361,
                  },
                  {
                    id: "411728",
                    text: "遂平县",
                    gisGcj02Lat: 33.1457,
                    gisGcj02Lng: 114.013,
                  },
                  {
                    id: "411729",
                    text: "新蔡县",
                    gisGcj02Lat: 32.7502,
                    gisGcj02Lng: 114.982,
                  },
                ],
              },
              {
                id: "419000",
                text: "直辖县级",
                children: [
                  {
                    id: "419001",
                    text: "济源市",
                    gisGcj02Lat: 35.0904,
                    gisGcj02Lng: 112.59,
                  },
                ],
              },
            ],
          },
          {
            id: "420000",
            text: "湖北省",
            children: [
              {
                id: "420100",
                text: "武汉市",
                children: [
                  {
                    id: "420102",
                    text: "江岸区",
                    gisGcj02Lat: 30.5998,
                    gisGcj02Lng: 114.309,
                  },
                  {
                    id: "420103",
                    text: "江汉区",
                    gisGcj02Lat: 30.6015,
                    gisGcj02Lng: 114.271,
                  },
                  {
                    id: "420104",
                    text: "硚口区",
                    gisGcj02Lat: 30.5695,
                    gisGcj02Lng: 114.264,
                  },
                  {
                    id: "420105",
                    text: "汉阳区",
                    gisGcj02Lat: 30.5492,
                    gisGcj02Lng: 114.275,
                  },
                  {
                    id: "420106",
                    text: "武昌区",
                    gisGcj02Lat: 30.5539,
                    gisGcj02Lng: 114.316,
                  },
                  {
                    id: "420107",
                    text: "青山区",
                    gisGcj02Lat: 30.6343,
                    gisGcj02Lng: 114.391,
                  },
                  {
                    id: "420111",
                    text: "洪山区",
                    gisGcj02Lat: 30.4999,
                    gisGcj02Lng: 114.344,
                  },
                  {
                    id: "420112",
                    text: "东西湖区",
                    gisGcj02Lat: 30.6199,
                    gisGcj02Lng: 114.137,
                  },
                  {
                    id: "420113",
                    text: "汉南区",
                    gisGcj02Lat: 30.3088,
                    gisGcj02Lng: 114.085,
                  },
                  {
                    id: "420114",
                    text: "蔡甸区",
                    gisGcj02Lat: 30.582,
                    gisGcj02Lng: 114.029,
                  },
                  {
                    id: "420115",
                    text: "江夏区",
                    gisGcj02Lat: 30.3465,
                    gisGcj02Lng: 114.313,
                  },
                  {
                    id: "420116",
                    text: "黄陂区",
                    gisGcj02Lat: 30.8815,
                    gisGcj02Lng: 114.375,
                  },
                  {
                    id: "420117",
                    text: "新洲区",
                    gisGcj02Lat: 30.8414,
                    gisGcj02Lng: 114.801,
                  },
                ],
              },
              {
                id: "420200",
                text: "黄石市",
                children: [
                  {
                    id: "420202",
                    text: "黄石港区",
                    gisGcj02Lat: 30.2228,
                    gisGcj02Lng: 115.066,
                  },
                  {
                    id: "420203",
                    text: "西塞山区",
                    gisGcj02Lat: 30.2049,
                    gisGcj02Lng: 115.11,
                  },
                  {
                    id: "420204",
                    text: "下陆区",
                    gisGcj02Lat: 30.1737,
                    gisGcj02Lng: 114.961,
                  },
                  {
                    id: "420205",
                    text: "铁山区",
                    gisGcj02Lat: 30.2068,
                    gisGcj02Lng: 114.901,
                  },
                  {
                    id: "420222",
                    text: "阳新县",
                    gisGcj02Lat: 29.8304,
                    gisGcj02Lng: 115.215,
                  },
                  {
                    id: "420281",
                    text: "大冶市",
                    gisGcj02Lat: 30.0944,
                    gisGcj02Lng: 114.972,
                  },
                ],
              },
              {
                id: "420300",
                text: "十堰市",
                children: [
                  {
                    id: "420302",
                    text: "茅箭区",
                    gisGcj02Lat: 32.5915,
                    gisGcj02Lng: 110.813,
                  },
                  {
                    id: "420303",
                    text: "张湾区",
                    gisGcj02Lat: 32.652,
                    gisGcj02Lng: 110.771,
                  },
                  {
                    id: "420304",
                    text: "郧阳区",
                    gisGcj02Lat: 32.8359,
                    gisGcj02Lng: 110.819,
                  },
                  {
                    id: "420322",
                    text: "郧西县",
                    gisGcj02Lat: 32.9935,
                    gisGcj02Lng: 110.426,
                  },
                  {
                    id: "420323",
                    text: "竹山县",
                    gisGcj02Lat: 32.2254,
                    gisGcj02Lng: 110.231,
                  },
                  {
                    id: "420324",
                    text: "竹溪县",
                    gisGcj02Lat: 32.319,
                    gisGcj02Lng: 109.718,
                  },
                  {
                    id: "420325",
                    text: "房县",
                    gisGcj02Lat: 32.0579,
                    gisGcj02Lng: 110.744,
                  },
                  {
                    id: "420381",
                    text: "丹江口市",
                    gisGcj02Lat: 32.5409,
                    gisGcj02Lng: 111.515,
                  },
                ],
              },
              {
                id: "420500",
                text: "宜昌市",
                children: [
                  {
                    id: "420502",
                    text: "西陵区",
                    gisGcj02Lat: 30.7108,
                    gisGcj02Lng: 111.286,
                  },
                  {
                    id: "420503",
                    text: "伍家岗区",
                    gisGcj02Lat: 30.6443,
                    gisGcj02Lng: 111.361,
                  },
                  {
                    id: "420504",
                    text: "点军区",
                    gisGcj02Lat: 30.6934,
                    gisGcj02Lng: 111.268,
                  },
                  {
                    id: "420505",
                    text: "猇亭区",
                    gisGcj02Lat: 30.5266,
                    gisGcj02Lng: 111.441,
                  },
                  {
                    id: "420506",
                    text: "夷陵区",
                    gisGcj02Lat: 30.7688,
                    gisGcj02Lng: 111.326,
                  },
                  {
                    id: "420525",
                    text: "远安县",
                    gisGcj02Lat: 31.0599,
                    gisGcj02Lng: 111.642,
                  },
                  {
                    id: "420526",
                    text: "兴山县",
                    gisGcj02Lat: 31.3469,
                    gisGcj02Lng: 110.75,
                  },
                  {
                    id: "420527",
                    text: "秭归县",
                    gisGcj02Lat: 30.827,
                    gisGcj02Lng: 110.982,
                  },
                  {
                    id: "420528",
                    text: "长阳土家族自治县",
                    gisGcj02Lat: 30.4705,
                    gisGcj02Lng: 111.201,
                  },
                  {
                    id: "420529",
                    text: "五峰土家族自治县",
                    gisGcj02Lat: 30.1986,
                    gisGcj02Lng: 110.675,
                  },
                  {
                    id: "420581",
                    text: "宜都市",
                    gisGcj02Lat: 30.3781,
                    gisGcj02Lng: 111.45,
                  },
                  {
                    id: "420582",
                    text: "当阳市",
                    gisGcj02Lat: 30.8208,
                    gisGcj02Lng: 111.789,
                  },
                  {
                    id: "420583",
                    text: "枝江市",
                    gisGcj02Lat: 30.4261,
                    gisGcj02Lng: 111.769,
                  },
                ],
              },
              {
                id: "420600",
                text: "襄阳市",
                children: [
                  {
                    id: "420602",
                    text: "襄城区",
                    gisGcj02Lat: 32.0102,
                    gisGcj02Lng: 112.134,
                  },
                  {
                    id: "420606",
                    text: "樊城区",
                    gisGcj02Lat: 32.0448,
                    gisGcj02Lng: 112.135,
                  },
                  {
                    id: "420607",
                    text: "襄州区",
                    gisGcj02Lat: 32.0151,
                    gisGcj02Lng: 112.15,
                  },
                  {
                    id: "420624",
                    text: "南漳县",
                    gisGcj02Lat: 31.7765,
                    gisGcj02Lng: 111.846,
                  },
                  {
                    id: "420625",
                    text: "谷城县",
                    gisGcj02Lat: 32.2638,
                    gisGcj02Lng: 111.653,
                  },
                  {
                    id: "420626",
                    text: "保康县",
                    gisGcj02Lat: 31.8787,
                    gisGcj02Lng: 111.261,
                  },
                  {
                    id: "420682",
                    text: "老河口市",
                    gisGcj02Lat: 32.3848,
                    gisGcj02Lng: 111.671,
                  },
                  {
                    id: "420683",
                    text: "枣阳市",
                    gisGcj02Lat: 32.1314,
                    gisGcj02Lng: 112.774,
                  },
                  {
                    id: "420684",
                    text: "宜城市",
                    gisGcj02Lat: 31.7197,
                    gisGcj02Lng: 112.258,
                  },
                ],
              },
              {
                id: "420700",
                text: "鄂州市",
                children: [
                  {
                    id: "420702",
                    text: "梁子湖区",
                    gisGcj02Lat: 30.1,
                    gisGcj02Lng: 114.685,
                  },
                  {
                    id: "420703",
                    text: "华容区",
                    gisGcj02Lat: 30.5333,
                    gisGcj02Lng: 114.736,
                  },
                  {
                    id: "420704",
                    text: "鄂城区",
                    gisGcj02Lat: 30.4002,
                    gisGcj02Lng: 114.892,
                  },
                ],
              },
              {
                id: "420800",
                text: "荆门市",
                children: [
                  {
                    id: "420802",
                    text: "东宝区",
                    gisGcj02Lat: 31.0519,
                    gisGcj02Lng: 112.201,
                  },
                  {
                    id: "420804",
                    text: "掇刀区",
                    gisGcj02Lat: 30.9732,
                    gisGcj02Lng: 112.208,
                  },
                  {
                    id: "420821",
                    text: "京山县",
                    gisGcj02Lat: 31.0224,
                    gisGcj02Lng: 113.111,
                  },
                  {
                    id: "420822",
                    text: "沙洋县",
                    gisGcj02Lat: 30.7092,
                    gisGcj02Lng: 112.589,
                  },
                  {
                    id: "420881",
                    text: "钟祥市",
                    gisGcj02Lat: 31.1678,
                    gisGcj02Lng: 112.589,
                  },
                ],
              },
              {
                id: "420900",
                text: "孝感市",
                children: [
                  {
                    id: "420902",
                    text: "孝南区",
                    gisGcj02Lat: 30.9168,
                    gisGcj02Lng: 113.911,
                  },
                  {
                    id: "420921",
                    text: "孝昌县",
                    gisGcj02Lat: 31.258,
                    gisGcj02Lng: 113.998,
                  },
                  {
                    id: "420922",
                    text: "大悟县",
                    gisGcj02Lat: 31.5618,
                    gisGcj02Lng: 114.126,
                  },
                  {
                    id: "420923",
                    text: "云梦县",
                    gisGcj02Lat: 31.0209,
                    gisGcj02Lng: 113.753,
                  },
                  {
                    id: "420981",
                    text: "应城市",
                    gisGcj02Lat: 30.9283,
                    gisGcj02Lng: 113.573,
                  },
                  {
                    id: "420982",
                    text: "安陆市",
                    gisGcj02Lat: 31.2569,
                    gisGcj02Lng: 113.686,
                  },
                  {
                    id: "420984",
                    text: "汉川市",
                    gisGcj02Lat: 30.6612,
                    gisGcj02Lng: 113.839,
                  },
                ],
              },
              {
                id: "421000",
                text: "荆州市",
                children: [
                  {
                    id: "421002",
                    text: "沙市区",
                    gisGcj02Lat: 30.3111,
                    gisGcj02Lng: 112.255,
                  },
                  {
                    id: "421003",
                    text: "荆州区",
                    gisGcj02Lat: 30.3526,
                    gisGcj02Lng: 112.19,
                  },
                  {
                    id: "421022",
                    text: "公安县",
                    gisGcj02Lat: 30.059,
                    gisGcj02Lng: 112.232,
                  },
                  {
                    id: "421023",
                    text: "监利市",
                    gisGcj02Lat: 29.8149,
                    gisGcj02Lng: 112.895,
                  },
                  {
                    id: "421024",
                    text: "江陵县",
                    gisGcj02Lat: 30.0417,
                    gisGcj02Lng: 112.425,
                  },
                  {
                    id: "421081",
                    text: "石首市",
                    gisGcj02Lat: 29.7213,
                    gisGcj02Lng: 112.426,
                  },
                  {
                    id: "421083",
                    text: "洪湖市",
                    gisGcj02Lat: 29.827,
                    gisGcj02Lng: 113.476,
                  },
                  {
                    id: "421087",
                    text: "松滋市",
                    gisGcj02Lat: 30.1696,
                    gisGcj02Lng: 111.767,
                  },
                ],
              },
              {
                id: "421100",
                text: "黄冈市",
                children: [
                  {
                    id: "421102",
                    text: "黄州区",
                    gisGcj02Lat: 30.4344,
                    gisGcj02Lng: 114.88,
                  },
                  {
                    id: "421121",
                    text: "团风县",
                    gisGcj02Lat: 30.6436,
                    gisGcj02Lng: 114.872,
                  },
                  {
                    id: "421122",
                    text: "红安县",
                    gisGcj02Lat: 31.2867,
                    gisGcj02Lng: 114.622,
                  },
                  {
                    id: "421123",
                    text: "罗田县",
                    gisGcj02Lat: 30.7826,
                    gisGcj02Lng: 115.4,
                  },
                  {
                    id: "421124",
                    text: "英山县",
                    gisGcj02Lat: 30.7352,
                    gisGcj02Lng: 115.681,
                  },
                  {
                    id: "421125",
                    text: "浠水县",
                    gisGcj02Lat: 30.4527,
                    gisGcj02Lng: 115.269,
                  },
                  {
                    id: "421126",
                    text: "蕲春县",
                    gisGcj02Lat: 30.2261,
                    gisGcj02Lng: 115.436,
                  },
                  {
                    id: "421127",
                    text: "黄梅县",
                    gisGcj02Lat: 30.0703,
                    gisGcj02Lng: 115.944,
                  },
                  {
                    id: "421181",
                    text: "麻城市",
                    gisGcj02Lat: 31.1723,
                    gisGcj02Lng: 115.01,
                  },
                  {
                    id: "421182",
                    text: "武穴市",
                    gisGcj02Lat: 29.8445,
                    gisGcj02Lng: 115.56,
                  },
                ],
              },
              {
                id: "421200",
                text: "咸宁市",
                children: [
                  {
                    id: "421202",
                    text: "咸安区",
                    gisGcj02Lat: 29.8529,
                    gisGcj02Lng: 114.299,
                  },
                  {
                    id: "421221",
                    text: "嘉鱼县",
                    gisGcj02Lat: 29.9705,
                    gisGcj02Lng: 113.939,
                  },
                  {
                    id: "421222",
                    text: "通城县",
                    gisGcj02Lat: 29.2457,
                    gisGcj02Lng: 113.816,
                  },
                  {
                    id: "421223",
                    text: "崇阳县",
                    gisGcj02Lat: 29.5556,
                    gisGcj02Lng: 114.04,
                  },
                  {
                    id: "421224",
                    text: "通山县",
                    gisGcj02Lat: 29.6063,
                    gisGcj02Lng: 114.482,
                  },
                  {
                    id: "421281",
                    text: "赤壁市",
                    gisGcj02Lat: 29.7245,
                    gisGcj02Lng: 113.9,
                  },
                ],
              },
              {
                id: "421300",
                text: "随州市",
                children: [
                  {
                    id: "421303",
                    text: "曾都区",
                    gisGcj02Lat: 31.7161,
                    gisGcj02Lng: 113.371,
                  },
                  {
                    id: "421321",
                    text: "随县",
                    gisGcj02Lat: 31.6179,
                    gisGcj02Lng: 113.827,
                  },
                  {
                    id: "421381",
                    text: "广水市",
                    gisGcj02Lat: 31.6179,
                    gisGcj02Lng: 113.827,
                  },
                ],
              },
              {
                id: "422800",
                text: "恩施土家族苗族自治州",
                children: [
                  {
                    id: "422801",
                    text: "恩施市",
                    gisGcj02Lat: 30.295,
                    gisGcj02Lng: 109.479,
                  },
                  {
                    id: "422802",
                    text: "利川市",
                    gisGcj02Lat: 30.2912,
                    gisGcj02Lng: 108.936,
                  },
                  {
                    id: "422822",
                    text: "建始县",
                    gisGcj02Lat: 30.6021,
                    gisGcj02Lng: 109.722,
                  },
                  {
                    id: "422823",
                    text: "巴东县",
                    gisGcj02Lat: 31.0423,
                    gisGcj02Lng: 110.341,
                  },
                  {
                    id: "422825",
                    text: "宣恩县",
                    gisGcj02Lat: 29.9871,
                    gisGcj02Lng: 109.492,
                  },
                  {
                    id: "422826",
                    text: "咸丰县",
                    gisGcj02Lat: 29.6798,
                    gisGcj02Lng: 109.152,
                  },
                  {
                    id: "422827",
                    text: "来凤县",
                    gisGcj02Lat: 29.4937,
                    gisGcj02Lng: 109.407,
                  },
                  {
                    id: "422828",
                    text: "鹤峰县",
                    gisGcj02Lat: 29.8907,
                    gisGcj02Lng: 110.031,
                  },
                ],
              },
              {
                id: "429000",
                text: "直辖县级",
                children: [
                  {
                    id: "429004",
                    text: "仙桃市",
                    gisGcj02Lat: 30.365,
                    gisGcj02Lng: 113.454,
                  },
                  {
                    id: "429005",
                    text: "潜江市",
                    gisGcj02Lat: 30.4212,
                    gisGcj02Lng: 112.897,
                  },
                  {
                    id: "429006",
                    text: "天门市",
                    gisGcj02Lat: 30.6531,
                    gisGcj02Lng: 113.166,
                  },
                  {
                    id: "429021",
                    text: "神农架林区",
                    gisGcj02Lat: 31.7444,
                    gisGcj02Lng: 110.672,
                  },
                ],
              },
            ],
          },
          {
            id: "430000",
            text: "湖南省",
            children: [
              {
                id: "430100",
                text: "长沙市",
                children: [
                  {
                    id: "430102",
                    text: "芙蓉区",
                    gisGcj02Lat: 28.1844,
                    gisGcj02Lng: 113.032,
                  },
                  {
                    id: "430103",
                    text: "天心区",
                    gisGcj02Lat: 28.1127,
                    gisGcj02Lng: 112.99,
                  },
                  {
                    id: "430104",
                    text: "岳麓区",
                    gisGcj02Lat: 28.2351,
                    gisGcj02Lng: 112.931,
                  },
                  {
                    id: "430105",
                    text: "开福区",
                    gisGcj02Lat: 28.2558,
                    gisGcj02Lng: 112.986,
                  },
                  {
                    id: "430111",
                    text: "雨花区",
                    gisGcj02Lat: 28.1354,
                    gisGcj02Lng: 113.036,
                  },
                  {
                    id: "430112",
                    text: "望城区",
                    gisGcj02Lat: 28.3475,
                    gisGcj02Lng: 112.82,
                  },
                  {
                    id: "430121",
                    text: "长沙县",
                    gisGcj02Lat: 28.246,
                    gisGcj02Lng: 113.081,
                  },
                  {
                    id: "430124",
                    text: "宁乡县",
                    gisGcj02Lat: 28.2536,
                    gisGcj02Lng: 112.557,
                  },
                  {
                    id: "430181",
                    text: "浏阳市",
                    gisGcj02Lat: 28.1637,
                    gisGcj02Lng: 113.643,
                  },
                ],
              },
              {
                id: "430200",
                text: "株洲市",
                children: [
                  {
                    id: "430202",
                    text: "荷塘区",
                    gisGcj02Lat: 27.8557,
                    gisGcj02Lng: 113.173,
                  },
                  {
                    id: "430203",
                    text: "芦淞区",
                    gisGcj02Lat: 27.7852,
                    gisGcj02Lng: 113.156,
                  },
                  {
                    id: "430204",
                    text: "石峰区",
                    gisGcj02Lat: 27.8755,
                    gisGcj02Lng: 113.118,
                  },
                  {
                    id: "430211",
                    text: "天元区",
                    gisGcj02Lat: 27.831,
                    gisGcj02Lng: 113.123,
                  },
                  {
                    id: "430221",
                    text: "株洲县",
                    gisGcj02Lat: 27.6983,
                    gisGcj02Lng: 113.144,
                  },
                  {
                    id: "430223",
                    text: "攸县",
                    gisGcj02Lat: 27.0035,
                    gisGcj02Lng: 113.344,
                  },
                  {
                    id: "430224",
                    text: "茶陵县",
                    gisGcj02Lat: 26.7915,
                    gisGcj02Lng: 113.544,
                  },
                  {
                    id: "430225",
                    text: "炎陵县",
                    gisGcj02Lat: 26.4882,
                    gisGcj02Lng: 113.772,
                  },
                  {
                    id: "430281",
                    text: "醴陵市",
                    gisGcj02Lat: 27.6462,
                    gisGcj02Lng: 113.497,
                  },
                ],
              },
              {
                id: "430300",
                text: "湘潭市",
                children: [
                  {
                    id: "430302",
                    text: "雨湖区",
                    gisGcj02Lat: 27.8686,
                    gisGcj02Lng: 112.904,
                  },
                  {
                    id: "430304",
                    text: "岳塘区",
                    gisGcj02Lat: 27.8578,
                    gisGcj02Lng: 112.961,
                  },
                  {
                    id: "430321",
                    text: "湘潭县",
                    gisGcj02Lat: 27.7789,
                    gisGcj02Lng: 112.951,
                  },
                  {
                    id: "430381",
                    text: "湘乡市",
                    gisGcj02Lat: 27.7354,
                    gisGcj02Lng: 112.535,
                  },
                  {
                    id: "430382",
                    text: "韶山市",
                    gisGcj02Lat: 27.915,
                    gisGcj02Lng: 112.527,
                  },
                ],
              },
              {
                id: "430400",
                text: "衡阳市",
                children: [
                  {
                    id: "430405",
                    text: "珠晖区",
                    gisGcj02Lat: 26.8936,
                    gisGcj02Lng: 112.621,
                  },
                  {
                    id: "430406",
                    text: "雁峰区",
                    gisGcj02Lat: 26.8887,
                    gisGcj02Lng: 112.617,
                  },
                  {
                    id: "430407",
                    text: "石鼓区",
                    gisGcj02Lat: 26.9023,
                    gisGcj02Lng: 112.611,
                  },
                  {
                    id: "430408",
                    text: "蒸湘区",
                    gisGcj02Lat: 26.8965,
                    gisGcj02Lng: 112.603,
                  },
                  {
                    id: "430412",
                    text: "南岳区",
                    gisGcj02Lat: 27.2326,
                    gisGcj02Lng: 112.738,
                  },
                  {
                    id: "430421",
                    text: "衡阳县",
                    gisGcj02Lat: 26.9706,
                    gisGcj02Lng: 112.371,
                  },
                  {
                    id: "430422",
                    text: "衡南县",
                    gisGcj02Lat: 26.7383,
                    gisGcj02Lng: 112.678,
                  },
                  {
                    id: "430423",
                    text: "衡山县",
                    gisGcj02Lat: 27.2313,
                    gisGcj02Lng: 112.868,
                  },
                  {
                    id: "430424",
                    text: "衡东县",
                    gisGcj02Lat: 27.0809,
                    gisGcj02Lng: 112.948,
                  },
                  {
                    id: "430426",
                    text: "祁东县",
                    gisGcj02Lat: 26.7996,
                    gisGcj02Lng: 112.09,
                  },
                  {
                    id: "430481",
                    text: "耒阳市",
                    gisGcj02Lat: 26.4213,
                    gisGcj02Lng: 112.86,
                  },
                  {
                    id: "430482",
                    text: "常宁市",
                    gisGcj02Lat: 26.4069,
                    gisGcj02Lng: 112.401,
                  },
                ],
              },
              {
                id: "430500",
                text: "邵阳市",
                children: [
                  {
                    id: "430502",
                    text: "双清区",
                    gisGcj02Lat: 27.2329,
                    gisGcj02Lng: 111.497,
                  },
                  {
                    id: "430503",
                    text: "大祥区",
                    gisGcj02Lat: 27.2333,
                    gisGcj02Lng: 111.454,
                  },
                  {
                    id: "430511",
                    text: "北塔区",
                    gisGcj02Lat: 27.2465,
                    gisGcj02Lng: 111.452,
                  },
                  {
                    id: "430521",
                    text: "邵东市",
                    gisGcj02Lat: 27.2584,
                    gisGcj02Lng: 111.744,
                  },
                  {
                    id: "430522",
                    text: "新邵县",
                    gisGcj02Lat: 27.3217,
                    gisGcj02Lng: 111.461,
                  },
                  {
                    id: "430523",
                    text: "邵阳县",
                    gisGcj02Lat: 26.9914,
                    gisGcj02Lng: 111.275,
                  },
                  {
                    id: "430524",
                    text: "隆回县",
                    gisGcj02Lat: 27.1094,
                    gisGcj02Lng: 111.032,
                  },
                  {
                    id: "430525",
                    text: "洞口县",
                    gisGcj02Lat: 27.0546,
                    gisGcj02Lng: 110.574,
                  },
                  {
                    id: "430527",
                    text: "绥宁县",
                    gisGcj02Lat: 26.5864,
                    gisGcj02Lng: 110.156,
                  },
                  {
                    id: "430528",
                    text: "新宁县",
                    gisGcj02Lat: 26.4294,
                    gisGcj02Lng: 110.851,
                  },
                  {
                    id: "430529",
                    text: "城步苗族自治县",
                    gisGcj02Lat: 26.3905,
                    gisGcj02Lng: 110.322,
                  },
                  {
                    id: "430581",
                    text: "武冈市",
                    gisGcj02Lat: 26.7282,
                    gisGcj02Lng: 110.633,
                  },
                ],
              },
              {
                id: "430600",
                text: "岳阳市",
                children: [
                  {
                    id: "430602",
                    text: "岳阳楼区",
                    gisGcj02Lat: 29.3719,
                    gisGcj02Lng: 113.129,
                  },
                  {
                    id: "430603",
                    text: "云溪区",
                    gisGcj02Lat: 29.4736,
                    gisGcj02Lng: 113.277,
                  },
                  {
                    id: "430611",
                    text: "君山区",
                    gisGcj02Lat: 29.4594,
                    gisGcj02Lng: 113.004,
                  },
                  {
                    id: "430621",
                    text: "岳阳县",
                    gisGcj02Lat: 29.1431,
                    gisGcj02Lng: 113.12,
                  },
                  {
                    id: "430623",
                    text: "华容县",
                    gisGcj02Lat: 29.5302,
                    gisGcj02Lng: 112.541,
                  },
                  {
                    id: "430624",
                    text: "湘阴县",
                    gisGcj02Lat: 28.6892,
                    gisGcj02Lng: 112.909,
                  },
                  {
                    id: "430626",
                    text: "平江县",
                    gisGcj02Lat: 28.7066,
                    gisGcj02Lng: 113.581,
                  },
                  {
                    id: "430681",
                    text: "汨罗市",
                    gisGcj02Lat: 28.8063,
                    gisGcj02Lng: 113.067,
                  },
                  {
                    id: "430682",
                    text: "临湘市",
                    gisGcj02Lat: 29.477,
                    gisGcj02Lng: 113.45,
                  },
                ],
              },
              {
                id: "430700",
                text: "常德市",
                children: [
                  {
                    id: "430702",
                    text: "武陵区",
                    gisGcj02Lat: 29.0288,
                    gisGcj02Lng: 111.698,
                  },
                  {
                    id: "430703",
                    text: "鼎城区",
                    gisGcj02Lat: 29.0186,
                    gisGcj02Lng: 111.681,
                  },
                  {
                    id: "430721",
                    text: "安乡县",
                    gisGcj02Lat: 29.4133,
                    gisGcj02Lng: 112.167,
                  },
                  {
                    id: "430722",
                    text: "汉寿县",
                    gisGcj02Lat: 28.903,
                    gisGcj02Lng: 111.967,
                  },
                  {
                    id: "430723",
                    text: "澧县",
                    gisGcj02Lat: 29.6332,
                    gisGcj02Lng: 111.759,
                  },
                  {
                    id: "430724",
                    text: "临澧县",
                    gisGcj02Lat: 29.4416,
                    gisGcj02Lng: 111.652,
                  },
                  {
                    id: "430725",
                    text: "桃源县",
                    gisGcj02Lat: 28.9047,
                    gisGcj02Lng: 111.489,
                  },
                  {
                    id: "430726",
                    text: "石门县",
                    gisGcj02Lat: 29.5842,
                    gisGcj02Lng: 111.38,
                  },
                  {
                    id: "430781",
                    text: "津市市",
                    gisGcj02Lat: 29.6056,
                    gisGcj02Lng: 111.878,
                  },
                ],
              },
              {
                id: "430800",
                text: "张家界市",
                children: [
                  {
                    id: "430802",
                    text: "永定区",
                    gisGcj02Lat: 29.1339,
                    gisGcj02Lng: 110.475,
                  },
                  {
                    id: "430811",
                    text: "武陵源区",
                    gisGcj02Lat: 29.3457,
                    gisGcj02Lng: 110.55,
                  },
                  {
                    id: "430821",
                    text: "慈利县",
                    gisGcj02Lat: 29.4299,
                    gisGcj02Lng: 111.139,
                  },
                  {
                    id: "430822",
                    text: "桑植县",
                    gisGcj02Lat: 29.3981,
                    gisGcj02Lng: 110.163,
                  },
                ],
              },
              {
                id: "430900",
                text: "益阳市",
                children: [
                  {
                    id: "430902",
                    text: "资阳区",
                    gisGcj02Lat: 28.591,
                    gisGcj02Lng: 112.324,
                  },
                  {
                    id: "430903",
                    text: "赫山区",
                    gisGcj02Lat: 28.5742,
                    gisGcj02Lng: 112.373,
                  },
                  {
                    id: "430921",
                    text: "南县",
                    gisGcj02Lat: 29.3616,
                    gisGcj02Lng: 112.396,
                  },
                  {
                    id: "430922",
                    text: "桃江县",
                    gisGcj02Lat: 28.5181,
                    gisGcj02Lng: 112.156,
                  },
                  {
                    id: "430923",
                    text: "安化县",
                    gisGcj02Lat: 28.3742,
                    gisGcj02Lng: 111.213,
                  },
                  {
                    id: "430981",
                    text: "沅江市",
                    gisGcj02Lat: 28.844,
                    gisGcj02Lng: 112.354,
                  },
                ],
              },
              {
                id: "431000",
                text: "郴州市",
                children: [
                  {
                    id: "431002",
                    text: "北湖区",
                    gisGcj02Lat: 25.784,
                    gisGcj02Lng: 113.011,
                  },
                  {
                    id: "431003",
                    text: "苏仙区",
                    gisGcj02Lat: 25.8004,
                    gisGcj02Lng: 113.042,
                  },
                  {
                    id: "431021",
                    text: "桂阳县",
                    gisGcj02Lat: 25.7541,
                    gisGcj02Lng: 112.734,
                  },
                  {
                    id: "431022",
                    text: "宜章县",
                    gisGcj02Lat: 25.3993,
                    gisGcj02Lng: 112.951,
                  },
                  {
                    id: "431023",
                    text: "永兴县",
                    gisGcj02Lat: 26.1265,
                    gisGcj02Lng: 113.112,
                  },
                  {
                    id: "431024",
                    text: "嘉禾县",
                    gisGcj02Lat: 25.5879,
                    gisGcj02Lng: 112.369,
                  },
                  {
                    id: "431025",
                    text: "临武县",
                    gisGcj02Lat: 25.276,
                    gisGcj02Lng: 112.564,
                  },
                  {
                    id: "431026",
                    text: "汝城县",
                    gisGcj02Lat: 25.552,
                    gisGcj02Lng: 113.686,
                  },
                  {
                    id: "431027",
                    text: "桂东县",
                    gisGcj02Lat: 26.0799,
                    gisGcj02Lng: 113.947,
                  },
                  {
                    id: "431028",
                    text: "安仁县",
                    gisGcj02Lat: 26.7093,
                    gisGcj02Lng: 113.269,
                  },
                  {
                    id: "431081",
                    text: "资兴市",
                    gisGcj02Lat: 25.9767,
                    gisGcj02Lng: 113.237,
                  },
                ],
              },
              {
                id: "431100",
                text: "永州市",
                children: [
                  {
                    id: "431102",
                    text: "零陵区",
                    gisGcj02Lat: 26.2211,
                    gisGcj02Lng: 111.621,
                  },
                  {
                    id: "431103",
                    text: "冷水滩区",
                    gisGcj02Lat: 26.4611,
                    gisGcj02Lng: 111.592,
                  },
                  {
                    id: "431121",
                    text: "祁阳市",
                    gisGcj02Lat: 26.5801,
                    gisGcj02Lng: 111.84,
                  },
                  {
                    id: "431122",
                    text: "东安县",
                    gisGcj02Lat: 26.392,
                    gisGcj02Lng: 111.316,
                  },
                  {
                    id: "431123",
                    text: "双牌县",
                    gisGcj02Lat: 25.9599,
                    gisGcj02Lng: 111.659,
                  },
                  {
                    id: "431124",
                    text: "道县",
                    gisGcj02Lat: 25.5277,
                    gisGcj02Lng: 111.602,
                  },
                  {
                    id: "431125",
                    text: "江永县",
                    gisGcj02Lat: 25.2723,
                    gisGcj02Lng: 111.341,
                  },
                  {
                    id: "431126",
                    text: "宁远县",
                    gisGcj02Lat: 25.5691,
                    gisGcj02Lng: 111.946,
                  },
                  {
                    id: "431127",
                    text: "蓝山县",
                    gisGcj02Lat: 25.3679,
                    gisGcj02Lng: 112.194,
                  },
                  {
                    id: "431128",
                    text: "新田县",
                    gisGcj02Lat: 25.9095,
                    gisGcj02Lng: 112.221,
                  },
                  {
                    id: "431129",
                    text: "江华瑶族自治县",
                    gisGcj02Lat: 25.1845,
                    gisGcj02Lng: 111.588,
                  },
                ],
              },
              {
                id: "431200",
                text: "怀化市",
                children: [
                  {
                    id: "431202",
                    text: "鹤城区",
                    gisGcj02Lat: 27.5494,
                    gisGcj02Lng: 109.965,
                  },
                  {
                    id: "431221",
                    text: "中方县",
                    gisGcj02Lat: 27.4399,
                    gisGcj02Lng: 109.945,
                  },
                  {
                    id: "431222",
                    text: "沅陵县",
                    gisGcj02Lat: 28.4555,
                    gisGcj02Lng: 110.396,
                  },
                  {
                    id: "431223",
                    text: "辰溪县",
                    gisGcj02Lat: 28.0041,
                    gisGcj02Lng: 110.189,
                  },
                  {
                    id: "431224",
                    text: "溆浦县",
                    gisGcj02Lat: 27.9084,
                    gisGcj02Lng: 110.594,
                  },
                  {
                    id: "431225",
                    text: "会同县",
                    gisGcj02Lat: 26.8872,
                    gisGcj02Lng: 109.736,
                  },
                  {
                    id: "431226",
                    text: "麻阳苗族自治县",
                    gisGcj02Lat: 27.866,
                    gisGcj02Lng: 109.802,
                  },
                  {
                    id: "431227",
                    text: "新晃侗族自治县",
                    gisGcj02Lat: 27.3594,
                    gisGcj02Lng: 109.172,
                  },
                  {
                    id: "431228",
                    text: "芷江侗族自治县",
                    gisGcj02Lat: 27.443,
                    gisGcj02Lng: 109.685,
                  },
                  {
                    id: "431229",
                    text: "靖州苗族侗族自治县",
                    gisGcj02Lat: 26.5765,
                    gisGcj02Lng: 109.698,
                  },
                  {
                    id: "431230",
                    text: "通道侗族自治县",
                    gisGcj02Lat: 26.1571,
                    gisGcj02Lng: 109.785,
                  },
                  {
                    id: "431281",
                    text: "洪江市",
                    gisGcj02Lat: 27.2092,
                    gisGcj02Lng: 109.837,
                  },
                ],
              },
              {
                id: "431300",
                text: "娄底市",
                children: [
                  {
                    id: "431302",
                    text: "娄星区",
                    gisGcj02Lat: 27.7299,
                    gisGcj02Lng: 112.002,
                  },
                  {
                    id: "431321",
                    text: "双峰县",
                    gisGcj02Lat: 27.4542,
                    gisGcj02Lng: 112.199,
                  },
                  {
                    id: "431322",
                    text: "新化县",
                    gisGcj02Lat: 27.7266,
                    gisGcj02Lng: 111.327,
                  },
                  {
                    id: "431381",
                    text: "冷水江市",
                    gisGcj02Lat: 27.6815,
                    gisGcj02Lng: 111.436,
                  },
                  {
                    id: "431382",
                    text: "涟源市",
                    gisGcj02Lat: 27.6883,
                    gisGcj02Lng: 111.672,
                  },
                ],
              },
              {
                id: "433100",
                text: "湘西土家族苗族自治州",
                children: [
                  {
                    id: "433101",
                    text: "吉首市",
                    gisGcj02Lat: 28.2625,
                    gisGcj02Lng: 109.698,
                  },
                  {
                    id: "433122",
                    text: "泸溪县",
                    gisGcj02Lat: 28.2205,
                    gisGcj02Lng: 110.217,
                  },
                  {
                    id: "433123",
                    text: "凤凰县",
                    gisGcj02Lat: 27.9482,
                    gisGcj02Lng: 109.602,
                  },
                  {
                    id: "433124",
                    text: "花垣县",
                    gisGcj02Lat: 28.5721,
                    gisGcj02Lng: 109.482,
                  },
                  {
                    id: "433125",
                    text: "保靖县",
                    gisGcj02Lat: 28.7,
                    gisGcj02Lng: 109.66,
                  },
                  {
                    id: "433126",
                    text: "古丈县",
                    gisGcj02Lat: 28.6194,
                    gisGcj02Lng: 109.948,
                  },
                  {
                    id: "433127",
                    text: "永顺县",
                    gisGcj02Lat: 29.001,
                    gisGcj02Lng: 109.853,
                  },
                  {
                    id: "433130",
                    text: "龙山县",
                    gisGcj02Lat: 29.4569,
                    gisGcj02Lng: 109.443,
                  },
                ],
              },
            ],
          },
          {
            id: "440000",
            text: "广东省",
            children: [
              {
                id: "440100",
                text: "广州市",
                children: [
                  {
                    id: "440103",
                    text: "荔湾区",
                    gisGcj02Lat: 23.1259,
                    gisGcj02Lng: 113.244,
                  },
                  {
                    id: "440104",
                    text: "越秀区",
                    gisGcj02Lat: 23.129,
                    gisGcj02Lng: 113.267,
                  },
                  {
                    id: "440105",
                    text: "海珠区",
                    gisGcj02Lat: 23.1038,
                    gisGcj02Lng: 113.262,
                  },
                  {
                    id: "440106",
                    text: "天河区",
                    gisGcj02Lat: 23.1247,
                    gisGcj02Lng: 113.361,
                  },
                  {
                    id: "440111",
                    text: "白云区",
                    gisGcj02Lat: 23.1579,
                    gisGcj02Lng: 113.273,
                  },
                  {
                    id: "440112",
                    text: "黄埔区",
                    gisGcj02Lat: 23.1064,
                    gisGcj02Lng: 113.459,
                  },
                  {
                    id: "440113",
                    text: "番禺区",
                    gisGcj02Lat: 22.936,
                    gisGcj02Lng: 113.384,
                  },
                  {
                    id: "440114",
                    text: "花都区",
                    gisGcj02Lat: 23.4036,
                    gisGcj02Lng: 113.22,
                  },
                  {
                    id: "440115",
                    text: "南沙区",
                    gisGcj02Lat: 22.7714,
                    gisGcj02Lng: 113.608,
                  },
                  {
                    id: "440117",
                    text: "从化区",
                    gisGcj02Lat: 23.5453,
                    gisGcj02Lng: 113.587,
                  },
                  {
                    id: "440118",
                    text: "增城区",
                    gisGcj02Lat: 23.2905,
                    gisGcj02Lng: 113.83,
                  },
                ],
              },
              {
                id: "440200",
                text: "韶关市",
                children: [
                  {
                    id: "440203",
                    text: "武江区",
                    gisGcj02Lat: 24.7926,
                    gisGcj02Lng: 113.588,
                  },
                  {
                    id: "440204",
                    text: "浈江区",
                    gisGcj02Lat: 24.8044,
                    gisGcj02Lng: 113.611,
                  },
                  {
                    id: "440205",
                    text: "曲江区",
                    gisGcj02Lat: 24.6791,
                    gisGcj02Lng: 113.602,
                  },
                  {
                    id: "440222",
                    text: "始兴县",
                    gisGcj02Lat: 24.9476,
                    gisGcj02Lng: 114.068,
                  },
                  {
                    id: "440224",
                    text: "仁化县",
                    gisGcj02Lat: 25.0874,
                    gisGcj02Lng: 113.747,
                  },
                  {
                    id: "440229",
                    text: "翁源县",
                    gisGcj02Lat: 24.3495,
                    gisGcj02Lng: 114.134,
                  },
                  {
                    id: "440232",
                    text: "乳源瑶族自治县",
                    gisGcj02Lat: 24.778,
                    gisGcj02Lng: 113.277,
                  },
                  {
                    id: "440233",
                    text: "新丰县",
                    gisGcj02Lat: 24.0592,
                    gisGcj02Lng: 114.208,
                  },
                  {
                    id: "440281",
                    text: "乐昌市",
                    gisGcj02Lat: 25.128,
                    gisGcj02Lng: 113.357,
                  },
                  {
                    id: "440282",
                    text: "南雄市",
                    gisGcj02Lat: 25.1171,
                    gisGcj02Lng: 114.31,
                  },
                ],
              },
              {
                id: "440300",
                text: "深圳市",
                children: [
                  {
                    id: "440303",
                    text: "罗湖区",
                    gisGcj02Lat: 22.5484,
                    gisGcj02Lng: 114.131,
                  },
                  {
                    id: "440304",
                    text: "福田区",
                    gisGcj02Lat: 22.5224,
                    gisGcj02Lng: 114.056,
                  },
                  {
                    id: "440305",
                    text: "南山区",
                    gisGcj02Lat: 22.5329,
                    gisGcj02Lng: 113.93,
                  },
                  {
                    id: "440306",
                    text: "宝安区",
                    gisGcj02Lat: 22.5537,
                    gisGcj02Lng: 113.883,
                  },
                  {
                    id: "440307",
                    text: "龙岗区",
                    gisGcj02Lat: 22.7199,
                    gisGcj02Lng: 114.248,
                  },
                  {
                    id: "440308",
                    text: "盐田区",
                    gisGcj02Lat: 22.5578,
                    gisGcj02Lng: 114.237,
                  },
                  {
                    id: "440309",
                    text: "光明新区",
                    gisGcj02Lat: 22.7773,
                    gisGcj02Lng: 113.896,
                  },
                  {
                    id: "440310",
                    text: "坪山新区",
                    gisGcj02Lat: 22.6905,
                    gisGcj02Lng: 114.346,
                  },
                  {
                    id: "440311",
                    text: "大鹏新区",
                    gisGcj02Lat: 22.5879,
                    gisGcj02Lng: 114.48,
                  },
                  {
                    id: "440312",
                    text: "龙华新区",
                    gisGcj02Lat: 22.687,
                    gisGcj02Lng: 114.037,
                  },
                ],
              },
              {
                id: "440400",
                text: "珠海市",
                children: [
                  {
                    id: "440402",
                    text: "香洲区",
                    gisGcj02Lat: 22.2665,
                    gisGcj02Lng: 113.544,
                  },
                  {
                    id: "440403",
                    text: "斗门区",
                    gisGcj02Lat: 22.209,
                    gisGcj02Lng: 113.296,
                  },
                  {
                    id: "440404",
                    text: "金湾区",
                    gisGcj02Lat: 22.1469,
                    gisGcj02Lng: 113.364,
                  },
                ],
              },
              {
                id: "440500",
                text: "汕头市",
                children: [
                  {
                    id: "440507",
                    text: "龙湖区",
                    gisGcj02Lat: 23.3717,
                    gisGcj02Lng: 116.716,
                  },
                  {
                    id: "440511",
                    text: "金平区",
                    gisGcj02Lat: 23.3664,
                    gisGcj02Lng: 116.704,
                  },
                  {
                    id: "440512",
                    text: "濠江区",
                    gisGcj02Lat: 23.2859,
                    gisGcj02Lng: 116.727,
                  },
                  {
                    id: "440513",
                    text: "潮阳区",
                    gisGcj02Lat: 23.2649,
                    gisGcj02Lng: 116.602,
                  },
                  {
                    id: "440514",
                    text: "潮南区",
                    gisGcj02Lat: 23.25,
                    gisGcj02Lng: 116.432,
                  },
                  {
                    id: "440515",
                    text: "澄海区",
                    gisGcj02Lat: 23.4673,
                    gisGcj02Lng: 116.756,
                  },
                  {
                    id: "440523",
                    text: "南澳县",
                    gisGcj02Lat: 23.4223,
                    gisGcj02Lng: 117.019,
                  },
                ],
              },
              {
                id: "440600",
                text: "佛山市",
                children: [
                  {
                    id: "440604",
                    text: "禅城区",
                    gisGcj02Lat: 23.0084,
                    gisGcj02Lng: 113.123,
                  },
                  {
                    id: "440605",
                    text: "南海区",
                    gisGcj02Lat: 23.0288,
                    gisGcj02Lng: 113.143,
                  },
                  {
                    id: "440606",
                    text: "顺德区",
                    gisGcj02Lat: 22.8045,
                    gisGcj02Lng: 113.294,
                  },
                  {
                    id: "440607",
                    text: "三水区",
                    gisGcj02Lat: 23.1556,
                    gisGcj02Lng: 112.897,
                  },
                  {
                    id: "440608",
                    text: "高明区",
                    gisGcj02Lat: 22.9002,
                    gisGcj02Lng: 112.893,
                  },
                ],
              },
              {
                id: "440700",
                text: "江门市",
                children: [
                  {
                    id: "440703",
                    text: "蓬江区",
                    gisGcj02Lat: 22.5951,
                    gisGcj02Lng: 113.078,
                  },
                  {
                    id: "440704",
                    text: "江海区",
                    gisGcj02Lat: 22.5602,
                    gisGcj02Lng: 113.111,
                  },
                  {
                    id: "440705",
                    text: "新会区",
                    gisGcj02Lat: 22.4588,
                    gisGcj02Lng: 113.032,
                  },
                  {
                    id: "440781",
                    text: "台山市",
                    gisGcj02Lat: 22.2515,
                    gisGcj02Lng: 112.794,
                  },
                  {
                    id: "440783",
                    text: "开平市",
                    gisGcj02Lat: 22.3762,
                    gisGcj02Lng: 112.698,
                  },
                  {
                    id: "440784",
                    text: "鹤山市",
                    gisGcj02Lat: 22.7652,
                    gisGcj02Lng: 112.964,
                  },
                  {
                    id: "440785",
                    text: "恩平市",
                    gisGcj02Lat: 22.1829,
                    gisGcj02Lng: 112.305,
                  },
                ],
              },
              {
                id: "440800",
                text: "湛江市",
                children: [
                  {
                    id: "440802",
                    text: "赤坎区",
                    gisGcj02Lat: 21.2661,
                    gisGcj02Lng: 110.366,
                  },
                  {
                    id: "440803",
                    text: "霞山区",
                    gisGcj02Lat: 21.1918,
                    gisGcj02Lng: 110.398,
                  },
                  {
                    id: "440804",
                    text: "坡头区",
                    gisGcj02Lat: 21.2447,
                    gisGcj02Lng: 110.455,
                  },
                  {
                    id: "440811",
                    text: "麻章区",
                    gisGcj02Lat: 21.2633,
                    gisGcj02Lng: 110.334,
                  },
                  {
                    id: "440823",
                    text: "遂溪县",
                    gisGcj02Lat: 21.3772,
                    gisGcj02Lng: 110.25,
                  },
                  {
                    id: "440825",
                    text: "徐闻县",
                    gisGcj02Lat: 20.3281,
                    gisGcj02Lng: 110.174,
                  },
                  {
                    id: "440881",
                    text: "廉江市",
                    gisGcj02Lat: 21.6092,
                    gisGcj02Lng: 110.284,
                  },
                  {
                    id: "440882",
                    text: "雷州市",
                    gisGcj02Lat: 20.9143,
                    gisGcj02Lng: 110.101,
                  },
                  {
                    id: "440883",
                    text: "吴川市",
                    gisGcj02Lat: 21.4458,
                    gisGcj02Lng: 110.777,
                  },
                ],
              },
              {
                id: "440900",
                text: "茂名市",
                children: [
                  {
                    id: "440902",
                    text: "茂南区",
                    gisGcj02Lat: 21.641,
                    gisGcj02Lng: 110.919,
                  },
                  {
                    id: "440904",
                    text: "电白区",
                    gisGcj02Lat: 21.5072,
                    gisGcj02Lng: 111.007,
                  },
                  {
                    id: "440981",
                    text: "高州市",
                    gisGcj02Lat: 21.9206,
                    gisGcj02Lng: 110.855,
                  },
                  {
                    id: "440982",
                    text: "化州市",
                    gisGcj02Lat: 21.6639,
                    gisGcj02Lng: 110.639,
                  },
                  {
                    id: "440983",
                    text: "信宜市",
                    gisGcj02Lat: 22.3535,
                    gisGcj02Lng: 110.946,
                  },
                ],
              },
              {
                id: "441200",
                text: "肇庆市",
                children: [
                  {
                    id: "441202",
                    text: "端州区",
                    gisGcj02Lat: 23.0519,
                    gisGcj02Lng: 112.485,
                  },
                  {
                    id: "441203",
                    text: "鼎湖区",
                    gisGcj02Lat: 23.1585,
                    gisGcj02Lng: 112.566,
                  },
                  {
                    id: "441223",
                    text: "广宁县",
                    gisGcj02Lat: 23.6346,
                    gisGcj02Lng: 112.441,
                  },
                  {
                    id: "441224",
                    text: "怀集县",
                    gisGcj02Lat: 23.9092,
                    gisGcj02Lng: 112.184,
                  },
                  {
                    id: "441225",
                    text: "封开县",
                    gisGcj02Lat: 23.4357,
                    gisGcj02Lng: 111.503,
                  },
                  {
                    id: "441226",
                    text: "德庆县",
                    gisGcj02Lat: 23.1437,
                    gisGcj02Lng: 111.786,
                  },
                  {
                    id: "441283",
                    text: "高要市",
                    gisGcj02Lat: 23.0258,
                    gisGcj02Lng: 112.458,
                  },
                  {
                    id: "441284",
                    text: "四会市",
                    gisGcj02Lat: 23.3269,
                    gisGcj02Lng: 112.734,
                  },
                ],
              },
              {
                id: "441300",
                text: "惠州市",
                children: [
                  {
                    id: "441302",
                    text: "惠城区",
                    gisGcj02Lat: 23.0838,
                    gisGcj02Lng: 114.383,
                  },
                  {
                    id: "441303",
                    text: "惠阳区",
                    gisGcj02Lat: 22.7885,
                    gisGcj02Lng: 114.456,
                  },
                  {
                    id: "441322",
                    text: "博罗县",
                    gisGcj02Lat: 23.1731,
                    gisGcj02Lng: 114.29,
                  },
                  {
                    id: "441323",
                    text: "惠东县",
                    gisGcj02Lat: 22.9848,
                    gisGcj02Lng: 114.72,
                  },
                  {
                    id: "441324",
                    text: "龙门县",
                    gisGcj02Lat: 23.7276,
                    gisGcj02Lng: 114.255,
                  },
                ],
              },
              {
                id: "441400",
                text: "梅州市",
                children: [
                  {
                    id: "441402",
                    text: "梅江区",
                    gisGcj02Lat: 24.3106,
                    gisGcj02Lng: 116.117,
                  },
                  {
                    id: "441403",
                    text: "梅县区",
                    gisGcj02Lat: 24.2867,
                    gisGcj02Lng: 116.098,
                  },
                  {
                    id: "441422",
                    text: "大埔县",
                    gisGcj02Lat: 24.3533,
                    gisGcj02Lng: 116.697,
                  },
                  {
                    id: "441423",
                    text: "丰顺县",
                    gisGcj02Lat: 23.7409,
                    gisGcj02Lng: 116.182,
                  },
                  {
                    id: "441424",
                    text: "五华县",
                    gisGcj02Lat: 23.9242,
                    gisGcj02Lng: 115.779,
                  },
                  {
                    id: "441426",
                    text: "平远县",
                    gisGcj02Lat: 24.5712,
                    gisGcj02Lng: 115.896,
                  },
                  {
                    id: "441427",
                    text: "蕉岭县",
                    gisGcj02Lat: 24.6573,
                    gisGcj02Lng: 116.171,
                  },
                  {
                    id: "441481",
                    text: "兴宁市",
                    gisGcj02Lat: 24.14,
                    gisGcj02Lng: 115.731,
                  },
                ],
              },
              {
                id: "441500",
                text: "汕尾市",
                children: [
                  {
                    id: "441502",
                    text: "城区",
                    gisGcj02Lat: 22.7789,
                    gisGcj02Lng: 115.365,
                  },
                  {
                    id: "441521",
                    text: "海丰县",
                    gisGcj02Lat: 22.9665,
                    gisGcj02Lng: 115.323,
                  },
                  {
                    id: "441523",
                    text: "陆河县",
                    gisGcj02Lat: 23.3036,
                    gisGcj02Lng: 115.656,
                  },
                  {
                    id: "441581",
                    text: "陆丰市",
                    gisGcj02Lat: 22.9433,
                    gisGcj02Lng: 115.648,
                  },
                ],
              },
              {
                id: "441600",
                text: "河源市",
                children: [
                  {
                    id: "441602",
                    text: "源城区",
                    gisGcj02Lat: 23.7341,
                    gisGcj02Lng: 114.702,
                  },
                  {
                    id: "441621",
                    text: "紫金县",
                    gisGcj02Lat: 23.6387,
                    gisGcj02Lng: 115.184,
                  },
                  {
                    id: "441622",
                    text: "龙川县",
                    gisGcj02Lat: 24.1014,
                    gisGcj02Lng: 115.26,
                  },
                  {
                    id: "441623",
                    text: "连平县",
                    gisGcj02Lat: 24.3716,
                    gisGcj02Lng: 114.49,
                  },
                  {
                    id: "441624",
                    text: "和平县",
                    gisGcj02Lat: 24.4432,
                    gisGcj02Lng: 114.938,
                  },
                  {
                    id: "441625",
                    text: "东源县",
                    gisGcj02Lat: 23.7883,
                    gisGcj02Lng: 114.746,
                  },
                ],
              },
              {
                id: "441700",
                text: "阳江市",
                children: [
                  {
                    id: "441702",
                    text: "江城区",
                    gisGcj02Lat: 21.8619,
                    gisGcj02Lng: 111.955,
                  },
                  {
                    id: "441704",
                    text: "阳东区",
                    gisGcj02Lat: 21.874,
                    gisGcj02Lng: 112.015,
                  },
                  {
                    id: "441721",
                    text: "阳西县",
                    gisGcj02Lat: 21.7523,
                    gisGcj02Lng: 111.618,
                  },
                  {
                    id: "441781",
                    text: "阳春市",
                    gisGcj02Lat: 22.1723,
                    gisGcj02Lng: 111.789,
                  },
                ],
              },
              {
                id: "441800",
                text: "清远市",
                children: [
                  {
                    id: "441802",
                    text: "清城区",
                    gisGcj02Lat: 23.6978,
                    gisGcj02Lng: 113.063,
                  },
                  {
                    id: "441803",
                    text: "清新区",
                    gisGcj02Lat: 23.7369,
                    gisGcj02Lng: 113.015,
                  },
                  {
                    id: "441821",
                    text: "佛冈县",
                    gisGcj02Lat: 23.8723,
                    gisGcj02Lng: 113.533,
                  },
                  {
                    id: "441823",
                    text: "阳山县",
                    gisGcj02Lat: 24.4652,
                    gisGcj02Lng: 112.641,
                  },
                  {
                    id: "441825",
                    text: "连山壮族瑶族自治县",
                    gisGcj02Lat: 24.5681,
                    gisGcj02Lng: 112.08,
                  },
                  {
                    id: "441826",
                    text: "连南瑶族自治县",
                    gisGcj02Lat: 24.7173,
                    gisGcj02Lng: 112.288,
                  },
                  {
                    id: "441881",
                    text: "英德市",
                    gisGcj02Lat: 24.1857,
                    gisGcj02Lng: 113.415,
                  },
                  {
                    id: "441882",
                    text: "连州市",
                    gisGcj02Lat: 24.7791,
                    gisGcj02Lng: 112.382,
                  },
                ],
              },
              {
                id: "441900",
                text: "东莞市",
                children: [
                  {
                    id: "441901",
                    text: "莞城区",
                    gisGcj02Lat: 23.0534,
                    gisGcj02Lng: 113.751,
                  },
                  {
                    id: "441902",
                    text: "南城区",
                    gisGcj02Lat: 23.0202,
                    gisGcj02Lng: 113.752,
                  },
                  {
                    id: "441904",
                    text: "万江区",
                    gisGcj02Lat: 23.0438,
                    gisGcj02Lng: 113.739,
                  },
                  {
                    id: "4419041",
                    text: "东城区",
                    gisGcj02Lat: 23.028,
                    gisGcj02Lng: 113.783,
                  },
                  {
                    id: "441905",
                    text: "石碣镇",
                    gisGcj02Lat: 23.099,
                    gisGcj02Lng: 113.802,
                  },
                  {
                    id: "441906",
                    text: "石龙镇",
                    gisGcj02Lat: 23.1074,
                    gisGcj02Lng: 113.876,
                  },
                  {
                    id: "441907",
                    text: "茶山镇",
                    gisGcj02Lat: 23.0624,
                    gisGcj02Lng: 113.884,
                  },
                  {
                    id: "441908",
                    text: "石排镇",
                    gisGcj02Lat: 23.0863,
                    gisGcj02Lng: 113.92,
                  },
                  {
                    id: "441909",
                    text: "企石镇",
                    gisGcj02Lat: 23.066,
                    gisGcj02Lng: 114.013,
                  },
                  {
                    id: "441910",
                    text: "横沥镇",
                    gisGcj02Lat: 23.0257,
                    gisGcj02Lng: 113.957,
                  },
                  {
                    id: "441911",
                    text: "桥头镇",
                    gisGcj02Lat: 22.9397,
                    gisGcj02Lng: 114.014,
                  },
                  {
                    id: "441912",
                    text: "谢岗镇",
                    gisGcj02Lat: 22.9597,
                    gisGcj02Lng: 114.141,
                  },
                  {
                    id: "441913",
                    text: "东坑镇",
                    gisGcj02Lat: 22.9928,
                    gisGcj02Lng: 113.94,
                  },
                  {
                    id: "441914",
                    text: "常平镇",
                    gisGcj02Lat: 23.0161,
                    gisGcj02Lng: 114.03,
                  },
                  {
                    id: "441915",
                    text: "寮步镇",
                    gisGcj02Lat: 22.9917,
                    gisGcj02Lng: 113.885,
                  },
                  {
                    id: "441916",
                    text: "大朗镇",
                    gisGcj02Lat: 22.9657,
                    gisGcj02Lng: 113.927,
                  },
                  {
                    id: "441917",
                    text: "麻涌镇",
                    gisGcj02Lat: 23.0453,
                    gisGcj02Lng: 113.546,
                  },
                  {
                    id: "441918",
                    text: "中堂镇",
                    gisGcj02Lat: 23.0902,
                    gisGcj02Lng: 113.654,
                  },
                  {
                    id: "441919",
                    text: "高埗镇",
                    gisGcj02Lat: 23.0684,
                    gisGcj02Lng: 113.736,
                  },
                  {
                    id: "441920",
                    text: "樟木头镇",
                    gisGcj02Lat: 22.9567,
                    gisGcj02Lng: 114.066,
                  },
                  {
                    id: "441921",
                    text: "大岭山镇",
                    gisGcj02Lat: 22.8854,
                    gisGcj02Lng: 113.783,
                  },
                  {
                    id: "441922",
                    text: "望牛墩镇",
                    gisGcj02Lat: 23.055,
                    gisGcj02Lng: 113.659,
                  },
                  {
                    id: "441923",
                    text: "黄江镇",
                    gisGcj02Lat: 22.8775,
                    gisGcj02Lng: 113.993,
                  },
                  {
                    id: "441924",
                    text: "洪梅镇",
                    gisGcj02Lat: 22.9927,
                    gisGcj02Lng: 113.613,
                  },
                  {
                    id: "441925",
                    text: "清溪镇",
                    gisGcj02Lat: 22.8445,
                    gisGcj02Lng: 114.156,
                  },
                  {
                    id: "441926",
                    text: "沙田镇",
                    gisGcj02Lat: 23.0489,
                    gisGcj02Lng: 113.76,
                  },
                  {
                    id: "441927",
                    text: "道滘镇",
                    gisGcj02Lat: 23.0489,
                    gisGcj02Lng: 113.76,
                  },
                  {
                    id: "441928",
                    text: "塘厦镇",
                    gisGcj02Lat: 22.8229,
                    gisGcj02Lng: 114.108,
                  },
                  {
                    id: "441929",
                    text: "虎门镇",
                    gisGcj02Lat: 22.8262,
                    gisGcj02Lng: 113.711,
                  },
                  {
                    id: "441930",
                    text: "厚街镇",
                    gisGcj02Lat: 22.9408,
                    gisGcj02Lng: 113.673,
                  },
                  {
                    id: "441931",
                    text: "凤岗镇",
                    gisGcj02Lat: 22.7446,
                    gisGcj02Lng: 114.141,
                  },
                  {
                    id: "441932",
                    text: "长安镇",
                    gisGcj02Lat: 22.8166,
                    gisGcj02Lng: 113.804,
                  },
                ],
              },
              {
                id: "442000",
                text: "中山市",
                children: [
                  {
                    id: "442001",
                    text: "石岐区",
                    gisGcj02Lat: 22.5252,
                    gisGcj02Lng: 113.379,
                  },
                  {
                    id: "442004",
                    text: "南区",
                    gisGcj02Lat: 22.4866,
                    gisGcj02Lng: 113.356,
                  },
                  {
                    id: "442005",
                    text: "五桂山区",
                    gisGcj02Lat: 22.5197,
                    gisGcj02Lng: 113.411,
                  },
                  {
                    id: "442006",
                    text: "火炬开发区",
                    gisGcj02Lat: 22.5661,
                    gisGcj02Lng: 113.481,
                  },
                  {
                    id: "442007",
                    text: "黄圃镇",
                    gisGcj02Lat: 22.7151,
                    gisGcj02Lng: 113.342,
                  },
                  {
                    id: "442008",
                    text: "南头镇",
                    gisGcj02Lat: 22.7139,
                    gisGcj02Lng: 113.296,
                  },
                  {
                    id: "442009",
                    text: "东凤镇",
                    gisGcj02Lat: 22.6877,
                    gisGcj02Lng: 113.261,
                  },
                  {
                    id: "442010",
                    text: "阜沙镇",
                    gisGcj02Lat: 22.6664,
                    gisGcj02Lng: 113.353,
                  },
                  {
                    id: "442011",
                    text: "小榄镇",
                    gisGcj02Lat: 22.667,
                    gisGcj02Lng: 113.244,
                  },
                  {
                    id: "442012",
                    text: "东升镇",
                    gisGcj02Lat: 22.614,
                    gisGcj02Lng: 113.296,
                  },
                  {
                    id: "442013",
                    text: "古镇镇",
                    gisGcj02Lat: 22.611,
                    gisGcj02Lng: 113.18,
                  },
                  {
                    id: "442014",
                    text: "横栏镇",
                    gisGcj02Lat: 22.5232,
                    gisGcj02Lng: 113.266,
                  },
                  {
                    id: "442015",
                    text: "三角镇",
                    gisGcj02Lat: 22.677,
                    gisGcj02Lng: 113.424,
                  },
                  {
                    id: "442016",
                    text: "民众镇",
                    gisGcj02Lat: 22.6235,
                    gisGcj02Lng: 113.486,
                  },
                  {
                    id: "442017",
                    text: "南朗镇",
                    gisGcj02Lat: 22.4924,
                    gisGcj02Lng: 113.534,
                  },
                  {
                    id: "442018",
                    text: "港口镇",
                    gisGcj02Lat: 22.5211,
                    gisGcj02Lng: 113.382,
                  },
                  {
                    id: "442019",
                    text: "大涌镇",
                    gisGcj02Lat: 22.4677,
                    gisGcj02Lng: 113.292,
                  },
                  {
                    id: "442020",
                    text: "沙溪镇",
                    gisGcj02Lat: 22.5263,
                    gisGcj02Lng: 113.328,
                  },
                  {
                    id: "442021",
                    text: "三乡镇",
                    gisGcj02Lat: 22.3525,
                    gisGcj02Lng: 113.433,
                  },
                  {
                    id: "442022",
                    text: "板芙镇",
                    gisGcj02Lat: 22.4157,
                    gisGcj02Lng: 113.32,
                  },
                  {
                    id: "442023",
                    text: "神湾镇",
                    gisGcj02Lat: 22.3125,
                    gisGcj02Lng: 113.359,
                  },
                  {
                    id: "442024",
                    text: "坦洲镇",
                    gisGcj02Lat: 22.2613,
                    gisGcj02Lng: 113.486,
                  },
                  {
                    id: "442025",
                    text: "西区",
                    gisGcj02Lat: 22.68534,
                    gisGcj02Lng: 113.21443,
                  },
                ],
              },
              {
                id: "445100",
                text: "潮州市",
                children: [
                  {
                    id: "445102",
                    text: "湘桥区",
                    gisGcj02Lat: 23.6745,
                    gisGcj02Lng: 116.628,
                  },
                  {
                    id: "445103",
                    text: "潮安区",
                    gisGcj02Lat: 23.6437,
                    gisGcj02Lng: 116.593,
                  },
                  {
                    id: "445122",
                    text: "饶平县",
                    gisGcj02Lat: 23.6699,
                    gisGcj02Lng: 117.007,
                  },
                ],
              },
              {
                id: "445200",
                text: "揭阳市",
                children: [
                  {
                    id: "445202",
                    text: "榕城区",
                    gisGcj02Lat: 23.5251,
                    gisGcj02Lng: 116.367,
                  },
                  {
                    id: "445203",
                    text: "揭东区",
                    gisGcj02Lat: 23.5699,
                    gisGcj02Lng: 116.413,
                  },
                  {
                    id: "445222",
                    text: "揭西县",
                    gisGcj02Lat: 23.4271,
                    gisGcj02Lng: 115.839,
                  },
                  {
                    id: "445224",
                    text: "惠来县",
                    gisGcj02Lat: 23.0329,
                    gisGcj02Lng: 116.296,
                  },
                  {
                    id: "445281",
                    text: "普宁市",
                    gisGcj02Lat: 23.2973,
                    gisGcj02Lng: 116.166,
                  },
                ],
              },
              {
                id: "445300",
                text: "云浮市",
                children: [
                  {
                    id: "445302",
                    text: "云城区",
                    gisGcj02Lat: 22.93,
                    gisGcj02Lng: 112.039,
                  },
                  {
                    id: "445303",
                    text: "云安区",
                    gisGcj02Lat: 23.0778,
                    gisGcj02Lng: 112.009,
                  },
                  {
                    id: "445321",
                    text: "新兴县",
                    gisGcj02Lat: 22.6973,
                    gisGcj02Lng: 112.23,
                  },
                  {
                    id: "445322",
                    text: "郁南县",
                    gisGcj02Lat: 23.2331,
                    gisGcj02Lng: 111.534,
                  },
                  {
                    id: "445381",
                    text: "罗定市",
                    gisGcj02Lat: 22.7697,
                    gisGcj02Lng: 111.57,
                  },
                ],
              },
            ],
          },
          {
            id: "450000",
            text: "广西",
            children: [
              {
                id: "450100",
                text: "南宁市",
                children: [
                  {
                    id: "450102",
                    text: "兴宁区",
                    gisGcj02Lat: 22.8535,
                    gisGcj02Lng: 108.367,
                  },
                  {
                    id: "450103",
                    text: "青秀区",
                    gisGcj02Lat: 22.7851,
                    gisGcj02Lng: 108.495,
                  },
                  {
                    id: "450105",
                    text: "江南区",
                    gisGcj02Lat: 22.7813,
                    gisGcj02Lng: 108.273,
                  },
                  {
                    id: "450107",
                    text: "西乡塘区",
                    gisGcj02Lat: 22.8339,
                    gisGcj02Lng: 108.313,
                  },
                  {
                    id: "450108",
                    text: "良庆区",
                    gisGcj02Lat: 22.7491,
                    gisGcj02Lng: 108.413,
                  },
                  {
                    id: "450109",
                    text: "邕宁区",
                    gisGcj02Lat: 22.7563,
                    gisGcj02Lng: 108.487,
                  },
                  {
                    id: "450122",
                    text: "武鸣县",
                    gisGcj02Lat: 23.1564,
                    gisGcj02Lng: 108.277,
                  },
                  {
                    id: "450123",
                    text: "隆安县",
                    gisGcj02Lat: 23.1734,
                    gisGcj02Lng: 107.692,
                  },
                  {
                    id: "450124",
                    text: "马山县",
                    gisGcj02Lat: 23.7093,
                    gisGcj02Lng: 108.177,
                  },
                  {
                    id: "450125",
                    text: "上林县",
                    gisGcj02Lat: 23.432,
                    gisGcj02Lng: 108.605,
                  },
                  {
                    id: "450126",
                    text: "宾阳县",
                    gisGcj02Lat: 23.2196,
                    gisGcj02Lng: 108.812,
                  },
                  {
                    id: "450127",
                    text: "横州市",
                    gisGcj02Lat: 22.6845,
                    gisGcj02Lng: 109.266,
                  },
                  {
                    id: "450128",
                    text: "埌东新区",
                    gisGcj02Lat: 22.813,
                    gisGcj02Lng: 108.419,
                  },
                ],
              },
              {
                id: "450200",
                text: "柳州市",
                children: [
                  {
                    id: "450202",
                    text: "城中区",
                    gisGcj02Lat: 24.3154,
                    gisGcj02Lng: 109.411,
                  },
                  {
                    id: "450203",
                    text: "鱼峰区",
                    gisGcj02Lat: 24.3187,
                    gisGcj02Lng: 109.453,
                  },
                  {
                    id: "450204",
                    text: "柳南区",
                    gisGcj02Lat: 24.336,
                    gisGcj02Lng: 109.385,
                  },
                  {
                    id: "450205",
                    text: "柳北区",
                    gisGcj02Lat: 24.3627,
                    gisGcj02Lng: 109.402,
                  },
                  {
                    id: "450221",
                    text: "柳江县",
                    gisGcj02Lat: 24.256,
                    gisGcj02Lng: 109.333,
                  },
                  {
                    id: "450222",
                    text: "柳城县",
                    gisGcj02Lat: 24.6495,
                    gisGcj02Lng: 109.239,
                  },
                  {
                    id: "450223",
                    text: "鹿寨县",
                    gisGcj02Lat: 24.4731,
                    gisGcj02Lng: 109.752,
                  },
                  {
                    id: "450224",
                    text: "融安县",
                    gisGcj02Lat: 25.2246,
                    gisGcj02Lng: 109.398,
                  },
                  {
                    id: "450225",
                    text: "融水苗族自治县",
                    gisGcj02Lat: 25.0663,
                    gisGcj02Lng: 109.256,
                  },
                  {
                    id: "450226",
                    text: "三江侗族自治县",
                    gisGcj02Lat: 25.7843,
                    gisGcj02Lng: 109.604,
                  },
                  {
                    id: "450227",
                    text: "柳东新区",
                    gisGcj02Lat: 24.3292,
                    gisGcj02Lng: 109.437,
                  },
                ],
              },
              {
                id: "450300",
                text: "桂林市",
                children: [
                  {
                    id: "450302",
                    text: "秀峰区",
                    gisGcj02Lat: 25.2825,
                    gisGcj02Lng: 110.289,
                  },
                  {
                    id: "450303",
                    text: "叠彩区",
                    gisGcj02Lat: 25.3138,
                    gisGcj02Lng: 110.302,
                  },
                  {
                    id: "450304",
                    text: "象山区",
                    gisGcj02Lat: 25.2617,
                    gisGcj02Lng: 110.281,
                  },
                  {
                    id: "450305",
                    text: "七星区",
                    gisGcj02Lat: 25.2525,
                    gisGcj02Lng: 110.318,
                  },
                  {
                    id: "450311",
                    text: "雁山区",
                    gisGcj02Lat: 25.0604,
                    gisGcj02Lng: 110.309,
                  },
                  {
                    id: "450312",
                    text: "临桂区",
                    gisGcj02Lat: 25.2463,
                    gisGcj02Lng: 110.205,
                  },
                  {
                    id: "450321",
                    text: "阳朔县",
                    gisGcj02Lat: 24.7758,
                    gisGcj02Lng: 110.495,
                  },
                  {
                    id: "450323",
                    text: "灵川县",
                    gisGcj02Lat: 25.4129,
                    gisGcj02Lng: 110.329,
                  },
                  {
                    id: "450324",
                    text: "全州县",
                    gisGcj02Lat: 25.928,
                    gisGcj02Lng: 111.072,
                  },
                  {
                    id: "450325",
                    text: "兴安县",
                    gisGcj02Lat: 25.6117,
                    gisGcj02Lng: 110.671,
                  },
                  {
                    id: "450326",
                    text: "永福县",
                    gisGcj02Lat: 24.98,
                    gisGcj02Lng: 109.983,
                  },
                  {
                    id: "450327",
                    text: "灌阳县",
                    gisGcj02Lat: 25.488,
                    gisGcj02Lng: 111.16,
                  },
                  {
                    id: "450328",
                    text: "龙胜各族自治县",
                    gisGcj02Lat: 25.7961,
                    gisGcj02Lng: 110.012,
                  },
                  {
                    id: "450329",
                    text: "资源县",
                    gisGcj02Lat: 26.0424,
                    gisGcj02Lng: 110.653,
                  },
                  {
                    id: "450330",
                    text: "平乐县",
                    gisGcj02Lat: 24.6324,
                    gisGcj02Lng: 110.642,
                  },
                  {
                    id: "450331",
                    text: "荔浦县",
                    gisGcj02Lat: 24.4959,
                    gisGcj02Lng: 110.397,
                  },
                  {
                    id: "450332",
                    text: "恭城瑶族自治县",
                    gisGcj02Lat: 24.8329,
                    gisGcj02Lng: 110.83,
                  },
                ],
              },
              {
                id: "450400",
                text: "梧州市",
                children: [
                  {
                    id: "450403",
                    text: "万秀区",
                    gisGcj02Lat: 23.473,
                    gisGcj02Lng: 111.321,
                  },
                  {
                    id: "450405",
                    text: "长洲区",
                    gisGcj02Lat: 23.4857,
                    gisGcj02Lng: 111.275,
                  },
                  {
                    id: "450406",
                    text: "龙圩区",
                    gisGcj02Lat: 23.4723,
                    gisGcj02Lng: 111.316,
                  },
                  {
                    id: "450421",
                    text: "苍梧县",
                    gisGcj02Lat: 23.4205,
                    gisGcj02Lng: 111.245,
                  },
                  {
                    id: "450422",
                    text: "藤县",
                    gisGcj02Lat: 23.3761,
                    gisGcj02Lng: 110.914,
                  },
                  {
                    id: "450423",
                    text: "蒙山县",
                    gisGcj02Lat: 24.2017,
                    gisGcj02Lng: 110.522,
                  },
                  {
                    id: "450481",
                    text: "岑溪市",
                    gisGcj02Lat: 22.9191,
                    gisGcj02Lng: 110.996,
                  },
                ],
              },
              {
                id: "450500",
                text: "北海市",
                children: [
                  {
                    id: "450502",
                    text: "海城区",
                    gisGcj02Lat: 21.475,
                    gisGcj02Lng: 109.117,
                  },
                  {
                    id: "450503",
                    text: "银海区",
                    gisGcj02Lat: 21.4783,
                    gisGcj02Lng: 109.13,
                  },
                  {
                    id: "450512",
                    text: "铁山港区",
                    gisGcj02Lat: 21.5966,
                    gisGcj02Lng: 109.456,
                  },
                  {
                    id: "450521",
                    text: "合浦县",
                    gisGcj02Lat: 21.666,
                    gisGcj02Lng: 109.201,
                  },
                ],
              },
              {
                id: "450600",
                text: "防城港市",
                children: [
                  {
                    id: "450602",
                    text: "港口区",
                    gisGcj02Lat: 21.6434,
                    gisGcj02Lng: 108.38,
                  },
                  {
                    id: "450603",
                    text: "防城区",
                    gisGcj02Lat: 21.7646,
                    gisGcj02Lng: 108.357,
                  },
                  {
                    id: "450621",
                    text: "上思县",
                    gisGcj02Lat: 22.1496,
                    gisGcj02Lng: 107.982,
                  },
                  {
                    id: "450681",
                    text: "东兴市",
                    gisGcj02Lat: 21.5471,
                    gisGcj02Lng: 107.972,
                  },
                ],
              },
              {
                id: "450700",
                text: "钦州市",
                children: [
                  {
                    id: "450702",
                    text: "钦南区",
                    gisGcj02Lat: 21.9514,
                    gisGcj02Lng: 108.618,
                  },
                  {
                    id: "450703",
                    text: "钦北区",
                    gisGcj02Lat: 21.9513,
                    gisGcj02Lng: 108.63,
                  },
                  {
                    id: "450721",
                    text: "灵山县",
                    gisGcj02Lat: 22.4165,
                    gisGcj02Lng: 109.292,
                  },
                  {
                    id: "450722",
                    text: "浦北县",
                    gisGcj02Lat: 22.2689,
                    gisGcj02Lng: 109.556,
                  },
                ],
              },
              {
                id: "450800",
                text: "贵港市",
                children: [
                  {
                    id: "450802",
                    text: "港北区",
                    gisGcj02Lat: 23.1115,
                    gisGcj02Lng: 109.572,
                  },
                  {
                    id: "450803",
                    text: "港南区",
                    gisGcj02Lat: 23.0723,
                    gisGcj02Lng: 109.606,
                  },
                  {
                    id: "450804",
                    text: "覃塘区",
                    gisGcj02Lat: 23.1268,
                    gisGcj02Lng: 109.443,
                  },
                  {
                    id: "450821",
                    text: "平南县",
                    gisGcj02Lat: 23.542,
                    gisGcj02Lng: 110.391,
                  },
                  {
                    id: "450881",
                    text: "桂平市",
                    gisGcj02Lat: 23.3934,
                    gisGcj02Lng: 110.081,
                  },
                ],
              },
              {
                id: "450900",
                text: "玉林市",
                children: [
                  {
                    id: "450902",
                    text: "玉州区",
                    gisGcj02Lat: 22.6281,
                    gisGcj02Lng: 110.151,
                  },
                  {
                    id: "450903",
                    text: "福绵区",
                    gisGcj02Lat: 22.5831,
                    gisGcj02Lng: 110.065,
                  },
                  {
                    id: "450904",
                    text: "玉东新区",
                    gisGcj02Lat: 22.6314,
                    gisGcj02Lng: 110.154,
                  },
                  {
                    id: "450921",
                    text: "容县",
                    gisGcj02Lat: 22.857,
                    gisGcj02Lng: 110.556,
                  },
                  {
                    id: "450922",
                    text: "陆川县",
                    gisGcj02Lat: 22.3245,
                    gisGcj02Lng: 110.264,
                  },
                  {
                    id: "450923",
                    text: "博白县",
                    gisGcj02Lat: 22.2729,
                    gisGcj02Lng: 109.977,
                  },
                  {
                    id: "450924",
                    text: "兴业县",
                    gisGcj02Lat: 22.7424,
                    gisGcj02Lng: 109.876,
                  },
                  {
                    id: "450981",
                    text: "北流市",
                    gisGcj02Lat: 22.7082,
                    gisGcj02Lng: 110.353,
                  },
                ],
              },
              {
                id: "451000",
                text: "百色市",
                children: [
                  {
                    id: "451002",
                    text: "右江区",
                    gisGcj02Lat: 23.9009,
                    gisGcj02Lng: 106.618,
                  },
                  {
                    id: "451021",
                    text: "田阳区",
                    gisGcj02Lat: 23.7353,
                    gisGcj02Lng: 106.916,
                  },
                  {
                    id: "451022",
                    text: "田东县",
                    gisGcj02Lat: 23.6,
                    gisGcj02Lng: 107.124,
                  },
                  {
                    id: "451023",
                    text: "平果市",
                    gisGcj02Lat: 23.3297,
                    gisGcj02Lng: 107.59,
                  },
                  {
                    id: "451024",
                    text: "德保县",
                    gisGcj02Lat: 23.3251,
                    gisGcj02Lng: 106.619,
                  },
                  {
                    id: "451025",
                    text: "靖西市",
                    gisGcj02Lat: 23.1343,
                    gisGcj02Lng: 106.418,
                  },
                  {
                    id: "451026",
                    text: "那坡县",
                    gisGcj02Lat: 23.4065,
                    gisGcj02Lng: 105.842,
                  },
                  {
                    id: "451027",
                    text: "凌云县",
                    gisGcj02Lat: 24.3475,
                    gisGcj02Lng: 106.562,
                  },
                  {
                    id: "451028",
                    text: "乐业县",
                    gisGcj02Lat: 24.7829,
                    gisGcj02Lng: 106.561,
                  },
                  {
                    id: "451029",
                    text: "田林县",
                    gisGcj02Lat: 24.2921,
                    gisGcj02Lng: 106.229,
                  },
                  {
                    id: "451030",
                    text: "西林县",
                    gisGcj02Lat: 24.4897,
                    gisGcj02Lng: 105.097,
                  },
                  {
                    id: "451031",
                    text: "隆林各族自治县",
                    gisGcj02Lat: 24.7704,
                    gisGcj02Lng: 105.343,
                  },
                ],
              },
              {
                id: "451100",
                text: "贺州市",
                children: [
                  {
                    id: "451102",
                    text: "八步区",
                    gisGcj02Lat: 24.4118,
                    gisGcj02Lng: 111.552,
                  },
                  {
                    id: "451121",
                    text: "昭平县",
                    gisGcj02Lat: 24.1701,
                    gisGcj02Lng: 110.811,
                  },
                  {
                    id: "451122",
                    text: "钟山县",
                    gisGcj02Lat: 24.5248,
                    gisGcj02Lng: 111.305,
                  },
                  {
                    id: "451123",
                    text: "富川瑶族自治县",
                    gisGcj02Lat: 24.8143,
                    gisGcj02Lng: 111.278,
                  },
                  {
                    id: "451124",
                    text: "平桂区",
                    gisGcj02Lat: 24.458,
                    gisGcj02Lng: 111.486,
                  },
                ],
              },
              {
                id: "451200",
                text: "河池市",
                children: [
                  {
                    id: "451202",
                    text: "金城江区",
                    gisGcj02Lat: 24.6897,
                    gisGcj02Lng: 108.037,
                  },
                  {
                    id: "451221",
                    text: "南丹县",
                    gisGcj02Lat: 24.9776,
                    gisGcj02Lng: 107.546,
                  },
                  {
                    id: "451222",
                    text: "天峨县",
                    gisGcj02Lat: 24.9959,
                    gisGcj02Lng: 107.172,
                  },
                  {
                    id: "451223",
                    text: "凤山县",
                    gisGcj02Lat: 24.5422,
                    gisGcj02Lng: 107.049,
                  },
                  {
                    id: "451224",
                    text: "东兰县",
                    gisGcj02Lat: 24.5105,
                    gisGcj02Lng: 107.375,
                  },
                  {
                    id: "451225",
                    text: "罗城仫佬族自治县",
                    gisGcj02Lat: 24.7792,
                    gisGcj02Lng: 108.908,
                  },
                  {
                    id: "451226",
                    text: "环江毛南族自治县",
                    gisGcj02Lat: 24.8292,
                    gisGcj02Lng: 108.261,
                  },
                  {
                    id: "451227",
                    text: "巴马瑶族自治县",
                    gisGcj02Lat: 24.1413,
                    gisGcj02Lng: 107.253,
                  },
                  {
                    id: "451228",
                    text: "都安瑶族自治县",
                    gisGcj02Lat: 23.9324,
                    gisGcj02Lng: 108.101,
                  },
                  {
                    id: "451229",
                    text: "大化瑶族自治县",
                    gisGcj02Lat: 23.7449,
                    gisGcj02Lng: 107.998,
                  },
                  {
                    id: "451281",
                    text: "宜州区",
                    gisGcj02Lat: 24.4939,
                    gisGcj02Lng: 108.653,
                  },
                ],
              },
              {
                id: "451300",
                text: "来宾市",
                children: [
                  {
                    id: "451302",
                    text: "兴宾区",
                    gisGcj02Lat: 23.7273,
                    gisGcj02Lng: 109.235,
                  },
                  {
                    id: "451321",
                    text: "忻城县",
                    gisGcj02Lat: 24.0686,
                    gisGcj02Lng: 108.664,
                  },
                  {
                    id: "451322",
                    text: "象州县",
                    gisGcj02Lat: 23.9736,
                    gisGcj02Lng: 109.699,
                  },
                  {
                    id: "451323",
                    text: "武宣县",
                    gisGcj02Lat: 23.5947,
                    gisGcj02Lng: 109.663,
                  },
                  {
                    id: "451324",
                    text: "金秀瑶族自治县",
                    gisGcj02Lat: 24.1293,
                    gisGcj02Lng: 110.191,
                  },
                  {
                    id: "451381",
                    text: "合山市",
                    gisGcj02Lat: 23.8062,
                    gisGcj02Lng: 108.886,
                  },
                ],
              },
              {
                id: "451400",
                text: "崇左市",
                children: [
                  {
                    id: "451402",
                    text: "江州区",
                    gisGcj02Lat: 22.4114,
                    gisGcj02Lng: 107.347,
                  },
                  {
                    id: "451421",
                    text: "扶绥县",
                    gisGcj02Lat: 22.6341,
                    gisGcj02Lng: 107.904,
                  },
                  {
                    id: "451422",
                    text: "宁明县",
                    gisGcj02Lat: 22.1366,
                    gisGcj02Lng: 107.073,
                  },
                  {
                    id: "451423",
                    text: "龙州县",
                    gisGcj02Lat: 22.3394,
                    gisGcj02Lng: 106.854,
                  },
                  {
                    id: "451424",
                    text: "大新县",
                    gisGcj02Lat: 22.8341,
                    gisGcj02Lng: 107.198,
                  },
                  {
                    id: "451425",
                    text: "天等县",
                    gisGcj02Lat: 23.077,
                    gisGcj02Lng: 107.14,
                  },
                  {
                    id: "451481",
                    text: "凭祥市",
                    gisGcj02Lat: 22.1057,
                    gisGcj02Lng: 106.755,
                  },
                ],
              },
            ],
          },
          {
            id: "460000",
            text: "海南省",
            children: [
              {
                id: "460100",
                text: "海口市",
                children: [
                  {
                    id: "460105",
                    text: "秀英区",
                    gisGcj02Lat: 20.0075,
                    gisGcj02Lng: 110.293,
                  },
                  {
                    id: "460106",
                    text: "龙华区",
                    gisGcj02Lat: 20.0287,
                    gisGcj02Lng: 110.302,
                  },
                  {
                    id: "460107",
                    text: "琼山区",
                    gisGcj02Lat: 20.0032,
                    gisGcj02Lng: 110.354,
                  },
                  {
                    id: "460108",
                    text: "美兰区",
                    gisGcj02Lat: 20.0286,
                    gisGcj02Lng: 110.369,
                  },
                ],
              },
              {
                id: "460200",
                text: "三亚市",
                children: [
                  {
                    id: "460202",
                    text: "海棠区",
                    gisGcj02Lat: 18.2479,
                    gisGcj02Lng: 109.508,
                  },
                  {
                    id: "460203",
                    text: "吉阳区",
                    gisGcj02Lat: 18.2479,
                    gisGcj02Lng: 109.508,
                  },
                  {
                    id: "460204",
                    text: "天涯区",
                    gisGcj02Lat: 18.2479,
                    gisGcj02Lng: 109.508,
                  },
                  {
                    id: "460205",
                    text: "崖州区",
                    gisGcj02Lat: 18.2479,
                    gisGcj02Lng: 109.508,
                  },
                ],
              },
              {
                id: "460300",
                text: "三沙市",
                children: [
                  {
                    id: "460321",
                    text: "西沙区",
                    gisGcj02Lat: 16.3313,
                    gisGcj02Lng: 112.026,
                  },
                  {
                    id: "460322",
                    text: "南沙区",
                    gisGcj02Lat: 11.4719,
                    gisGcj02Lng: 116.75,
                  },
                  {
                    id: "460323",
                    text: "中沙群岛",
                    gisGcj02Lat: 15.1129,
                    gisGcj02Lng: 117.74,
                  },
                ],
              },
              {
                id: "469000",
                text: "直辖县级",
                children: [
                  {
                    id: "469001",
                    text: "五指山市",
                    gisGcj02Lat: 18.7769,
                    gisGcj02Lng: 109.517,
                  },
                  {
                    id: "469002",
                    text: "琼海市",
                    gisGcj02Lat: 19.246,
                    gisGcj02Lng: 110.467,
                  },
                  {
                    id: "469003",
                    text: "儋州市",
                    gisGcj02Lat: 19.5175,
                    gisGcj02Lng: 109.577,
                  },
                  {
                    id: "469005",
                    text: "文昌市",
                    gisGcj02Lat: 19.613,
                    gisGcj02Lng: 110.754,
                  },
                  {
                    id: "469006",
                    text: "万宁市",
                    gisGcj02Lat: 18.7962,
                    gisGcj02Lng: 110.389,
                  },
                  {
                    id: "469007",
                    text: "东方市",
                    gisGcj02Lat: 19.102,
                    gisGcj02Lng: 108.654,
                  },
                  {
                    id: "469021",
                    text: "定安县",
                    gisGcj02Lat: 19.6992,
                    gisGcj02Lng: 110.324,
                  },
                  {
                    id: "469022",
                    text: "屯昌县",
                    gisGcj02Lat: 19.3629,
                    gisGcj02Lng: 110.103,
                  },
                  {
                    id: "469023",
                    text: "澄迈县",
                    gisGcj02Lat: 19.7371,
                    gisGcj02Lng: 110.007,
                  },
                  {
                    id: "469024",
                    text: "临高县",
                    gisGcj02Lat: 19.9083,
                    gisGcj02Lng: 109.688,
                  },
                  {
                    id: "469025",
                    text: "白沙黎族自治县",
                    gisGcj02Lat: 19.2246,
                    gisGcj02Lng: 109.453,
                  },
                  {
                    id: "469026",
                    text: "昌江黎族自治县",
                    gisGcj02Lat: 19.261,
                    gisGcj02Lng: 109.053,
                  },
                  {
                    id: "469027",
                    text: "乐东黎族自治县",
                    gisGcj02Lat: 18.7476,
                    gisGcj02Lng: 109.175,
                  },
                  {
                    id: "469028",
                    text: "陵水黎族自治县",
                    gisGcj02Lat: 18.505,
                    gisGcj02Lng: 110.037,
                  },
                  {
                    id: "469029",
                    text: "保亭黎族苗族自治县",
                    gisGcj02Lat: 18.6364,
                    gisGcj02Lng: 109.702,
                  },
                  {
                    id: "469030",
                    text: "琼中黎族苗族自治县",
                    gisGcj02Lat: 19.0356,
                    gisGcj02Lng: 109.84,
                  },
                ],
              },
            ],
          },
          {
            id: "500000",
            text: "重庆市",
            children: [
              {
                id: "500100",
                text: "重庆市",
                children: [
                  {
                    id: "500101",
                    text: "万州区",
                    gisGcj02Lat: 30.8079,
                    gisGcj02Lng: 108.409,
                  },
                  {
                    id: "500102",
                    text: "涪陵区",
                    gisGcj02Lat: 29.7029,
                    gisGcj02Lng: 107.39,
                  },
                  {
                    id: "500103",
                    text: "渝中区",
                    gisGcj02Lat: 29.5528,
                    gisGcj02Lng: 106.569,
                  },
                  {
                    id: "500104",
                    text: "大渡口区",
                    gisGcj02Lat: 29.4845,
                    gisGcj02Lng: 106.483,
                  },
                  {
                    id: "500105",
                    text: "江北区",
                    gisGcj02Lat: 29.6066,
                    gisGcj02Lng: 106.574,
                  },
                  {
                    id: "500106",
                    text: "沙坪坝区",
                    gisGcj02Lat: 29.5411,
                    gisGcj02Lng: 106.458,
                  },
                  {
                    id: "500107",
                    text: "九龙坡区",
                    gisGcj02Lat: 29.502,
                    gisGcj02Lng: 106.511,
                  },
                  {
                    id: "500108",
                    text: "南岸区",
                    gisGcj02Lat: 29.5231,
                    gisGcj02Lng: 106.563,
                  },
                  {
                    id: "500109",
                    text: "北碚区",
                    gisGcj02Lat: 29.8057,
                    gisGcj02Lng: 106.396,
                  },
                  {
                    id: "500110",
                    text: "綦江区",
                    gisGcj02Lat: 28.9607,
                    gisGcj02Lng: 106.927,
                  },
                  {
                    id: "500111",
                    text: "大足区",
                    gisGcj02Lat: 29.484,
                    gisGcj02Lng: 105.768,
                  },
                  {
                    id: "500112",
                    text: "渝北区",
                    gisGcj02Lat: 29.7182,
                    gisGcj02Lng: 106.631,
                  },
                  {
                    id: "500113",
                    text: "巴南区",
                    gisGcj02Lat: 29.3831,
                    gisGcj02Lng: 106.524,
                  },
                  {
                    id: "500114",
                    text: "黔江区",
                    gisGcj02Lat: 29.5332,
                    gisGcj02Lng: 108.771,
                  },
                  {
                    id: "500115",
                    text: "长寿区",
                    gisGcj02Lat: 29.8536,
                    gisGcj02Lng: 107.082,
                  },
                  {
                    id: "500116",
                    text: "江津区",
                    gisGcj02Lat: 29.2901,
                    gisGcj02Lng: 106.259,
                  },
                  {
                    id: "500117",
                    text: "合川区",
                    gisGcj02Lat: 29.9723,
                    gisGcj02Lng: 106.276,
                  },
                  {
                    id: "500118",
                    text: "永川区",
                    gisGcj02Lat: 29.3559,
                    gisGcj02Lng: 105.927,
                  },
                  {
                    id: "500119",
                    text: "南川区",
                    gisGcj02Lat: 29.1575,
                    gisGcj02Lng: 107.099,
                  },
                  {
                    id: "500120",
                    text: "璧山区",
                    gisGcj02Lat: 29.5936,
                    gisGcj02Lng: 106.231,
                  },
                  {
                    id: "500151",
                    text: "铜梁区",
                    gisGcj02Lat: 29.8399,
                    gisGcj02Lng: 106.055,
                  },
                  {
                    id: "500223",
                    text: "潼南区",
                    gisGcj02Lat: 30.1912,
                    gisGcj02Lng: 105.84,
                  },
                  {
                    id: "500226",
                    text: "荣昌区",
                    gisGcj02Lat: 29.4049,
                    gisGcj02Lng: 105.594,
                  },
                  {
                    id: "500228",
                    text: "梁平区",
                    gisGcj02Lat: 30.6754,
                    gisGcj02Lng: 107.8,
                  },
                  {
                    id: "500229",
                    text: "城口县",
                    gisGcj02Lat: 31.948,
                    gisGcj02Lng: 108.665,
                  },
                  {
                    id: "500230",
                    text: "丰都县",
                    gisGcj02Lat: 29.8635,
                    gisGcj02Lng: 107.731,
                  },
                  {
                    id: "500231",
                    text: "垫江县",
                    gisGcj02Lat: 30.3336,
                    gisGcj02Lng: 107.354,
                  },
                  {
                    id: "500232",
                    text: "武隆区",
                    gisGcj02Lat: 29.3255,
                    gisGcj02Lng: 107.76,
                  },
                  {
                    id: "500233",
                    text: "忠县",
                    gisGcj02Lat: 30.289,
                    gisGcj02Lng: 108.037,
                  },
                  {
                    id: "500234",
                    text: "开州区",
                    gisGcj02Lat: 31.1609,
                    gisGcj02Lng: 108.393,
                  },
                  {
                    id: "500235",
                    text: "云阳县",
                    gisGcj02Lat: 30.9306,
                    gisGcj02Lng: 108.697,
                  },
                  {
                    id: "500236",
                    text: "奉节县",
                    gisGcj02Lat: 31.0182,
                    gisGcj02Lng: 109.465,
                  },
                  {
                    id: "500237",
                    text: "巫山县",
                    gisGcj02Lat: 31.0746,
                    gisGcj02Lng: 109.878,
                  },
                  {
                    id: "500238",
                    text: "巫溪县",
                    gisGcj02Lat: 31.3976,
                    gisGcj02Lng: 109.631,
                  },
                  {
                    id: "500240",
                    text: "石柱土家族自治县",
                    gisGcj02Lat: 30.0005,
                    gisGcj02Lng: 108.114,
                  },
                  {
                    id: "500241",
                    text: "秀山土家族苗族自治县",
                    gisGcj02Lat: 28.4506,
                    gisGcj02Lng: 108.989,
                  },
                  {
                    id: "500242",
                    text: "酉阳土家族苗族自治县",
                    gisGcj02Lat: 28.8446,
                    gisGcj02Lng: 108.772,
                  },
                  {
                    id: "500243",
                    text: "彭水苗族土家族自治县",
                    gisGcj02Lat: 29.2952,
                    gisGcj02Lng: 108.166,
                  },
                ],
              },
            ],
          },
          {
            id: "510000",
            text: "四川省",
            children: [
              {
                id: "510100",
                text: "成都市",
                children: [
                  {
                    id: "510104",
                    text: "锦江区",
                    gisGcj02Lat: 30.6561,
                    gisGcj02Lng: 104.083,
                  },
                  {
                    id: "510105",
                    text: "青羊区",
                    gisGcj02Lat: 30.6739,
                    gisGcj02Lng: 104.062,
                  },
                  {
                    id: "510106",
                    text: "金牛区",
                    gisGcj02Lat: 30.6913,
                    gisGcj02Lng: 104.051,
                  },
                  {
                    id: "510107",
                    text: "武侯区",
                    gisGcj02Lat: 30.6423,
                    gisGcj02Lng: 104.043,
                  },
                  {
                    id: "510108",
                    text: "成华区",
                    gisGcj02Lat: 30.6599,
                    gisGcj02Lng: 104.102,
                  },
                  {
                    id: "510112",
                    text: "龙泉驿区",
                    gisGcj02Lat: 30.5566,
                    gisGcj02Lng: 104.275,
                  },
                  {
                    id: "510113",
                    text: "青白江区",
                    gisGcj02Lat: 30.8784,
                    gisGcj02Lng: 104.251,
                  },
                  {
                    id: "510114",
                    text: "新都区",
                    gisGcj02Lat: 30.8231,
                    gisGcj02Lng: 104.159,
                  },
                  {
                    id: "510115",
                    text: "温江区",
                    gisGcj02Lat: 30.6844,
                    gisGcj02Lng: 103.849,
                  },
                  {
                    id: "510121",
                    text: "金堂县",
                    gisGcj02Lat: 30.8619,
                    gisGcj02Lng: 104.412,
                  },
                  {
                    id: "510122",
                    text: "双流区",
                    gisGcj02Lat: 30.5744,
                    gisGcj02Lng: 103.924,
                  },
                  {
                    id: "510124",
                    text: "郫都区",
                    gisGcj02Lat: 30.8105,
                    gisGcj02Lng: 103.887,
                  },
                  {
                    id: "510129",
                    text: "大邑县",
                    gisGcj02Lat: 30.5874,
                    gisGcj02Lng: 103.521,
                  },
                  {
                    id: "510131",
                    text: "蒲江县",
                    gisGcj02Lat: 30.1967,
                    gisGcj02Lng: 103.506,
                  },
                  {
                    id: "510132",
                    text: "新津区",
                    gisGcj02Lat: 30.4098,
                    gisGcj02Lng: 103.811,
                  },
                  {
                    id: "510181",
                    text: "都江堰市",
                    gisGcj02Lat: 30.9982,
                    gisGcj02Lng: 103.619,
                  },
                  {
                    id: "510182",
                    text: "彭州市",
                    gisGcj02Lat: 30.9901,
                    gisGcj02Lng: 103.958,
                  },
                  {
                    id: "510183",
                    text: "邛崃市",
                    gisGcj02Lat: 30.4149,
                    gisGcj02Lng: 103.463,
                  },
                  {
                    id: "510184",
                    text: "崇州市",
                    gisGcj02Lat: 30.6301,
                    gisGcj02Lng: 103.673,
                  },
                  {
                    id: "510185",
                    text: "简阳市",
                    gisGcj02Lat: 30.6301,
                    gisGcj02Lng: 103.673,
                  },
                ],
              },
              {
                id: "510300",
                text: "自贡市",
                children: [
                  {
                    id: "510302",
                    text: "自流井区",
                    gisGcj02Lat: 29.3375,
                    gisGcj02Lng: 104.777,
                  },
                  {
                    id: "510303",
                    text: "贡井区",
                    gisGcj02Lat: 29.3458,
                    gisGcj02Lng: 104.715,
                  },
                  {
                    id: "510304",
                    text: "大安区",
                    gisGcj02Lat: 29.3636,
                    gisGcj02Lng: 104.774,
                  },
                  {
                    id: "510311",
                    text: "沿滩区",
                    gisGcj02Lat: 29.2661,
                    gisGcj02Lng: 104.88,
                  },
                  {
                    id: "510321",
                    text: "荣县",
                    gisGcj02Lat: 29.4445,
                    gisGcj02Lng: 104.418,
                  },
                  {
                    id: "510322",
                    text: "富顺县",
                    gisGcj02Lat: 29.1812,
                    gisGcj02Lng: 104.975,
                  },
                ],
              },
              {
                id: "510400",
                text: "攀枝花市",
                children: [
                  {
                    id: "510402",
                    text: "东区",
                    gisGcj02Lat: 26.5468,
                    gisGcj02Lng: 101.705,
                  },
                  {
                    id: "510403",
                    text: "西区",
                    gisGcj02Lat: 26.5975,
                    gisGcj02Lng: 101.631,
                  },
                  {
                    id: "510411",
                    text: "仁和区",
                    gisGcj02Lat: 26.4984,
                    gisGcj02Lng: 101.738,
                  },
                  {
                    id: "510421",
                    text: "米易县",
                    gisGcj02Lat: 26.8872,
                    gisGcj02Lng: 102.111,
                  },
                  {
                    id: "510422",
                    text: "盐边县",
                    gisGcj02Lat: 26.6885,
                    gisGcj02Lng: 101.854,
                  },
                ],
              },
              {
                id: "510500",
                text: "泸州市",
                children: [
                  {
                    id: "510502",
                    text: "江阳区",
                    gisGcj02Lat: 28.8893,
                    gisGcj02Lng: 105.453,
                  },
                  {
                    id: "510503",
                    text: "纳溪区",
                    gisGcj02Lat: 28.7734,
                    gisGcj02Lng: 105.373,
                  },
                  {
                    id: "510504",
                    text: "龙马潭区",
                    gisGcj02Lat: 28.9131,
                    gisGcj02Lng: 105.438,
                  },
                  {
                    id: "510521",
                    text: "泸县",
                    gisGcj02Lat: 29.1504,
                    gisGcj02Lng: 105.382,
                  },
                  {
                    id: "510522",
                    text: "合江县",
                    gisGcj02Lat: 28.81,
                    gisGcj02Lng: 105.835,
                  },
                  {
                    id: "510524",
                    text: "叙永县",
                    gisGcj02Lat: 28.1559,
                    gisGcj02Lng: 105.445,
                  },
                  {
                    id: "510525",
                    text: "古蔺县",
                    gisGcj02Lat: 28.0387,
                    gisGcj02Lng: 105.813,
                  },
                ],
              },
              {
                id: "510600",
                text: "德阳市",
                children: [
                  {
                    id: "510603",
                    text: "旌阳区",
                    gisGcj02Lat: 31.1391,
                    gisGcj02Lng: 104.394,
                  },
                  {
                    id: "510623",
                    text: "中江县",
                    gisGcj02Lat: 31.033,
                    gisGcj02Lng: 104.679,
                  },
                  {
                    id: "510626",
                    text: "罗江县",
                    gisGcj02Lat: 31.3167,
                    gisGcj02Lng: 104.51,
                  },
                  {
                    id: "510681",
                    text: "广汉市",
                    gisGcj02Lat: 30.9769,
                    gisGcj02Lng: 104.282,
                  },
                  {
                    id: "510682",
                    text: "什邡市",
                    gisGcj02Lat: 31.1264,
                    gisGcj02Lng: 104.168,
                  },
                  {
                    id: "510683",
                    text: "绵竹市",
                    gisGcj02Lat: 31.3377,
                    gisGcj02Lng: 104.221,
                  },
                ],
              },
              {
                id: "510700",
                text: "绵阳市",
                children: [
                  {
                    id: "510703",
                    text: "涪城区",
                    gisGcj02Lat: 31.4552,
                    gisGcj02Lng: 104.757,
                  },
                  {
                    id: "510704",
                    text: "游仙区",
                    gisGcj02Lat: 31.4657,
                    gisGcj02Lng: 104.771,
                  },
                  {
                    id: "510722",
                    text: "三台县",
                    gisGcj02Lat: 31.0918,
                    gisGcj02Lng: 105.091,
                  },
                  {
                    id: "510723",
                    text: "盐亭县",
                    gisGcj02Lat: 31.2218,
                    gisGcj02Lng: 105.39,
                  },
                  {
                    id: "510724",
                    text: "安县",
                    gisGcj02Lat: 31.5349,
                    gisGcj02Lng: 104.567,
                  },
                  {
                    id: "510725",
                    text: "梓潼县",
                    gisGcj02Lat: 31.6359,
                    gisGcj02Lng: 105.162,
                  },
                  {
                    id: "510726",
                    text: "北川羌族自治县",
                    gisGcj02Lat: 31.8329,
                    gisGcj02Lng: 104.464,
                  },
                  {
                    id: "510727",
                    text: "平武县",
                    gisGcj02Lat: 32.4079,
                    gisGcj02Lng: 104.529,
                  },
                  {
                    id: "510781",
                    text: "江油市",
                    gisGcj02Lat: 31.7778,
                    gisGcj02Lng: 104.745,
                  },
                ],
              },
              {
                id: "510800",
                text: "广元市",
                children: [
                  {
                    id: "510802",
                    text: "利州区",
                    gisGcj02Lat: 32.4323,
                    gisGcj02Lng: 105.826,
                  },
                  {
                    id: "510811",
                    text: "昭化区",
                    gisGcj02Lat: 32.3865,
                    gisGcj02Lng: 105.64,
                  },
                  {
                    id: "510812",
                    text: "朝天区",
                    gisGcj02Lat: 32.644,
                    gisGcj02Lng: 105.893,
                  },
                  {
                    id: "510821",
                    text: "旺苍县",
                    gisGcj02Lat: 32.2285,
                    gisGcj02Lng: 106.29,
                  },
                  {
                    id: "510822",
                    text: "青川县",
                    gisGcj02Lat: 32.5856,
                    gisGcj02Lng: 105.239,
                  },
                  {
                    id: "510823",
                    text: "剑阁县",
                    gisGcj02Lat: 32.2884,
                    gisGcj02Lng: 105.525,
                  },
                  {
                    id: "510824",
                    text: "苍溪县",
                    gisGcj02Lat: 31.7321,
                    gisGcj02Lng: 105.936,
                  },
                ],
              },
              {
                id: "510900",
                text: "遂宁市",
                children: [
                  {
                    id: "510903",
                    text: "船山区",
                    gisGcj02Lat: 30.4999,
                    gisGcj02Lng: 105.581,
                  },
                  {
                    id: "510904",
                    text: "安居区",
                    gisGcj02Lat: 30.3578,
                    gisGcj02Lng: 105.464,
                  },
                  {
                    id: "510921",
                    text: "蓬溪县",
                    gisGcj02Lat: 30.7577,
                    gisGcj02Lng: 105.708,
                  },
                  {
                    id: "510922",
                    text: "射洪市",
                    gisGcj02Lat: 30.872,
                    gisGcj02Lng: 105.389,
                  },
                  {
                    id: "510923",
                    text: "大英县",
                    gisGcj02Lat: 30.5943,
                    gisGcj02Lng: 105.243,
                  },
                ],
              },
              {
                id: "511000",
                text: "内江市",
                children: [
                  {
                    id: "511002",
                    text: "市中区",
                    gisGcj02Lat: 29.5871,
                    gisGcj02Lng: 105.068,
                  },
                  {
                    id: "511011",
                    text: "东兴区",
                    gisGcj02Lat: 29.5928,
                    gisGcj02Lng: 105.076,
                  },
                  {
                    id: "511024",
                    text: "威远县",
                    gisGcj02Lat: 29.5282,
                    gisGcj02Lng: 104.67,
                  },
                  {
                    id: "511025",
                    text: "资中县",
                    gisGcj02Lat: 29.7641,
                    gisGcj02Lng: 104.852,
                  },
                  {
                    id: "511028",
                    text: "隆昌县",
                    gisGcj02Lat: 29.3394,
                    gisGcj02Lng: 105.287,
                  },
                ],
              },
              {
                id: "511100",
                text: "乐山市",
                children: [
                  {
                    id: "511102",
                    text: "市中区",
                    gisGcj02Lat: 29.5554,
                    gisGcj02Lng: 103.762,
                  },
                  {
                    id: "511111",
                    text: "沙湾区",
                    gisGcj02Lat: 29.4119,
                    gisGcj02Lng: 103.549,
                  },
                  {
                    id: "511112",
                    text: "五通桥区",
                    gisGcj02Lat: 29.4034,
                    gisGcj02Lng: 103.823,
                  },
                  {
                    id: "511113",
                    text: "金口河区",
                    gisGcj02Lat: 29.2458,
                    gisGcj02Lng: 103.079,
                  },
                  {
                    id: "511123",
                    text: "犍为县",
                    gisGcj02Lat: 29.2097,
                    gisGcj02Lng: 103.95,
                  },
                  {
                    id: "511124",
                    text: "井研县",
                    gisGcj02Lat: 29.6523,
                    gisGcj02Lng: 104.07,
                  },
                  {
                    id: "511126",
                    text: "夹江县",
                    gisGcj02Lat: 29.7387,
                    gisGcj02Lng: 103.572,
                  },
                  {
                    id: "511129",
                    text: "沐川县",
                    gisGcj02Lat: 28.9565,
                    gisGcj02Lng: 103.904,
                  },
                  {
                    id: "511132",
                    text: "峨边彝族自治县",
                    gisGcj02Lat: 29.23,
                    gisGcj02Lng: 103.263,
                  },
                  {
                    id: "511133",
                    text: "马边彝族自治县",
                    gisGcj02Lat: 28.8359,
                    gisGcj02Lng: 103.546,
                  },
                  {
                    id: "511181",
                    text: "峨眉山市",
                    gisGcj02Lat: 29.6012,
                    gisGcj02Lng: 103.484,
                  },
                ],
              },
              {
                id: "511300",
                text: "南充市",
                children: [
                  {
                    id: "511302",
                    text: "顺庆区",
                    gisGcj02Lat: 30.7964,
                    gisGcj02Lng: 106.092,
                  },
                  {
                    id: "511303",
                    text: "高坪区",
                    gisGcj02Lat: 30.7816,
                    gisGcj02Lng: 106.119,
                  },
                  {
                    id: "511304",
                    text: "嘉陵区",
                    gisGcj02Lat: 30.7585,
                    gisGcj02Lng: 106.071,
                  },
                  {
                    id: "511321",
                    text: "南部县",
                    gisGcj02Lat: 31.3545,
                    gisGcj02Lng: 106.067,
                  },
                  {
                    id: "511322",
                    text: "营山县",
                    gisGcj02Lat: 31.0775,
                    gisGcj02Lng: 106.566,
                  },
                  {
                    id: "511323",
                    text: "蓬安县",
                    gisGcj02Lat: 31.0296,
                    gisGcj02Lng: 106.413,
                  },
                  {
                    id: "511324",
                    text: "仪陇县",
                    gisGcj02Lat: 31.2763,
                    gisGcj02Lng: 106.3,
                  },
                  {
                    id: "511325",
                    text: "西充县",
                    gisGcj02Lat: 30.9969,
                    gisGcj02Lng: 105.9,
                  },
                  {
                    id: "511381",
                    text: "阆中市",
                    gisGcj02Lat: 31.5583,
                    gisGcj02Lng: 106.005,
                  },
                ],
              },
              {
                id: "511400",
                text: "眉山市",
                children: [
                  {
                    id: "511402",
                    text: "东坡区",
                    gisGcj02Lat: 30.0422,
                    gisGcj02Lng: 103.832,
                  },
                  {
                    id: "511403",
                    text: "彭山区",
                    gisGcj02Lat: 30.1928,
                    gisGcj02Lng: 103.873,
                  },
                  {
                    id: "511421",
                    text: "仁寿县",
                    gisGcj02Lat: 29.996,
                    gisGcj02Lng: 104.134,
                  },
                  {
                    id: "511423",
                    text: "洪雅县",
                    gisGcj02Lat: 29.9066,
                    gisGcj02Lng: 103.373,
                  },
                  {
                    id: "511424",
                    text: "丹棱县",
                    gisGcj02Lat: 30.0156,
                    gisGcj02Lng: 103.513,
                  },
                  {
                    id: "511425",
                    text: "青神县",
                    gisGcj02Lat: 29.8323,
                    gisGcj02Lng: 103.848,
                  },
                ],
              },
              {
                id: "511500",
                text: "宜宾市",
                children: [
                  {
                    id: "511502",
                    text: "翠屏区",
                    gisGcj02Lat: 28.7657,
                    gisGcj02Lng: 104.62,
                  },
                  {
                    id: "511503",
                    text: "南溪区",
                    gisGcj02Lat: 28.8398,
                    gisGcj02Lng: 104.981,
                  },
                  {
                    id: "511521",
                    text: "宜宾县",
                    gisGcj02Lat: 28.69,
                    gisGcj02Lng: 104.533,
                  },
                  {
                    id: "511523",
                    text: "江安县",
                    gisGcj02Lat: 28.7239,
                    gisGcj02Lng: 105.067,
                  },
                  {
                    id: "511524",
                    text: "长宁县",
                    gisGcj02Lat: 28.5778,
                    gisGcj02Lng: 104.925,
                  },
                  {
                    id: "511525",
                    text: "高县",
                    gisGcj02Lat: 28.4362,
                    gisGcj02Lng: 104.518,
                  },
                  {
                    id: "511526",
                    text: "珙县",
                    gisGcj02Lat: 28.4451,
                    gisGcj02Lng: 104.714,
                  },
                  {
                    id: "511527",
                    text: "筠连县",
                    gisGcj02Lat: 28.1649,
                    gisGcj02Lng: 104.512,
                  },
                  {
                    id: "511528",
                    text: "兴文县",
                    gisGcj02Lat: 28.3044,
                    gisGcj02Lng: 105.237,
                  },
                  {
                    id: "511529",
                    text: "屏山县",
                    gisGcj02Lat: 28.6437,
                    gisGcj02Lng: 104.163,
                  },
                ],
              },
              {
                id: "511600",
                text: "广安市",
                children: [
                  {
                    id: "511602",
                    text: "广安区",
                    gisGcj02Lat: 30.4739,
                    gisGcj02Lng: 106.642,
                  },
                  {
                    id: "511603",
                    text: "前锋区",
                    gisGcj02Lat: 30.4946,
                    gisGcj02Lng: 106.894,
                  },
                  {
                    id: "511621",
                    text: "岳池县",
                    gisGcj02Lat: 30.5392,
                    gisGcj02Lng: 106.441,
                  },
                  {
                    id: "511622",
                    text: "武胜县",
                    gisGcj02Lat: 30.3493,
                    gisGcj02Lng: 106.296,
                  },
                  {
                    id: "511623",
                    text: "邻水县",
                    gisGcj02Lat: 30.3345,
                    gisGcj02Lng: 106.93,
                  },
                  {
                    id: "511681",
                    text: "华蓥市",
                    gisGcj02Lat: 30.3901,
                    gisGcj02Lng: 106.785,
                  },
                ],
              },
              {
                id: "511700",
                text: "达州市",
                children: [
                  {
                    id: "511702",
                    text: "通川区",
                    gisGcj02Lat: 31.2147,
                    gisGcj02Lng: 107.505,
                  },
                  {
                    id: "511703",
                    text: "达川区",
                    gisGcj02Lat: 31.2095,
                    gisGcj02Lng: 107.502,
                  },
                  {
                    id: "511722",
                    text: "宣汉县",
                    gisGcj02Lat: 31.3552,
                    gisGcj02Lng: 107.728,
                  },
                  {
                    id: "511723",
                    text: "开江县",
                    gisGcj02Lat: 31.0841,
                    gisGcj02Lng: 107.869,
                  },
                  {
                    id: "511724",
                    text: "大竹县",
                    gisGcj02Lat: 30.7415,
                    gisGcj02Lng: 107.209,
                  },
                  {
                    id: "511725",
                    text: "渠县",
                    gisGcj02Lat: 30.8376,
                    gisGcj02Lng: 106.974,
                  },
                  {
                    id: "511781",
                    text: "万源市",
                    gisGcj02Lat: 32.0809,
                    gisGcj02Lng: 108.036,
                  },
                ],
              },
              {
                id: "511800",
                text: "雅安市",
                children: [
                  {
                    id: "511802",
                    text: "雨城区",
                    gisGcj02Lat: 30.0053,
                    gisGcj02Lng: 103.033,
                  },
                  {
                    id: "511803",
                    text: "名山区",
                    gisGcj02Lat: 30.0847,
                    gisGcj02Lng: 103.112,
                  },
                  {
                    id: "511822",
                    text: "荥经县",
                    gisGcj02Lat: 29.794,
                    gisGcj02Lng: 102.847,
                  },
                  {
                    id: "511823",
                    text: "汉源县",
                    gisGcj02Lat: 29.3517,
                    gisGcj02Lng: 102.678,
                  },
                  {
                    id: "511824",
                    text: "石棉县",
                    gisGcj02Lat: 29.228,
                    gisGcj02Lng: 102.359,
                  },
                  {
                    id: "511825",
                    text: "天全县",
                    gisGcj02Lat: 30.0675,
                    gisGcj02Lng: 102.759,
                  },
                  {
                    id: "511826",
                    text: "芦山县",
                    gisGcj02Lat: 30.1437,
                    gisGcj02Lng: 102.928,
                  },
                  {
                    id: "511827",
                    text: "宝兴县",
                    gisGcj02Lat: 30.3684,
                    gisGcj02Lng: 102.816,
                  },
                ],
              },
              {
                id: "511900",
                text: "巴中市",
                children: [
                  {
                    id: "511902",
                    text: "巴州区",
                    gisGcj02Lat: 31.8512,
                    gisGcj02Lng: 106.769,
                  },
                  {
                    id: "511903",
                    text: "恩阳区",
                    gisGcj02Lat: 31.8588,
                    gisGcj02Lng: 106.754,
                  },
                  {
                    id: "511921",
                    text: "通江县",
                    gisGcj02Lat: 31.9129,
                    gisGcj02Lng: 107.244,
                  },
                  {
                    id: "511922",
                    text: "南江县",
                    gisGcj02Lat: 32.3534,
                    gisGcj02Lng: 106.842,
                  },
                  {
                    id: "511923",
                    text: "平昌县",
                    gisGcj02Lat: 31.5594,
                    gisGcj02Lng: 107.104,
                  },
                ],
              },
              {
                id: "512000",
                text: "资阳市",
                children: [
                  {
                    id: "512002",
                    text: "雁江区",
                    gisGcj02Lat: 30.1152,
                    gisGcj02Lng: 104.652,
                  },
                  {
                    id: "512021",
                    text: "安岳县",
                    gisGcj02Lat: 30.0979,
                    gisGcj02Lng: 105.336,
                  },
                  {
                    id: "512022",
                    text: "乐至县",
                    gisGcj02Lat: 30.2723,
                    gisGcj02Lng: 105.032,
                  },
                  {
                    id: "512081",
                    text: "简阳市",
                    gisGcj02Lat: 30.3904,
                    gisGcj02Lng: 104.549,
                  },
                ],
              },
              {
                id: "513200",
                text: "阿坝藏族羌族自治州",
                children: [
                  {
                    id: "513221",
                    text: "汶川县",
                    gisGcj02Lat: 31.4733,
                    gisGcj02Lng: 103.591,
                  },
                  {
                    id: "513222",
                    text: "理县",
                    gisGcj02Lat: 31.436,
                    gisGcj02Lng: 103.172,
                  },
                  {
                    id: "513223",
                    text: "茂县",
                    gisGcj02Lat: 31.682,
                    gisGcj02Lng: 103.854,
                  },
                  {
                    id: "513224",
                    text: "松潘县",
                    gisGcj02Lat: 32.6387,
                    gisGcj02Lng: 103.599,
                  },
                  {
                    id: "513225",
                    text: "九寨沟县",
                    gisGcj02Lat: 33.2632,
                    gisGcj02Lng: 104.237,
                  },
                  {
                    id: "513226",
                    text: "金川县",
                    gisGcj02Lat: 31.4762,
                    gisGcj02Lng: 102.066,
                  },
                  {
                    id: "513227",
                    text: "小金县",
                    gisGcj02Lat: 30.9993,
                    gisGcj02Lng: 102.365,
                  },
                  {
                    id: "513228",
                    text: "黑水县",
                    gisGcj02Lat: 32.0618,
                    gisGcj02Lng: 102.992,
                  },
                  {
                    id: "513229",
                    text: "马尔康县",
                    gisGcj02Lat: 31.9058,
                    gisGcj02Lng: 102.206,
                  },
                  {
                    id: "513230",
                    text: "壤塘县",
                    gisGcj02Lat: 32.2658,
                    gisGcj02Lng: 100.978,
                  },
                  {
                    id: "513231",
                    text: "阿坝县",
                    gisGcj02Lat: 32.903,
                    gisGcj02Lng: 101.706,
                  },
                  {
                    id: "513232",
                    text: "若尔盖县",
                    gisGcj02Lat: 33.5743,
                    gisGcj02Lng: 102.96,
                  },
                  {
                    id: "513233",
                    text: "红原县",
                    gisGcj02Lat: 32.7899,
                    gisGcj02Lng: 102.545,
                  },
                ],
              },
              {
                id: "513300",
                text: "甘孜藏族自治州",
                children: [
                  {
                    id: "513321",
                    text: "康定市",
                    gisGcj02Lat: 30.0553,
                    gisGcj02Lng: 101.965,
                  },
                  {
                    id: "513322",
                    text: "泸定县",
                    gisGcj02Lat: 29.9147,
                    gisGcj02Lng: 102.235,
                  },
                  {
                    id: "513323",
                    text: "丹巴县",
                    gisGcj02Lat: 30.8766,
                    gisGcj02Lng: 101.884,
                  },
                  {
                    id: "513324",
                    text: "九龙县",
                    gisGcj02Lat: 29.0009,
                    gisGcj02Lng: 101.508,
                  },
                  {
                    id: "513325",
                    text: "雅江县",
                    gisGcj02Lat: 30.0328,
                    gisGcj02Lng: 101.015,
                  },
                  {
                    id: "513326",
                    text: "道孚县",
                    gisGcj02Lat: 30.9805,
                    gisGcj02Lng: 101.126,
                  },
                  {
                    id: "513327",
                    text: "炉霍县",
                    gisGcj02Lat: 31.3917,
                    gisGcj02Lng: 100.677,
                  },
                  {
                    id: "513328",
                    text: "甘孜县",
                    gisGcj02Lat: 31.6267,
                    gisGcj02Lng: 99.9931,
                  },
                  {
                    id: "513329",
                    text: "新龙县",
                    gisGcj02Lat: 30.9407,
                    gisGcj02Lng: 100.312,
                  },
                  {
                    id: "513330",
                    text: "德格县",
                    gisGcj02Lat: 31.8062,
                    gisGcj02Lng: 98.5808,
                  },
                  {
                    id: "513331",
                    text: "白玉县",
                    gisGcj02Lat: 31.209,
                    gisGcj02Lng: 98.8257,
                  },
                  {
                    id: "513332",
                    text: "石渠县",
                    gisGcj02Lat: 32.9788,
                    gisGcj02Lng: 98.1016,
                  },
                  {
                    id: "513333",
                    text: "色达县",
                    gisGcj02Lat: 32.2684,
                    gisGcj02Lng: 100.332,
                  },
                  {
                    id: "513334",
                    text: "理塘县",
                    gisGcj02Lat: 29.9967,
                    gisGcj02Lng: 100.27,
                  },
                  {
                    id: "513335",
                    text: "巴塘县",
                    gisGcj02Lat: 30.0042,
                    gisGcj02Lng: 99.1041,
                  },
                  {
                    id: "513336",
                    text: "乡城县",
                    gisGcj02Lat: 28.9355,
                    gisGcj02Lng: 99.7994,
                  },
                  {
                    id: "513337",
                    text: "稻城县",
                    gisGcj02Lat: 29.0379,
                    gisGcj02Lng: 100.298,
                  },
                  {
                    id: "513338",
                    text: "得荣县",
                    gisGcj02Lat: 28.713,
                    gisGcj02Lng: 99.2863,
                  },
                ],
              },
              {
                id: "513400",
                text: "凉山彝族自治州",
                children: [
                  {
                    id: "513401",
                    text: "西昌市",
                    gisGcj02Lat: 27.8952,
                    gisGcj02Lng: 102.264,
                  },
                  {
                    id: "513422",
                    text: "木里藏族自治县",
                    gisGcj02Lat: 27.9287,
                    gisGcj02Lng: 101.28,
                  },
                  {
                    id: "513423",
                    text: "盐源县",
                    gisGcj02Lat: 27.4218,
                    gisGcj02Lng: 101.51,
                  },
                  {
                    id: "513424",
                    text: "德昌县",
                    gisGcj02Lat: 27.4048,
                    gisGcj02Lng: 102.18,
                  },
                  {
                    id: "513425",
                    text: "会理市",
                    gisGcj02Lat: 26.6563,
                    gisGcj02Lng: 102.245,
                  },
                  {
                    id: "513426",
                    text: "会东县",
                    gisGcj02Lat: 26.6343,
                    gisGcj02Lng: 102.578,
                  },
                  {
                    id: "513427",
                    text: "宁南县",
                    gisGcj02Lat: 27.0657,
                    gisGcj02Lng: 102.761,
                  },
                  {
                    id: "513428",
                    text: "普格县",
                    gisGcj02Lat: 27.3748,
                    gisGcj02Lng: 102.541,
                  },
                  {
                    id: "513429",
                    text: "布拖县",
                    gisGcj02Lat: 27.7079,
                    gisGcj02Lng: 102.812,
                  },
                  {
                    id: "513430",
                    text: "金阳县",
                    gisGcj02Lat: 27.697,
                    gisGcj02Lng: 103.248,
                  },
                  {
                    id: "513431",
                    text: "昭觉县",
                    gisGcj02Lat: 28.0116,
                    gisGcj02Lng: 102.847,
                  },
                  {
                    id: "513432",
                    text: "喜德县",
                    gisGcj02Lat: 28.3074,
                    gisGcj02Lng: 102.413,
                  },
                  {
                    id: "513433",
                    text: "冕宁县",
                    gisGcj02Lat: 28.5516,
                    gisGcj02Lng: 102.171,
                  },
                  {
                    id: "513434",
                    text: "越西县",
                    gisGcj02Lat: 28.6413,
                    gisGcj02Lng: 102.508,
                  },
                  {
                    id: "513435",
                    text: "甘洛县",
                    gisGcj02Lat: 28.9662,
                    gisGcj02Lng: 102.772,
                  },
                  {
                    id: "513436",
                    text: "美姑县",
                    gisGcj02Lat: 28.326,
                    gisGcj02Lng: 103.131,
                  },
                  {
                    id: "513437",
                    text: "雷波县",
                    gisGcj02Lat: 28.2641,
                    gisGcj02Lng: 103.573,
                  },
                ],
              },
            ],
          },
          {
            id: "520000",
            text: "贵州省",
            children: [
              {
                id: "520100",
                text: "贵阳市",
                children: [
                  {
                    id: "520102",
                    text: "南明区",
                    gisGcj02Lat: 26.5682,
                    gisGcj02Lng: 106.715,
                  },
                  {
                    id: "520103",
                    text: "云岩区",
                    gisGcj02Lat: 26.6048,
                    gisGcj02Lng: 106.725,
                  },
                  {
                    id: "520111",
                    text: "花溪区",
                    gisGcj02Lat: 26.4334,
                    gisGcj02Lng: 106.677,
                  },
                  {
                    id: "520112",
                    text: "乌当区",
                    gisGcj02Lat: 26.6302,
                    gisGcj02Lng: 106.752,
                  },
                  {
                    id: "520113",
                    text: "白云区",
                    gisGcj02Lat: 26.6828,
                    gisGcj02Lng: 106.631,
                  },
                  {
                    id: "520115",
                    text: "观山湖区",
                    gisGcj02Lat: 26.6182,
                    gisGcj02Lng: 106.625,
                  },
                  {
                    id: "520121",
                    text: "开阳县",
                    gisGcj02Lat: 27.0553,
                    gisGcj02Lng: 106.969,
                  },
                  {
                    id: "520122",
                    text: "息烽县",
                    gisGcj02Lat: 27.0935,
                    gisGcj02Lng: 106.738,
                  },
                  {
                    id: "520123",
                    text: "修文县",
                    gisGcj02Lat: 26.8378,
                    gisGcj02Lng: 106.595,
                  },
                  {
                    id: "520181",
                    text: "清镇市",
                    gisGcj02Lat: 26.5526,
                    gisGcj02Lng: 106.469,
                  },
                ],
              },
              {
                id: "520200",
                text: "六盘水市",
                children: [
                  {
                    id: "520201",
                    text: "钟山区",
                    gisGcj02Lat: 26.577,
                    gisGcj02Lng: 104.878,
                  },
                  {
                    id: "520203",
                    text: "六枝特区",
                    gisGcj02Lat: 26.2012,
                    gisGcj02Lng: 105.481,
                  },
                  {
                    id: "520221",
                    text: "水城区",
                    gisGcj02Lat: 26.5478,
                    gisGcj02Lng: 104.958,
                  },
                  {
                    id: "520222",
                    text: "盘县",
                    gisGcj02Lat: 25.7136,
                    gisGcj02Lng: 104.471,
                  },
                ],
              },
              {
                id: "520300",
                text: "遵义市",
                children: [
                  {
                    id: "520302",
                    text: "红花岗区",
                    gisGcj02Lat: 27.6447,
                    gisGcj02Lng: 106.894,
                  },
                  {
                    id: "520303",
                    text: "汇川区",
                    gisGcj02Lat: 27.7062,
                    gisGcj02Lng: 106.939,
                  },
                  {
                    id: "520321",
                    text: "遵义县",
                    gisGcj02Lat: 27.5377,
                    gisGcj02Lng: 106.833,
                  },
                  {
                    id: "520322",
                    text: "桐梓县",
                    gisGcj02Lat: 28.1381,
                    gisGcj02Lng: 106.826,
                  },
                  {
                    id: "520323",
                    text: "绥阳县",
                    gisGcj02Lat: 27.947,
                    gisGcj02Lng: 107.191,
                  },
                  {
                    id: "520324",
                    text: "正安县",
                    gisGcj02Lat: 28.5512,
                    gisGcj02Lng: 107.444,
                  },
                  {
                    id: "520325",
                    text: "道真仡佬族苗族自治县",
                    gisGcj02Lat: 28.864,
                    gisGcj02Lng: 107.612,
                  },
                  {
                    id: "520326",
                    text: "务川仡佬族苗族自治县",
                    gisGcj02Lat: 28.5223,
                    gisGcj02Lng: 107.889,
                  },
                  {
                    id: "520327",
                    text: "凤冈县",
                    gisGcj02Lat: 27.9546,
                    gisGcj02Lng: 107.717,
                  },
                  {
                    id: "520328",
                    text: "湄潭县",
                    gisGcj02Lat: 27.7668,
                    gisGcj02Lng: 107.488,
                  },
                  {
                    id: "520329",
                    text: "余庆县",
                    gisGcj02Lat: 27.2253,
                    gisGcj02Lng: 107.888,
                  },
                  {
                    id: "520330",
                    text: "习水县",
                    gisGcj02Lat: 28.3198,
                    gisGcj02Lng: 106.213,
                  },
                  {
                    id: "520381",
                    text: "赤水市",
                    gisGcj02Lat: 28.5892,
                    gisGcj02Lng: 105.698,
                  },
                  {
                    id: "520382",
                    text: "仁怀市",
                    gisGcj02Lat: 27.7923,
                    gisGcj02Lng: 106.402,
                  },
                ],
              },
              {
                id: "520400",
                text: "安顺市",
                children: [
                  {
                    id: "520402",
                    text: "西秀区",
                    gisGcj02Lat: 26.2449,
                    gisGcj02Lng: 105.966,
                  },
                  {
                    id: "520421",
                    text: "平坝区",
                    gisGcj02Lat: 26.4054,
                    gisGcj02Lng: 106.257,
                  },
                  {
                    id: "520422",
                    text: "普定县",
                    gisGcj02Lat: 26.3014,
                    gisGcj02Lng: 105.743,
                  },
                  {
                    id: "520423",
                    text: "镇宁布依族苗族自治县",
                    gisGcj02Lat: 26.0553,
                    gisGcj02Lng: 105.765,
                  },
                  {
                    id: "520424",
                    text: "关岭布依族苗族自治县",
                    gisGcj02Lat: 25.9425,
                    gisGcj02Lng: 105.619,
                  },
                  {
                    id: "520425",
                    text: "紫云苗族布依族自治县",
                    gisGcj02Lat: 25.7526,
                    gisGcj02Lng: 106.084,
                  },
                ],
              },
              {
                id: "520500",
                text: "毕节市",
                children: [
                  {
                    id: "520502",
                    text: "七星关区",
                    gisGcj02Lat: 27.1536,
                    gisGcj02Lng: 104.95,
                  },
                  {
                    id: "520521",
                    text: "大方县",
                    gisGcj02Lat: 27.1435,
                    gisGcj02Lng: 105.609,
                  },
                  {
                    id: "520522",
                    text: "黔西市",
                    gisGcj02Lat: 27.0249,
                    gisGcj02Lng: 106.038,
                  },
                  {
                    id: "520523",
                    text: "金沙县",
                    gisGcj02Lat: 27.4597,
                    gisGcj02Lng: 106.222,
                  },
                  {
                    id: "520524",
                    text: "织金县",
                    gisGcj02Lat: 26.6685,
                    gisGcj02Lng: 105.769,
                  },
                  {
                    id: "520525",
                    text: "纳雍县",
                    gisGcj02Lat: 26.7699,
                    gisGcj02Lng: 105.375,
                  },
                  {
                    id: "520526",
                    text: "威宁彝族回族苗族自治县",
                    gisGcj02Lat: 26.8591,
                    gisGcj02Lng: 104.287,
                  },
                  {
                    id: "520527",
                    text: "赫章县",
                    gisGcj02Lat: 27.1192,
                    gisGcj02Lng: 104.726,
                  },
                ],
              },
              {
                id: "520600",
                text: "铜仁市",
                children: [
                  {
                    id: "520602",
                    text: "碧江区",
                    gisGcj02Lat: 27.7183,
                    gisGcj02Lng: 109.192,
                  },
                  {
                    id: "520603",
                    text: "万山区",
                    gisGcj02Lat: 27.519,
                    gisGcj02Lng: 109.212,
                  },
                  {
                    id: "520621",
                    text: "江口县",
                    gisGcj02Lat: 27.6919,
                    gisGcj02Lng: 108.848,
                  },
                  {
                    id: "520622",
                    text: "玉屏侗族自治县",
                    gisGcj02Lat: 27.238,
                    gisGcj02Lng: 108.918,
                  },
                  {
                    id: "520623",
                    text: "石阡县",
                    gisGcj02Lat: 27.5194,
                    gisGcj02Lng: 108.23,
                  },
                  {
                    id: "520624",
                    text: "思南县",
                    gisGcj02Lat: 27.9413,
                    gisGcj02Lng: 108.256,
                  },
                  {
                    id: "520625",
                    text: "印江土家族苗族自治县",
                    gisGcj02Lat: 27.998,
                    gisGcj02Lng: 108.406,
                  },
                  {
                    id: "520626",
                    text: "德江县",
                    gisGcj02Lat: 28.2609,
                    gisGcj02Lng: 108.117,
                  },
                  {
                    id: "520627",
                    text: "沿河土家族自治县",
                    gisGcj02Lat: 28.5605,
                    gisGcj02Lng: 108.496,
                  },
                  {
                    id: "520628",
                    text: "松桃苗族自治县",
                    gisGcj02Lat: 28.1654,
                    gisGcj02Lng: 109.203,
                  },
                ],
              },
              {
                id: "522300",
                text: "黔西南布依族苗族自治州",
                children: [
                  {
                    id: "522301",
                    text: "兴义市 ",
                    gisGcj02Lat: 25.0921,
                    gisGcj02Lng: 104.895,
                  },
                  {
                    id: "522322",
                    text: "兴仁县",
                    gisGcj02Lat: 25.4328,
                    gisGcj02Lng: 105.187,
                  },
                  {
                    id: "522323",
                    text: "普安县",
                    gisGcj02Lat: 25.786,
                    gisGcj02Lng: 104.955,
                  },
                  {
                    id: "522324",
                    text: "晴隆县",
                    gisGcj02Lat: 25.8352,
                    gisGcj02Lng: 105.219,
                  },
                  {
                    id: "522325",
                    text: "贞丰县",
                    gisGcj02Lat: 25.3846,
                    gisGcj02Lng: 105.655,
                  },
                  {
                    id: "522326",
                    text: "望谟县",
                    gisGcj02Lat: 25.1782,
                    gisGcj02Lng: 106.1,
                  },
                  {
                    id: "522327",
                    text: "册亨县",
                    gisGcj02Lat: 24.9838,
                    gisGcj02Lng: 105.812,
                  },
                  {
                    id: "522328",
                    text: "安龙县",
                    gisGcj02Lat: 25.0982,
                    gisGcj02Lng: 105.443,
                  },
                ],
              },
              {
                id: "522600",
                text: "黔东南苗族侗族自治州",
                children: [
                  {
                    id: "522601",
                    text: "凯里市",
                    gisGcj02Lat: 26.5669,
                    gisGcj02Lng: 107.981,
                  },
                  {
                    id: "522622",
                    text: "黄平县",
                    gisGcj02Lat: 26.8957,
                    gisGcj02Lng: 107.902,
                  },
                  {
                    id: "522623",
                    text: "施秉县",
                    gisGcj02Lat: 27.035,
                    gisGcj02Lng: 108.126,
                  },
                  {
                    id: "522624",
                    text: "三穗县",
                    gisGcj02Lat: 26.9477,
                    gisGcj02Lng: 108.671,
                  },
                  {
                    id: "522625",
                    text: "镇远县",
                    gisGcj02Lat: 27.0493,
                    gisGcj02Lng: 108.427,
                  },
                  {
                    id: "522626",
                    text: "岑巩县",
                    gisGcj02Lat: 27.1754,
                    gisGcj02Lng: 108.819,
                  },
                  {
                    id: "522627",
                    text: "天柱县",
                    gisGcj02Lat: 26.9078,
                    gisGcj02Lng: 109.207,
                  },
                  {
                    id: "522628",
                    text: "锦屏县",
                    gisGcj02Lat: 26.6763,
                    gisGcj02Lng: 109.2,
                  },
                  {
                    id: "522629",
                    text: "剑河县",
                    gisGcj02Lat: 26.6525,
                    gisGcj02Lng: 108.591,
                  },
                  {
                    id: "522630",
                    text: "台江县",
                    gisGcj02Lat: 26.6692,
                    gisGcj02Lng: 108.318,
                  },
                  {
                    id: "522631",
                    text: "黎平县",
                    gisGcj02Lat: 26.2311,
                    gisGcj02Lng: 109.136,
                  },
                  {
                    id: "522632",
                    text: "榕江县",
                    gisGcj02Lat: 25.9242,
                    gisGcj02Lng: 108.521,
                  },
                  {
                    id: "522633",
                    text: "从江县",
                    gisGcj02Lat: 25.7542,
                    gisGcj02Lng: 108.905,
                  },
                  {
                    id: "522634",
                    text: "雷山县",
                    gisGcj02Lat: 26.3839,
                    gisGcj02Lng: 108.077,
                  },
                  {
                    id: "522635",
                    text: "麻江县",
                    gisGcj02Lat: 26.4923,
                    gisGcj02Lng: 107.592,
                  },
                  {
                    id: "522636",
                    text: "丹寨县",
                    gisGcj02Lat: 26.1982,
                    gisGcj02Lng: 107.797,
                  },
                ],
              },
              {
                id: "522700",
                text: "黔南布依族苗族自治州",
                children: [
                  {
                    id: "522701",
                    text: "都匀市",
                    gisGcj02Lat: 26.2594,
                    gisGcj02Lng: 107.519,
                  },
                  {
                    id: "522702",
                    text: "福泉市",
                    gisGcj02Lat: 26.6799,
                    gisGcj02Lng: 107.517,
                  },
                  {
                    id: "522722",
                    text: "荔波县",
                    gisGcj02Lat: 25.4139,
                    gisGcj02Lng: 107.886,
                  },
                  {
                    id: "522723",
                    text: "贵定县",
                    gisGcj02Lat: 26.5781,
                    gisGcj02Lng: 107.237,
                  },
                  {
                    id: "522725",
                    text: "瓮安县",
                    gisGcj02Lat: 27.0681,
                    gisGcj02Lng: 107.476,
                  },
                  {
                    id: "522726",
                    text: "独山县",
                    gisGcj02Lat: 25.8245,
                    gisGcj02Lng: 107.541,
                  },
                  {
                    id: "522727",
                    text: "平塘县",
                    gisGcj02Lat: 25.8329,
                    gisGcj02Lng: 107.324,
                  },
                  {
                    id: "522728",
                    text: "罗甸县",
                    gisGcj02Lat: 25.4259,
                    gisGcj02Lng: 106.752,
                  },
                  {
                    id: "522729",
                    text: "长顺县",
                    gisGcj02Lat: 26.023,
                    gisGcj02Lng: 106.452,
                  },
                  {
                    id: "522730",
                    text: "龙里县",
                    gisGcj02Lat: 26.4508,
                    gisGcj02Lng: 106.977,
                  },
                  {
                    id: "522731",
                    text: "惠水县",
                    gisGcj02Lat: 26.1339,
                    gisGcj02Lng: 106.659,
                  },
                  {
                    id: "522732",
                    text: "三都水族自治县",
                    gisGcj02Lat: 25.9856,
                    gisGcj02Lng: 107.875,
                  },
                ],
              },
            ],
          },
          {
            id: "530000",
            text: "云南省",
            children: [
              {
                id: "530100",
                text: "昆明市",
                children: [
                  {
                    id: "530102",
                    text: "五华区",
                    gisGcj02Lat: 25.0352,
                    gisGcj02Lng: 102.708,
                  },
                  {
                    id: "530103",
                    text: "盘龙区",
                    gisGcj02Lat: 25.0405,
                    gisGcj02Lng: 102.72,
                  },
                  {
                    id: "530111",
                    text: "官渡区",
                    gisGcj02Lat: 25.015,
                    gisGcj02Lng: 102.744,
                  },
                  {
                    id: "530112",
                    text: "西山区",
                    gisGcj02Lat: 25.038,
                    gisGcj02Lng: 102.665,
                  },
                  {
                    id: "530113",
                    text: "东川区",
                    gisGcj02Lat: 26.083,
                    gisGcj02Lng: 103.188,
                  },
                  {
                    id: "530114",
                    text: "呈贡区",
                    gisGcj02Lat: 24.8893,
                    gisGcj02Lng: 102.801,
                  },
                  {
                    id: "530122",
                    text: "晋宁县",
                    gisGcj02Lat: 24.6665,
                    gisGcj02Lng: 102.594,
                  },
                  {
                    id: "530124",
                    text: "富民县",
                    gisGcj02Lat: 25.2212,
                    gisGcj02Lng: 102.498,
                  },
                  {
                    id: "530125",
                    text: "宜良县",
                    gisGcj02Lat: 24.917,
                    gisGcj02Lng: 103.141,
                  },
                  {
                    id: "530126",
                    text: "石林彝族自治县",
                    gisGcj02Lat: 24.759,
                    gisGcj02Lng: 103.271,
                  },
                  {
                    id: "530127",
                    text: "嵩明县",
                    gisGcj02Lat: 25.3399,
                    gisGcj02Lng: 103.037,
                  },
                  {
                    id: "530128",
                    text: "禄劝彝族苗族自治县",
                    gisGcj02Lat: 25.5539,
                    gisGcj02Lng: 102.467,
                  },
                  {
                    id: "530129",
                    text: "寻甸回族彝族自治县 ",
                    gisGcj02Lat: 25.5596,
                    gisGcj02Lng: 103.256,
                  },
                  {
                    id: "530181",
                    text: "安宁市",
                    gisGcj02Lat: 24.9165,
                    gisGcj02Lng: 102.47,
                  },
                ],
              },
              {
                id: "530300",
                text: "曲靖市",
                children: [
                  {
                    id: "530302",
                    text: "麒麟区",
                    gisGcj02Lat: 25.4951,
                    gisGcj02Lng: 103.805,
                  },
                  {
                    id: "530321",
                    text: "马龙县",
                    gisGcj02Lat: 25.4252,
                    gisGcj02Lng: 103.579,
                  },
                  {
                    id: "530322",
                    text: "陆良县",
                    gisGcj02Lat: 25.0233,
                    gisGcj02Lng: 103.666,
                  },
                  {
                    id: "530323",
                    text: "师宗县",
                    gisGcj02Lat: 24.8282,
                    gisGcj02Lng: 103.991,
                  },
                  {
                    id: "530324",
                    text: "罗平县",
                    gisGcj02Lat: 24.8844,
                    gisGcj02Lng: 104.309,
                  },
                  {
                    id: "530325",
                    text: "富源县",
                    gisGcj02Lat: 25.6659,
                    gisGcj02Lng: 104.254,
                  },
                  {
                    id: "530326",
                    text: "会泽县",
                    gisGcj02Lat: 26.4108,
                    gisGcj02Lng: 103.3,
                  },
                  {
                    id: "530328",
                    text: "沾益县",
                    gisGcj02Lat: 25.6071,
                    gisGcj02Lng: 103.821,
                  },
                  {
                    id: "530381",
                    text: "宣威市",
                    gisGcj02Lat: 26.2173,
                    gisGcj02Lng: 104.104,
                  },
                ],
              },
              {
                id: "530400",
                text: "玉溪市",
                children: [
                  {
                    id: "530402",
                    text: "红塔区",
                    gisGcj02Lat: 24.3541,
                    gisGcj02Lng: 102.545,
                  },
                  {
                    id: "530421",
                    text: "江川县",
                    gisGcj02Lat: 24.2886,
                    gisGcj02Lng: 102.754,
                  },
                  {
                    id: "530422",
                    text: "澄江市",
                    gisGcj02Lat: 24.6738,
                    gisGcj02Lng: 102.908,
                  },
                  {
                    id: "530423",
                    text: "通海县",
                    gisGcj02Lat: 24.1136,
                    gisGcj02Lng: 102.766,
                  },
                  {
                    id: "530424",
                    text: "华宁县",
                    gisGcj02Lat: 24.1926,
                    gisGcj02Lng: 102.928,
                  },
                  {
                    id: "530425",
                    text: "易门县",
                    gisGcj02Lat: 24.6712,
                    gisGcj02Lng: 102.164,
                  },
                  {
                    id: "530426",
                    text: "峨山彝族自治县",
                    gisGcj02Lat: 24.169,
                    gisGcj02Lng: 102.406,
                  },
                  {
                    id: "530427",
                    text: "新平彝族傣族自治县",
                    gisGcj02Lat: 24.0689,
                    gisGcj02Lng: 101.989,
                  },
                  {
                    id: "530428",
                    text: "元江哈尼族彝族傣族自治县",
                    gisGcj02Lat: 23.5965,
                    gisGcj02Lng: 101.998,
                  },
                ],
              },
              {
                id: "530500",
                text: "保山市",
                children: [
                  {
                    id: "530502",
                    text: "隆阳区",
                    gisGcj02Lat: 25.1116,
                    gisGcj02Lng: 99.1633,
                  },
                  {
                    id: "530521",
                    text: "施甸县",
                    gisGcj02Lat: 24.7242,
                    gisGcj02Lng: 99.1877,
                  },
                  {
                    id: "530522",
                    text: "腾冲县",
                    gisGcj02Lat: 25.0254,
                    gisGcj02Lng: 98.4941,
                  },
                  {
                    id: "530523",
                    text: "龙陵县",
                    gisGcj02Lat: 24.5875,
                    gisGcj02Lng: 98.6902,
                  },
                  {
                    id: "530524",
                    text: "昌宁县",
                    gisGcj02Lat: 24.8276,
                    gisGcj02Lng: 99.6036,
                  },
                ],
              },
              {
                id: "530600",
                text: "昭通市",
                children: [
                  {
                    id: "530602",
                    text: "昭阳区",
                    gisGcj02Lat: 27.32,
                    gisGcj02Lng: 103.707,
                  },
                  {
                    id: "530621",
                    text: "鲁甸县",
                    gisGcj02Lat: 27.1924,
                    gisGcj02Lng: 103.547,
                  },
                  {
                    id: "530622",
                    text: "巧家县",
                    gisGcj02Lat: 26.9124,
                    gisGcj02Lng: 102.924,
                  },
                  {
                    id: "530623",
                    text: "盐津县",
                    gisGcj02Lat: 28.1086,
                    gisGcj02Lng: 104.235,
                  },
                  {
                    id: "530624",
                    text: "大关县",
                    gisGcj02Lat: 27.7488,
                    gisGcj02Lng: 103.893,
                  },
                  {
                    id: "530625",
                    text: "永善县",
                    gisGcj02Lat: 28.2279,
                    gisGcj02Lng: 103.635,
                  },
                  {
                    id: "530626",
                    text: "绥江县",
                    gisGcj02Lat: 28.5966,
                    gisGcj02Lng: 103.949,
                  },
                  {
                    id: "530627",
                    text: "镇雄县",
                    gisGcj02Lat: 27.4398,
                    gisGcj02Lng: 104.873,
                  },
                  {
                    id: "530628",
                    text: "彝良县",
                    gisGcj02Lat: 27.6281,
                    gisGcj02Lng: 104.05,
                  },
                  {
                    id: "530629",
                    text: "威信县",
                    gisGcj02Lat: 27.8407,
                    gisGcj02Lng: 105.048,
                  },
                  {
                    id: "530630",
                    text: "水富县",
                    gisGcj02Lat: 28.6299,
                    gisGcj02Lng: 104.416,
                  },
                ],
              },
              {
                id: "530700",
                text: "丽江市",
                children: [
                  {
                    id: "530702",
                    text: "古城区",
                    gisGcj02Lat: 26.877,
                    gisGcj02Lng: 100.226,
                  },
                  {
                    id: "530721",
                    text: "玉龙纳西族自治县",
                    gisGcj02Lat: 26.8215,
                    gisGcj02Lng: 100.237,
                  },
                  {
                    id: "530722",
                    text: "永胜县",
                    gisGcj02Lat: 26.6859,
                    gisGcj02Lng: 100.747,
                  },
                  {
                    id: "530723",
                    text: "华坪县",
                    gisGcj02Lat: 26.6297,
                    gisGcj02Lng: 101.266,
                  },
                  {
                    id: "530724",
                    text: "宁蒗彝族自治县",
                    gisGcj02Lat: 27.2818,
                    gisGcj02Lng: 100.851,
                  },
                ],
              },
              {
                id: "530800",
                text: "普洱市",
                children: [
                  {
                    id: "530802",
                    text: "思茅区",
                    gisGcj02Lat: 22.7869,
                    gisGcj02Lng: 100.977,
                  },
                  {
                    id: "530821",
                    text: "宁洱哈尼族彝族自治县",
                    gisGcj02Lat: 23.0634,
                    gisGcj02Lng: 101.047,
                  },
                  {
                    id: "530822",
                    text: "墨江哈尼族自治县",
                    gisGcj02Lat: 23.4321,
                    gisGcj02Lng: 101.692,
                  },
                  {
                    id: "530823",
                    text: "景东彝族自治县",
                    gisGcj02Lat: 24.4479,
                    gisGcj02Lng: 100.836,
                  },
                  {
                    id: "530824",
                    text: "景谷傣族彝族自治县",
                    gisGcj02Lat: 23.497,
                    gisGcj02Lng: 100.703,
                  },
                  {
                    id: "530825",
                    text: "镇沅彝族哈尼族拉祜族自治县",
                    gisGcj02Lat: 24.0056,
                    gisGcj02Lng: 101.107,
                  },
                  {
                    id: "530826",
                    text: "江城哈尼族彝族自治县",
                    gisGcj02Lat: 22.5842,
                    gisGcj02Lng: 101.858,
                  },
                  {
                    id: "530827",
                    text: "孟连傣族拉祜族佤族自治县",
                    gisGcj02Lat: 22.3292,
                    gisGcj02Lng: 99.5842,
                  },
                  {
                    id: "530828",
                    text: "澜沧拉祜族自治县",
                    gisGcj02Lat: 22.5547,
                    gisGcj02Lng: 99.9359,
                  },
                  {
                    id: "530829",
                    text: "西盟佤族自治县",
                    gisGcj02Lat: 22.6477,
                    gisGcj02Lng: 99.5987,
                  },
                ],
              },
              {
                id: "530900",
                text: "临沧市",
                children: [
                  {
                    id: "530902",
                    text: "临翔区",
                    gisGcj02Lat: 23.895,
                    gisGcj02Lng: 100.082,
                  },
                  {
                    id: "530921",
                    text: "凤庆县",
                    gisGcj02Lat: 24.5803,
                    gisGcj02Lng: 99.9284,
                  },
                  {
                    id: "530922",
                    text: "云县",
                    gisGcj02Lat: 24.4468,
                    gisGcj02Lng: 100.128,
                  },
                  {
                    id: "530923",
                    text: "永德县",
                    gisGcj02Lat: 24.0276,
                    gisGcj02Lng: 99.2533,
                  },
                  {
                    id: "530924",
                    text: "镇康县",
                    gisGcj02Lat: 23.7624,
                    gisGcj02Lng: 98.8255,
                  },
                  {
                    id: "530925",
                    text: "双江拉祜族佤族布朗族傣族自治县",
                    gisGcj02Lat: 23.4735,
                    gisGcj02Lng: 99.8277,
                  },
                  {
                    id: "530926",
                    text: "耿马傣族佤族自治县",
                    gisGcj02Lat: 23.5378,
                    gisGcj02Lng: 99.3979,
                  },
                  {
                    id: "530927",
                    text: "沧源佤族自治县",
                    gisGcj02Lat: 23.1482,
                    gisGcj02Lng: 99.2455,
                  },
                ],
              },
              {
                id: "532300",
                text: "楚雄彝族自治州",
                children: [
                  {
                    id: "532301",
                    text: "楚雄市",
                    gisGcj02Lat: 25.0329,
                    gisGcj02Lng: 101.546,
                  },
                  {
                    id: "532322",
                    text: "双柏县",
                    gisGcj02Lat: 24.6888,
                    gisGcj02Lng: 101.642,
                  },
                  {
                    id: "532323",
                    text: "牟定县",
                    gisGcj02Lat: 25.3155,
                    gisGcj02Lng: 101.54,
                  },
                  {
                    id: "532324",
                    text: "南华县",
                    gisGcj02Lat: 25.1929,
                    gisGcj02Lng: 101.273,
                  },
                  {
                    id: "532325",
                    text: "姚安县",
                    gisGcj02Lat: 25.5047,
                    gisGcj02Lng: 101.243,
                  },
                  {
                    id: "532326",
                    text: "大姚县",
                    gisGcj02Lat: 25.7222,
                    gisGcj02Lng: 101.324,
                  },
                  {
                    id: "532327",
                    text: "永仁县",
                    gisGcj02Lat: 26.0579,
                    gisGcj02Lng: 101.672,
                  },
                  {
                    id: "532328",
                    text: "元谋县",
                    gisGcj02Lat: 25.7044,
                    gisGcj02Lng: 101.877,
                  },
                  {
                    id: "532329",
                    text: "武定县",
                    gisGcj02Lat: 25.5295,
                    gisGcj02Lng: 102.404,
                  },
                  {
                    id: "532331",
                    text: "禄丰市",
                    gisGcj02Lat: 25.1481,
                    gisGcj02Lng: 102.078,
                  },
                ],
              },
              {
                id: "532500",
                text: "红河哈尼族彝族自治州",
                children: [
                  {
                    id: "532501",
                    text: "个旧市",
                    gisGcj02Lat: 23.3589,
                    gisGcj02Lng: 103.16,
                  },
                  {
                    id: "532502",
                    text: "开远市",
                    gisGcj02Lat: 23.7101,
                    gisGcj02Lng: 103.27,
                  },
                  {
                    id: "532503",
                    text: "蒙自市",
                    gisGcj02Lat: 23.3668,
                    gisGcj02Lng: 103.385,
                  },
                  {
                    id: "532504",
                    text: "弥勒市",
                    gisGcj02Lat: 24.4084,
                    gisGcj02Lng: 103.437,
                  },
                  {
                    id: "532523",
                    text: "屏边苗族自治县",
                    gisGcj02Lat: 22.9842,
                    gisGcj02Lng: 103.686,
                  },
                  {
                    id: "532524",
                    text: "建水县",
                    gisGcj02Lat: 23.6347,
                    gisGcj02Lng: 102.827,
                  },
                  {
                    id: "532525",
                    text: "石屏县",
                    gisGcj02Lat: 23.7144,
                    gisGcj02Lng: 102.494,
                  },
                  {
                    id: "532527",
                    text: "泸西县",
                    gisGcj02Lat: 24.5285,
                    gisGcj02Lng: 103.764,
                  },
                  {
                    id: "532528",
                    text: "元阳县",
                    gisGcj02Lat: 23.2228,
                    gisGcj02Lng: 102.833,
                  },
                  {
                    id: "532529",
                    text: "红河县",
                    gisGcj02Lat: 23.3677,
                    gisGcj02Lng: 102.421,
                  },
                  {
                    id: "532530",
                    text: "金平苗族瑶族傣族自治县",
                    gisGcj02Lat: 22.7796,
                    gisGcj02Lng: 103.227,
                  },
                  {
                    id: "532531",
                    text: "绿春县",
                    gisGcj02Lat: 22.9937,
                    gisGcj02Lng: 102.397,
                  },
                  {
                    id: "532532",
                    text: "河口瑶族自治县",
                    gisGcj02Lat: 22.5293,
                    gisGcj02Lng: 103.939,
                  },
                ],
              },
              {
                id: "532600",
                text: "文山壮族苗族自治州",
                children: [
                  {
                    id: "532601",
                    text: "文山市",
                    gisGcj02Lat: 23.3692,
                    gisGcj02Lng: 104.244,
                  },
                  {
                    id: "532622",
                    text: "砚山县",
                    gisGcj02Lat: 23.6072,
                    gisGcj02Lng: 104.333,
                  },
                  {
                    id: "532623",
                    text: "西畴县",
                    gisGcj02Lat: 23.4394,
                    gisGcj02Lng: 104.674,
                  },
                  {
                    id: "532624",
                    text: "麻栗坡县",
                    gisGcj02Lat: 23.1203,
                    gisGcj02Lng: 104.701,
                  },
                  {
                    id: "532625",
                    text: "马关县",
                    gisGcj02Lat: 23.0129,
                    gisGcj02Lng: 104.395,
                  },
                  {
                    id: "532626",
                    text: "丘北县",
                    gisGcj02Lat: 24.0396,
                    gisGcj02Lng: 104.193,
                  },
                  {
                    id: "532627",
                    text: "广南县",
                    gisGcj02Lat: 24.0464,
                    gisGcj02Lng: 105.055,
                  },
                  {
                    id: "532628",
                    text: "富宁县",
                    gisGcj02Lat: 23.6254,
                    gisGcj02Lng: 105.631,
                  },
                ],
              },
              {
                id: "532800",
                text: "西双版纳傣族自治州",
                children: [
                  {
                    id: "532801",
                    text: "景洪市",
                    gisGcj02Lat: 22.0107,
                    gisGcj02Lng: 100.8,
                  },
                  {
                    id: "532822",
                    text: "勐海县",
                    gisGcj02Lat: 21.9618,
                    gisGcj02Lng: 100.449,
                  },
                  {
                    id: "532823",
                    text: "勐腊县",
                    gisGcj02Lat: 21.4816,
                    gisGcj02Lng: 101.565,
                  },
                ],
              },
              {
                id: "532900",
                text: "大理白族自治州",
                children: [
                  {
                    id: "532901",
                    text: "大理市",
                    gisGcj02Lat: 25.5916,
                    gisGcj02Lng: 100.23,
                  },
                  {
                    id: "532922",
                    text: "漾濞彝族自治县",
                    gisGcj02Lat: 25.6652,
                    gisGcj02Lng: 99.9547,
                  },
                  {
                    id: "532923",
                    text: "祥云县",
                    gisGcj02Lat: 25.4734,
                    gisGcj02Lng: 100.558,
                  },
                  {
                    id: "532924",
                    text: "宾川县",
                    gisGcj02Lat: 25.8314,
                    gisGcj02Lng: 100.577,
                  },
                  {
                    id: "532925",
                    text: "弥渡县",
                    gisGcj02Lat: 25.3418,
                    gisGcj02Lng: 100.491,
                  },
                  {
                    id: "532926",
                    text: "南涧彝族自治县",
                    gisGcj02Lat: 25.0435,
                    gisGcj02Lng: 100.51,
                  },
                  {
                    id: "532927",
                    text: "巍山彝族回族自治县",
                    gisGcj02Lat: 25.232,
                    gisGcj02Lng: 100.306,
                  },
                  {
                    id: "532928",
                    text: "永平县",
                    gisGcj02Lat: 25.4645,
                    gisGcj02Lng: 99.5409,
                  },
                  {
                    id: "532929",
                    text: "云龙县",
                    gisGcj02Lat: 25.885,
                    gisGcj02Lng: 99.3726,
                  },
                  {
                    id: "532930",
                    text: "洱源县",
                    gisGcj02Lat: 26.1083,
                    gisGcj02Lng: 99.949,
                  },
                  {
                    id: "532931",
                    text: "剑川县",
                    gisGcj02Lat: 26.5369,
                    gisGcj02Lng: 99.9054,
                  },
                  {
                    id: "532932",
                    text: "鹤庆县",
                    gisGcj02Lat: 26.558,
                    gisGcj02Lng: 100.177,
                  },
                ],
              },
              {
                id: "533100",
                text: "德宏傣族景颇族自治州",
                children: [
                  {
                    id: "533102",
                    text: "瑞丽市",
                    gisGcj02Lat: 24.0128,
                    gisGcj02Lng: 97.8518,
                  },
                  {
                    id: "533103",
                    text: "芒市",
                    gisGcj02Lat: 24.4337,
                    gisGcj02Lng: 98.5886,
                  },
                  {
                    id: "533122",
                    text: "梁河县",
                    gisGcj02Lat: 24.8066,
                    gisGcj02Lng: 98.2971,
                  },
                  {
                    id: "533123",
                    text: "盈江县",
                    gisGcj02Lat: 24.7058,
                    gisGcj02Lng: 97.9318,
                  },
                  {
                    id: "533124",
                    text: "陇川县",
                    gisGcj02Lat: 24.183,
                    gisGcj02Lng: 97.792,
                  },
                ],
              },
              {
                id: "533300",
                text: "怒江傈僳族自治州",
                children: [
                  {
                    id: "533321",
                    text: "泸水县",
                    gisGcj02Lat: 25.8377,
                    gisGcj02Lng: 98.8553,
                  },
                  {
                    id: "533323",
                    text: "福贡县",
                    gisGcj02Lat: 26.9037,
                    gisGcj02Lng: 98.8697,
                  },
                  {
                    id: "533324",
                    text: "贡山独龙族怒族自治县",
                    gisGcj02Lat: 27.7409,
                    gisGcj02Lng: 98.6658,
                  },
                  {
                    id: "533325",
                    text: "兰坪白族普米族自治县",
                    gisGcj02Lat: 26.4525,
                    gisGcj02Lng: 99.4189,
                  },
                ],
              },
              {
                id: "533400",
                text: "迪庆藏族自治州",
                children: [
                  {
                    id: "533421",
                    text: "香格里拉市",
                    gisGcj02Lat: 27.8231,
                    gisGcj02Lng: 99.706,
                  },
                  {
                    id: "533422",
                    text: "德钦县",
                    gisGcj02Lat: 28.4863,
                    gisGcj02Lng: 98.9108,
                  },
                  {
                    id: "533423",
                    text: "维西傈僳族自治县",
                    gisGcj02Lat: 27.1793,
                    gisGcj02Lng: 99.284,
                  },
                ],
              },
            ],
          },
          {
            id: "540000",
            text: "西藏",
            children: [
              {
                id: "540100",
                text: "拉萨市",
                children: [
                  {
                    id: "540102",
                    text: "城关区",
                    gisGcj02Lat: 29.6531,
                    gisGcj02Lng: 91.1386,
                  },
                  {
                    id: "540121",
                    text: "林周县",
                    gisGcj02Lat: 29.8944,
                    gisGcj02Lng: 91.2586,
                  },
                  {
                    id: "540122",
                    text: "当雄县",
                    gisGcj02Lat: 30.4831,
                    gisGcj02Lng: 91.1008,
                  },
                  {
                    id: "540123",
                    text: "尼木县",
                    gisGcj02Lat: 29.4335,
                    gisGcj02Lng: 90.1638,
                  },
                  {
                    id: "540124",
                    text: "曲水县",
                    gisGcj02Lat: 29.3564,
                    gisGcj02Lng: 90.7319,
                  },
                  {
                    id: "540125",
                    text: "堆龙德庆县",
                    gisGcj02Lat: 29.65,
                    gisGcj02Lng: 91.0003,
                  },
                  {
                    id: "540126",
                    text: "达孜县",
                    gisGcj02Lat: 29.6722,
                    gisGcj02Lng: 91.3576,
                  },
                  {
                    id: "540127",
                    text: "墨竹工卡县",
                    gisGcj02Lat: 29.8361,
                    gisGcj02Lng: 91.7281,
                  },
                ],
              },
              {
                id: "540200",
                text: "日喀则市",
                children: [
                  {
                    id: "540202",
                    text: "桑珠孜区",
                    gisGcj02Lat: 29.2696,
                    gisGcj02Lng: 88.8804,
                  },
                  {
                    id: "540221",
                    text: "南木林县",
                    gisGcj02Lat: 29.6821,
                    gisGcj02Lng: 89.0969,
                  },
                  {
                    id: "540222",
                    text: "江孜县",
                    gisGcj02Lat: 28.9174,
                    gisGcj02Lng: 89.6026,
                  },
                  {
                    id: "540223",
                    text: "定日县",
                    gisGcj02Lat: 28.6613,
                    gisGcj02Lng: 87.1218,
                  },
                  {
                    id: "540224",
                    text: "萨迦县",
                    gisGcj02Lat: 28.903,
                    gisGcj02Lng: 88.0219,
                  },
                  {
                    id: "540225",
                    text: "拉孜县",
                    gisGcj02Lat: 29.085,
                    gisGcj02Lng: 87.6341,
                  },
                  {
                    id: "540226",
                    text: "昂仁县",
                    gisGcj02Lat: 29.295,
                    gisGcj02Lng: 87.2386,
                  },
                  {
                    id: "540227",
                    text: "谢通门县",
                    gisGcj02Lat: 29.4334,
                    gisGcj02Lng: 88.2624,
                  },
                  {
                    id: "540228",
                    text: "白朗县",
                    gisGcj02Lat: 29.1055,
                    gisGcj02Lng: 89.262,
                  },
                  {
                    id: "540229",
                    text: "仁布县",
                    gisGcj02Lat: 29.2301,
                    gisGcj02Lng: 89.8423,
                  },
                  {
                    id: "540230",
                    text: "康马县",
                    gisGcj02Lat: 28.5567,
                    gisGcj02Lng: 89.6853,
                  },
                  {
                    id: "540231",
                    text: "定结县",
                    gisGcj02Lat: 28.364,
                    gisGcj02Lng: 87.7726,
                  },
                  {
                    id: "540232",
                    text: "仲巴县",
                    gisGcj02Lat: 29.7659,
                    gisGcj02Lng: 84.0295,
                  },
                  {
                    id: "540233",
                    text: "亚东县",
                    gisGcj02Lat: 27.4839,
                    gisGcj02Lng: 88.908,
                  },
                  {
                    id: "540234",
                    text: "吉隆县",
                    gisGcj02Lat: 28.8538,
                    gisGcj02Lng: 85.2985,
                  },
                  {
                    id: "540235",
                    text: "聂拉木县",
                    gisGcj02Lat: 28.1565,
                    gisGcj02Lng: 85.98,
                  },
                  {
                    id: "540236",
                    text: "萨嘎县",
                    gisGcj02Lat: 29.3294,
                    gisGcj02Lng: 85.2341,
                  },
                  {
                    id: "540237",
                    text: "岗巴县",
                    gisGcj02Lat: 28.275,
                    gisGcj02Lng: 88.5207,
                  },
                ],
              },
              {
                id: "540300",
                text: "昌都市",
                children: [
                  {
                    id: "540302",
                    text: "卡若区",
                    gisGcj02Lat: 31.1385,
                    gisGcj02Lng: 97.1804,
                  },
                  {
                    id: "540321",
                    text: "江达县",
                    gisGcj02Lat: 31.5034,
                    gisGcj02Lng: 98.2187,
                  },
                  {
                    id: "540322",
                    text: "贡觉县",
                    gisGcj02Lat: 30.8594,
                    gisGcj02Lng: 98.2716,
                  },
                  {
                    id: "540323",
                    text: "类乌齐县",
                    gisGcj02Lat: 31.2121,
                    gisGcj02Lng: 96.6002,
                  },
                  {
                    id: "540324",
                    text: "丁青县",
                    gisGcj02Lat: 31.4162,
                    gisGcj02Lng: 95.5936,
                  },
                  {
                    id: "540325",
                    text: "察雅县",
                    gisGcj02Lat: 30.6534,
                    gisGcj02Lng: 97.5652,
                  },
                  {
                    id: "540326",
                    text: "八宿县",
                    gisGcj02Lat: 30.0535,
                    gisGcj02Lng: 96.9176,
                  },
                  {
                    id: "540327",
                    text: "左贡县",
                    gisGcj02Lat: 29.6711,
                    gisGcj02Lng: 97.8443,
                  },
                  {
                    id: "540328",
                    text: "芒康县",
                    gisGcj02Lat: 29.6795,
                    gisGcj02Lng: 98.5938,
                  },
                  {
                    id: "540329",
                    text: "洛隆县",
                    gisGcj02Lat: 30.7405,
                    gisGcj02Lng: 95.8264,
                  },
                  {
                    id: "540330",
                    text: "边坝县",
                    gisGcj02Lat: 30.9343,
                    gisGcj02Lng: 94.7069,
                  },
                ],
              },
              {
                id: "542200",
                text: "山南地区",
                children: [
                  {
                    id: "542221",
                    text: "乃东县",
                    gisGcj02Lat: 29.2249,
                    gisGcj02Lng: 91.7615,
                  },
                  {
                    id: "542222",
                    text: "扎囊县",
                    gisGcj02Lat: 29.2399,
                    gisGcj02Lng: 91.3329,
                  },
                  {
                    id: "542223",
                    text: "贡嘎县",
                    gisGcj02Lat: 29.2941,
                    gisGcj02Lng: 90.9887,
                  },
                  {
                    id: "542224",
                    text: "桑日县",
                    gisGcj02Lat: 29.2664,
                    gisGcj02Lng: 92.0201,
                  },
                  {
                    id: "542225",
                    text: "琼结县",
                    gisGcj02Lat: 29.0263,
                    gisGcj02Lng: 91.6809,
                  },
                  {
                    id: "542226",
                    text: "曲松县",
                    gisGcj02Lat: 29.0641,
                    gisGcj02Lng: 92.2026,
                  },
                  {
                    id: "542227",
                    text: "措美县",
                    gisGcj02Lat: 28.4379,
                    gisGcj02Lng: 91.4324,
                  },
                  {
                    id: "542228",
                    text: "洛扎县",
                    gisGcj02Lat: 28.3872,
                    gisGcj02Lng: 90.8604,
                  },
                  {
                    id: "542229",
                    text: "加查县",
                    gisGcj02Lat: 29.1397,
                    gisGcj02Lng: 92.577,
                  },
                  {
                    id: "542231",
                    text: "隆子县",
                    gisGcj02Lat: 28.408,
                    gisGcj02Lng: 92.4615,
                  },
                  {
                    id: "542232",
                    text: "错那县",
                    gisGcj02Lat: 27.9922,
                    gisGcj02Lng: 91.9575,
                  },
                  {
                    id: "542233",
                    text: "浪卡子县",
                    gisGcj02Lat: 28.9695,
                    gisGcj02Lng: 90.4,
                  },
                ],
              },
              {
                id: "542400",
                text: "那曲地区",
                children: [
                  {
                    id: "542421",
                    text: "那曲县",
                    gisGcj02Lat: 31.4696,
                    gisGcj02Lng: 92.0535,
                  },
                  {
                    id: "542422",
                    text: "嘉黎县",
                    gisGcj02Lat: 30.6423,
                    gisGcj02Lng: 93.2499,
                  },
                  {
                    id: "542423",
                    text: "比如县",
                    gisGcj02Lat: 31.4779,
                    gisGcj02Lng: 93.6869,
                  },
                  {
                    id: "542424",
                    text: "聂荣县",
                    gisGcj02Lat: 32.1119,
                    gisGcj02Lng: 92.2957,
                  },
                  {
                    id: "542425",
                    text: "安多县",
                    gisGcj02Lat: 32.2612,
                    gisGcj02Lng: 91.6795,
                  },
                  {
                    id: "542426",
                    text: "申扎县",
                    gisGcj02Lat: 30.93,
                    gisGcj02Lng: 88.7078,
                  },
                  {
                    id: "542427",
                    text: "索县",
                    gisGcj02Lat: 31.8843,
                    gisGcj02Lng: 93.783,
                  },
                  {
                    id: "542428",
                    text: "班戈县",
                    gisGcj02Lat: 31.3615,
                    gisGcj02Lng: 90.0191,
                  },
                  {
                    id: "542429",
                    text: "巴青县",
                    gisGcj02Lat: 31.9183,
                    gisGcj02Lng: 94.0532,
                  },
                  {
                    id: "542430",
                    text: "尼玛县",
                    gisGcj02Lat: 31.7965,
                    gisGcj02Lng: 87.2526,
                  },
                  {
                    id: "542431",
                    text: "双湖县",
                    gisGcj02Lat: 33.189,
                    gisGcj02Lng: 88.8378,
                  },
                ],
              },
              {
                id: "542500",
                text: "阿里地区",
                children: [
                  {
                    id: "542521",
                    text: "普兰县",
                    gisGcj02Lat: 30.3,
                    gisGcj02Lng: 81.177,
                  },
                  {
                    id: "542522",
                    text: "札达县",
                    gisGcj02Lat: 31.4834,
                    gisGcj02Lng: 79.8026,
                  },
                  {
                    id: "542523",
                    text: "噶尔县",
                    gisGcj02Lat: 32.5002,
                    gisGcj02Lng: 80.0958,
                  },
                  {
                    id: "542524",
                    text: "日土县",
                    gisGcj02Lat: 33.3874,
                    gisGcj02Lng: 79.7131,
                  },
                  {
                    id: "542525",
                    text: "革吉县",
                    gisGcj02Lat: 32.3964,
                    gisGcj02Lng: 81.151,
                  },
                  {
                    id: "542526",
                    text: "改则县",
                    gisGcj02Lat: 32.3045,
                    gisGcj02Lng: 84.063,
                  },
                  {
                    id: "542527",
                    text: "措勤县",
                    gisGcj02Lat: 31.021,
                    gisGcj02Lng: 85.1662,
                  },
                ],
              },
              {
                id: "542600",
                text: "林芝地区",
                children: [
                  {
                    id: "542621",
                    text: "林芝县",
                    gisGcj02Lat: 29.5756,
                    gisGcj02Lng: 94.4839,
                  },
                  {
                    id: "542622",
                    text: "工布江达县",
                    gisGcj02Lat: 29.8858,
                    gisGcj02Lng: 93.2452,
                  },
                  {
                    id: "542623",
                    text: "米林县",
                    gisGcj02Lat: 29.2153,
                    gisGcj02Lng: 94.2132,
                  },
                  {
                    id: "542624",
                    text: "墨脱县",
                    gisGcj02Lat: 29.327,
                    gisGcj02Lng: 95.3316,
                  },
                  {
                    id: "542625",
                    text: "波密县",
                    gisGcj02Lat: 29.8591,
                    gisGcj02Lng: 95.771,
                  },
                  {
                    id: "542626",
                    text: "察隅县",
                    gisGcj02Lat: 28.6618,
                    gisGcj02Lng: 97.4668,
                  },
                  {
                    id: "542627",
                    text: "朗县",
                    gisGcj02Lat: 29.0455,
                    gisGcj02Lng: 93.0754,
                  },
                ],
              },
            ],
          },
          {
            id: "610000",
            text: "陕西省",
            children: [
              {
                id: "610100",
                text: "西安市",
                children: [
                  {
                    id: "610102",
                    text: "新城区",
                    gisGcj02Lat: 34.2664,
                    gisGcj02Lng: 108.961,
                  },
                  {
                    id: "610103",
                    text: "碑林区",
                    gisGcj02Lat: 34.2304,
                    gisGcj02Lng: 108.934,
                  },
                  {
                    id: "610104",
                    text: "莲湖区",
                    gisGcj02Lat: 34.2671,
                    gisGcj02Lng: 108.94,
                  },
                  {
                    id: "610111",
                    text: "灞桥区",
                    gisGcj02Lat: 34.2726,
                    gisGcj02Lng: 109.065,
                  },
                  {
                    id: "610112",
                    text: "未央区",
                    gisGcj02Lat: 34.293,
                    gisGcj02Lng: 108.947,
                  },
                  {
                    id: "610113",
                    text: "雁塔区",
                    gisGcj02Lat: 34.2225,
                    gisGcj02Lng: 108.949,
                  },
                  {
                    id: "610114",
                    text: "阎良区",
                    gisGcj02Lat: 34.6622,
                    gisGcj02Lng: 109.226,
                  },
                  {
                    id: "610115",
                    text: "临潼区",
                    gisGcj02Lat: 34.3666,
                    gisGcj02Lng: 109.214,
                  },
                  {
                    id: "610116",
                    text: "长安区",
                    gisGcj02Lat: 34.1556,
                    gisGcj02Lng: 108.946,
                  },
                  {
                    id: "610117",
                    text: "鄠邑区",
                    gisGcj02Lat: 34.1556,
                    gisGcj02Lng: 108.946,
                  },
                  {
                    id: "610122",
                    text: "蓝田县",
                    gisGcj02Lat: 34.1513,
                    gisGcj02Lng: 109.323,
                  },
                  {
                    id: "610124",
                    text: "周至县",
                    gisGcj02Lat: 34.1634,
                    gisGcj02Lng: 108.222,
                  },
                  {
                    id: "610125",
                    text: "户县",
                    gisGcj02Lat: 34.1086,
                    gisGcj02Lng: 108.605,
                  },
                  {
                    id: "610126",
                    text: "高陵区",
                    gisGcj02Lat: 34.5348,
                    gisGcj02Lng: 109.088,
                  },
                ],
              },
              {
                id: "610200",
                text: "铜川市",
                children: [
                  {
                    id: "610202",
                    text: "王益区",
                    gisGcj02Lat: 35.069,
                    gisGcj02Lng: 109.076,
                  },
                  {
                    id: "610203",
                    text: "印台区",
                    gisGcj02Lat: 35.1169,
                    gisGcj02Lng: 109.102,
                  },
                  {
                    id: "610204",
                    text: "耀州区",
                    gisGcj02Lat: 34.9131,
                    gisGcj02Lng: 108.986,
                  },
                  {
                    id: "610222",
                    text: "宜君县",
                    gisGcj02Lat: 35.4011,
                    gisGcj02Lng: 109.118,
                  },
                ],
              },
              {
                id: "610300",
                text: "宝鸡市",
                children: [
                  {
                    id: "610302",
                    text: "渭滨区",
                    gisGcj02Lat: 34.3712,
                    gisGcj02Lng: 107.15,
                  },
                  {
                    id: "610303",
                    text: "金台区",
                    gisGcj02Lat: 34.3761,
                    gisGcj02Lng: 107.147,
                  },
                  {
                    id: "610304",
                    text: "陈仓区",
                    gisGcj02Lat: 34.3545,
                    gisGcj02Lng: 107.387,
                  },
                  {
                    id: "610322",
                    text: "凤翔区",
                    gisGcj02Lat: 34.5232,
                    gisGcj02Lng: 107.396,
                  },
                  {
                    id: "610323",
                    text: "岐山县",
                    gisGcj02Lat: 34.4438,
                    gisGcj02Lng: 107.622,
                  },
                  {
                    id: "610324",
                    text: "扶风县",
                    gisGcj02Lat: 34.3752,
                    gisGcj02Lng: 107.9,
                  },
                  {
                    id: "610326",
                    text: "眉县",
                    gisGcj02Lat: 34.2757,
                    gisGcj02Lng: 107.751,
                  },
                  {
                    id: "610327",
                    text: "陇县",
                    gisGcj02Lat: 34.894,
                    gisGcj02Lng: 106.859,
                  },
                  {
                    id: "610328",
                    text: "千阳县",
                    gisGcj02Lat: 34.6422,
                    gisGcj02Lng: 107.13,
                  },
                  {
                    id: "610329",
                    text: "麟游县",
                    gisGcj02Lat: 34.6784,
                    gisGcj02Lng: 107.796,
                  },
                  {
                    id: "610330",
                    text: "凤县",
                    gisGcj02Lat: 33.9117,
                    gisGcj02Lng: 106.524,
                  },
                  {
                    id: "610331",
                    text: "太白县",
                    gisGcj02Lat: 34.0621,
                    gisGcj02Lng: 107.316,
                  },
                ],
              },
              {
                id: "610400",
                text: "咸阳市",
                children: [
                  {
                    id: "610402",
                    text: "秦都区",
                    gisGcj02Lat: 34.338,
                    gisGcj02Lng: 108.715,
                  },
                  {
                    id: "610403",
                    text: "杨陵区",
                    gisGcj02Lat: 34.2704,
                    gisGcj02Lng: 108.083,
                  },
                  {
                    id: "610404",
                    text: "渭城区",
                    gisGcj02Lat: 34.332,
                    gisGcj02Lng: 108.722,
                  },
                  {
                    id: "610422",
                    text: "三原县",
                    gisGcj02Lat: 34.6156,
                    gisGcj02Lng: 108.932,
                  },
                  {
                    id: "610423",
                    text: "泾阳县",
                    gisGcj02Lat: 34.5271,
                    gisGcj02Lng: 108.843,
                  },
                  {
                    id: "610424",
                    text: "乾县",
                    gisGcj02Lat: 34.5295,
                    gisGcj02Lng: 108.242,
                  },
                  {
                    id: "610425",
                    text: "礼泉县",
                    gisGcj02Lat: 34.4846,
                    gisGcj02Lng: 108.426,
                  },
                  {
                    id: "610426",
                    text: "永寿县",
                    gisGcj02Lat: 34.6908,
                    gisGcj02Lng: 108.145,
                  },
                  {
                    id: "610427",
                    text: "彬县",
                    gisGcj02Lat: 35.0342,
                    gisGcj02Lng: 108.085,
                  },
                  {
                    id: "610428",
                    text: "长武县",
                    gisGcj02Lat: 35.2067,
                    gisGcj02Lng: 107.795,
                  },
                  {
                    id: "610429",
                    text: "旬邑县",
                    gisGcj02Lat: 35.1134,
                    gisGcj02Lng: 108.334,
                  },
                  {
                    id: "610430",
                    text: "淳化县",
                    gisGcj02Lat: 34.7989,
                    gisGcj02Lng: 108.58,
                  },
                  {
                    id: "610431",
                    text: "武功县",
                    gisGcj02Lat: 34.26,
                    gisGcj02Lng: 108.204,
                  },
                  {
                    id: "610481",
                    text: "兴平市",
                    gisGcj02Lat: 34.2979,
                    gisGcj02Lng: 108.491,
                  },
                ],
              },
              {
                id: "610500",
                text: "渭南市",
                children: [
                  {
                    id: "610502",
                    text: "临渭区",
                    gisGcj02Lat: 34.4982,
                    gisGcj02Lng: 109.493,
                  },
                  {
                    id: "610503",
                    text: "华洲区",
                    gisGcj02Lat: 34.5126,
                    gisGcj02Lng: 109.772,
                  },
                  {
                    id: "610521",
                    text: "华县",
                    gisGcj02Lat: 34.5126,
                    gisGcj02Lng: 109.772,
                  },
                  {
                    id: "610522",
                    text: "潼关县",
                    gisGcj02Lat: 34.5428,
                    gisGcj02Lng: 110.244,
                  },
                  {
                    id: "610523",
                    text: "大荔县",
                    gisGcj02Lat: 34.7957,
                    gisGcj02Lng: 109.942,
                  },
                  {
                    id: "610524",
                    text: "合阳县",
                    gisGcj02Lat: 35.238,
                    gisGcj02Lng: 110.149,
                  },
                  {
                    id: "610525",
                    text: "澄城县",
                    gisGcj02Lat: 35.184,
                    gisGcj02Lng: 109.934,
                  },
                  {
                    id: "610526",
                    text: "蒲城县",
                    gisGcj02Lat: 34.9568,
                    gisGcj02Lng: 109.59,
                  },
                  {
                    id: "610527",
                    text: "白水县",
                    gisGcj02Lat: 35.1786,
                    gisGcj02Lng: 109.593,
                  },
                  {
                    id: "610528",
                    text: "富平县",
                    gisGcj02Lat: 34.7511,
                    gisGcj02Lng: 109.18,
                  },
                  {
                    id: "610581",
                    text: "韩城市",
                    gisGcj02Lat: 35.4793,
                    gisGcj02Lng: 110.442,
                  },
                  {
                    id: "610582",
                    text: "华阴市",
                    gisGcj02Lat: 34.5661,
                    gisGcj02Lng: 110.088,
                  },
                ],
              },
              {
                id: "610600",
                text: "延安市",
                children: [
                  {
                    id: "610602",
                    text: "宝塔区",
                    gisGcj02Lat: 36.5915,
                    gisGcj02Lng: 109.493,
                  },
                  {
                    id: "610603",
                    text: "安塞区",
                    gisGcj02Lat: 36.5915,
                    gisGcj02Lng: 109.493,
                  },
                  {
                    id: "610621",
                    text: "延长县",
                    gisGcj02Lat: 36.579,
                    gisGcj02Lng: 110.011,
                  },
                  {
                    id: "610622",
                    text: "延川县",
                    gisGcj02Lat: 36.8782,
                    gisGcj02Lng: 110.194,
                  },
                  {
                    id: "610623",
                    text: "子长市",
                    gisGcj02Lat: 37.1425,
                    gisGcj02Lng: 109.675,
                  },
                  {
                    id: "610624",
                    text: "安塞县",
                    gisGcj02Lat: 36.8651,
                    gisGcj02Lng: 109.327,
                  },
                  {
                    id: "610625",
                    text: "志丹县",
                    gisGcj02Lat: 36.8218,
                    gisGcj02Lng: 108.768,
                  },
                  {
                    id: "610626",
                    text: "吴起县",
                    gisGcj02Lat: 36.9278,
                    gisGcj02Lng: 108.176,
                  },
                  {
                    id: "610627",
                    text: "甘泉县",
                    gisGcj02Lat: 36.2775,
                    gisGcj02Lng: 109.35,
                  },
                  {
                    id: "610628",
                    text: "富县",
                    gisGcj02Lat: 35.988,
                    gisGcj02Lng: 109.379,
                  },
                  {
                    id: "610629",
                    text: "洛川县",
                    gisGcj02Lat: 35.7608,
                    gisGcj02Lng: 109.433,
                  },
                  {
                    id: "610630",
                    text: "宜川县",
                    gisGcj02Lat: 36.0473,
                    gisGcj02Lng: 110.172,
                  },
                  {
                    id: "610631",
                    text: "黄龙县",
                    gisGcj02Lat: 35.5835,
                    gisGcj02Lng: 109.843,
                  },
                  {
                    id: "610632",
                    text: "黄陵县",
                    gisGcj02Lat: 35.5836,
                    gisGcj02Lng: 109.263,
                  },
                ],
              },
              {
                id: "610700",
                text: "汉中市",
                children: [
                  {
                    id: "610702",
                    text: "汉台区",
                    gisGcj02Lat: 33.0677,
                    gisGcj02Lng: 107.032,
                  },
                  {
                    id: "610721",
                    text: "南郑县",
                    gisGcj02Lat: 33.003,
                    gisGcj02Lng: 106.94,
                  },
                  {
                    id: "610722",
                    text: "城固县",
                    gisGcj02Lat: 33.1566,
                    gisGcj02Lng: 107.334,
                  },
                  {
                    id: "610723",
                    text: "洋县",
                    gisGcj02Lat: 33.221,
                    gisGcj02Lng: 107.547,
                  },
                  {
                    id: "610724",
                    text: "西乡县",
                    gisGcj02Lat: 32.9841,
                    gisGcj02Lng: 107.769,
                  },
                  {
                    id: "610725",
                    text: "勉县",
                    gisGcj02Lat: 33.1527,
                    gisGcj02Lng: 106.676,
                  },
                  {
                    id: "610726",
                    text: "宁强县",
                    gisGcj02Lat: 32.8288,
                    gisGcj02Lng: 106.26,
                  },
                  {
                    id: "610727",
                    text: "略阳县",
                    gisGcj02Lat: 33.3301,
                    gisGcj02Lng: 106.154,
                  },
                  {
                    id: "610728",
                    text: "镇巴县",
                    gisGcj02Lat: 32.5349,
                    gisGcj02Lng: 107.896,
                  },
                  {
                    id: "610729",
                    text: "留坝县",
                    gisGcj02Lat: 33.6161,
                    gisGcj02Lng: 106.922,
                  },
                  {
                    id: "610730",
                    text: "佛坪县",
                    gisGcj02Lat: 33.525,
                    gisGcj02Lng: 107.99,
                  },
                ],
              },
              {
                id: "610800",
                text: "榆林市",
                children: [
                  {
                    id: "610802",
                    text: "榆阳区",
                    gisGcj02Lat: 38.2784,
                    gisGcj02Lng: 109.735,
                  },
                  {
                    id: "610803",
                    text: "横山区",
                    gisGcj02Lat: 38.2784,
                    gisGcj02Lng: 109.735,
                  },
                  {
                    id: "610821",
                    text: "神木县",
                    gisGcj02Lat: 38.8423,
                    gisGcj02Lng: 110.499,
                  },
                  {
                    id: "610822",
                    text: "府谷县",
                    gisGcj02Lat: 39.028,
                    gisGcj02Lng: 111.067,
                  },
                  {
                    id: "610823",
                    text: "横山县",
                    gisGcj02Lat: 37.958,
                    gisGcj02Lng: 109.296,
                  },
                  {
                    id: "610824",
                    text: "靖边县",
                    gisGcj02Lat: 37.5994,
                    gisGcj02Lng: 108.794,
                  },
                  {
                    id: "610825",
                    text: "定边县",
                    gisGcj02Lat: 37.5904,
                    gisGcj02Lng: 107.598,
                  },
                  {
                    id: "610826",
                    text: "绥德县",
                    gisGcj02Lat: 37.4978,
                    gisGcj02Lng: 110.261,
                  },
                  {
                    id: "610827",
                    text: "米脂县",
                    gisGcj02Lat: 37.7553,
                    gisGcj02Lng: 110.184,
                  },
                  {
                    id: "610828",
                    text: "佳县",
                    gisGcj02Lat: 38.0225,
                    gisGcj02Lng: 110.494,
                  },
                  {
                    id: "610829",
                    text: "吴堡县",
                    gisGcj02Lat: 37.4571,
                    gisGcj02Lng: 110.745,
                  },
                  {
                    id: "610830",
                    text: "清涧县",
                    gisGcj02Lat: 37.0885,
                    gisGcj02Lng: 110.122,
                  },
                  {
                    id: "610831",
                    text: "子洲县",
                    gisGcj02Lat: 37.6124,
                    gisGcj02Lng: 110.035,
                  },
                ],
              },
              {
                id: "610900",
                text: "安康市",
                children: [
                  {
                    id: "610902",
                    text: "汉滨区",
                    gisGcj02Lat: 32.6952,
                    gisGcj02Lng: 109.027,
                  },
                  {
                    id: "610921",
                    text: "汉阴县",
                    gisGcj02Lat: 32.8913,
                    gisGcj02Lng: 108.511,
                  },
                  {
                    id: "610922",
                    text: "石泉县",
                    gisGcj02Lat: 33.0397,
                    gisGcj02Lng: 108.248,
                  },
                  {
                    id: "610923",
                    text: "宁陕县",
                    gisGcj02Lat: 33.3173,
                    gisGcj02Lng: 108.315,
                  },
                  {
                    id: "610924",
                    text: "紫阳县",
                    gisGcj02Lat: 32.5211,
                    gisGcj02Lng: 108.537,
                  },
                  {
                    id: "610925",
                    text: "岚皋县",
                    gisGcj02Lat: 32.3079,
                    gisGcj02Lng: 108.903,
                  },
                  {
                    id: "610926",
                    text: "平利县",
                    gisGcj02Lat: 32.3911,
                    gisGcj02Lng: 109.358,
                  },
                  {
                    id: "610927",
                    text: "镇坪县",
                    gisGcj02Lat: 31.8833,
                    gisGcj02Lng: 109.525,
                  },
                  {
                    id: "610928",
                    text: "旬阳市",
                    gisGcj02Lat: 32.8321,
                    gisGcj02Lng: 109.362,
                  },
                  {
                    id: "610929",
                    text: "白河县",
                    gisGcj02Lat: 32.8096,
                    gisGcj02Lng: 110.113,
                  },
                ],
              },
              {
                id: "611000",
                text: "商洛市",
                children: [
                  {
                    id: "611002",
                    text: "商州区",
                    gisGcj02Lat: 33.8627,
                    gisGcj02Lng: 109.941,
                  },
                  {
                    id: "611021",
                    text: "洛南县",
                    gisGcj02Lat: 34.0899,
                    gisGcj02Lng: 110.146,
                  },
                  {
                    id: "611022",
                    text: "丹凤县",
                    gisGcj02Lat: 33.6947,
                    gisGcj02Lng: 110.335,
                  },
                  {
                    id: "611023",
                    text: "商南县",
                    gisGcj02Lat: 33.5258,
                    gisGcj02Lng: 110.884,
                  },
                  {
                    id: "611024",
                    text: "山阳县",
                    gisGcj02Lat: 33.5293,
                    gisGcj02Lng: 109.888,
                  },
                  {
                    id: "611025",
                    text: "镇安县",
                    gisGcj02Lat: 33.4237,
                    gisGcj02Lng: 109.154,
                  },
                  {
                    id: "611026",
                    text: "柞水县",
                    gisGcj02Lat: 33.6831,
                    gisGcj02Lng: 109.111,
                  },
                ],
              },
              {
                id: "611100",
                text: "西咸新区",
                children: [
                  {
                    id: "611101",
                    text: "空港新城",
                    gisGcj02Lat: 34.4409,
                    gisGcj02Lng: 108.761,
                  },
                  {
                    id: "611102",
                    text: "沣东新城",
                    gisGcj02Lat: 34.2674,
                    gisGcj02Lng: 108.83,
                  },
                  {
                    id: "611103",
                    text: "秦汉新城",
                    gisGcj02Lat: 34.3865,
                    gisGcj02Lng: 108.838,
                  },
                  {
                    id: "611104",
                    text: "沣西新城",
                    gisGcj02Lat: 34.1905,
                    gisGcj02Lng: 108.712,
                  },
                  {
                    id: "611105",
                    text: "泾河新城",
                    gisGcj02Lat: 34.4606,
                    gisGcj02Lng: 109.05,
                  },
                ],
              },
            ],
          },
          {
            id: "620000",
            text: "甘肃省",
            children: [
              {
                id: "620100",
                text: "兰州市",
                children: [
                  {
                    id: "620102",
                    text: "城关区",
                    gisGcj02Lat: 36.0573,
                    gisGcj02Lng: 103.825,
                  },
                  {
                    id: "620103",
                    text: "七里河区",
                    gisGcj02Lat: 36.0658,
                    gisGcj02Lng: 103.786,
                  },
                  {
                    id: "620104",
                    text: "西固区",
                    gisGcj02Lat: 36.0886,
                    gisGcj02Lng: 103.628,
                  },
                  {
                    id: "620105",
                    text: "安宁区",
                    gisGcj02Lat: 36.1038,
                    gisGcj02Lng: 103.719,
                  },
                  {
                    id: "620111",
                    text: "红古区",
                    gisGcj02Lat: 36.3454,
                    gisGcj02Lng: 102.86,
                  },
                  {
                    id: "620121",
                    text: "永登县",
                    gisGcj02Lat: 36.7352,
                    gisGcj02Lng: 103.261,
                  },
                  {
                    id: "620122",
                    text: "皋兰县",
                    gisGcj02Lat: 36.3321,
                    gisGcj02Lng: 103.945,
                  },
                  {
                    id: "620123",
                    text: "榆中县",
                    gisGcj02Lat: 35.8442,
                    gisGcj02Lng: 104.115,
                  },
                ],
              },
              {
                id: "620200",
                text: "嘉峪关市",
                children: [
                  {
                    id: "620201",
                    text: "雄关区",
                    gisGcj02Lat: 39.7793,
                    gisGcj02Lng: 98.2774,
                  },
                  {
                    id: "620202",
                    text: "长城区",
                    gisGcj02Lat: 39.7874,
                    gisGcj02Lng: 98.2735,
                  },
                  {
                    id: "620203",
                    text: "镜铁区",
                    gisGcj02Lat: 39.7865,
                    gisGcj02Lng: 98.2773,
                  },
                ],
              },
              {
                id: "620300",
                text: "金昌市",
                children: [
                  {
                    id: "620302",
                    text: "金川区",
                    gisGcj02Lat: 38.521,
                    gisGcj02Lng: 102.194,
                  },
                  {
                    id: "620321",
                    text: "永昌县",
                    gisGcj02Lat: 38.2471,
                    gisGcj02Lng: 101.972,
                  },
                ],
              },
              {
                id: "620400",
                text: "白银市",
                children: [
                  {
                    id: "620402",
                    text: "白银区",
                    gisGcj02Lat: 36.5441,
                    gisGcj02Lng: 104.174,
                  },
                  {
                    id: "620403",
                    text: "平川区",
                    gisGcj02Lat: 36.7277,
                    gisGcj02Lng: 104.825,
                  },
                  {
                    id: "620421",
                    text: "靖远县",
                    gisGcj02Lat: 36.566,
                    gisGcj02Lng: 104.683,
                  },
                  {
                    id: "620422",
                    text: "会宁县",
                    gisGcj02Lat: 35.6963,
                    gisGcj02Lng: 105.053,
                  },
                  {
                    id: "620423",
                    text: "景泰县",
                    gisGcj02Lat: 37.1836,
                    gisGcj02Lng: 104.063,
                  },
                ],
              },
              {
                id: "620500",
                text: "天水市",
                children: [
                  {
                    id: "620502",
                    text: "秦州区",
                    gisGcj02Lat: 34.5809,
                    gisGcj02Lng: 105.724,
                  },
                  {
                    id: "620503",
                    text: "麦积区",
                    gisGcj02Lat: 34.5707,
                    gisGcj02Lng: 105.89,
                  },
                  {
                    id: "620521",
                    text: "清水县",
                    gisGcj02Lat: 34.7503,
                    gisGcj02Lng: 106.137,
                  },
                  {
                    id: "620522",
                    text: "秦安县",
                    gisGcj02Lat: 34.8589,
                    gisGcj02Lng: 105.67,
                  },
                  {
                    id: "620523",
                    text: "甘谷县",
                    gisGcj02Lat: 34.7366,
                    gisGcj02Lng: 105.333,
                  },
                  {
                    id: "620524",
                    text: "武山县",
                    gisGcj02Lat: 34.7212,
                    gisGcj02Lng: 104.884,
                  },
                  {
                    id: "620525",
                    text: "张家川回族自治县",
                    gisGcj02Lat: 34.9958,
                    gisGcj02Lng: 106.216,
                  },
                ],
              },
              {
                id: "620600",
                text: "武威市",
                children: [
                  {
                    id: "620602",
                    text: "凉州区",
                    gisGcj02Lat: 37.9283,
                    gisGcj02Lng: 102.642,
                  },
                  {
                    id: "620621",
                    text: "民勤县",
                    gisGcj02Lat: 38.6249,
                    gisGcj02Lng: 103.09,
                  },
                  {
                    id: "620622",
                    text: "古浪县",
                    gisGcj02Lat: 37.4651,
                    gisGcj02Lng: 102.892,
                  },
                  {
                    id: "620623",
                    text: "天祝藏族自治县",
                    gisGcj02Lat: 36.9771,
                    gisGcj02Lng: 103.136,
                  },
                ],
              },
              {
                id: "620700",
                text: "张掖市",
                children: [
                  {
                    id: "620702",
                    text: "甘州区",
                    gisGcj02Lat: 38.9295,
                    gisGcj02Lng: 100.453,
                  },
                  {
                    id: "620721",
                    text: "肃南裕固族自治县",
                    gisGcj02Lat: 38.8378,
                    gisGcj02Lng: 99.6141,
                  },
                  {
                    id: "620722",
                    text: "民乐县",
                    gisGcj02Lat: 38.4348,
                    gisGcj02Lng: 100.811,
                  },
                  {
                    id: "620723",
                    text: "临泽县",
                    gisGcj02Lat: 39.1525,
                    gisGcj02Lng: 100.164,
                  },
                  {
                    id: "620724",
                    text: "高台县",
                    gisGcj02Lat: 39.3783,
                    gisGcj02Lng: 99.8192,
                  },
                  {
                    id: "620725",
                    text: "山丹县",
                    gisGcj02Lat: 38.7847,
                    gisGcj02Lng: 101.094,
                  },
                ],
              },
              {
                id: "620800",
                text: "平凉市",
                children: [
                  {
                    id: "620802",
                    text: "崆峒区",
                    gisGcj02Lat: 35.5426,
                    gisGcj02Lng: 106.675,
                  },
                  {
                    id: "620821",
                    text: "泾川县",
                    gisGcj02Lat: 35.3322,
                    gisGcj02Lng: 107.366,
                  },
                  {
                    id: "620822",
                    text: "灵台县",
                    gisGcj02Lat: 35.0677,
                    gisGcj02Lng: 107.617,
                  },
                  {
                    id: "620823",
                    text: "崇信县",
                    gisGcj02Lat: 35.3034,
                    gisGcj02Lng: 107.037,
                  },
                  {
                    id: "620824",
                    text: "华亭县",
                    gisGcj02Lat: 35.2183,
                    gisGcj02Lng: 106.655,
                  },
                  {
                    id: "620825",
                    text: "庄浪县",
                    gisGcj02Lat: 35.2024,
                    gisGcj02Lng: 106.037,
                  },
                  {
                    id: "620826",
                    text: "静宁县",
                    gisGcj02Lat: 35.5199,
                    gisGcj02Lng: 105.727,
                  },
                ],
              },
              {
                id: "620900",
                text: "酒泉市",
                children: [
                  {
                    id: "620902",
                    text: "肃州区",
                    gisGcj02Lat: 39.7451,
                    gisGcj02Lng: 98.5078,
                  },
                  {
                    id: "620921",
                    text: "金塔县",
                    gisGcj02Lat: 39.9773,
                    gisGcj02Lng: 98.9,
                  },
                  {
                    id: "620922",
                    text: "瓜州县",
                    gisGcj02Lat: 40.5155,
                    gisGcj02Lng: 95.7827,
                  },
                  {
                    id: "620923",
                    text: "肃北蒙古族自治县",
                    gisGcj02Lat: 39.5121,
                    gisGcj02Lng: 94.8765,
                  },
                  {
                    id: "620924",
                    text: "阿克塞哈萨克族自治县",
                    gisGcj02Lat: 39.6343,
                    gisGcj02Lng: 94.341,
                  },
                  {
                    id: "620981",
                    text: "玉门市",
                    gisGcj02Lat: 40.2917,
                    gisGcj02Lng: 97.0454,
                  },
                  {
                    id: "620982",
                    text: "敦煌市",
                    gisGcj02Lat: 40.1421,
                    gisGcj02Lng: 94.6616,
                  },
                ],
              },
              {
                id: "621000",
                text: "庆阳市",
                children: [
                  {
                    id: "621002",
                    text: "西峰区",
                    gisGcj02Lat: 35.7307,
                    gisGcj02Lng: 107.651,
                  },
                  {
                    id: "621021",
                    text: "庆城县",
                    gisGcj02Lat: 36.0151,
                    gisGcj02Lng: 107.883,
                  },
                  {
                    id: "621022",
                    text: "环县",
                    gisGcj02Lat: 36.5685,
                    gisGcj02Lng: 107.308,
                  },
                  {
                    id: "621023",
                    text: "华池县",
                    gisGcj02Lat: 36.4611,
                    gisGcj02Lng: 107.989,
                  },
                  {
                    id: "621024",
                    text: "合水县",
                    gisGcj02Lat: 35.8191,
                    gisGcj02Lng: 108.02,
                  },
                  {
                    id: "621025",
                    text: "正宁县",
                    gisGcj02Lat: 35.4917,
                    gisGcj02Lng: 108.36,
                  },
                  {
                    id: "621026",
                    text: "宁县",
                    gisGcj02Lat: 35.5016,
                    gisGcj02Lng: 107.925,
                  },
                  {
                    id: "621027",
                    text: "镇原县",
                    gisGcj02Lat: 35.6771,
                    gisGcj02Lng: 107.199,
                  },
                ],
              },
              {
                id: "621100",
                text: "定西市",
                children: [
                  {
                    id: "621102",
                    text: "安定区",
                    gisGcj02Lat: 35.5807,
                    gisGcj02Lng: 104.611,
                  },
                  {
                    id: "621121",
                    text: "通渭县",
                    gisGcj02Lat: 35.211,
                    gisGcj02Lng: 105.242,
                  },
                  {
                    id: "621122",
                    text: "陇西县",
                    gisGcj02Lat: 35.0024,
                    gisGcj02Lng: 104.634,
                  },
                  {
                    id: "621123",
                    text: "渭源县",
                    gisGcj02Lat: 35.1365,
                    gisGcj02Lng: 104.214,
                  },
                  {
                    id: "621124",
                    text: "临洮县",
                    gisGcj02Lat: 35.3751,
                    gisGcj02Lng: 103.862,
                  },
                  {
                    id: "621125",
                    text: "漳县",
                    gisGcj02Lat: 34.8498,
                    gisGcj02Lng: 104.467,
                  },
                  {
                    id: "621126",
                    text: "岷县",
                    gisGcj02Lat: 34.4344,
                    gisGcj02Lng: 104.038,
                  },
                ],
              },
              {
                id: "621200",
                text: "陇南市",
                children: [
                  {
                    id: "621202",
                    text: "武都区",
                    gisGcj02Lat: 33.3924,
                    gisGcj02Lng: 104.927,
                  },
                  {
                    id: "621221",
                    text: "成县",
                    gisGcj02Lat: 33.7393,
                    gisGcj02Lng: 105.726,
                  },
                  {
                    id: "621222",
                    text: "文县",
                    gisGcj02Lat: 32.9434,
                    gisGcj02Lng: 104.684,
                  },
                  {
                    id: "621223",
                    text: "宕昌县",
                    gisGcj02Lat: 34.0473,
                    gisGcj02Lng: 104.393,
                  },
                  {
                    id: "621224",
                    text: "康县",
                    gisGcj02Lat: 33.3291,
                    gisGcj02Lng: 105.607,
                  },
                  {
                    id: "621225",
                    text: "西和县",
                    gisGcj02Lat: 34.0143,
                    gisGcj02Lng: 105.301,
                  },
                  {
                    id: "621226",
                    text: "礼县",
                    gisGcj02Lat: 34.1894,
                    gisGcj02Lng: 105.178,
                  },
                  {
                    id: "621227",
                    text: "徽县",
                    gisGcj02Lat: 33.769,
                    gisGcj02Lng: 106.085,
                  },
                  {
                    id: "621228",
                    text: "两当县",
                    gisGcj02Lat: 33.9096,
                    gisGcj02Lng: 106.305,
                  },
                ],
              },
              {
                id: "622900",
                text: "临夏回族自治州",
                children: [
                  {
                    id: "622901",
                    text: "临夏市",
                    gisGcj02Lat: 35.5992,
                    gisGcj02Lng: 103.21,
                  },
                  {
                    id: "622921",
                    text: "临夏县",
                    gisGcj02Lat: 35.4952,
                    gisGcj02Lng: 102.994,
                  },
                  {
                    id: "622922",
                    text: "康乐县",
                    gisGcj02Lat: 35.3722,
                    gisGcj02Lng: 103.711,
                  },
                  {
                    id: "622923",
                    text: "永靖县",
                    gisGcj02Lat: 35.9384,
                    gisGcj02Lng: 103.32,
                  },
                  {
                    id: "622924",
                    text: "广河县",
                    gisGcj02Lat: 35.481,
                    gisGcj02Lng: 103.569,
                  },
                  {
                    id: "622925",
                    text: "和政县",
                    gisGcj02Lat: 35.4259,
                    gisGcj02Lng: 103.349,
                  },
                  {
                    id: "622926",
                    text: "东乡族自治县",
                    gisGcj02Lat: 35.6647,
                    gisGcj02Lng: 103.395,
                  },
                  {
                    id: "622927",
                    text: "积石山保安族东乡族撒拉族自治县",
                    gisGcj02Lat: 35.7182,
                    gisGcj02Lng: 102.874,
                  },
                ],
              },
              {
                id: "623000",
                text: "甘南藏族自治州",
                children: [
                  {
                    id: "623001",
                    text: "合作市",
                    gisGcj02Lat: 35.0002,
                    gisGcj02Lng: 102.911,
                  },
                  {
                    id: "623021",
                    text: "临潭县",
                    gisGcj02Lat: 34.6951,
                    gisGcj02Lng: 103.353,
                  },
                  {
                    id: "623022",
                    text: "卓尼县",
                    gisGcj02Lat: 34.5892,
                    gisGcj02Lng: 103.508,
                  },
                  {
                    id: "623023",
                    text: "舟曲县",
                    gisGcj02Lat: 33.7847,
                    gisGcj02Lng: 104.372,
                  },
                  {
                    id: "623024",
                    text: "迭部县",
                    gisGcj02Lat: 34.0562,
                    gisGcj02Lng: 103.223,
                  },
                  {
                    id: "623025",
                    text: "玛曲县",
                    gisGcj02Lat: 33.997,
                    gisGcj02Lng: 102.075,
                  },
                  {
                    id: "623026",
                    text: "碌曲县",
                    gisGcj02Lat: 34.5887,
                    gisGcj02Lng: 102.492,
                  },
                  {
                    id: "623027",
                    text: "夏河县",
                    gisGcj02Lat: 35.2049,
                    gisGcj02Lng: 102.522,
                  },
                ],
              },
            ],
          },
          {
            id: "630000",
            text: "青海省",
            children: [
              {
                id: "630100",
                text: "西宁市",
                children: [
                  {
                    id: "630102",
                    text: "城东区",
                    gisGcj02Lat: 36.5997,
                    gisGcj02Lng: 101.804,
                  },
                  {
                    id: "630103",
                    text: "城中区",
                    gisGcj02Lat: 36.6228,
                    gisGcj02Lng: 101.784,
                  },
                  {
                    id: "630104",
                    text: "城西区",
                    gisGcj02Lat: 36.6283,
                    gisGcj02Lng: 101.766,
                  },
                  {
                    id: "630105",
                    text: "城北区",
                    gisGcj02Lat: 36.6501,
                    gisGcj02Lng: 101.766,
                  },
                  {
                    id: "630121",
                    text: "大通回族土族自治县",
                    gisGcj02Lat: 36.9349,
                    gisGcj02Lng: 101.702,
                  },
                  {
                    id: "630122",
                    text: "湟中区",
                    gisGcj02Lat: 36.5008,
                    gisGcj02Lng: 101.572,
                  },
                  {
                    id: "630123",
                    text: "湟源县",
                    gisGcj02Lat: 36.6824,
                    gisGcj02Lng: 101.256,
                  },
                ],
              },
              {
                id: "630200",
                text: "海东市",
                children: [
                  {
                    id: "630202",
                    text: "乐都区",
                    gisGcj02Lat: 36.4803,
                    gisGcj02Lng: 102.402,
                  },
                  {
                    id: "630221",
                    text: "平安县",
                    gisGcj02Lat: 36.5027,
                    gisGcj02Lng: 102.104,
                  },
                  {
                    id: "630222",
                    text: "民和回族土族自治县",
                    gisGcj02Lat: 36.3295,
                    gisGcj02Lng: 102.804,
                  },
                  {
                    id: "630223",
                    text: "互助土族自治县",
                    gisGcj02Lat: 36.8399,
                    gisGcj02Lng: 101.957,
                  },
                  {
                    id: "630224",
                    text: "化隆回族自治县",
                    gisGcj02Lat: 36.0983,
                    gisGcj02Lng: 102.262,
                  },
                  {
                    id: "630225",
                    text: "循化撒拉族自治县",
                    gisGcj02Lat: 35.8472,
                    gisGcj02Lng: 102.487,
                  },
                ],
              },
              {
                id: "632200",
                text: "海北藏族自治州",
                children: [
                  {
                    id: "632221",
                    text: "门源回族自治县",
                    gisGcj02Lat: 37.3761,
                    gisGcj02Lng: 101.622,
                  },
                  {
                    id: "632222",
                    text: "祁连县",
                    gisGcj02Lat: 38.179,
                    gisGcj02Lng: 100.246,
                  },
                  {
                    id: "632223",
                    text: "海晏县",
                    gisGcj02Lat: 36.899,
                    gisGcj02Lng: 100.993,
                  },
                  {
                    id: "632224",
                    text: "刚察县",
                    gisGcj02Lat: 37.3216,
                    gisGcj02Lng: 100.147,
                  },
                ],
              },
              {
                id: "632300",
                text: "黄南藏族自治州",
                children: [
                  {
                    id: "632321",
                    text: "同仁市",
                    gisGcj02Lat: 35.516,
                    gisGcj02Lng: 102.018,
                  },
                  {
                    id: "632322",
                    text: "尖扎县",
                    gisGcj02Lat: 35.9395,
                    gisGcj02Lng: 102.034,
                  },
                  {
                    id: "632323",
                    text: "泽库县",
                    gisGcj02Lat: 35.0352,
                    gisGcj02Lng: 101.464,
                  },
                  {
                    id: "632324",
                    text: "河南蒙古族自治县",
                    gisGcj02Lat: 34.7348,
                    gisGcj02Lng: 101.609,
                  },
                ],
              },
              {
                id: "632500",
                text: "海南藏族自治州",
                children: [
                  {
                    id: "632521",
                    text: "共和县",
                    gisGcj02Lat: 36.2841,
                    gisGcj02Lng: 100.62,
                  },
                  {
                    id: "632522",
                    text: "同德县",
                    gisGcj02Lat: 35.2549,
                    gisGcj02Lng: 100.572,
                  },
                  {
                    id: "632523",
                    text: "贵德县",
                    gisGcj02Lat: 36.044,
                    gisGcj02Lng: 101.432,
                  },
                  {
                    id: "632524",
                    text: "兴海县",
                    gisGcj02Lat: 35.5903,
                    gisGcj02Lng: 99.9885,
                  },
                  {
                    id: "632525",
                    text: "贵南县",
                    gisGcj02Lat: 35.5867,
                    gisGcj02Lng: 100.747,
                  },
                ],
              },
              {
                id: "632600",
                text: "果洛藏族自治州",
                children: [
                  {
                    id: "632621",
                    text: "玛沁县",
                    gisGcj02Lat: 34.4775,
                    gisGcj02Lng: 100.239,
                  },
                  {
                    id: "632622",
                    text: "班玛县",
                    gisGcj02Lat: 32.9325,
                    gisGcj02Lng: 100.737,
                  },
                  {
                    id: "632623",
                    text: "甘德县",
                    gisGcj02Lat: 33.9684,
                    gisGcj02Lng: 99.9025,
                  },
                  {
                    id: "632624",
                    text: "达日县",
                    gisGcj02Lat: 33.7519,
                    gisGcj02Lng: 99.6518,
                  },
                  {
                    id: "632625",
                    text: "久治县",
                    gisGcj02Lat: 33.4299,
                    gisGcj02Lng: 101.483,
                  },
                  {
                    id: "632626",
                    text: "玛多县",
                    gisGcj02Lat: 34.9157,
                    gisGcj02Lng: 98.21,
                  },
                ],
              },
              {
                id: "632700",
                text: "玉树藏族自治州",
                children: [
                  {
                    id: "632701",
                    text: "玉树市",
                    gisGcj02Lat: 33.0039,
                    gisGcj02Lng: 97.0088,
                  },
                  {
                    id: "632722",
                    text: "杂多县",
                    gisGcj02Lat: 32.8932,
                    gisGcj02Lng: 95.2986,
                  },
                  {
                    id: "632723",
                    text: "称多县",
                    gisGcj02Lat: 33.369,
                    gisGcj02Lng: 97.1079,
                  },
                  {
                    id: "632724",
                    text: "治多县",
                    gisGcj02Lat: 33.8528,
                    gisGcj02Lng: 95.6157,
                  },
                  {
                    id: "632725",
                    text: "囊谦县",
                    gisGcj02Lat: 32.2036,
                    gisGcj02Lng: 96.4775,
                  },
                  {
                    id: "632726",
                    text: "曲麻莱县",
                    gisGcj02Lat: 34.1261,
                    gisGcj02Lng: 95.7976,
                  },
                ],
              },
              {
                id: "632800",
                text: "海西蒙古族藏族自治州",
                children: [
                  {
                    id: "632801",
                    text: "格尔木市",
                    gisGcj02Lat: 36.4024,
                    gisGcj02Lng: 94.9033,
                  },
                  {
                    id: "632802",
                    text: "德令哈市",
                    gisGcj02Lat: 37.3695,
                    gisGcj02Lng: 97.3608,
                  },
                  {
                    id: "632821",
                    text: "乌兰县",
                    gisGcj02Lat: 36.9347,
                    gisGcj02Lng: 98.482,
                  },
                  {
                    id: "632822",
                    text: "都兰县",
                    gisGcj02Lat: 36.3013,
                    gisGcj02Lng: 98.0923,
                  },
                  {
                    id: "632823",
                    text: "天峻县",
                    gisGcj02Lat: 37.3033,
                    gisGcj02Lng: 99.0245,
                  },
                ],
              },
            ],
          },
          {
            id: "640000",
            text: "宁夏",
            children: [
              {
                id: "640100",
                text: "银川市",
                children: [
                  {
                    id: "640104",
                    text: "兴庆区",
                    gisGcj02Lat: 38.4739,
                    gisGcj02Lng: 106.289,
                  },
                  {
                    id: "640105",
                    text: "西夏区",
                    gisGcj02Lat: 38.4914,
                    gisGcj02Lng: 106.15,
                  },
                  {
                    id: "640106",
                    text: "金凤区",
                    gisGcj02Lat: 38.4729,
                    gisGcj02Lng: 106.243,
                  },
                  {
                    id: "640121",
                    text: "永宁县",
                    gisGcj02Lat: 38.2756,
                    gisGcj02Lng: 106.252,
                  },
                  {
                    id: "640122",
                    text: "贺兰县",
                    gisGcj02Lat: 38.5544,
                    gisGcj02Lng: 106.35,
                  },
                  {
                    id: "640181",
                    text: "灵武市",
                    gisGcj02Lat: 38.1027,
                    gisGcj02Lng: 106.34,
                  },
                ],
              },
              {
                id: "640200",
                text: "石嘴山市",
                children: [
                  {
                    id: "640202",
                    text: "大武口区",
                    gisGcj02Lat: 39.0123,
                    gisGcj02Lng: 106.377,
                  },
                  {
                    id: "640205",
                    text: "惠农区",
                    gisGcj02Lat: 39.1319,
                    gisGcj02Lng: 106.711,
                  },
                  {
                    id: "640221",
                    text: "平罗县",
                    gisGcj02Lat: 38.9043,
                    gisGcj02Lng: 106.545,
                  },
                ],
              },
              {
                id: "640300",
                text: "吴忠市",
                children: [
                  {
                    id: "640302",
                    text: "利通区",
                    gisGcj02Lat: 37.9851,
                    gisGcj02Lng: 106.203,
                  },
                  {
                    id: "640303",
                    text: "红寺堡区",
                    gisGcj02Lat: 37.9975,
                    gisGcj02Lng: 106.198,
                  },
                  {
                    id: "640323",
                    text: "盐池县",
                    gisGcj02Lat: 37.7833,
                    gisGcj02Lng: 107.407,
                  },
                  {
                    id: "640324",
                    text: "同心县",
                    gisGcj02Lat: 36.9812,
                    gisGcj02Lng: 105.914,
                  },
                  {
                    id: "640381",
                    text: "青铜峡市",
                    gisGcj02Lat: 38.02,
                    gisGcj02Lng: 106.075,
                  },
                ],
              },
              {
                id: "640400",
                text: "固原市",
                children: [
                  {
                    id: "640402",
                    text: "原州区",
                    gisGcj02Lat: 36.0037,
                    gisGcj02Lng: 106.288,
                  },
                  {
                    id: "640422",
                    text: "西吉县",
                    gisGcj02Lat: 35.9662,
                    gisGcj02Lng: 105.731,
                  },
                  {
                    id: "640423",
                    text: "隆德县",
                    gisGcj02Lat: 35.6172,
                    gisGcj02Lng: 106.124,
                  },
                  {
                    id: "640424",
                    text: "泾源县",
                    gisGcj02Lat: 35.4907,
                    gisGcj02Lng: 106.339,
                  },
                  {
                    id: "640425",
                    text: "彭阳县",
                    gisGcj02Lat: 35.8508,
                    gisGcj02Lng: 106.645,
                  },
                ],
              },
              {
                id: "640500",
                text: "中卫市",
                children: [
                  {
                    id: "640502",
                    text: "沙坡头区",
                    gisGcj02Lat: 37.5104,
                    gisGcj02Lng: 105.19,
                  },
                  {
                    id: "640521",
                    text: "中宁县",
                    gisGcj02Lat: 37.4915,
                    gisGcj02Lng: 105.685,
                  },
                  {
                    id: "640522",
                    text: "海原县",
                    gisGcj02Lat: 36.565,
                    gisGcj02Lng: 105.647,
                  },
                ],
              },
            ],
          },
          {
            id: "650000",
            text: "新疆",
            children: [
              {
                id: "650100",
                text: "乌鲁木齐市",
                children: [
                  {
                    id: "650102",
                    text: "天山区",
                    gisGcj02Lat: 43.7944,
                    gisGcj02Lng: 87.6317,
                  },
                  {
                    id: "650103",
                    text: "沙依巴克区",
                    gisGcj02Lat: 43.8012,
                    gisGcj02Lng: 87.5979,
                  },
                  {
                    id: "650104",
                    text: "新市区",
                    gisGcj02Lat: 43.8435,
                    gisGcj02Lng: 87.5741,
                  },
                  {
                    id: "650105",
                    text: "水磨沟区",
                    gisGcj02Lat: 43.8325,
                    gisGcj02Lng: 87.6425,
                  },
                  {
                    id: "650106",
                    text: "头屯河区",
                    gisGcj02Lat: 43.8549,
                    gisGcj02Lng: 87.2914,
                  },
                  {
                    id: "650107",
                    text: "达坂城区",
                    gisGcj02Lat: 43.358,
                    gisGcj02Lng: 88.307,
                  },
                  {
                    id: "650109",
                    text: "米东区",
                    gisGcj02Lat: 43.9474,
                    gisGcj02Lng: 87.6858,
                  },
                  {
                    id: "650110",
                    text: "南山矿区",
                    gisGcj02Lat: 43.9474,
                    gisGcj02Lng: 87.6858,
                  },
                  {
                    id: "650111",
                    text: "东山区",
                    gisGcj02Lat: 43.9474,
                    gisGcj02Lng: 87.6858,
                  },
                  {
                    id: "650121",
                    text: "乌鲁木齐县",
                    gisGcj02Lat: 43.4712,
                    gisGcj02Lng: 87.4094,
                  },
                ],
              },
              {
                id: "650200",
                text: "克拉玛依市",
                children: [
                  {
                    id: "650202",
                    text: "独山子区",
                    gisGcj02Lat: 44.3287,
                    gisGcj02Lng: 84.8867,
                  },
                  {
                    id: "650203",
                    text: "克拉玛依区",
                    gisGcj02Lat: 45.5909,
                    gisGcj02Lng: 84.8623,
                  },
                  {
                    id: "650204",
                    text: "白碱滩区",
                    gisGcj02Lat: 45.6877,
                    gisGcj02Lng: 85.1324,
                  },
                  {
                    id: "650205",
                    text: "乌尔禾区",
                    gisGcj02Lat: 46.0901,
                    gisGcj02Lng: 85.6914,
                  },
                ],
              },
              {
                id: "652100",
                text: "吐鲁番地区",
                children: [
                  {
                    id: "652101",
                    text: "吐鲁番市",
                    gisGcj02Lat: 42.9351,
                    gisGcj02Lng: 89.1858,
                  },
                  {
                    id: "652122",
                    text: "鄯善县",
                    gisGcj02Lat: 42.8635,
                    gisGcj02Lng: 90.214,
                  },
                  {
                    id: "652123",
                    text: "托克逊县",
                    gisGcj02Lat: 42.7923,
                    gisGcj02Lng: 88.6582,
                  },
                ],
              },
              {
                id: "652200",
                text: "哈密地区",
                children: [
                  {
                    id: "652201",
                    text: "哈密市",
                    gisGcj02Lat: 42.827,
                    gisGcj02Lng: 93.5145,
                  },
                  {
                    id: "652222",
                    text: "巴里坤哈萨克自治县",
                    gisGcj02Lat: 43.5999,
                    gisGcj02Lng: 93.0124,
                  },
                  {
                    id: "652223",
                    text: "伊吾县",
                    gisGcj02Lat: 43.2537,
                    gisGcj02Lng: 94.694,
                  },
                ],
              },
              {
                id: "652300",
                text: "昌吉回族自治州",
                children: [
                  {
                    id: "652301",
                    text: "昌吉市",
                    gisGcj02Lat: 44.0127,
                    gisGcj02Lng: 87.3025,
                  },
                  {
                    id: "652302",
                    text: "阜康市",
                    gisGcj02Lat: 44.1584,
                    gisGcj02Lng: 87.9853,
                  },
                  {
                    id: "652323",
                    text: "呼图壁县",
                    gisGcj02Lat: 44.1898,
                    gisGcj02Lng: 86.8989,
                  },
                  {
                    id: "652324",
                    text: "玛纳斯县",
                    gisGcj02Lat: 44.3044,
                    gisGcj02Lng: 86.2145,
                  },
                  {
                    id: "652325",
                    text: "奇台县",
                    gisGcj02Lat: 44.0222,
                    gisGcj02Lng: 89.5932,
                  },
                  {
                    id: "652327",
                    text: "吉木萨尔县",
                    gisGcj02Lat: 44.0005,
                    gisGcj02Lng: 89.1808,
                  },
                  {
                    id: "652328",
                    text: "木垒哈萨克自治县",
                    gisGcj02Lat: 43.8351,
                    gisGcj02Lng: 90.289,
                  },
                ],
              },
              {
                id: "652700",
                text: "博尔塔拉蒙古自治州",
                children: [
                  {
                    id: "652701",
                    text: "博乐市",
                    gisGcj02Lat: 44.9005,
                    gisGcj02Lng: 82.0713,
                  },
                  {
                    id: "652702",
                    text: "阿拉山口市",
                    gisGcj02Lat: 45.1706,
                    gisGcj02Lng: 82.5677,
                  },
                  {
                    id: "652722",
                    text: "精河县",
                    gisGcj02Lat: 44.6077,
                    gisGcj02Lng: 82.8942,
                  },
                  {
                    id: "652723",
                    text: "温泉县",
                    gisGcj02Lat: 44.9737,
                    gisGcj02Lng: 81.0313,
                  },
                ],
              },
              {
                id: "652800",
                text: "巴音郭楞蒙古自治州",
                children: [
                  {
                    id: "652801",
                    text: "库尔勒市",
                    gisGcj02Lat: 41.766,
                    gisGcj02Lng: 86.1553,
                  },
                  {
                    id: "652822",
                    text: "轮台县",
                    gisGcj02Lat: 41.7764,
                    gisGcj02Lng: 84.261,
                  },
                  {
                    id: "652823",
                    text: "尉犁县",
                    gisGcj02Lat: 41.3363,
                    gisGcj02Lng: 86.259,
                  },
                  {
                    id: "652824",
                    text: "若羌县",
                    gisGcj02Lat: 39.0179,
                    gisGcj02Lng: 88.1681,
                  },
                  {
                    id: "652825",
                    text: "且末县",
                    gisGcj02Lat: 38.1453,
                    gisGcj02Lng: 85.5297,
                  },
                  {
                    id: "652826",
                    text: "焉耆回族自治县",
                    gisGcj02Lat: 42.059,
                    gisGcj02Lng: 86.5744,
                  },
                  {
                    id: "652827",
                    text: "和静县",
                    gisGcj02Lat: 42.3184,
                    gisGcj02Lng: 86.3961,
                  },
                  {
                    id: "652828",
                    text: "和硕县",
                    gisGcj02Lat: 42.2681,
                    gisGcj02Lng: 86.8639,
                  },
                  {
                    id: "652829",
                    text: "博湖县",
                    gisGcj02Lat: 41.9801,
                    gisGcj02Lng: 86.6333,
                  },
                ],
              },
              {
                id: "652900",
                text: "阿克苏地区",
                children: [
                  {
                    id: "652901",
                    text: "阿克苏市",
                    gisGcj02Lat: 41.1675,
                    gisGcj02Lng: 80.2634,
                  },
                  {
                    id: "652922",
                    text: "温宿县",
                    gisGcj02Lat: 41.2768,
                    gisGcj02Lng: 80.2417,
                  },
                  {
                    id: "652923",
                    text: "库车市",
                    gisGcj02Lat: 41.7179,
                    gisGcj02Lng: 82.9621,
                  },
                  {
                    id: "652924",
                    text: "沙雅县",
                    gisGcj02Lat: 41.225,
                    gisGcj02Lng: 82.7813,
                  },
                  {
                    id: "652925",
                    text: "新和县",
                    gisGcj02Lat: 41.5496,
                    gisGcj02Lng: 82.6105,
                  },
                  {
                    id: "652926",
                    text: "拜城县",
                    gisGcj02Lat: 41.798,
                    gisGcj02Lng: 81.8756,
                  },
                  {
                    id: "652927",
                    text: "乌什县",
                    gisGcj02Lat: 41.2157,
                    gisGcj02Lng: 79.2294,
                  },
                  {
                    id: "652928",
                    text: "阿瓦提县",
                    gisGcj02Lat: 40.6393,
                    gisGcj02Lng: 80.3834,
                  },
                  {
                    id: "652929",
                    text: "柯坪县",
                    gisGcj02Lat: 40.5059,
                    gisGcj02Lng: 79.0475,
                  },
                ],
              },
              {
                id: "653000",
                text: "克孜勒苏柯尔克孜自治州",
                children: [
                  {
                    id: "653001",
                    text: "阿图什市",
                    gisGcj02Lat: 39.7161,
                    gisGcj02Lng: 76.1683,
                  },
                  {
                    id: "653022",
                    text: "阿克陶县",
                    gisGcj02Lat: 39.1489,
                    gisGcj02Lng: 75.9469,
                  },
                  {
                    id: "653023",
                    text: "阿合奇县",
                    gisGcj02Lat: 40.9395,
                    gisGcj02Lng: 78.4485,
                  },
                  {
                    id: "653024",
                    text: "乌恰县",
                    gisGcj02Lat: 39.7198,
                    gisGcj02Lng: 75.2584,
                  },
                ],
              },
              {
                id: "653100",
                text: "喀什地区",
                children: [
                  {
                    id: "653101",
                    text: "喀什市",
                    gisGcj02Lat: 39.4677,
                    gisGcj02Lng: 75.9938,
                  },
                  {
                    id: "653121",
                    text: "疏附县",
                    gisGcj02Lat: 39.3753,
                    gisGcj02Lng: 75.8603,
                  },
                  {
                    id: "653122",
                    text: "疏勒县",
                    gisGcj02Lat: 39.4062,
                    gisGcj02Lng: 76.054,
                  },
                  {
                    id: "653123",
                    text: "英吉沙县",
                    gisGcj02Lat: 38.9297,
                    gisGcj02Lng: 76.1757,
                  },
                  {
                    id: "653124",
                    text: "泽普县",
                    gisGcj02Lat: 38.1894,
                    gisGcj02Lng: 77.2714,
                  },
                  {
                    id: "653125",
                    text: "莎车县",
                    gisGcj02Lat: 38.416,
                    gisGcj02Lng: 77.2432,
                  },
                  {
                    id: "653126",
                    text: "叶城县",
                    gisGcj02Lat: 37.8832,
                    gisGcj02Lng: 77.4166,
                  },
                  {
                    id: "653127",
                    text: "麦盖提县",
                    gisGcj02Lat: 38.8966,
                    gisGcj02Lng: 77.6422,
                  },
                  {
                    id: "653128",
                    text: "岳普湖县",
                    gisGcj02Lat: 39.2356,
                    gisGcj02Lng: 76.7723,
                  },
                  {
                    id: "653129",
                    text: "伽师县",
                    gisGcj02Lat: 39.488,
                    gisGcj02Lng: 76.7237,
                  },
                  {
                    id: "653130",
                    text: "巴楚县",
                    gisGcj02Lat: 39.7855,
                    gisGcj02Lng: 78.5489,
                  },
                  {
                    id: "653131",
                    text: "塔什库尔干塔吉克自治县",
                    gisGcj02Lat: 37.7789,
                    gisGcj02Lng: 75.232,
                  },
                ],
              },
              {
                id: "653200",
                text: "和田地区",
                children: [
                  {
                    id: "653201",
                    text: "和田市",
                    gisGcj02Lat: 37.1121,
                    gisGcj02Lng: 79.9135,
                  },
                  {
                    id: "653221",
                    text: "和田县",
                    gisGcj02Lat: 37.0892,
                    gisGcj02Lng: 79.8287,
                  },
                  {
                    id: "653222",
                    text: "墨玉县",
                    gisGcj02Lat: 37.2725,
                    gisGcj02Lng: 79.7403,
                  },
                  {
                    id: "653223",
                    text: "皮山县",
                    gisGcj02Lat: 37.6201,
                    gisGcj02Lng: 78.2812,
                  },
                  {
                    id: "653224",
                    text: "洛浦县",
                    gisGcj02Lat: 37.0736,
                    gisGcj02Lng: 80.1854,
                  },
                  {
                    id: "653225",
                    text: "策勒县",
                    gisGcj02Lat: 36.9984,
                    gisGcj02Lng: 80.81,
                  },
                  {
                    id: "653226",
                    text: "于田县",
                    gisGcj02Lat: 36.854,
                    gisGcj02Lng: 81.6672,
                  },
                  {
                    id: "653227",
                    text: "民丰县",
                    gisGcj02Lat: 37.0658,
                    gisGcj02Lng: 82.6844,
                  },
                ],
              },
              {
                id: "654000",
                text: "伊犁哈萨克自治州",
                children: [
                  {
                    id: "654002",
                    text: "伊宁市",
                    gisGcj02Lat: 43.9129,
                    gisGcj02Lng: 81.3293,
                  },
                  {
                    id: "654003",
                    text: "奎屯市",
                    gisGcj02Lat: 44.425,
                    gisGcj02Lng: 84.9023,
                  },
                  {
                    id: "654004",
                    text: "霍尔果斯市",
                    gisGcj02Lat: 44.2058,
                    gisGcj02Lng: 80.4182,
                  },
                  {
                    id: "654021",
                    text: "伊宁县",
                    gisGcj02Lat: 43.9786,
                    gisGcj02Lng: 81.5276,
                  },
                  {
                    id: "654022",
                    text: "察布查尔锡伯自治县",
                    gisGcj02Lat: 43.8402,
                    gisGcj02Lng: 81.1496,
                  },
                  {
                    id: "654023",
                    text: "霍城县",
                    gisGcj02Lat: 44.0533,
                    gisGcj02Lng: 80.8783,
                  },
                  {
                    id: "654024",
                    text: "巩留县",
                    gisGcj02Lat: 43.4843,
                    gisGcj02Lng: 82.2285,
                  },
                  {
                    id: "654025",
                    text: "新源县",
                    gisGcj02Lat: 43.4284,
                    gisGcj02Lng: 83.2609,
                  },
                  {
                    id: "654026",
                    text: "昭苏县",
                    gisGcj02Lat: 43.1583,
                    gisGcj02Lng: 81.1307,
                  },
                  {
                    id: "654027",
                    text: "特克斯县",
                    gisGcj02Lat: 43.2194,
                    gisGcj02Lng: 81.84,
                  },
                  {
                    id: "654028",
                    text: "尼勒克县",
                    gisGcj02Lat: 43.799,
                    gisGcj02Lng: 82.5118,
                  },
                ],
              },
              {
                id: "654200",
                text: "塔城地区",
                children: [
                  {
                    id: "654201",
                    text: "塔城市",
                    gisGcj02Lat: 46.7485,
                    gisGcj02Lng: 82.9789,
                  },
                  {
                    id: "654202",
                    text: "乌苏市",
                    gisGcj02Lat: 44.4373,
                    gisGcj02Lng: 84.6826,
                  },
                  {
                    id: "654221",
                    text: "额敏县",
                    gisGcj02Lat: 46.5284,
                    gisGcj02Lng: 83.6287,
                  },
                  {
                    id: "654223",
                    text: "沙湾市",
                    gisGcj02Lat: 44.3314,
                    gisGcj02Lng: 85.6193,
                  },
                  {
                    id: "654224",
                    text: "托里县",
                    gisGcj02Lat: 45.9362,
                    gisGcj02Lng: 83.6059,
                  },
                  {
                    id: "654225",
                    text: "裕民县",
                    gisGcj02Lat: 46.2038,
                    gisGcj02Lng: 82.99,
                  },
                  {
                    id: "654226",
                    text: "和布克赛尔蒙古自治县",
                    gisGcj02Lat: 46.7936,
                    gisGcj02Lng: 85.7266,
                  },
                ],
              },
              {
                id: "654300",
                text: "阿勒泰地区",
                children: [
                  {
                    id: "654301",
                    text: "阿勒泰市",
                    gisGcj02Lat: 47.8317,
                    gisGcj02Lng: 88.1391,
                  },
                  {
                    id: "654321",
                    text: "布尔津县",
                    gisGcj02Lat: 47.7006,
                    gisGcj02Lng: 86.8575,
                  },
                  {
                    id: "654322",
                    text: "富蕴县",
                    gisGcj02Lat: 46.9944,
                    gisGcj02Lng: 89.5268,
                  },
                  {
                    id: "654323",
                    text: "福海县",
                    gisGcj02Lat: 47.1106,
                    gisGcj02Lng: 87.4951,
                  },
                  {
                    id: "654324",
                    text: "哈巴河县",
                    gisGcj02Lat: 48.0605,
                    gisGcj02Lng: 86.4209,
                  },
                  {
                    id: "654325",
                    text: "青河县",
                    gisGcj02Lat: 46.6738,
                    gisGcj02Lng: 90.383,
                  },
                  {
                    id: "654326",
                    text: "吉木乃县",
                    gisGcj02Lat: 47.4336,
                    gisGcj02Lng: 85.8781,
                  },
                ],
              },
              {
                id: "659000",
                text: "直辖县级",
                children: [
                  {
                    id: "659010",
                    text: "胡杨河市",
                    gisGcj02Lat: 44.7228,
                    gisGcj02Lng: 84.8399,
                  },
                  {
                    id: "659011",
                    text: "新星市",
                    gisGcj02Lat: 42.8029,
                    gisGcj02Lng: 93.755,
                  },
                  {
                    id: "659001",
                    text: "石河子市",
                    gisGcj02Lat: 44.3059,
                    gisGcj02Lng: 86.0411,
                  },
                  {
                    id: "659002",
                    text: "阿拉尔市",
                    gisGcj02Lat: 40.5419,
                    gisGcj02Lng: 81.2859,
                  },
                  {
                    id: "659003",
                    text: "图木舒克市",
                    gisGcj02Lat: 39.8673,
                    gisGcj02Lng: 79.078,
                  },
                  {
                    id: "659004",
                    text: "五家渠市",
                    gisGcj02Lat: 44.1674,
                    gisGcj02Lng: 87.5269,
                  },
                  {
                    id: "659005",
                    text: "北屯市",
                    gisGcj02Lat: 47.3623,
                    gisGcj02Lng: 87.8085,
                  },
                  {
                    id: "659006",
                    text: "铁门关市",
                    gisGcj02Lat: 41.811,
                    gisGcj02Lng: 86.1947,
                  },
                  {
                    id: "659007",
                    text: "双河市",
                    gisGcj02Lat: 29.6604,
                    gisGcj02Lng: 91.1322,
                  },
                ],
              },
            ],
          },
          {
            id: "710000",
            text: "台湾省",
            children: [
              {
                id: "710100",
                text: "台北市",
                children: [
                  {
                    id: "710101",
                    text: "松山区",
                    gisGcj02Lat: 25.0497,
                    gisGcj02Lng: 121.577,
                  },
                  {
                    id: "710102",
                    text: "信义区",
                    gisGcj02Lat: 25.1294,
                    gisGcj02Lng: 121.751,
                  },
                  {
                    id: "710103",
                    text: "大安区",
                    gisGcj02Lat: 25.0264,
                    gisGcj02Lng: 121.535,
                  },
                  {
                    id: "710104",
                    text: "中山区",
                    gisGcj02Lat: 25.0644,
                    gisGcj02Lng: 121.533,
                  },
                  {
                    id: "710105",
                    text: "中正区",
                    gisGcj02Lat: 25.0324,
                    gisGcj02Lng: 121.518,
                  },
                  {
                    id: "710106",
                    text: "大同区",
                    gisGcj02Lat: 25.066,
                    gisGcj02Lng: 121.516,
                  },
                  {
                    id: "710107",
                    text: "万华区",
                    gisGcj02Lat: 25.0319,
                    gisGcj02Lng: 121.499,
                  },
                  {
                    id: "710108",
                    text: "文山区",
                    gisGcj02Lat: 24.9898,
                    gisGcj02Lng: 121.57,
                  },
                  {
                    id: "710109",
                    text: "南港区",
                    gisGcj02Lat: 25.0547,
                    gisGcj02Lng: 121.607,
                  },
                  {
                    id: "710110",
                    text: "内湖区",
                    gisGcj02Lat: 25.0697,
                    gisGcj02Lng: 121.589,
                  },
                  {
                    id: "710111",
                    text: "士林区",
                    gisGcj02Lat: 25.0928,
                    gisGcj02Lng: 121.52,
                  },
                  {
                    id: "710112",
                    text: "北投区",
                    gisGcj02Lat: 25.1324,
                    gisGcj02Lng: 121.501,
                  },
                ],
              },
              {
                id: "710200",
                text: "高雄市",
                children: [
                  {
                    id: "710201",
                    text: "盐埕区",
                    gisGcj02Lat: 22.6247,
                    gisGcj02Lng: 120.287,
                  },
                  {
                    id: "710202",
                    text: "鼓山区",
                    gisGcj02Lat: 22.6368,
                    gisGcj02Lng: 120.281,
                  },
                  {
                    id: "710203",
                    text: "左营区",
                    gisGcj02Lat: 22.6901,
                    gisGcj02Lng: 120.295,
                  },
                  {
                    id: "710204",
                    text: "楠梓区",
                    gisGcj02Lat: 22.7284,
                    gisGcj02Lng: 120.326,
                  },
                  {
                    id: "710205",
                    text: "三民区",
                    gisGcj02Lat: 22.6477,
                    gisGcj02Lng: 120.3,
                  },
                  {
                    id: "710206",
                    text: "新兴区",
                    gisGcj02Lat: 22.6311,
                    gisGcj02Lng: 120.31,
                  },
                  {
                    id: "710207",
                    text: "前金区",
                    gisGcj02Lat: 22.6274,
                    gisGcj02Lng: 120.294,
                  },
                  {
                    id: "710208",
                    text: "苓雅区",
                    gisGcj02Lat: 22.6218,
                    gisGcj02Lng: 120.312,
                  },
                  {
                    id: "710209",
                    text: "前镇区",
                    gisGcj02Lat: 22.5864,
                    gisGcj02Lng: 120.319,
                  },
                  {
                    id: "710210",
                    text: "旗津区",
                    gisGcj02Lat: 22.5906,
                    gisGcj02Lng: 120.284,
                  },
                  {
                    id: "710211",
                    text: "小港区",
                    gisGcj02Lat: 22.5654,
                    gisGcj02Lng: 120.338,
                  },
                  {
                    id: "710212",
                    text: "凤山区",
                    gisGcj02Lat: 22.6269,
                    gisGcj02Lng: 120.357,
                  },
                  {
                    id: "710213",
                    text: "林园区",
                    gisGcj02Lat: 22.5015,
                    gisGcj02Lng: 120.396,
                  },
                  {
                    id: "710214",
                    text: "大寮区",
                    gisGcj02Lat: 22.6054,
                    gisGcj02Lng: 120.395,
                  },
                  {
                    id: "710215",
                    text: "大树区",
                    gisGcj02Lat: 22.6934,
                    gisGcj02Lng: 120.433,
                  },
                  {
                    id: "710216",
                    text: "大社区",
                    gisGcj02Lat: 22.73,
                    gisGcj02Lng: 120.347,
                  },
                  {
                    id: "710217",
                    text: "仁武区",
                    gisGcj02Lat: 22.7019,
                    gisGcj02Lng: 120.348,
                  },
                  {
                    id: "710218",
                    text: "鸟松区",
                    gisGcj02Lat: 22.6593,
                    gisGcj02Lng: 120.364,
                  },
                  {
                    id: "710219",
                    text: "冈山区",
                    gisGcj02Lat: 22.7968,
                    gisGcj02Lng: 120.296,
                  },
                  {
                    id: "710220",
                    text: "桥头区",
                    gisGcj02Lat: 22.7575,
                    gisGcj02Lng: 120.306,
                  },
                  {
                    id: "710221",
                    text: "燕巢区",
                    gisGcj02Lat: 22.7934,
                    gisGcj02Lng: 120.362,
                  },
                  {
                    id: "710222",
                    text: "田寮区",
                    gisGcj02Lat: 22.8693,
                    gisGcj02Lng: 120.36,
                  },
                  {
                    id: "710223",
                    text: "阿莲区",
                    gisGcj02Lat: 22.8837,
                    gisGcj02Lng: 120.327,
                  },
                  {
                    id: "710224",
                    text: "路竹区",
                    gisGcj02Lat: 22.8569,
                    gisGcj02Lng: 120.262,
                  },
                  {
                    id: "710225",
                    text: "湖内区",
                    gisGcj02Lat: 22.9082,
                    gisGcj02Lng: 120.212,
                  },
                  {
                    id: "710226",
                    text: "茄萣区",
                    gisGcj02Lat: 22.9066,
                    gisGcj02Lng: 120.183,
                  },
                  {
                    id: "710227",
                    text: "永安区",
                    gisGcj02Lat: 22.8186,
                    gisGcj02Lng: 120.225,
                  },
                  {
                    id: "710228",
                    text: "弥陀区",
                    gisGcj02Lat: 22.7829,
                    gisGcj02Lng: 120.247,
                  },
                  {
                    id: "710229",
                    text: "梓官区",
                    gisGcj02Lat: 22.7605,
                    gisGcj02Lng: 120.267,
                  },
                  {
                    id: "710230",
                    text: "旗山区",
                    gisGcj02Lat: 22.8885,
                    gisGcj02Lng: 120.484,
                  },
                  {
                    id: "710231",
                    text: "美浓区",
                    gisGcj02Lat: 22.8979,
                    gisGcj02Lng: 120.542,
                  },
                  {
                    id: "710232",
                    text: "六龟区",
                    gisGcj02Lat: 22.9979,
                    gisGcj02Lng: 120.633,
                  },
                  {
                    id: "710233",
                    text: "甲仙区",
                    gisGcj02Lat: 23.0847,
                    gisGcj02Lng: 120.591,
                  },
                  {
                    id: "710234",
                    text: "杉林区",
                    gisGcj02Lat: 22.9707,
                    gisGcj02Lng: 120.539,
                  },
                  {
                    id: "710235",
                    text: "内门区",
                    gisGcj02Lat: 22.9434,
                    gisGcj02Lng: 120.462,
                  },
                  {
                    id: "710236",
                    text: "茂林区",
                    gisGcj02Lat: 22.8862,
                    gisGcj02Lng: 120.663,
                  },
                  {
                    id: "710237",
                    text: "桃源区",
                    gisGcj02Lat: 23.1591,
                    gisGcj02Lng: 120.76,
                  },
                  {
                    id: "710238",
                    text: "那玛夏区",
                    gisGcj02Lat: 23.217,
                    gisGcj02Lng: 120.693,
                  },
                ],
              },
              {
                id: "710300",
                text: "基隆市",
                children: [
                  {
                    id: "710301",
                    text: "中正区",
                    gisGcj02Lat: 25.0324,
                    gisGcj02Lng: 121.518,
                  },
                  {
                    id: "710302",
                    text: "七堵区",
                    gisGcj02Lat: 25.0957,
                    gisGcj02Lng: 121.713,
                  },
                  {
                    id: "710303",
                    text: "暖暖区",
                    gisGcj02Lat: 25.0998,
                    gisGcj02Lng: 121.736,
                  },
                  {
                    id: "710304",
                    text: "仁爱区",
                    gisGcj02Lat: 25.1275,
                    gisGcj02Lng: 121.741,
                  },
                  {
                    id: "710305",
                    text: "中山区",
                    gisGcj02Lat: 25.134,
                    gisGcj02Lng: 121.739,
                  },
                  {
                    id: "710306",
                    text: "安乐区",
                    gisGcj02Lat: 25.1209,
                    gisGcj02Lng: 121.723,
                  },
                  {
                    id: "710307",
                    text: "信义区",
                    gisGcj02Lat: 25.1294,
                    gisGcj02Lng: 121.751,
                  },
                ],
              },
              {
                id: "710400",
                text: "台中市",
                children: [
                  {
                    id: "710401",
                    text: "中区",
                    gisGcj02Lat: 24.1438,
                    gisGcj02Lng: 120.68,
                  },
                  {
                    id: "710402",
                    text: "东区",
                    gisGcj02Lat: 24.1366,
                    gisGcj02Lng: 120.704,
                  },
                  {
                    id: "710403",
                    text: "南区",
                    gisGcj02Lat: 22.9609,
                    gisGcj02Lng: 120.189,
                  },
                  {
                    id: "710404",
                    text: "西区",
                    gisGcj02Lat: 24.1414,
                    gisGcj02Lng: 120.671,
                  },
                  {
                    id: "710405",
                    text: "北区",
                    gisGcj02Lat: 24.166,
                    gisGcj02Lng: 120.682,
                  },
                  {
                    id: "710406",
                    text: "西屯区",
                    gisGcj02Lat: 24.1813,
                    gisGcj02Lng: 120.64,
                  },
                  {
                    id: "710407",
                    text: "南屯区",
                    gisGcj02Lat: 24.1383,
                    gisGcj02Lng: 120.643,
                  },
                  {
                    id: "710408",
                    text: "北屯区",
                    gisGcj02Lat: 24.1822,
                    gisGcj02Lng: 120.686,
                  },
                  {
                    id: "710409",
                    text: "丰原区",
                    gisGcj02Lat: 24.2422,
                    gisGcj02Lng: 120.718,
                  },
                  {
                    id: "710410",
                    text: "东势区",
                    gisGcj02Lat: 24.2586,
                    gisGcj02Lng: 120.828,
                  },
                  {
                    id: "710411",
                    text: "大甲区",
                    gisGcj02Lat: 24.3489,
                    gisGcj02Lng: 120.622,
                  },
                  {
                    id: "710412",
                    text: "清水区",
                    gisGcj02Lat: 24.2687,
                    gisGcj02Lng: 120.56,
                  },
                  {
                    id: "710413",
                    text: "沙鹿区",
                    gisGcj02Lat: 24.2335,
                    gisGcj02Lng: 120.566,
                  },
                  {
                    id: "710414",
                    text: "梧栖区",
                    gisGcj02Lat: 24.255,
                    gisGcj02Lng: 120.532,
                  },
                  {
                    id: "710415",
                    text: "后里区",
                    gisGcj02Lat: 24.3049,
                    gisGcj02Lng: 120.711,
                  },
                  {
                    id: "710416",
                    text: "神冈区",
                    gisGcj02Lat: 24.2578,
                    gisGcj02Lng: 120.662,
                  },
                  {
                    id: "710417",
                    text: "潭子区",
                    gisGcj02Lat: 24.2095,
                    gisGcj02Lng: 120.705,
                  },
                  {
                    id: "710418",
                    text: "大雅区",
                    gisGcj02Lat: 24.2292,
                    gisGcj02Lng: 120.648,
                  },
                  {
                    id: "710419",
                    text: "新社区",
                    gisGcj02Lat: 24.2341,
                    gisGcj02Lng: 120.81,
                  },
                  {
                    id: "710420",
                    text: "石冈区",
                    gisGcj02Lat: 24.275,
                    gisGcj02Lng: 120.78,
                  },
                  {
                    id: "710421",
                    text: "外埔区",
                    gisGcj02Lat: 24.332,
                    gisGcj02Lng: 120.654,
                  },
                  {
                    id: "710422",
                    text: "大安区",
                    gisGcj02Lat: 24.3461,
                    gisGcj02Lng: 120.587,
                  },
                  {
                    id: "710423",
                    text: "乌日区",
                    gisGcj02Lat: 24.1045,
                    gisGcj02Lng: 120.624,
                  },
                  {
                    id: "710424",
                    text: "大肚区",
                    gisGcj02Lat: 24.1537,
                    gisGcj02Lng: 120.541,
                  },
                  {
                    id: "710425",
                    text: "龙井区",
                    gisGcj02Lat: 24.1927,
                    gisGcj02Lng: 120.546,
                  },
                  {
                    id: "710426",
                    text: "雾峰区",
                    gisGcj02Lat: 24.0615,
                    gisGcj02Lng: 120.7,
                  },
                  {
                    id: "710427",
                    text: "太平区",
                    gisGcj02Lat: 24.1265,
                    gisGcj02Lng: 120.719,
                  },
                  {
                    id: "710428",
                    text: "大里区",
                    gisGcj02Lat: 24.0994,
                    gisGcj02Lng: 120.678,
                  },
                  {
                    id: "710429",
                    text: "和平区",
                    gisGcj02Lat: 24.1748,
                    gisGcj02Lng: 120.883,
                  },
                ],
              },
              {
                id: "710500",
                text: "台南市",
                children: [
                  {
                    id: "710501",
                    text: "东区",
                    gisGcj02Lat: 22.9801,
                    gisGcj02Lng: 120.224,
                  },
                  {
                    id: "710502",
                    text: "南区",
                    gisGcj02Lat: 22.9609,
                    gisGcj02Lng: 120.189,
                  },
                  {
                    id: "710504",
                    text: "北区",
                    gisGcj02Lat: 24.166,
                    gisGcj02Lng: 120.682,
                  },
                  {
                    id: "710506",
                    text: "安南区",
                    gisGcj02Lat: 23.0472,
                    gisGcj02Lng: 120.185,
                  },
                  {
                    id: "710507",
                    text: "安平区",
                    gisGcj02Lat: 23.0008,
                    gisGcj02Lng: 120.167,
                  },
                  {
                    id: "710508",
                    text: "中西区",
                    gisGcj02Lat: 22.9922,
                    gisGcj02Lng: 120.206,
                  },
                  {
                    id: "710509",
                    text: "新营区",
                    gisGcj02Lat: 23.3103,
                    gisGcj02Lng: 120.317,
                  },
                  {
                    id: "710510",
                    text: "盐水区",
                    gisGcj02Lat: 23.3198,
                    gisGcj02Lng: 120.266,
                  },
                  {
                    id: "710511",
                    text: "白河区",
                    gisGcj02Lat: 23.3512,
                    gisGcj02Lng: 120.416,
                  },
                  {
                    id: "710512",
                    text: "柳营区",
                    gisGcj02Lat: 23.2781,
                    gisGcj02Lng: 120.311,
                  },
                  {
                    id: "710513",
                    text: "后壁区",
                    gisGcj02Lat: 23.3667,
                    gisGcj02Lng: 120.363,
                  },
                  {
                    id: "710514",
                    text: "东山区",
                    gisGcj02Lat: 23.3261,
                    gisGcj02Lng: 120.404,
                  },
                  {
                    id: "710515",
                    text: "麻豆区",
                    gisGcj02Lat: 23.1817,
                    gisGcj02Lng: 120.248,
                  },
                  {
                    id: "710516",
                    text: "下营区",
                    gisGcj02Lat: 23.2354,
                    gisGcj02Lng: 120.264,
                  },
                  {
                    id: "710517",
                    text: "六甲区",
                    gisGcj02Lat: 23.2319,
                    gisGcj02Lng: 120.348,
                  },
                  {
                    id: "710518",
                    text: "官田区",
                    gisGcj02Lat: 23.1947,
                    gisGcj02Lng: 120.314,
                  },
                  {
                    id: "710519",
                    text: "大内区",
                    gisGcj02Lat: 23.1195,
                    gisGcj02Lng: 120.349,
                  },
                  {
                    id: "710520",
                    text: "佳里区",
                    gisGcj02Lat: 23.1651,
                    gisGcj02Lng: 120.177,
                  },
                  {
                    id: "710521",
                    text: "学甲区",
                    gisGcj02Lat: 23.2323,
                    gisGcj02Lng: 120.18,
                  },
                  {
                    id: "710522",
                    text: "西港区",
                    gisGcj02Lat: 23.1231,
                    gisGcj02Lng: 120.204,
                  },
                  {
                    id: "710523",
                    text: "七股区",
                    gisGcj02Lat: 23.1405,
                    gisGcj02Lng: 120.14,
                  },
                  {
                    id: "710524",
                    text: "将军区",
                    gisGcj02Lat: 23.1995,
                    gisGcj02Lng: 120.157,
                  },
                  {
                    id: "710525",
                    text: "北门区",
                    gisGcj02Lat: 23.2671,
                    gisGcj02Lng: 120.126,
                  },
                  {
                    id: "710526",
                    text: "新化区",
                    gisGcj02Lat: 23.0385,
                    gisGcj02Lng: 120.311,
                  },
                  {
                    id: "710527",
                    text: "善化区",
                    gisGcj02Lat: 23.1323,
                    gisGcj02Lng: 120.297,
                  },
                  {
                    id: "710528",
                    text: "新市区",
                    gisGcj02Lat: 23.079,
                    gisGcj02Lng: 120.295,
                  },
                  {
                    id: "710529",
                    text: "安定区",
                    gisGcj02Lat: 23.1215,
                    gisGcj02Lng: 120.237,
                  },
                  {
                    id: "710530",
                    text: "山上区",
                    gisGcj02Lat: 23.1032,
                    gisGcj02Lng: 120.353,
                  },
                  {
                    id: "710531",
                    text: "玉井区",
                    gisGcj02Lat: 23.1239,
                    gisGcj02Lng: 120.46,
                  },
                  {
                    id: "710532",
                    text: "楠西区",
                    gisGcj02Lat: 23.1735,
                    gisGcj02Lng: 120.485,
                  },
                  {
                    id: "710533",
                    text: "南化区",
                    gisGcj02Lat: 23.0426,
                    gisGcj02Lng: 120.477,
                  },
                  {
                    id: "710534",
                    text: "左镇区",
                    gisGcj02Lat: 23.058,
                    gisGcj02Lng: 120.407,
                  },
                  {
                    id: "710535",
                    text: "仁德区",
                    gisGcj02Lat: 22.9722,
                    gisGcj02Lng: 120.252,
                  },
                  {
                    id: "710536",
                    text: "归仁区",
                    gisGcj02Lat: 22.9671,
                    gisGcj02Lng: 120.294,
                  },
                  {
                    id: "710537",
                    text: "关庙区",
                    gisGcj02Lat: 22.9629,
                    gisGcj02Lng: 120.328,
                  },
                  {
                    id: "710538",
                    text: "龙崎区",
                    gisGcj02Lat: 22.9657,
                    gisGcj02Lng: 120.361,
                  },
                  {
                    id: "710539",
                    text: "永康区",
                    gisGcj02Lat: 23.0261,
                    gisGcj02Lng: 120.257,
                  },
                ],
              },
              {
                id: "710600",
                text: "新竹市",
                children: [
                  {
                    id: "710601",
                    text: "东区",
                    gisGcj02Lat: 24.8013,
                    gisGcj02Lng: 120.97,
                  },
                  {
                    id: "710602",
                    text: "北区",
                    gisGcj02Lat: 24.166,
                    gisGcj02Lng: 120.682,
                  },
                  {
                    id: "710603",
                    text: "香山区",
                    gisGcj02Lat: 24.7689,
                    gisGcj02Lng: 120.957,
                  },
                ],
              },
              {
                id: "710700",
                text: "嘉义市",
                children: [
                  {
                    id: "710701",
                    text: "东区",
                    gisGcj02Lat: 23.4862,
                    gisGcj02Lng: 120.458,
                  },
                  {
                    id: "710702",
                    text: "西区",
                    gisGcj02Lat: 23.473,
                    gisGcj02Lng: 120.437,
                  },
                ],
              },
              {
                id: "710800",
                text: "新北市",
                children: [
                  {
                    id: "710801",
                    text: "板桥区",
                    gisGcj02Lat: 25.0096,
                    gisGcj02Lng: 121.459,
                  },
                  {
                    id: "710802",
                    text: "三重区",
                    gisGcj02Lat: 25.0615,
                    gisGcj02Lng: 121.488,
                  },
                  {
                    id: "710803",
                    text: "中和区",
                    gisGcj02Lat: 24.9994,
                    gisGcj02Lng: 121.499,
                  },
                  {
                    id: "710804",
                    text: "永和区",
                    gisGcj02Lat: 25.0078,
                    gisGcj02Lng: 121.514,
                  },
                  {
                    id: "710805",
                    text: "新庄区",
                    gisGcj02Lat: 25.0359,
                    gisGcj02Lng: 121.45,
                  },
                  {
                    id: "710806",
                    text: "新店区",
                    gisGcj02Lat: 24.9676,
                    gisGcj02Lng: 121.542,
                  },
                  {
                    id: "710807",
                    text: "树林区",
                    gisGcj02Lat: 24.9907,
                    gisGcj02Lng: 121.421,
                  },
                  {
                    id: "710808",
                    text: "莺歌区",
                    gisGcj02Lat: 24.9554,
                    gisGcj02Lng: 121.355,
                  },
                  {
                    id: "710809",
                    text: "三峡区",
                    gisGcj02Lat: 24.9343,
                    gisGcj02Lng: 121.369,
                  },
                  {
                    id: "710810",
                    text: "淡水区",
                    gisGcj02Lat: 25.1695,
                    gisGcj02Lng: 121.441,
                  },
                  {
                    id: "710811",
                    text: "汐止区",
                    gisGcj02Lat: 25.063,
                    gisGcj02Lng: 121.629,
                  },
                  {
                    id: "710812",
                    text: "瑞芳区",
                    gisGcj02Lat: 25.1089,
                    gisGcj02Lng: 121.81,
                  },
                  {
                    id: "710813",
                    text: "土城区",
                    gisGcj02Lat: 24.9722,
                    gisGcj02Lng: 121.443,
                  },
                  {
                    id: "710814",
                    text: "芦洲区",
                    gisGcj02Lat: 25.0849,
                    gisGcj02Lng: 121.474,
                  },
                  {
                    id: "710815",
                    text: "五股区",
                    gisGcj02Lat: 25.0827,
                    gisGcj02Lng: 121.438,
                  },
                  {
                    id: "710816",
                    text: "泰山区",
                    gisGcj02Lat: 25.0589,
                    gisGcj02Lng: 121.431,
                  },
                  {
                    id: "710817",
                    text: "林口区",
                    gisGcj02Lat: 25.0775,
                    gisGcj02Lng: 121.392,
                  },
                  {
                    id: "710818",
                    text: "深坑区",
                    gisGcj02Lat: 25.0023,
                    gisGcj02Lng: 121.616,
                  },
                  {
                    id: "710819",
                    text: "石碇区",
                    gisGcj02Lat: 24.9917,
                    gisGcj02Lng: 121.659,
                  },
                  {
                    id: "710820",
                    text: "坪林区",
                    gisGcj02Lat: 24.9374,
                    gisGcj02Lng: 121.711,
                  },
                  {
                    id: "710821",
                    text: "三芝区",
                    gisGcj02Lat: 25.258,
                    gisGcj02Lng: 121.501,
                  },
                  {
                    id: "710822",
                    text: "石门区",
                    gisGcj02Lat: 25.2904,
                    gisGcj02Lng: 121.568,
                  },
                  {
                    id: "710823",
                    text: "八里区",
                    gisGcj02Lat: 25.1467,
                    gisGcj02Lng: 121.398,
                  },
                  {
                    id: "710824",
                    text: "平溪区",
                    gisGcj02Lat: 25.0257,
                    gisGcj02Lng: 121.738,
                  },
                  {
                    id: "710825",
                    text: "双溪区",
                    gisGcj02Lat: 25.0334,
                    gisGcj02Lng: 121.866,
                  },
                  {
                    id: "710826",
                    text: "贡寮区",
                    gisGcj02Lat: 25.0224,
                    gisGcj02Lng: 121.908,
                  },
                  {
                    id: "710827",
                    text: "金山区",
                    gisGcj02Lat: 25.2219,
                    gisGcj02Lng: 121.636,
                  },
                  {
                    id: "710828",
                    text: "万里区",
                    gisGcj02Lat: 25.1812,
                    gisGcj02Lng: 121.689,
                  },
                  {
                    id: "710829",
                    text: "乌来区",
                    gisGcj02Lat: 24.8653,
                    gisGcj02Lng: 121.551,
                  },
                ],
              },
              {
                id: "712300",
                text: "桃园市",
                children: [
                  {
                    id: "712301",
                    text: "桃园区",
                    gisGcj02Lat: 24.9938,
                    gisGcj02Lng: 121.301,
                  },
                  {
                    id: "712302",
                    text: "中坜区",
                    gisGcj02Lat: 24.9654,
                    gisGcj02Lng: 121.225,
                  },
                  {
                    id: "712303",
                    text: "平镇区",
                    gisGcj02Lat: 24.9458,
                    gisGcj02Lng: 121.218,
                  },
                  {
                    id: "712304",
                    text: "八德区",
                    gisGcj02Lat: 24.9287,
                    gisGcj02Lng: 121.285,
                  },
                  {
                    id: "712305",
                    text: "杨梅区",
                    gisGcj02Lat: 24.9076,
                    gisGcj02Lng: 121.146,
                  },
                  {
                    id: "712306",
                    text: "芦竹区",
                    gisGcj02Lat: 25.0454,
                    gisGcj02Lng: 121.292,
                  },
                  {
                    id: "712321",
                    text: "大溪区",
                    gisGcj02Lat: 24.8806,
                    gisGcj02Lng: 121.287,
                  },
                  {
                    id: "712324",
                    text: "大园区",
                    gisGcj02Lat: 25.0645,
                    gisGcj02Lng: 121.196,
                  },
                  {
                    id: "712325",
                    text: "龟山区",
                    gisGcj02Lat: 24.9925,
                    gisGcj02Lng: 121.338,
                  },
                  {
                    id: "712327",
                    text: "龙潭区",
                    gisGcj02Lat: 24.8639,
                    gisGcj02Lng: 121.216,
                  },
                  {
                    id: "712329",
                    text: "新屋区",
                    gisGcj02Lat: 24.9722,
                    gisGcj02Lng: 121.106,
                  },
                  {
                    id: "712330",
                    text: "观音区",
                    gisGcj02Lat: 25.0333,
                    gisGcj02Lng: 121.078,
                  },
                  {
                    id: "712331",
                    text: "复兴区",
                    gisGcj02Lat: 24.8209,
                    gisGcj02Lng: 121.353,
                  },
                ],
              },
              {
                id: "712200",
                text: "宜兰县",
                children: [
                  {
                    id: "712201",
                    text: "宜兰市",
                    gisGcj02Lat: 24.7517,
                    gisGcj02Lng: 121.753,
                  },
                  {
                    id: "712221",
                    text: "罗东镇",
                    gisGcj02Lat: 24.677,
                    gisGcj02Lng: 121.767,
                  },
                  {
                    id: "712222",
                    text: "苏澳镇",
                    gisGcj02Lat: 24.5946,
                    gisGcj02Lng: 121.843,
                  },
                  {
                    id: "712223",
                    text: "头城镇",
                    gisGcj02Lat: 24.8592,
                    gisGcj02Lng: 121.823,
                  },
                  {
                    id: "712224",
                    text: "礁溪乡",
                    gisGcj02Lat: 24.8223,
                    gisGcj02Lng: 121.767,
                  },
                  {
                    id: "712225",
                    text: "壮围乡",
                    gisGcj02Lat: 24.7449,
                    gisGcj02Lng: 121.782,
                  },
                  {
                    id: "712226",
                    text: "员山乡",
                    gisGcj02Lat: 24.7418,
                    gisGcj02Lng: 121.722,
                  },
                  {
                    id: "712227",
                    text: "冬山乡",
                    gisGcj02Lat: 24.6345,
                    gisGcj02Lng: 121.792,
                  },
                  {
                    id: "712228",
                    text: "五结乡",
                    gisGcj02Lat: 24.6846,
                    gisGcj02Lng: 121.798,
                  },
                  {
                    id: "712229",
                    text: "三星乡",
                    gisGcj02Lat: 23.7753,
                    gisGcj02Lng: 121.003,
                  },
                  {
                    id: "712230",
                    text: "大同乡",
                    gisGcj02Lat: 24.676,
                    gisGcj02Lng: 121.606,
                  },
                  {
                    id: "712231",
                    text: "南澳乡",
                    gisGcj02Lat: 24.4654,
                    gisGcj02Lng: 121.8,
                  },
                ],
              },
              {
                id: "712400",
                text: "新竹县",
                children: [
                  {
                    id: "712401",
                    text: "竹北市",
                    gisGcj02Lat: 24.8397,
                    gisGcj02Lng: 121.004,
                  },
                  {
                    id: "712421",
                    text: "竹东镇",
                    gisGcj02Lat: 24.7336,
                    gisGcj02Lng: 121.086,
                  },
                  {
                    id: "712422",
                    text: "新埔镇",
                    gisGcj02Lat: 24.8248,
                    gisGcj02Lng: 121.073,
                  },
                  {
                    id: "712423",
                    text: "关西镇",
                    gisGcj02Lat: 24.7888,
                    gisGcj02Lng: 121.177,
                  },
                  {
                    id: "712424",
                    text: "湖口乡",
                    gisGcj02Lat: 24.9039,
                    gisGcj02Lng: 121.044,
                  },
                  {
                    id: "712425",
                    text: "新丰乡",
                    gisGcj02Lat: 24.8996,
                    gisGcj02Lng: 120.983,
                  },
                  {
                    id: "712426",
                    text: "芎林乡",
                    gisGcj02Lat: 24.7744,
                    gisGcj02Lng: 121.077,
                  },
                  {
                    id: "712427",
                    text: "横山乡",
                    gisGcj02Lat: 24.7208,
                    gisGcj02Lng: 121.116,
                  },
                  {
                    id: "712428",
                    text: "北埔乡",
                    gisGcj02Lat: 24.6971,
                    gisGcj02Lng: 121.053,
                  },
                  {
                    id: "712429",
                    text: "宝山乡",
                    gisGcj02Lat: 24.761,
                    gisGcj02Lng: 120.986,
                  },
                  {
                    id: "712430",
                    text: "峨眉乡",
                    gisGcj02Lat: 24.6861,
                    gisGcj02Lng: 121.015,
                  },
                  {
                    id: "712431",
                    text: "尖石乡",
                    gisGcj02Lat: 24.7044,
                    gisGcj02Lng: 121.198,
                  },
                  {
                    id: "712432",
                    text: "五峰乡",
                    gisGcj02Lat: 23.7753,
                    gisGcj02Lng: 121.003,
                  },
                ],
              },
              {
                id: "712500",
                text: "苗栗县",
                children: [
                  {
                    id: "712501",
                    text: "苗栗市",
                    gisGcj02Lat: 24.5615,
                    gisGcj02Lng: 120.819,
                  },
                  {
                    id: "712521",
                    text: "苑里镇",
                    gisGcj02Lat: 24.4417,
                    gisGcj02Lng: 120.649,
                  },
                  {
                    id: "712522",
                    text: "通霄镇",
                    gisGcj02Lat: 24.4891,
                    gisGcj02Lng: 120.677,
                  },
                  {
                    id: "712523",
                    text: "竹南镇",
                    gisGcj02Lat: 24.6855,
                    gisGcj02Lng: 120.873,
                  },
                  {
                    id: "712524",
                    text: "头份镇",
                    gisGcj02Lat: 24.688,
                    gisGcj02Lng: 120.895,
                  },
                  {
                    id: "712525",
                    text: "后龙镇",
                    gisGcj02Lat: 24.6126,
                    gisGcj02Lng: 120.786,
                  },
                  {
                    id: "712526",
                    text: "卓兰镇",
                    gisGcj02Lat: 24.3095,
                    gisGcj02Lng: 120.823,
                  },
                  {
                    id: "712527",
                    text: "大湖乡",
                    gisGcj02Lat: 24.4225,
                    gisGcj02Lng: 120.864,
                  },
                  {
                    id: "712528",
                    text: "公馆乡",
                    gisGcj02Lat: 24.4991,
                    gisGcj02Lng: 120.823,
                  },
                  {
                    id: "712529",
                    text: "铜锣乡",
                    gisGcj02Lat: 23.7753,
                    gisGcj02Lng: 121.003,
                  },
                  {
                    id: "712530",
                    text: "南庄乡",
                    gisGcj02Lat: 24.5968,
                    gisGcj02Lng: 120.995,
                  },
                  {
                    id: "712531",
                    text: "头屋乡",
                    gisGcj02Lat: 24.5742,
                    gisGcj02Lng: 120.847,
                  },
                  {
                    id: "712532",
                    text: "三义乡",
                    gisGcj02Lat: 24.3503,
                    gisGcj02Lng: 120.742,
                  },
                  {
                    id: "712533",
                    text: "西湖乡",
                    gisGcj02Lat: 23.7753,
                    gisGcj02Lng: 121.003,
                  },
                  {
                    id: "712534",
                    text: "造桥乡",
                    gisGcj02Lat: 24.6375,
                    gisGcj02Lng: 120.862,
                  },
                  {
                    id: "712535",
                    text: "三湾乡",
                    gisGcj02Lat: 24.6511,
                    gisGcj02Lng: 120.951,
                  },
                  {
                    id: "712536",
                    text: "狮潭乡",
                    gisGcj02Lat: 24.54,
                    gisGcj02Lng: 120.918,
                  },
                  {
                    id: "712537",
                    text: "泰安乡",
                    gisGcj02Lat: 24.4426,
                    gisGcj02Lng: 120.904,
                  },
                ],
              },
              {
                id: "712700",
                text: "彰化县",
                children: [
                  {
                    id: "712701",
                    text: "彰化市",
                    gisGcj02Lat: 24.0809,
                    gisGcj02Lng: 120.542,
                  },
                  {
                    id: "712721",
                    text: "鹿港镇",
                    gisGcj02Lat: 24.0569,
                    gisGcj02Lng: 120.435,
                  },
                  {
                    id: "712722",
                    text: "和美镇",
                    gisGcj02Lat: 24.1109,
                    gisGcj02Lng: 120.5,
                  },
                  {
                    id: "712723",
                    text: "线西乡",
                    gisGcj02Lat: 24.1287,
                    gisGcj02Lng: 120.466,
                  },
                  {
                    id: "712724",
                    text: "伸港乡",
                    gisGcj02Lat: 24.1461,
                    gisGcj02Lng: 120.484,
                  },
                  {
                    id: "712725",
                    text: "福兴乡",
                    gisGcj02Lat: 24.0479,
                    gisGcj02Lng: 120.444,
                  },
                  {
                    id: "712726",
                    text: "秀水乡",
                    gisGcj02Lat: 24.0353,
                    gisGcj02Lng: 120.503,
                  },
                  {
                    id: "712727",
                    text: "花坛乡",
                    gisGcj02Lat: 24.0294,
                    gisGcj02Lng: 120.538,
                  },
                  {
                    id: "712728",
                    text: "芬园乡",
                    gisGcj02Lat: 24.0137,
                    gisGcj02Lng: 120.629,
                  },
                  {
                    id: "712729",
                    text: "员林镇",
                    gisGcj02Lat: 23.959,
                    gisGcj02Lng: 120.575,
                  },
                  {
                    id: "712730",
                    text: "溪湖镇",
                    gisGcj02Lat: 23.9623,
                    gisGcj02Lng: 120.479,
                  },
                  {
                    id: "712731",
                    text: "田中镇",
                    gisGcj02Lat: 23.8617,
                    gisGcj02Lng: 120.581,
                  },
                  {
                    id: "712732",
                    text: "大村乡",
                    gisGcj02Lat: 23.9937,
                    gisGcj02Lng: 120.541,
                  },
                  {
                    id: "712733",
                    text: "埔盐乡",
                    gisGcj02Lat: 24.0003,
                    gisGcj02Lng: 120.464,
                  },
                  {
                    id: "712734",
                    text: "埔心乡",
                    gisGcj02Lat: 23.953,
                    gisGcj02Lng: 120.544,
                  },
                  {
                    id: "712735",
                    text: "永靖乡",
                    gisGcj02Lat: 23.9247,
                    gisGcj02Lng: 120.548,
                  },
                  {
                    id: "712736",
                    text: "社头乡",
                    gisGcj02Lat: 23.8967,
                    gisGcj02Lng: 120.583,
                  },
                  {
                    id: "712737",
                    text: "二水乡",
                    gisGcj02Lat: 23.807,
                    gisGcj02Lng: 120.619,
                  },
                  {
                    id: "712738",
                    text: "北斗镇",
                    gisGcj02Lat: 23.8709,
                    gisGcj02Lng: 120.52,
                  },
                  {
                    id: "712739",
                    text: "二林镇",
                    gisGcj02Lat: 23.8998,
                    gisGcj02Lng: 120.374,
                  },
                  {
                    id: "712740",
                    text: "田尾乡",
                    gisGcj02Lat: 23.8907,
                    gisGcj02Lng: 120.525,
                  },
                  {
                    id: "712741",
                    text: "埤头乡",
                    gisGcj02Lat: 23.8913,
                    gisGcj02Lng: 120.463,
                  },
                  {
                    id: "712742",
                    text: "芳苑乡",
                    gisGcj02Lat: 23.9242,
                    gisGcj02Lng: 120.32,
                  },
                  {
                    id: "712743",
                    text: "大城乡",
                    gisGcj02Lat: 23.8524,
                    gisGcj02Lng: 120.321,
                  },
                  {
                    id: "712744",
                    text: "竹塘乡",
                    gisGcj02Lat: 23.8601,
                    gisGcj02Lng: 120.427,
                  },
                  {
                    id: "712745",
                    text: "溪州乡",
                    gisGcj02Lat: 23.8512,
                    gisGcj02Lng: 120.499,
                  },
                ],
              },
              {
                id: "712800",
                text: "南投县",
                children: [
                  {
                    id: "712801",
                    text: "南投市",
                    gisGcj02Lat: 23.91,
                    gisGcj02Lng: 120.684,
                  },
                  {
                    id: "712821",
                    text: "埔里镇",
                    gisGcj02Lat: 23.9648,
                    gisGcj02Lng: 120.965,
                  },
                  {
                    id: "712822",
                    text: "草屯镇",
                    gisGcj02Lat: 23.9739,
                    gisGcj02Lng: 120.68,
                  },
                  {
                    id: "712823",
                    text: "竹山镇",
                    gisGcj02Lat: 23.7577,
                    gisGcj02Lng: 120.672,
                  },
                  {
                    id: "712824",
                    text: "集集镇",
                    gisGcj02Lat: 23.829,
                    gisGcj02Lng: 120.784,
                  },
                  {
                    id: "712825",
                    text: "名间乡",
                    gisGcj02Lat: 23.8384,
                    gisGcj02Lng: 120.703,
                  },
                  {
                    id: "712826",
                    text: "鹿谷乡",
                    gisGcj02Lat: 23.7445,
                    gisGcj02Lng: 120.753,
                  },
                  {
                    id: "712827",
                    text: "中寮乡",
                    gisGcj02Lat: 23.8789,
                    gisGcj02Lng: 120.767,
                  },
                  {
                    id: "712828",
                    text: "鱼池乡",
                    gisGcj02Lat: 23.8964,
                    gisGcj02Lng: 120.936,
                  },
                  {
                    id: "712829",
                    text: "国姓乡",
                    gisGcj02Lat: 24.0423,
                    gisGcj02Lng: 120.859,
                  },
                  {
                    id: "712830",
                    text: "水里乡",
                    gisGcj02Lat: 23.8121,
                    gisGcj02Lng: 120.856,
                  },
                  {
                    id: "712831",
                    text: "信义乡",
                    gisGcj02Lat: 23.6999,
                    gisGcj02Lng: 120.855,
                  },
                  {
                    id: "712832",
                    text: "仁爱乡",
                    gisGcj02Lat: 24.0244,
                    gisGcj02Lng: 121.134,
                  },
                ],
              },
              {
                id: "712900",
                text: "云林县",
                children: [
                  {
                    id: "712901",
                    text: "斗六市",
                    gisGcj02Lat: 23.6977,
                    gisGcj02Lng: 120.527,
                  },
                  {
                    id: "712921",
                    text: "斗南镇",
                    gisGcj02Lat: 23.6797,
                    gisGcj02Lng: 120.479,
                  },
                  {
                    id: "712922",
                    text: "虎尾镇",
                    gisGcj02Lat: 23.7082,
                    gisGcj02Lng: 120.445,
                  },
                  {
                    id: "712923",
                    text: "西螺镇",
                    gisGcj02Lat: 23.798,
                    gisGcj02Lng: 120.466,
                  },
                  {
                    id: "712924",
                    text: "土库镇",
                    gisGcj02Lat: 23.6778,
                    gisGcj02Lng: 120.393,
                  },
                  {
                    id: "712925",
                    text: "北港镇",
                    gisGcj02Lat: 23.5755,
                    gisGcj02Lng: 120.302,
                  },
                  {
                    id: "712926",
                    text: "古坑乡",
                    gisGcj02Lat: 23.6426,
                    gisGcj02Lng: 120.562,
                  },
                  {
                    id: "712927",
                    text: "大埤乡",
                    gisGcj02Lat: 23.6459,
                    gisGcj02Lng: 120.431,
                  },
                  {
                    id: "712928",
                    text: "莿桐乡",
                    gisGcj02Lat: 23.7608,
                    gisGcj02Lng: 120.502,
                  },
                  {
                    id: "712929",
                    text: "林内乡",
                    gisGcj02Lat: 23.7587,
                    gisGcj02Lng: 120.611,
                  },
                  {
                    id: "712930",
                    text: "二仑乡",
                    gisGcj02Lat: 23.7713,
                    gisGcj02Lng: 120.415,
                  },
                  {
                    id: "712931",
                    text: "仑背乡",
                    gisGcj02Lat: 23.7588,
                    gisGcj02Lng: 120.354,
                  },
                  {
                    id: "712932",
                    text: "麦寮乡",
                    gisGcj02Lat: 23.7538,
                    gisGcj02Lng: 120.252,
                  },
                  {
                    id: "712933",
                    text: "东势乡",
                    gisGcj02Lat: 23.6747,
                    gisGcj02Lng: 120.253,
                  },
                  {
                    id: "712934",
                    text: "褒忠乡",
                    gisGcj02Lat: 23.6942,
                    gisGcj02Lng: 120.31,
                  },
                  {
                    id: "712935",
                    text: "台西乡",
                    gisGcj02Lat: 23.7028,
                    gisGcj02Lng: 120.196,
                  },
                  {
                    id: "712936",
                    text: "元长乡",
                    gisGcj02Lat: 23.6495,
                    gisGcj02Lng: 120.315,
                  },
                  {
                    id: "712937",
                    text: "四湖乡",
                    gisGcj02Lat: 23.6377,
                    gisGcj02Lng: 120.226,
                  },
                  {
                    id: "712938",
                    text: "口湖乡",
                    gisGcj02Lat: 23.5824,
                    gisGcj02Lng: 120.185,
                  },
                  {
                    id: "712939",
                    text: "水林乡",
                    gisGcj02Lat: 23.5726,
                    gisGcj02Lng: 120.246,
                  },
                ],
              },
              {
                id: "713000",
                text: "嘉义县",
                children: [
                  {
                    id: "713001",
                    text: "太保市",
                    gisGcj02Lat: 23.4596,
                    gisGcj02Lng: 120.333,
                  },
                  {
                    id: "713002",
                    text: "朴子市",
                    gisGcj02Lat: 23.465,
                    gisGcj02Lng: 120.247,
                  },
                  {
                    id: "713023",
                    text: "布袋镇",
                    gisGcj02Lat: 23.378,
                    gisGcj02Lng: 120.167,
                  },
                  {
                    id: "713024",
                    text: "大林镇",
                    gisGcj02Lat: 23.6038,
                    gisGcj02Lng: 120.471,
                  },
                  {
                    id: "713025",
                    text: "民雄乡",
                    gisGcj02Lat: 23.5515,
                    gisGcj02Lng: 120.429,
                  },
                  {
                    id: "713026",
                    text: "溪口乡",
                    gisGcj02Lat: 23.6022,
                    gisGcj02Lng: 120.394,
                  },
                  {
                    id: "713027",
                    text: "新港乡",
                    gisGcj02Lat: 23.5518,
                    gisGcj02Lng: 120.348,
                  },
                  {
                    id: "713028",
                    text: "六脚乡",
                    gisGcj02Lat: 23.4939,
                    gisGcj02Lng: 120.291,
                  },
                  {
                    id: "713029",
                    text: "东石乡",
                    gisGcj02Lat: 23.4592,
                    gisGcj02Lng: 120.154,
                  },
                  {
                    id: "713030",
                    text: "义竹乡",
                    gisGcj02Lat: 23.3363,
                    gisGcj02Lng: 120.243,
                  },
                  {
                    id: "713031",
                    text: "鹿草乡",
                    gisGcj02Lat: 23.4108,
                    gisGcj02Lng: 120.308,
                  },
                  {
                    id: "713032",
                    text: "水上乡",
                    gisGcj02Lat: 23.4281,
                    gisGcj02Lng: 120.398,
                  },
                  {
                    id: "713033",
                    text: "中埔乡",
                    gisGcj02Lat: 23.4251,
                    gisGcj02Lng: 120.523,
                  },
                  {
                    id: "713034",
                    text: "竹崎乡",
                    gisGcj02Lat: 23.5232,
                    gisGcj02Lng: 120.551,
                  },
                  {
                    id: "713035",
                    text: "梅山乡",
                    gisGcj02Lat: 23.5849,
                    gisGcj02Lng: 120.557,
                  },
                  {
                    id: "713036",
                    text: "番路乡",
                    gisGcj02Lat: 23.4652,
                    gisGcj02Lng: 120.555,
                  },
                  {
                    id: "713037",
                    text: "大埔乡",
                    gisGcj02Lat: 23.2967,
                    gisGcj02Lng: 120.594,
                  },
                  {
                    id: "713038",
                    text: "阿里山乡",
                    gisGcj02Lat: 23.468,
                    gisGcj02Lng: 120.733,
                  },
                ],
              },
              {
                id: "713300",
                text: "屏东县",
                children: [
                  {
                    id: "713301",
                    text: "屏东市",
                    gisGcj02Lat: 22.6697,
                    gisGcj02Lng: 120.488,
                  },
                  {
                    id: "713321",
                    text: "潮州镇",
                    gisGcj02Lat: 22.5505,
                    gisGcj02Lng: 120.543,
                  },
                  {
                    id: "713322",
                    text: "东港镇",
                    gisGcj02Lat: 22.4666,
                    gisGcj02Lng: 120.454,
                  },
                  {
                    id: "713323",
                    text: "恒春镇",
                    gisGcj02Lat: 22.0024,
                    gisGcj02Lng: 120.745,
                  },
                  {
                    id: "713324",
                    text: "万丹乡",
                    gisGcj02Lat: 22.5898,
                    gisGcj02Lng: 120.485,
                  },
                  {
                    id: "713325",
                    text: "长治乡",
                    gisGcj02Lat: 22.6771,
                    gisGcj02Lng: 120.528,
                  },
                  {
                    id: "713326",
                    text: "麟洛乡",
                    gisGcj02Lat: 22.6506,
                    gisGcj02Lng: 120.527,
                  },
                  {
                    id: "713327",
                    text: "九如乡",
                    gisGcj02Lat: 22.7398,
                    gisGcj02Lng: 120.49,
                  },
                  {
                    id: "713328",
                    text: "里港乡",
                    gisGcj02Lat: 22.7792,
                    gisGcj02Lng: 120.494,
                  },
                  {
                    id: "713329",
                    text: "盐埔乡",
                    gisGcj02Lat: 22.7548,
                    gisGcj02Lng: 120.573,
                  },
                  {
                    id: "713330",
                    text: "高树乡",
                    gisGcj02Lat: 22.8268,
                    gisGcj02Lng: 120.6,
                  },
                  {
                    id: "713331",
                    text: "万峦乡",
                    gisGcj02Lat: 22.572,
                    gisGcj02Lng: 120.566,
                  },
                  {
                    id: "713332",
                    text: "内埔乡",
                    gisGcj02Lat: 22.612,
                    gisGcj02Lng: 120.567,
                  },
                  {
                    id: "713333",
                    text: "竹田乡",
                    gisGcj02Lat: 22.5847,
                    gisGcj02Lng: 120.544,
                  },
                  {
                    id: "713334",
                    text: "新埤乡",
                    gisGcj02Lat: 22.47,
                    gisGcj02Lng: 120.55,
                  },
                  {
                    id: "713335",
                    text: "枋寮乡",
                    gisGcj02Lat: 22.3656,
                    gisGcj02Lng: 120.593,
                  },
                  {
                    id: "713336",
                    text: "新园乡",
                    gisGcj02Lat: 22.544,
                    gisGcj02Lng: 120.462,
                  },
                  {
                    id: "713337",
                    text: "崁顶乡",
                    gisGcj02Lat: 22.5148,
                    gisGcj02Lng: 120.515,
                  },
                  {
                    id: "713338",
                    text: "林边乡",
                    gisGcj02Lat: 22.434,
                    gisGcj02Lng: 120.515,
                  },
                  {
                    id: "713339",
                    text: "南州乡",
                    gisGcj02Lat: 22.4902,
                    gisGcj02Lng: 120.51,
                  },
                  {
                    id: "713340",
                    text: "佳冬乡",
                    gisGcj02Lat: 22.4177,
                    gisGcj02Lng: 120.552,
                  },
                  {
                    id: "713341",
                    text: "琉球乡",
                    gisGcj02Lat: 22.3424,
                    gisGcj02Lng: 120.369,
                  },
                  {
                    id: "713342",
                    text: "车城乡",
                    gisGcj02Lat: 22.0721,
                    gisGcj02Lng: 120.711,
                  },
                  {
                    id: "713343",
                    text: "满州乡",
                    gisGcj02Lat: 22.0209,
                    gisGcj02Lng: 120.839,
                  },
                  {
                    id: "713344",
                    text: "枋山乡",
                    gisGcj02Lat: 22.2603,
                    gisGcj02Lng: 120.656,
                  },
                  {
                    id: "713345",
                    text: "三地门乡",
                    gisGcj02Lat: 22.7139,
                    gisGcj02Lng: 120.654,
                  },
                  {
                    id: "713346",
                    text: "雾台乡",
                    gisGcj02Lat: 22.7449,
                    gisGcj02Lng: 120.732,
                  },
                  {
                    id: "713347",
                    text: "玛家乡",
                    gisGcj02Lat: 22.7067,
                    gisGcj02Lng: 120.644,
                  },
                  {
                    id: "713348",
                    text: "泰武乡",
                    gisGcj02Lat: 22.5918,
                    gisGcj02Lng: 120.633,
                  },
                  {
                    id: "713349",
                    text: "来义乡",
                    gisGcj02Lat: 22.5259,
                    gisGcj02Lng: 120.634,
                  },
                  {
                    id: "713350",
                    text: "春日乡",
                    gisGcj02Lat: 22.3707,
                    gisGcj02Lng: 120.629,
                  },
                  {
                    id: "713351",
                    text: "狮子乡",
                    gisGcj02Lat: 22.2019,
                    gisGcj02Lng: 120.705,
                  },
                  {
                    id: "713352",
                    text: "牡丹乡",
                    gisGcj02Lat: 22.1257,
                    gisGcj02Lng: 120.77,
                  },
                ],
              },
              {
                id: "713400",
                text: "台东县",
                children: [
                  {
                    id: "713401",
                    text: "台东市",
                    gisGcj02Lat: 22.756,
                    gisGcj02Lng: 121.146,
                  },
                  {
                    id: "713421",
                    text: "成功镇",
                    gisGcj02Lat: 23.1002,
                    gisGcj02Lng: 121.38,
                  },
                  {
                    id: "713422",
                    text: "关山镇",
                    gisGcj02Lat: 23.0474,
                    gisGcj02Lng: 121.163,
                  },
                  {
                    id: "713423",
                    text: "卑南乡",
                    gisGcj02Lat: 22.786,
                    gisGcj02Lng: 121.084,
                  },
                  {
                    id: "713424",
                    text: "鹿野乡",
                    gisGcj02Lat: 22.914,
                    gisGcj02Lng: 121.136,
                  },
                  {
                    id: "713425",
                    text: "池上乡",
                    gisGcj02Lat: 23.1224,
                    gisGcj02Lng: 121.215,
                  },
                  {
                    id: "713426",
                    text: "东河乡",
                    gisGcj02Lat: 22.9699,
                    gisGcj02Lng: 121.3,
                  },
                  {
                    id: "713427",
                    text: "长滨乡",
                    gisGcj02Lat: 23.315,
                    gisGcj02Lng: 121.452,
                  },
                  {
                    id: "713428",
                    text: "太麻里乡",
                    gisGcj02Lat: 22.6154,
                    gisGcj02Lng: 121.007,
                  },
                  {
                    id: "713429",
                    text: "大武乡",
                    gisGcj02Lat: 22.3399,
                    gisGcj02Lng: 120.89,
                  },
                  {
                    id: "713430",
                    text: "绿岛乡",
                    gisGcj02Lat: 22.6617,
                    gisGcj02Lng: 121.493,
                  },
                  {
                    id: "713431",
                    text: "海端乡",
                    gisGcj02Lat: 23.1011,
                    gisGcj02Lng: 121.172,
                  },
                  {
                    id: "713432",
                    text: "延平乡",
                    gisGcj02Lat: 22.9024,
                    gisGcj02Lng: 121.084,
                  },
                  {
                    id: "713433",
                    text: "金峰乡",
                    gisGcj02Lat: 22.5955,
                    gisGcj02Lng: 120.971,
                  },
                  {
                    id: "713434",
                    text: "达仁乡",
                    gisGcj02Lat: 22.2949,
                    gisGcj02Lng: 120.884,
                  },
                  {
                    id: "713435",
                    text: "兰屿乡",
                    gisGcj02Lat: 22.0567,
                    gisGcj02Lng: 121.532,
                  },
                ],
              },
              {
                id: "713500",
                text: "花莲县",
                children: [
                  {
                    id: "713501",
                    text: "花莲市",
                    gisGcj02Lat: 23.9821,
                    gisGcj02Lng: 121.607,
                  },
                  {
                    id: "713521",
                    text: "凤林镇",
                    gisGcj02Lat: 23.7446,
                    gisGcj02Lng: 121.452,
                  },
                  {
                    id: "713522",
                    text: "玉里镇",
                    gisGcj02Lat: 23.3365,
                    gisGcj02Lng: 121.316,
                  },
                  {
                    id: "713523",
                    text: "新城乡",
                    gisGcj02Lat: 24.1281,
                    gisGcj02Lng: 121.641,
                  },
                  {
                    id: "713524",
                    text: "吉安乡",
                    gisGcj02Lat: 23.9616,
                    gisGcj02Lng: 121.568,
                  },
                  {
                    id: "713525",
                    text: "寿丰乡",
                    gisGcj02Lat: 23.8707,
                    gisGcj02Lng: 121.509,
                  },
                  {
                    id: "713526",
                    text: "光复乡",
                    gisGcj02Lat: 23.6691,
                    gisGcj02Lng: 121.423,
                  },
                  {
                    id: "713527",
                    text: "丰滨乡",
                    gisGcj02Lat: 23.5971,
                    gisGcj02Lng: 121.519,
                  },
                  {
                    id: "713528",
                    text: "瑞穗乡",
                    gisGcj02Lat: 23.4968,
                    gisGcj02Lng: 121.376,
                  },
                  {
                    id: "713529",
                    text: "富里乡",
                    gisGcj02Lat: 23.18,
                    gisGcj02Lng: 121.25,
                  },
                  {
                    id: "713530",
                    text: "秀林乡",
                    gisGcj02Lat: 24.1166,
                    gisGcj02Lng: 121.62,
                  },
                  {
                    id: "713531",
                    text: "万荣乡",
                    gisGcj02Lat: 23.7153,
                    gisGcj02Lng: 121.407,
                  },
                  {
                    id: "713532",
                    text: "卓溪乡",
                    gisGcj02Lat: 23.3464,
                    gisGcj02Lng: 121.303,
                  },
                ],
              },
              {
                id: "713600",
                text: "澎湖县",
                children: [
                  {
                    id: "713601",
                    text: "马公市",
                    gisGcj02Lat: 23.5658,
                    gisGcj02Lng: 119.566,
                  },
                  {
                    id: "713621",
                    text: "湖西乡",
                    gisGcj02Lat: 23.5834,
                    gisGcj02Lng: 119.66,
                  },
                  {
                    id: "713622",
                    text: "白沙乡",
                    gisGcj02Lat: 23.6661,
                    gisGcj02Lng: 119.598,
                  },
                  {
                    id: "713623",
                    text: "西屿乡",
                    gisGcj02Lat: 23.6008,
                    gisGcj02Lng: 119.507,
                  },
                  {
                    id: "713624",
                    text: "望安乡",
                    gisGcj02Lat: 23.3575,
                    gisGcj02Lng: 119.501,
                  },
                  {
                    id: "713625",
                    text: "七美乡",
                    gisGcj02Lat: 23.206,
                    gisGcj02Lng: 119.424,
                  },
                ],
              },
              {
                id: "713700",
                text: "金门县",
                children: [
                  {
                    id: "713701",
                    text: "金城镇",
                    gisGcj02Lat: 24.4167,
                    gisGcj02Lng: 118.317,
                  },
                  {
                    id: "713702",
                    text: "金湖镇",
                    gisGcj02Lat: 24.4386,
                    gisGcj02Lng: 118.42,
                  },
                  {
                    id: "713703",
                    text: "金沙镇",
                    gisGcj02Lat: 24.4811,
                    gisGcj02Lng: 118.428,
                  },
                  {
                    id: "713704",
                    text: "金宁乡",
                    gisGcj02Lat: 24.4567,
                    gisGcj02Lng: 118.335,
                  },
                  {
                    id: "713705",
                    text: "烈屿乡",
                    gisGcj02Lat: 24.4331,
                    gisGcj02Lng: 118.247,
                  },
                  {
                    id: "713706",
                    text: "乌丘乡",
                    gisGcj02Lat: 24.435,
                    gisGcj02Lng: 118.32,
                  },
                ],
              },
              {
                id: "713800",
                text: "连江县",
                children: [
                  {
                    id: "713801",
                    text: "南竿乡",
                    gisGcj02Lat: 26.144,
                    gisGcj02Lng: 119.944,
                  },
                  {
                    id: "713802",
                    text: "北竿乡",
                    gisGcj02Lat: 26.222,
                    gisGcj02Lng: 120.001,
                  },
                  {
                    id: "713803",
                    text: "莒光乡",
                    gisGcj02Lat: 25.9763,
                    gisGcj02Lng: 119.94,
                  },
                  {
                    id: "713804",
                    text: "东引乡",
                    gisGcj02Lat: 26.3662,
                    gisGcj02Lng: 120.494,
                  },
                ],
              },
            ],
          },
          {
            id: "810000",
            text: "香港",
            children: [
              {
                id: "810100",
                text: "香港岛",
                children: [
                  {
                    id: "810101",
                    text: "中西区",
                    gisGcj02Lat: 22.282,
                    gisGcj02Lng: 114.154,
                  },
                  {
                    id: "810102",
                    text: "湾仔区",
                    gisGcj02Lat: 22.2764,
                    gisGcj02Lng: 114.183,
                  },
                  {
                    id: "810103",
                    text: "东区",
                    gisGcj02Lat: 22.2628,
                    gisGcj02Lng: 114.256,
                  },
                  {
                    id: "810104",
                    text: "南区",
                    gisGcj02Lat: 22.2468,
                    gisGcj02Lng: 114.174,
                  },
                ],
              },
              {
                id: "810200",
                text: "九龙",
                children: [
                  {
                    id: "810201",
                    text: "油尖旺区",
                    gisGcj02Lat: 22.3117,
                    gisGcj02Lng: 114.173,
                  },
                  {
                    id: "810202",
                    text: "深水埗区",
                    gisGcj02Lat: 22.3282,
                    gisGcj02Lng: 114.167,
                  },
                  {
                    id: "810203",
                    text: "九龙城区",
                    gisGcj02Lat: 22.3267,
                    gisGcj02Lng: 114.195,
                  },
                  {
                    id: "810204",
                    text: "黄大仙区",
                    gisGcj02Lat: 22.3363,
                    gisGcj02Lng: 114.199,
                  },
                  {
                    id: "810205",
                    text: "观塘区",
                    gisGcj02Lat: 22.3094,
                    gisGcj02Lng: 114.231,
                  },
                ],
              },
              {
                id: "810300",
                text: "新界",
                children: [
                  {
                    id: "810301",
                    text: "荃湾区",
                    gisGcj02Lat: 22.371,
                    gisGcj02Lng: 114.123,
                  },
                  {
                    id: "810302",
                    text: "屯门区",
                    gisGcj02Lat: 22.391,
                    gisGcj02Lng: 113.977,
                  },
                  {
                    id: "810303",
                    text: "元朗区",
                    gisGcj02Lat: 22.4433,
                    gisGcj02Lng: 114.04,
                  },
                  {
                    id: "810304",
                    text: "北区",
                    gisGcj02Lat: 22.4941,
                    gisGcj02Lng: 114.149,
                  },
                  {
                    id: "810305",
                    text: "大埔区",
                    gisGcj02Lat: 22.4457,
                    gisGcj02Lng: 114.172,
                  },
                  {
                    id: "810306",
                    text: "西贡区",
                    gisGcj02Lat: 22.3794,
                    gisGcj02Lng: 114.279,
                  },
                  {
                    id: "810307",
                    text: "沙田区",
                    gisGcj02Lat: 22.3793,
                    gisGcj02Lng: 114.192,
                  },
                  {
                    id: "810308",
                    text: "葵青区",
                    gisGcj02Lat: 22.3639,
                    gisGcj02Lng: 114.139,
                  },
                  {
                    id: "810309",
                    text: "离岛区",
                    gisGcj02Lat: 22.2815,
                    gisGcj02Lng: 113.946,
                  },
                ],
              },
            ],
          },
          {
            id: "820000",
            text: "澳门",
            children: [
              {
                id: "820100",
                text: "澳门半岛",
                children: [
                  {
                    id: "820101",
                    text: "花地玛堂区",
                    gisGcj02Lat: 22.2081,
                    gisGcj02Lng: 113.552,
                  },
                  {
                    id: "820102",
                    text: "圣安多尼堂区",
                    gisGcj02Lat: 22.1238,
                    gisGcj02Lng: 113.564,
                  },
                  {
                    id: "820103",
                    text: "大堂区",
                    gisGcj02Lat: 22.1884,
                    gisGcj02Lng: 113.553,
                  },
                  {
                    id: "820104",
                    text: "望德堂区",
                    gisGcj02Lat: 22.1941,
                    gisGcj02Lng: 113.551,
                  },
                  {
                    id: "820105",
                    text: "风顺堂区",
                    gisGcj02Lat: 22.1874,
                    gisGcj02Lng: 113.542,
                  },
                ],
              },
              {
                id: "820200",
                text: "氹仔岛",
                children: [
                  {
                    id: "820201",
                    text: "嘉模堂区",
                    gisGcj02Lat: 22.149,
                    gisGcj02Lng: 113.565,
                  },
                ],
              },
              {
                id: "820300",
                text: "路环岛",
                children: [
                  {
                    id: "820301",
                    text: "圣方济各堂区",
                    gisGcj02Lat: 22.1235,
                    gisGcj02Lng: 113.56,
                  },
                ],
              },
            ],
          },
        ];;
